"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key2 of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key2) && key2 !== except)
        __defProp(to, key2, { get: () => from2[key2], enumerable: !(desc = __getOwnPropDesc(from2, key2)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// node_modules/is-hotkey/lib/index.js
var require_lib = __commonJS({
  "node_modules/is-hotkey/lib/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var IS_MAC = typeof window != "undefined" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
    var MODIFIERS = {
      alt: "altKey",
      control: "ctrlKey",
      meta: "metaKey",
      shift: "shiftKey"
    };
    var ALIASES = {
      add: "+",
      break: "pause",
      cmd: "meta",
      command: "meta",
      ctl: "control",
      ctrl: "control",
      del: "delete",
      down: "arrowdown",
      esc: "escape",
      ins: "insert",
      left: "arrowleft",
      mod: IS_MAC ? "meta" : "control",
      opt: "alt",
      option: "alt",
      return: "enter",
      right: "arrowright",
      space: " ",
      spacebar: " ",
      up: "arrowup",
      win: "meta",
      windows: "meta"
    };
    var CODES = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      control: 17,
      alt: 18,
      pause: 19,
      capslock: 20,
      escape: 27,
      " ": 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      arrowleft: 37,
      arrowup: 38,
      arrowright: 39,
      arrowdown: 40,
      insert: 45,
      delete: 46,
      meta: 91,
      numlock: 144,
      scrolllock: 145,
      ";": 186,
      "=": 187,
      ",": 188,
      "-": 189,
      ".": 190,
      "/": 191,
      "`": 192,
      "[": 219,
      "\\": 220,
      "]": 221,
      "'": 222
    };
    for (f = 1; f < 20; f++) {
      CODES["f" + f] = 111 + f;
    }
    var f;
    function isHotkey2(hotkey, options2, event) {
      if (options2 && !("byKey" in options2)) {
        event = options2;
        options2 = null;
      }
      if (!Array.isArray(hotkey)) {
        hotkey = [hotkey];
      }
      var array = hotkey.map(function(string) {
        return parseHotkey(string, options2);
      });
      var check = function check2(e) {
        return array.some(function(object) {
          return compareHotkey(object, e);
        });
      };
      var ret = event == null ? check : check(event);
      return ret;
    }
    function isCodeHotkey(hotkey, event) {
      return isHotkey2(hotkey, event);
    }
    function isKeyHotkey(hotkey, event) {
      return isHotkey2(hotkey, { byKey: true }, event);
    }
    function parseHotkey(hotkey, options2) {
      var byKey = options2 && options2.byKey;
      var ret = {};
      hotkey = hotkey.replace("++", "+add");
      var values = hotkey.split("+");
      var length2 = values.length;
      for (var k in MODIFIERS) {
        ret[MODIFIERS[k]] = false;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = void 0;
      try {
        for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;
          var optional = value.endsWith("?") && value.length > 1;
          if (optional) {
            value = value.slice(0, -1);
          }
          var name = toKeyName(value);
          var modifier = MODIFIERS[name];
          if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
            throw new TypeError('Unknown modifier: "' + value + '"');
          }
          if (length2 === 1 || !modifier) {
            if (byKey) {
              ret.key = name;
            } else {
              ret.which = toKeyCode(value);
            }
          }
          if (modifier) {
            ret[modifier] = optional ? null : true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      return ret;
    }
    function compareHotkey(object, event) {
      for (var key2 in object) {
        var expected = object[key2];
        var actual = void 0;
        if (expected == null) {
          continue;
        }
        if (key2 === "key" && event.key != null) {
          actual = event.key.toLowerCase();
        } else if (key2 === "which") {
          actual = expected === 91 && event.which === 93 ? 91 : event.which;
        } else {
          actual = event[key2];
        }
        if (actual == null && expected === false) {
          continue;
        }
        if (actual !== expected) {
          return false;
        }
      }
      return true;
    }
    function toKeyCode(name) {
      name = toKeyName(name);
      var code = CODES[name] || name.toUpperCase().charCodeAt(0);
      return code;
    }
    function toKeyName(name) {
      name = name.toLowerCase();
      name = ALIASES[name] || name;
      return name;
    }
    exports.default = isHotkey2;
    exports.isHotkey = isHotkey2;
    exports.isCodeHotkey = isCodeHotkey;
    exports.isKeyHotkey = isKeyHotkey;
    exports.parseHotkey = parseHotkey;
    exports.compareHotkey = compareHotkey;
    exports.toKeyCode = toKeyCode;
    exports.toKeyName = toKeyName;
  }
});

// node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "node_modules/lodash/_freeGlobal.js"(exports, module2) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// node_modules/lodash/_root.js
var require_root = __commonJS({
  "node_modules/lodash/_root.js"(exports, module2) {
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// node_modules/lodash/isFinite.js
var require_isFinite = __commonJS({
  "node_modules/lodash/isFinite.js"(exports, module2) {
    var root = require_root();
    var nativeIsFinite = root.isFinite;
    function isFinite3(value) {
      return typeof value == "number" && nativeIsFinite(value);
    }
    module2.exports = isFinite3;
  }
});

// node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "node_modules/lodash/isObject.js"(exports, module2) {
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module2.exports = isObject;
  }
});

// node_modules/lodash/now.js
var require_now = __commonJS({
  "node_modules/lodash/now.js"(exports, module2) {
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module2.exports = now;
  }
});

// node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "node_modules/lodash/_trimmedEndIndex.js"(exports, module2) {
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {
      }
      return index;
    }
    module2.exports = trimmedEndIndex;
  }
});

// node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "node_modules/lodash/_baseTrim.js"(exports, module2) {
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    module2.exports = baseTrim;
  }
});

// node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "node_modules/lodash/_Symbol.js"(exports, module2) {
    var root = require_root();
    var Symbol2 = root.Symbol;
    module2.exports = Symbol2;
  }
});

// node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "node_modules/lodash/_getRawTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module2.exports = getRawTag;
  }
});

// node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "node_modules/lodash/_objectToString.js"(exports, module2) {
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module2.exports = objectToString;
  }
});

// node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "node_modules/lodash/_baseGetTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module2.exports = baseGetTag;
  }
});

// node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "node_modules/lodash/isObjectLike.js"(exports, module2) {
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module2.exports = isObjectLike;
  }
});

// node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "node_modules/lodash/isSymbol.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module2.exports = isSymbol;
  }
});

// node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "node_modules/lodash/toNumber.js"(exports, module2) {
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = toNumber;
  }
});

// node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "node_modules/lodash/debounce.js"(exports, module2) {
    var isObject = require_isObject();
    var now = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce3(func, wait, options2) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options2)) {
        leading = !!options2.leading;
        maxing = "maxWait" in options2;
        maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options2 ? !!options2.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module2.exports = debounce3;
  }
});

// node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "node_modules/lodash/isFunction.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObject = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module2.exports = isFunction;
  }
});

// node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "node_modules/lodash/_coreJsData.js"(exports, module2) {
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module2.exports = coreJsData;
  }
});

// node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "node_modules/lodash/_isMasked.js"(exports, module2) {
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module2.exports = isMasked;
  }
});

// node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "node_modules/lodash/_toSource.js"(exports, module2) {
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module2.exports = toSource;
  }
});

// node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "node_modules/lodash/_baseIsNative.js"(exports, module2) {
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module2.exports = baseIsNative;
  }
});

// node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "node_modules/lodash/_getValue.js"(exports, module2) {
    function getValue(object, key2) {
      return object == null ? void 0 : object[key2];
    }
    module2.exports = getValue;
  }
});

// node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "node_modules/lodash/_getNative.js"(exports, module2) {
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key2) {
      var value = getValue(object, key2);
      return baseIsNative(value) ? value : void 0;
    }
    module2.exports = getNative;
  }
});

// node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "node_modules/lodash/_nativeCreate.js"(exports, module2) {
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module2.exports = nativeCreate;
  }
});

// node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "node_modules/lodash/_hashClear.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module2.exports = hashClear;
  }
});

// node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "node_modules/lodash/_hashDelete.js"(exports, module2) {
    function hashDelete(key2) {
      var result = this.has(key2) && delete this.__data__[key2];
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = hashDelete;
  }
});

// node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "node_modules/lodash/_hashGet.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function hashGet(key2) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key2];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty2.call(data, key2) ? data[key2] : void 0;
    }
    module2.exports = hashGet;
  }
});

// node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "node_modules/lodash/_hashHas.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function hashHas(key2) {
      var data = this.__data__;
      return nativeCreate ? data[key2] !== void 0 : hasOwnProperty2.call(data, key2);
    }
    module2.exports = hashHas;
  }
});

// node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "node_modules/lodash/_hashSet.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key2, value) {
      var data = this.__data__;
      this.size += this.has(key2) ? 0 : 1;
      data[key2] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module2.exports = hashSet;
  }
});

// node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "node_modules/lodash/_Hash.js"(exports, module2) {
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length2) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module2.exports = Hash;
  }
});

// node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "node_modules/lodash/_listCacheClear.js"(exports, module2) {
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module2.exports = listCacheClear;
  }
});

// node_modules/lodash/eq.js
var require_eq = __commonJS({
  "node_modules/lodash/eq.js"(exports, module2) {
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module2.exports = eq;
  }
});

// node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "node_modules/lodash/_assocIndexOf.js"(exports, module2) {
    var eq = require_eq();
    function assocIndexOf(array, key2) {
      var length2 = array.length;
      while (length2--) {
        if (eq(array[length2][0], key2)) {
          return length2;
        }
      }
      return -1;
    }
    module2.exports = assocIndexOf;
  }
});

// node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "node_modules/lodash/_listCacheDelete.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key2) {
      var data = this.__data__, index = assocIndexOf(data, key2);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module2.exports = listCacheDelete;
  }
});

// node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "node_modules/lodash/_listCacheGet.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key2) {
      var data = this.__data__, index = assocIndexOf(data, key2);
      return index < 0 ? void 0 : data[index][1];
    }
    module2.exports = listCacheGet;
  }
});

// node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "node_modules/lodash/_listCacheHas.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key2) {
      return assocIndexOf(this.__data__, key2) > -1;
    }
    module2.exports = listCacheHas;
  }
});

// node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "node_modules/lodash/_listCacheSet.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key2, value) {
      var data = this.__data__, index = assocIndexOf(data, key2);
      if (index < 0) {
        ++this.size;
        data.push([key2, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module2.exports = listCacheSet;
  }
});

// node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "node_modules/lodash/_ListCache.js"(exports, module2) {
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length2) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module2.exports = ListCache;
  }
});

// node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "node_modules/lodash/_Map.js"(exports, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var Map2 = getNative(root, "Map");
    module2.exports = Map2;
  }
});

// node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "node_modules/lodash/_mapCacheClear.js"(exports, module2) {
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    module2.exports = mapCacheClear;
  }
});

// node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "node_modules/lodash/_isKeyable.js"(exports, module2) {
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module2.exports = isKeyable;
  }
});

// node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "node_modules/lodash/_getMapData.js"(exports, module2) {
    var isKeyable = require_isKeyable();
    function getMapData(map, key2) {
      var data = map.__data__;
      return isKeyable(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
    }
    module2.exports = getMapData;
  }
});

// node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "node_modules/lodash/_mapCacheDelete.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheDelete(key2) {
      var result = getMapData(this, key2)["delete"](key2);
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = mapCacheDelete;
  }
});

// node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "node_modules/lodash/_mapCacheGet.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheGet(key2) {
      return getMapData(this, key2).get(key2);
    }
    module2.exports = mapCacheGet;
  }
});

// node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "node_modules/lodash/_mapCacheHas.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheHas(key2) {
      return getMapData(this, key2).has(key2);
    }
    module2.exports = mapCacheHas;
  }
});

// node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "node_modules/lodash/_mapCacheSet.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheSet(key2, value) {
      var data = getMapData(this, key2), size = data.size;
      data.set(key2, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module2.exports = mapCacheSet;
  }
});

// node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "node_modules/lodash/_MapCache.js"(exports, module2) {
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length2) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module2.exports = MapCache;
  }
});

// node_modules/lodash/memoize.js
var require_memoize = __commonJS({
  "node_modules/lodash/memoize.js"(exports, module2) {
    var MapCache = require_MapCache();
    var FUNC_ERROR_TEXT = "Expected a function";
    function memoize6(func, resolver) {
      if (typeof func != "function" || resolver != null && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key2)) {
          return cache.get(key2);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key2, result) || cache;
        return result;
      };
      memoized.cache = new (memoize6.Cache || MapCache)();
      return memoized;
    }
    memoize6.Cache = MapCache;
    module2.exports = memoize6;
  }
});

// node_modules/lodash/_baseHas.js
var require_baseHas = __commonJS({
  "node_modules/lodash/_baseHas.js"(exports, module2) {
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function baseHas(object, key2) {
      return object != null && hasOwnProperty2.call(object, key2);
    }
    module2.exports = baseHas;
  }
});

// node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "node_modules/lodash/isArray.js"(exports, module2) {
    var isArray = Array.isArray;
    module2.exports = isArray;
  }
});

// node_modules/lodash/_isKey.js
var require_isKey = __commonJS({
  "node_modules/lodash/_isKey.js"(exports, module2) {
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    var reIsPlainProp = /^\w*$/;
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    module2.exports = isKey;
  }
});

// node_modules/lodash/_memoizeCapped.js
var require_memoizeCapped = __commonJS({
  "node_modules/lodash/_memoizeCapped.js"(exports, module2) {
    var memoize6 = require_memoize();
    var MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(func) {
      var result = memoize6(func, function(key2) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key2;
      });
      var cache = result.cache;
      return result;
    }
    module2.exports = memoizeCapped;
  }
});

// node_modules/lodash/_stringToPath.js
var require_stringToPath = __commonJS({
  "node_modules/lodash/_stringToPath.js"(exports, module2) {
    var memoizeCapped = require_memoizeCapped();
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46) {
        result.push("");
      }
      string.replace(rePropName, function(match2, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
      });
      return result;
    });
    module2.exports = stringToPath;
  }
});

// node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "node_modules/lodash/_arrayMap.js"(exports, module2) {
    function arrayMap(array, iteratee) {
      var index = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
      while (++index < length2) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    module2.exports = arrayMap;
  }
});

// node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "node_modules/lodash/_baseToString.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var arrayMap = require_arrayMap();
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isArray(value)) {
        return arrayMap(value, baseToString) + "";
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module2.exports = baseToString;
  }
});

// node_modules/lodash/toString.js
var require_toString = __commonJS({
  "node_modules/lodash/toString.js"(exports, module2) {
    var baseToString = require_baseToString();
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    module2.exports = toString;
  }
});

// node_modules/lodash/_castPath.js
var require_castPath = __commonJS({
  "node_modules/lodash/_castPath.js"(exports, module2) {
    var isArray = require_isArray();
    var isKey = require_isKey();
    var stringToPath = require_stringToPath();
    var toString = require_toString();
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }
    module2.exports = castPath;
  }
});

// node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "node_modules/lodash/_baseIsArguments.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module2.exports = baseIsArguments;
  }
});

// node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "node_modules/lodash/isArguments.js"(exports, module2) {
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module2.exports = isArguments;
  }
});

// node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "node_modules/lodash/_isIndex.js"(exports, module2) {
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length2) {
      var type = typeof value;
      length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
      return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
    }
    module2.exports = isIndex;
  }
});

// node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "node_modules/lodash/isLength.js"(exports, module2) {
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module2.exports = isLength;
  }
});

// node_modules/lodash/_toKey.js
var require_toKey = __commonJS({
  "node_modules/lodash/_toKey.js"(exports, module2) {
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    function toKey(value) {
      if (typeof value == "string" || isSymbol(value)) {
        return value;
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module2.exports = toKey;
  }
});

// node_modules/lodash/_hasPath.js
var require_hasPath = __commonJS({
  "node_modules/lodash/_hasPath.js"(exports, module2) {
    var castPath = require_castPath();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isIndex = require_isIndex();
    var isLength = require_isLength();
    var toKey = require_toKey();
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);
      var index = -1, length2 = path.length, result = false;
      while (++index < length2) {
        var key2 = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key2))) {
          break;
        }
        object = object[key2];
      }
      if (result || ++index != length2) {
        return result;
      }
      length2 = object == null ? 0 : object.length;
      return !!length2 && isLength(length2) && isIndex(key2, length2) && (isArray(object) || isArguments(object));
    }
    module2.exports = hasPath;
  }
});

// node_modules/lodash/has.js
var require_has = __commonJS({
  "node_modules/lodash/has.js"(exports, module2) {
    var baseHas = require_baseHas();
    var hasPath = require_hasPath();
    function has2(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }
    module2.exports = has2;
  }
});

// node_modules/lodash/_baseGet.js
var require_baseGet = __commonJS({
  "node_modules/lodash/_baseGet.js"(exports, module2) {
    var castPath = require_castPath();
    var toKey = require_toKey();
    function baseGet(object, path) {
      path = castPath(path, object);
      var index = 0, length2 = path.length;
      while (object != null && index < length2) {
        object = object[toKey(path[index++])];
      }
      return index && index == length2 ? object : void 0;
    }
    module2.exports = baseGet;
  }
});

// node_modules/lodash/_defineProperty.js
var require_defineProperty = __commonJS({
  "node_modules/lodash/_defineProperty.js"(exports, module2) {
    var getNative = require_getNative();
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    module2.exports = defineProperty;
  }
});

// node_modules/lodash/_baseAssignValue.js
var require_baseAssignValue = __commonJS({
  "node_modules/lodash/_baseAssignValue.js"(exports, module2) {
    var defineProperty = require_defineProperty();
    function baseAssignValue(object, key2, value) {
      if (key2 == "__proto__" && defineProperty) {
        defineProperty(object, key2, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key2] = value;
      }
    }
    module2.exports = baseAssignValue;
  }
});

// node_modules/lodash/_assignValue.js
var require_assignValue = __commonJS({
  "node_modules/lodash/_assignValue.js"(exports, module2) {
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function assignValue(object, key2, value) {
      var objValue = object[key2];
      if (!(hasOwnProperty2.call(object, key2) && eq(objValue, value)) || value === void 0 && !(key2 in object)) {
        baseAssignValue(object, key2, value);
      }
    }
    module2.exports = assignValue;
  }
});

// node_modules/lodash/_baseSet.js
var require_baseSet = __commonJS({
  "node_modules/lodash/_baseSet.js"(exports, module2) {
    var assignValue = require_assignValue();
    var castPath = require_castPath();
    var isIndex = require_isIndex();
    var isObject = require_isObject();
    var toKey = require_toKey();
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);
      var index = -1, length2 = path.length, lastIndex = length2 - 1, nested = object;
      while (nested != null && ++index < length2) {
        var key2 = toKey(path[index]), newValue = value;
        if (key2 === "__proto__" || key2 === "constructor" || key2 === "prototype") {
          return object;
        }
        if (index != lastIndex) {
          var objValue = nested[key2];
          newValue = customizer ? customizer(objValue, key2, nested) : void 0;
          if (newValue === void 0) {
            newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
          }
        }
        assignValue(nested, key2, newValue);
        nested = nested[key2];
      }
      return object;
    }
    module2.exports = baseSet;
  }
});

// node_modules/lodash/_basePickBy.js
var require_basePickBy = __commonJS({
  "node_modules/lodash/_basePickBy.js"(exports, module2) {
    var baseGet = require_baseGet();
    var baseSet = require_baseSet();
    var castPath = require_castPath();
    function basePickBy(object, paths, predicate) {
      var index = -1, length2 = paths.length, result = {};
      while (++index < length2) {
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }
    module2.exports = basePickBy;
  }
});

// node_modules/lodash/_baseHasIn.js
var require_baseHasIn = __commonJS({
  "node_modules/lodash/_baseHasIn.js"(exports, module2) {
    function baseHasIn(object, key2) {
      return object != null && key2 in Object(object);
    }
    module2.exports = baseHasIn;
  }
});

// node_modules/lodash/hasIn.js
var require_hasIn = __commonJS({
  "node_modules/lodash/hasIn.js"(exports, module2) {
    var baseHasIn = require_baseHasIn();
    var hasPath = require_hasPath();
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }
    module2.exports = hasIn;
  }
});

// node_modules/lodash/_basePick.js
var require_basePick = __commonJS({
  "node_modules/lodash/_basePick.js"(exports, module2) {
    var basePickBy = require_basePickBy();
    var hasIn = require_hasIn();
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }
    module2.exports = basePick;
  }
});

// node_modules/lodash/_arrayPush.js
var require_arrayPush = __commonJS({
  "node_modules/lodash/_arrayPush.js"(exports, module2) {
    function arrayPush(array, values) {
      var index = -1, length2 = values.length, offset = array.length;
      while (++index < length2) {
        array[offset + index] = values[index];
      }
      return array;
    }
    module2.exports = arrayPush;
  }
});

// node_modules/lodash/_isFlattenable.js
var require_isFlattenable = __commonJS({
  "node_modules/lodash/_isFlattenable.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    module2.exports = isFlattenable;
  }
});

// node_modules/lodash/_baseFlatten.js
var require_baseFlatten = __commonJS({
  "node_modules/lodash/_baseFlatten.js"(exports, module2) {
    var arrayPush = require_arrayPush();
    var isFlattenable = require_isFlattenable();
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1, length2 = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);
      while (++index < length2) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }
    module2.exports = baseFlatten;
  }
});

// node_modules/lodash/flatten.js
var require_flatten = __commonJS({
  "node_modules/lodash/flatten.js"(exports, module2) {
    var baseFlatten = require_baseFlatten();
    function flatten(array) {
      var length2 = array == null ? 0 : array.length;
      return length2 ? baseFlatten(array, 1) : [];
    }
    module2.exports = flatten;
  }
});

// node_modules/lodash/_apply.js
var require_apply = __commonJS({
  "node_modules/lodash/_apply.js"(exports, module2) {
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module2.exports = apply;
  }
});

// node_modules/lodash/_overRest.js
var require_overRest = __commonJS({
  "node_modules/lodash/_overRest.js"(exports, module2) {
    var apply = require_apply();
    var nativeMax = Math.max;
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length2 = nativeMax(args.length - start, 0), array = Array(length2);
        while (++index < length2) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    module2.exports = overRest;
  }
});

// node_modules/lodash/constant.js
var require_constant = __commonJS({
  "node_modules/lodash/constant.js"(exports, module2) {
    function constant(value) {
      return function() {
        return value;
      };
    }
    module2.exports = constant;
  }
});

// node_modules/lodash/identity.js
var require_identity = __commonJS({
  "node_modules/lodash/identity.js"(exports, module2) {
    function identity(value) {
      return value;
    }
    module2.exports = identity;
  }
});

// node_modules/lodash/_baseSetToString.js
var require_baseSetToString = __commonJS({
  "node_modules/lodash/_baseSetToString.js"(exports, module2) {
    var constant = require_constant();
    var defineProperty = require_defineProperty();
    var identity = require_identity();
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    module2.exports = baseSetToString;
  }
});

// node_modules/lodash/_shortOut.js
var require_shortOut = __commonJS({
  "node_modules/lodash/_shortOut.js"(exports, module2) {
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    module2.exports = shortOut;
  }
});

// node_modules/lodash/_setToString.js
var require_setToString = __commonJS({
  "node_modules/lodash/_setToString.js"(exports, module2) {
    var baseSetToString = require_baseSetToString();
    var shortOut = require_shortOut();
    var setToString = shortOut(baseSetToString);
    module2.exports = setToString;
  }
});

// node_modules/lodash/_flatRest.js
var require_flatRest = __commonJS({
  "node_modules/lodash/_flatRest.js"(exports, module2) {
    var flatten = require_flatten();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function flatRest(func) {
      return setToString(overRest(func, void 0, flatten), func + "");
    }
    module2.exports = flatRest;
  }
});

// node_modules/lodash/pick.js
var require_pick = __commonJS({
  "node_modules/lodash/pick.js"(exports, module2) {
    var basePick = require_basePick();
    var flatRest = require_flatRest();
    var pick3 = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });
    module2.exports = pick3;
  }
});

// node_modules/stop-media-stream/index.js
var require_stop_media_stream = __commonJS({
  "node_modules/stop-media-stream/index.js"(exports, module2) {
    function stopAndRemoveTrack(mediaStream) {
      return function(track) {
        track.stop();
        mediaStream.removeTrack(track);
      };
    }
    function stopMediaStream4(mediaStream) {
      if (!mediaStream) {
        return;
      }
      mediaStream.getTracks().forEach(stopAndRemoveTrack(mediaStream));
    }
    module2.exports = stopMediaStream4;
  }
});

// node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element3 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment4 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element3;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment4;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/react-is/index.js"(exports, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var require_hoist_non_react_statics_cjs = __commonJS({
  "node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"(exports, module2) {
    "use strict";
    var reactIs = require_react_is();
    var REACT_STATICS = {
      childContextTypes: true,
      contextType: true,
      contextTypes: true,
      defaultProps: true,
      displayName: true,
      getDefaultProps: true,
      getDerivedStateFromError: true,
      getDerivedStateFromProps: true,
      mixins: true,
      propTypes: true,
      type: true
    };
    var KNOWN_STATICS = {
      name: true,
      length: true,
      prototype: true,
      caller: true,
      callee: true,
      arguments: true,
      arity: true
    };
    var FORWARD_REF_STATICS = {
      "$$typeof": true,
      render: true,
      defaultProps: true,
      displayName: true,
      propTypes: true
    };
    var MEMO_STATICS = {
      "$$typeof": true,
      compare: true,
      defaultProps: true,
      displayName: true,
      propTypes: true,
      type: true
    };
    var TYPE_STATICS = {};
    TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
    TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
    function getStatics(component) {
      if (reactIs.isMemo(component)) {
        return MEMO_STATICS;
      }
      return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
    }
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = Object.prototype;
    function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
      if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
          var inheritedComponent = getPrototypeOf(sourceComponent);
          if (inheritedComponent && inheritedComponent !== objectPrototype) {
            hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
          }
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) {
          keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for (var i = 0; i < keys.length; ++i) {
          var key2 = keys[i];
          if (!KNOWN_STATICS[key2] && !(blacklist && blacklist[key2]) && !(sourceStatics && sourceStatics[key2]) && !(targetStatics && targetStatics[key2])) {
            var descriptor = getOwnPropertyDescriptor(sourceComponent, key2);
            try {
              defineProperty(targetComponent, key2, descriptor);
            } catch (e) {
            }
          }
        }
      }
      return targetComponent;
    }
    module2.exports = hoistNonReactStatics;
  }
});

// node_modules/lodash/_baseRest.js
var require_baseRest = __commonJS({
  "node_modules/lodash/_baseRest.js"(exports, module2) {
    var identity = require_identity();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    module2.exports = baseRest;
  }
});

// node_modules/lodash/_WeakMap.js
var require_WeakMap = __commonJS({
  "node_modules/lodash/_WeakMap.js"(exports, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var WeakMap2 = getNative(root, "WeakMap");
    module2.exports = WeakMap2;
  }
});

// node_modules/lodash/_metaMap.js
var require_metaMap = __commonJS({
  "node_modules/lodash/_metaMap.js"(exports, module2) {
    var WeakMap2 = require_WeakMap();
    var metaMap = WeakMap2 && new WeakMap2();
    module2.exports = metaMap;
  }
});

// node_modules/lodash/_baseSetData.js
var require_baseSetData = __commonJS({
  "node_modules/lodash/_baseSetData.js"(exports, module2) {
    var identity = require_identity();
    var metaMap = require_metaMap();
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };
    module2.exports = baseSetData;
  }
});

// node_modules/lodash/_baseCreate.js
var require_baseCreate = __commonJS({
  "node_modules/lodash/_baseCreate.js"(exports, module2) {
    var isObject = require_isObject();
    var objectCreate = Object.create;
    var baseCreate = function() {
      function object() {
      }
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    }();
    module2.exports = baseCreate;
  }
});

// node_modules/lodash/_createCtor.js
var require_createCtor = __commonJS({
  "node_modules/lodash/_createCtor.js"(exports, module2) {
    var baseCreate = require_baseCreate();
    var isObject = require_isObject();
    function createCtor(Ctor) {
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0:
            return new Ctor();
          case 1:
            return new Ctor(args[0]);
          case 2:
            return new Ctor(args[0], args[1]);
          case 3:
            return new Ctor(args[0], args[1], args[2]);
          case 4:
            return new Ctor(args[0], args[1], args[2], args[3]);
          case 5:
            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        return isObject(result) ? result : thisBinding;
      };
    }
    module2.exports = createCtor;
  }
});

// node_modules/lodash/_createBind.js
var require_createBind = __commonJS({
  "node_modules/lodash/_createBind.js"(exports, module2) {
    var createCtor = require_createCtor();
    var root = require_root();
    var WRAP_BIND_FLAG = 1;
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
      function wrapper() {
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }
    module2.exports = createBind;
  }
});

// node_modules/lodash/_composeArgs.js
var require_composeArgs = __commonJS({
  "node_modules/lodash/_composeArgs.js"(exports, module2) {
    var nativeMax = Math.max;
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }
    module2.exports = composeArgs;
  }
});

// node_modules/lodash/_composeArgsRight.js
var require_composeArgsRight = __commonJS({
  "node_modules/lodash/_composeArgsRight.js"(exports, module2) {
    var nativeMax = Math.max;
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }
    module2.exports = composeArgsRight;
  }
});

// node_modules/lodash/_countHolders.js
var require_countHolders = __commonJS({
  "node_modules/lodash/_countHolders.js"(exports, module2) {
    function countHolders(array, placeholder) {
      var length2 = array.length, result = 0;
      while (length2--) {
        if (array[length2] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    module2.exports = countHolders;
  }
});

// node_modules/lodash/_baseLodash.js
var require_baseLodash = __commonJS({
  "node_modules/lodash/_baseLodash.js"(exports, module2) {
    function baseLodash() {
    }
    module2.exports = baseLodash;
  }
});

// node_modules/lodash/_LazyWrapper.js
var require_LazyWrapper = __commonJS({
  "node_modules/lodash/_LazyWrapper.js"(exports, module2) {
    var baseCreate = require_baseCreate();
    var baseLodash = require_baseLodash();
    var MAX_ARRAY_LENGTH = 4294967295;
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;
    module2.exports = LazyWrapper;
  }
});

// node_modules/lodash/noop.js
var require_noop = __commonJS({
  "node_modules/lodash/noop.js"(exports, module2) {
    function noop() {
    }
    module2.exports = noop;
  }
});

// node_modules/lodash/_getData.js
var require_getData = __commonJS({
  "node_modules/lodash/_getData.js"(exports, module2) {
    var metaMap = require_metaMap();
    var noop = require_noop();
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };
    module2.exports = getData;
  }
});

// node_modules/lodash/_realNames.js
var require_realNames = __commonJS({
  "node_modules/lodash/_realNames.js"(exports, module2) {
    var realNames = {};
    module2.exports = realNames;
  }
});

// node_modules/lodash/_getFuncName.js
var require_getFuncName = __commonJS({
  "node_modules/lodash/_getFuncName.js"(exports, module2) {
    var realNames = require_realNames();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function getFuncName(func) {
      var result = func.name + "", array = realNames[result], length2 = hasOwnProperty2.call(realNames, result) ? array.length : 0;
      while (length2--) {
        var data = array[length2], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }
    module2.exports = getFuncName;
  }
});

// node_modules/lodash/_LodashWrapper.js
var require_LodashWrapper = __commonJS({
  "node_modules/lodash/_LodashWrapper.js"(exports, module2) {
    var baseCreate = require_baseCreate();
    var baseLodash = require_baseLodash();
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = void 0;
    }
    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;
    module2.exports = LodashWrapper;
  }
});

// node_modules/lodash/_copyArray.js
var require_copyArray = __commonJS({
  "node_modules/lodash/_copyArray.js"(exports, module2) {
    function copyArray(source, array) {
      var index = -1, length2 = source.length;
      array || (array = Array(length2));
      while (++index < length2) {
        array[index] = source[index];
      }
      return array;
    }
    module2.exports = copyArray;
  }
});

// node_modules/lodash/_wrapperClone.js
var require_wrapperClone = __commonJS({
  "node_modules/lodash/_wrapperClone.js"(exports, module2) {
    var LazyWrapper = require_LazyWrapper();
    var LodashWrapper = require_LodashWrapper();
    var copyArray = require_copyArray();
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__ = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }
    module2.exports = wrapperClone;
  }
});

// node_modules/lodash/wrapperLodash.js
var require_wrapperLodash = __commonJS({
  "node_modules/lodash/wrapperLodash.js"(exports, module2) {
    var LazyWrapper = require_LazyWrapper();
    var LodashWrapper = require_LodashWrapper();
    var baseLodash = require_baseLodash();
    var isArray = require_isArray();
    var isObjectLike = require_isObjectLike();
    var wrapperClone = require_wrapperClone();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty2.call(value, "__wrapped__")) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;
    module2.exports = lodash;
  }
});

// node_modules/lodash/_isLaziable.js
var require_isLaziable = __commonJS({
  "node_modules/lodash/_isLaziable.js"(exports, module2) {
    var LazyWrapper = require_LazyWrapper();
    var getData = require_getData();
    var getFuncName = require_getFuncName();
    var lodash = require_wrapperLodash();
    function isLaziable(func) {
      var funcName = getFuncName(func), other = lodash[funcName];
      if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }
    module2.exports = isLaziable;
  }
});

// node_modules/lodash/_setData.js
var require_setData = __commonJS({
  "node_modules/lodash/_setData.js"(exports, module2) {
    var baseSetData = require_baseSetData();
    var shortOut = require_shortOut();
    var setData = shortOut(baseSetData);
    module2.exports = setData;
  }
});

// node_modules/lodash/_getWrapDetails.js
var require_getWrapDetails = __commonJS({
  "node_modules/lodash/_getWrapDetails.js"(exports, module2) {
    var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/;
    var reSplitDetails = /,? & /;
    function getWrapDetails(source) {
      var match2 = source.match(reWrapDetails);
      return match2 ? match2[1].split(reSplitDetails) : [];
    }
    module2.exports = getWrapDetails;
  }
});

// node_modules/lodash/_insertWrapDetails.js
var require_insertWrapDetails = __commonJS({
  "node_modules/lodash/_insertWrapDetails.js"(exports, module2) {
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
    function insertWrapDetails(source, details) {
      var length2 = details.length;
      if (!length2) {
        return source;
      }
      var lastIndex = length2 - 1;
      details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
      details = details.join(length2 > 2 ? ", " : " ");
      return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
    }
    module2.exports = insertWrapDetails;
  }
});

// node_modules/lodash/_arrayEach.js
var require_arrayEach = __commonJS({
  "node_modules/lodash/_arrayEach.js"(exports, module2) {
    function arrayEach(array, iteratee) {
      var index = -1, length2 = array == null ? 0 : array.length;
      while (++index < length2) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    module2.exports = arrayEach;
  }
});

// node_modules/lodash/_baseFindIndex.js
var require_baseFindIndex = __commonJS({
  "node_modules/lodash/_baseFindIndex.js"(exports, module2) {
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length2 = array.length, index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length2) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    module2.exports = baseFindIndex;
  }
});

// node_modules/lodash/_baseIsNaN.js
var require_baseIsNaN = __commonJS({
  "node_modules/lodash/_baseIsNaN.js"(exports, module2) {
    function baseIsNaN(value) {
      return value !== value;
    }
    module2.exports = baseIsNaN;
  }
});

// node_modules/lodash/_strictIndexOf.js
var require_strictIndexOf = __commonJS({
  "node_modules/lodash/_strictIndexOf.js"(exports, module2) {
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1, length2 = array.length;
      while (++index < length2) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }
    module2.exports = strictIndexOf;
  }
});

// node_modules/lodash/_baseIndexOf.js
var require_baseIndexOf = __commonJS({
  "node_modules/lodash/_baseIndexOf.js"(exports, module2) {
    var baseFindIndex = require_baseFindIndex();
    var baseIsNaN = require_baseIsNaN();
    var strictIndexOf = require_strictIndexOf();
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    module2.exports = baseIndexOf;
  }
});

// node_modules/lodash/_arrayIncludes.js
var require_arrayIncludes = __commonJS({
  "node_modules/lodash/_arrayIncludes.js"(exports, module2) {
    var baseIndexOf = require_baseIndexOf();
    function arrayIncludes(array, value) {
      var length2 = array == null ? 0 : array.length;
      return !!length2 && baseIndexOf(array, value, 0) > -1;
    }
    module2.exports = arrayIncludes;
  }
});

// node_modules/lodash/_updateWrapDetails.js
var require_updateWrapDetails = __commonJS({
  "node_modules/lodash/_updateWrapDetails.js"(exports, module2) {
    var arrayEach = require_arrayEach();
    var arrayIncludes = require_arrayIncludes();
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_CURRY_RIGHT_FLAG = 16;
    var WRAP_PARTIAL_FLAG = 32;
    var WRAP_PARTIAL_RIGHT_FLAG = 64;
    var WRAP_ARY_FLAG = 128;
    var WRAP_REARG_FLAG = 256;
    var WRAP_FLIP_FLAG = 512;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = "_." + pair[0];
        if (bitmask & pair[1] && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }
    module2.exports = updateWrapDetails;
  }
});

// node_modules/lodash/_setWrapToString.js
var require_setWrapToString = __commonJS({
  "node_modules/lodash/_setWrapToString.js"(exports, module2) {
    var getWrapDetails = require_getWrapDetails();
    var insertWrapDetails = require_insertWrapDetails();
    var setToString = require_setToString();
    var updateWrapDetails = require_updateWrapDetails();
    function setWrapToString(wrapper, reference, bitmask) {
      var source = reference + "";
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }
    module2.exports = setWrapToString;
  }
});

// node_modules/lodash/_createRecurry.js
var require_createRecurry = __commonJS({
  "node_modules/lodash/_createRecurry.js"(exports, module2) {
    var isLaziable = require_isLaziable();
    var setData = require_setData();
    var setWrapToString = require_setWrapToString();
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_BOUND_FLAG = 4;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_PARTIAL_FLAG = 32;
    var WRAP_PARTIAL_RIGHT_FLAG = 64;
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : void 0, newHoldersRight = isCurry ? void 0 : holders, newPartials = isCurry ? partials : void 0, newPartialsRight = isCurry ? void 0 : partials;
      bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
      ];
      var result = wrapFunc.apply(void 0, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }
    module2.exports = createRecurry;
  }
});

// node_modules/lodash/_getHolder.js
var require_getHolder = __commonJS({
  "node_modules/lodash/_getHolder.js"(exports, module2) {
    function getHolder(func) {
      var object = func;
      return object.placeholder;
    }
    module2.exports = getHolder;
  }
});

// node_modules/lodash/_reorder.js
var require_reorder = __commonJS({
  "node_modules/lodash/_reorder.js"(exports, module2) {
    var copyArray = require_copyArray();
    var isIndex = require_isIndex();
    var nativeMin = Math.min;
    function reorder(array, indexes) {
      var arrLength = array.length, length2 = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
      while (length2--) {
        var index = indexes[length2];
        array[length2] = isIndex(index, arrLength) ? oldArray[index] : void 0;
      }
      return array;
    }
    module2.exports = reorder;
  }
});

// node_modules/lodash/_replaceHolders.js
var require_replaceHolders = __commonJS({
  "node_modules/lodash/_replaceHolders.js"(exports, module2) {
    var PLACEHOLDER = "__lodash_placeholder__";
    function replaceHolders(array, placeholder) {
      var index = -1, length2 = array.length, resIndex = 0, result = [];
      while (++index < length2) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }
    module2.exports = replaceHolders;
  }
});

// node_modules/lodash/_createHybrid.js
var require_createHybrid = __commonJS({
  "node_modules/lodash/_createHybrid.js"(exports, module2) {
    var composeArgs = require_composeArgs();
    var composeArgsRight = require_composeArgsRight();
    var countHolders = require_countHolders();
    var createCtor = require_createCtor();
    var createRecurry = require_createRecurry();
    var getHolder = require_getHolder();
    var reorder = require_reorder();
    var replaceHolders = require_replaceHolders();
    var root = require_root();
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_CURRY_RIGHT_FLAG = 16;
    var WRAP_ARY_FLAG = 128;
    var WRAP_FLIP_FLAG = 512;
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? void 0 : createCtor(func);
      function wrapper() {
        var length2 = arguments.length, args = Array(length2), index = length2;
        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length2 -= holdersCount;
        if (isCurried && length2 < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func,
            bitmask,
            createHybrid,
            wrapper.placeholder,
            thisArg,
            args,
            newHolders,
            argPos,
            ary,
            arity - length2
          );
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length2 = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length2 > 1) {
          args.reverse();
        }
        if (isAry && ary < length2) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }
    module2.exports = createHybrid;
  }
});

// node_modules/lodash/_createCurry.js
var require_createCurry = __commonJS({
  "node_modules/lodash/_createCurry.js"(exports, module2) {
    var apply = require_apply();
    var createCtor = require_createCtor();
    var createHybrid = require_createHybrid();
    var createRecurry = require_createRecurry();
    var getHolder = require_getHolder();
    var replaceHolders = require_replaceHolders();
    var root = require_root();
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);
      function wrapper() {
        var length2 = arguments.length, args = Array(length2), index = length2, placeholder = getHolder(wrapper);
        while (index--) {
          args[index] = arguments[index];
        }
        var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
        length2 -= holders.length;
        if (length2 < arity) {
          return createRecurry(
            func,
            bitmask,
            createHybrid,
            wrapper.placeholder,
            void 0,
            args,
            holders,
            void 0,
            void 0,
            arity - length2
          );
        }
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }
    module2.exports = createCurry;
  }
});

// node_modules/lodash/_createPartial.js
var require_createPartial = __commonJS({
  "node_modules/lodash/_createPartial.js"(exports, module2) {
    var apply = require_apply();
    var createCtor = require_createCtor();
    var root = require_root();
    var WRAP_BIND_FLAG = 1;
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
      function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }
    module2.exports = createPartial;
  }
});

// node_modules/lodash/_mergeData.js
var require_mergeData = __commonJS({
  "node_modules/lodash/_mergeData.js"(exports, module2) {
    var composeArgs = require_composeArgs();
    var composeArgsRight = require_composeArgsRight();
    var replaceHolders = require_replaceHolders();
    var PLACEHOLDER = "__lodash_placeholder__";
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_BOUND_FLAG = 4;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_ARY_FLAG = 128;
    var WRAP_REARG_FLAG = 256;
    var nativeMin = Math.min;
    function mergeData(data, source) {
      var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
      var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
      if (!(isCommon || isCombo)) {
        return data;
      }
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      value = source[7];
      if (value) {
        data[7] = value;
      }
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      if (data[9] == null) {
        data[9] = source[9];
      }
      data[0] = source[0];
      data[1] = newBitmask;
      return data;
    }
    module2.exports = mergeData;
  }
});

// node_modules/lodash/toFinite.js
var require_toFinite = __commonJS({
  "node_modules/lodash/toFinite.js"(exports, module2) {
    var toNumber = require_toNumber();
    var INFINITY = 1 / 0;
    var MAX_INTEGER = 17976931348623157e292;
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }
    module2.exports = toFinite;
  }
});

// node_modules/lodash/toInteger.js
var require_toInteger = __commonJS({
  "node_modules/lodash/toInteger.js"(exports, module2) {
    var toFinite = require_toFinite();
    function toInteger(value) {
      var result = toFinite(value), remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    module2.exports = toInteger;
  }
});

// node_modules/lodash/_createWrap.js
var require_createWrap = __commonJS({
  "node_modules/lodash/_createWrap.js"(exports, module2) {
    var baseSetData = require_baseSetData();
    var createBind = require_createBind();
    var createCurry = require_createCurry();
    var createHybrid = require_createHybrid();
    var createPartial = require_createPartial();
    var getData = require_getData();
    var mergeData = require_mergeData();
    var setData = require_setData();
    var setWrapToString = require_setWrapToString();
    var toInteger = require_toInteger();
    var FUNC_ERROR_TEXT = "Expected a function";
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_CURRY_RIGHT_FLAG = 16;
    var WRAP_PARTIAL_FLAG = 32;
    var WRAP_PARTIAL_RIGHT_FLAG = 64;
    var nativeMax = Math.max;
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length2 = partials ? partials.length : 0;
      if (!length2) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = void 0;
      }
      ary = ary === void 0 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === void 0 ? arity : toInteger(arity);
      length2 -= holders ? holders.length : 0;
      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = void 0;
      }
      var data = isBindKey ? void 0 : getData(func);
      var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
      ];
      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === void 0 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length2, 0);
      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(void 0, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }
    module2.exports = createWrap;
  }
});

// node_modules/lodash/partial.js
var require_partial = __commonJS({
  "node_modules/lodash/partial.js"(exports, module2) {
    var baseRest = require_baseRest();
    var createWrap = require_createWrap();
    var getHolder = require_getHolder();
    var replaceHolders = require_replaceHolders();
    var WRAP_PARTIAL_FLAG = 32;
    var partial3 = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial3));
      return createWrap(func, WRAP_PARTIAL_FLAG, void 0, partials, holders);
    });
    partial3.placeholder = {};
    module2.exports = partial3;
  }
});

// node_modules/lodash/head.js
var require_head = __commonJS({
  "node_modules/lodash/head.js"(exports, module2) {
    function head(array) {
      return array && array.length ? array[0] : void 0;
    }
    module2.exports = head;
  }
});

// node_modules/lodash/first.js
var require_first = __commonJS({
  "node_modules/lodash/first.js"(exports, module2) {
    module2.exports = require_head();
  }
});

// node_modules/lodash/_setCacheAdd.js
var require_setCacheAdd = __commonJS({
  "node_modules/lodash/_setCacheAdd.js"(exports, module2) {
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    module2.exports = setCacheAdd;
  }
});

// node_modules/lodash/_setCacheHas.js
var require_setCacheHas = __commonJS({
  "node_modules/lodash/_setCacheHas.js"(exports, module2) {
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    module2.exports = setCacheHas;
  }
});

// node_modules/lodash/_SetCache.js
var require_SetCache = __commonJS({
  "node_modules/lodash/_SetCache.js"(exports, module2) {
    var MapCache = require_MapCache();
    var setCacheAdd = require_setCacheAdd();
    var setCacheHas = require_setCacheHas();
    function SetCache(values) {
      var index = -1, length2 = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length2) {
        this.add(values[index]);
      }
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    module2.exports = SetCache;
  }
});

// node_modules/lodash/_arrayIncludesWith.js
var require_arrayIncludesWith = __commonJS({
  "node_modules/lodash/_arrayIncludesWith.js"(exports, module2) {
    function arrayIncludesWith(array, value, comparator) {
      var index = -1, length2 = array == null ? 0 : array.length;
      while (++index < length2) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }
    module2.exports = arrayIncludesWith;
  }
});

// node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "node_modules/lodash/_baseUnary.js"(exports, module2) {
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module2.exports = baseUnary;
  }
});

// node_modules/lodash/_cacheHas.js
var require_cacheHas = __commonJS({
  "node_modules/lodash/_cacheHas.js"(exports, module2) {
    function cacheHas(cache, key2) {
      return cache.has(key2);
    }
    module2.exports = cacheHas;
  }
});

// node_modules/lodash/_baseIntersection.js
var require_baseIntersection = __commonJS({
  "node_modules/lodash/_baseIntersection.js"(exports, module2) {
    var SetCache = require_SetCache();
    var arrayIncludes = require_arrayIncludes();
    var arrayIncludesWith = require_arrayIncludesWith();
    var arrayMap = require_arrayMap();
    var baseUnary = require_baseUnary();
    var cacheHas = require_cacheHas();
    var nativeMin = Math.min;
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length2 >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : void 0;
      }
      array = arrays[0];
      var index = -1, seen = caches[0];
      outer:
        while (++index < length2 && result.length < maxLength) {
          var value = array[index], computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while (--othIndex) {
              var cache = caches[othIndex];
              if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                continue outer;
              }
            }
            if (seen) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
      return result;
    }
    module2.exports = baseIntersection;
  }
});

// node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "node_modules/lodash/isArrayLike.js"(exports, module2) {
    var isFunction = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module2.exports = isArrayLike;
  }
});

// node_modules/lodash/isArrayLikeObject.js
var require_isArrayLikeObject = __commonJS({
  "node_modules/lodash/isArrayLikeObject.js"(exports, module2) {
    var isArrayLike = require_isArrayLike();
    var isObjectLike = require_isObjectLike();
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    module2.exports = isArrayLikeObject;
  }
});

// node_modules/lodash/_castArrayLikeObject.js
var require_castArrayLikeObject = __commonJS({
  "node_modules/lodash/_castArrayLikeObject.js"(exports, module2) {
    var isArrayLikeObject = require_isArrayLikeObject();
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }
    module2.exports = castArrayLikeObject;
  }
});

// node_modules/lodash/intersection.js
var require_intersection = __commonJS({
  "node_modules/lodash/intersection.js"(exports, module2) {
    var arrayMap = require_arrayMap();
    var baseIntersection = require_baseIntersection();
    var baseRest = require_baseRest();
    var castArrayLikeObject = require_castArrayLikeObject();
    var intersection2 = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
    });
    module2.exports = intersection2;
  }
});

// node_modules/lodash/before.js
var require_before = __commonJS({
  "node_modules/lodash/before.js"(exports, module2) {
    var toInteger = require_toInteger();
    var FUNC_ERROR_TEXT = "Expected a function";
    function before(n, func) {
      var result;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = void 0;
        }
        return result;
      };
    }
    module2.exports = before;
  }
});

// node_modules/lodash/once.js
var require_once = __commonJS({
  "node_modules/lodash/once.js"(exports, module2) {
    var before = require_before();
    function once2(func) {
      return before(2, func);
    }
    module2.exports = once2;
  }
});

// node_modules/lodash/_createRound.js
var require_createRound = __commonJS({
  "node_modules/lodash/_createRound.js"(exports, module2) {
    var root = require_root();
    var toInteger = require_toInteger();
    var toNumber = require_toNumber();
    var toString = require_toString();
    var nativeIsFinite = root.isFinite;
    var nativeMin = Math.min;
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
          pair = (toString(value) + "e").split("e");
          return +(pair[0] + "e" + (+pair[1] - precision));
        }
        return func(number);
      };
    }
    module2.exports = createRound;
  }
});

// node_modules/lodash/ceil.js
var require_ceil = __commonJS({
  "node_modules/lodash/ceil.js"(exports, module2) {
    var createRound = require_createRound();
    var ceil2 = createRound("ceil");
    module2.exports = ceil2;
  }
});

// node_modules/lodash/_baseClamp.js
var require_baseClamp = __commonJS({
  "node_modules/lodash/_baseClamp.js"(exports, module2) {
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== void 0) {
          number = number <= upper ? number : upper;
        }
        if (lower !== void 0) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }
    module2.exports = baseClamp;
  }
});

// node_modules/lodash/clamp.js
var require_clamp = __commonJS({
  "node_modules/lodash/clamp.js"(exports, module2) {
    var baseClamp = require_baseClamp();
    var toNumber = require_toNumber();
    function clamp2(number, lower, upper) {
      if (upper === void 0) {
        upper = lower;
        lower = void 0;
      }
      if (upper !== void 0) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== void 0) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }
    module2.exports = clamp2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/_virtual/_rollupPluginBabelHelpers.js
var require_rollupPluginBabelHelpers = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/_virtual/_rollupPluginBabelHelpers.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _typeof(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof = function(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof(obj);
    }
    function _defineProperty(obj, key2, value) {
      if (key2 in obj) {
        Object.defineProperty(obj, key2, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key2] = value;
      }
      return obj;
    }
    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
          symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
        keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread2(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys(Object(source), true).forEach(function(key2) {
            _defineProperty(target, key2, source[key2]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(Object(source)).forEach(function(key2) {
            Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
          });
        }
      }
      return target;
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr))
        return arr;
    }
    function _iterableToArrayLimit(arr, i) {
      if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
        return;
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i)
            break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null)
            _i["return"]();
        } finally {
          if (_d)
            throw _e;
        }
      }
      return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o)
        return;
      if (typeof o === "string")
        return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor)
        n = o.constructor.name;
      if (n === "Map" || n === "Set")
        return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length)
        len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
      return arr2;
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    exports.arrayLikeToArray = _arrayLikeToArray;
    exports.arrayWithHoles = _arrayWithHoles;
    exports.defineProperty = _defineProperty;
    exports.iterableToArrayLimit = _iterableToArrayLimit;
    exports.nonIterableRest = _nonIterableRest;
    exports.objectSpread2 = _objectSpread2;
    exports.slicedToArray = _slicedToArray;
    exports.typeof = _typeof;
    exports.unsupportedIterableToArray = _unsupportedIterableToArray;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/createHandlerSetter.js
var require_createHandlerSetter = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/createHandlerSetter.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var createHandlerSetter = function createHandlerSetter2(handlerValue) {
      var handlerRef = react.useRef(handlerValue);
      handlerRef.current = handlerValue;
      var setHandler = react.useCallback(function(nextCallback) {
        if (typeof nextCallback !== "function") {
          throw new Error("the argument supplied to the 'setHandler' function should be of type function");
        }
        handlerRef.current = nextCallback;
      });
      return [handlerRef, setHandler];
    };
    exports.default = createHandlerSetter;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDidMount.js
var require_useDidMount = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDidMount.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var useDidMount = function useDidMount2(handler) {
      var _createHandlerSetter = createHandlerSetter.default(handler), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onMountHandler = _createHandlerSetter2[0], setOnMountHandler = _createHandlerSetter2[1];
      react.useEffect(function() {
        if (onMountHandler.current) {
          onMountHandler.current();
        }
      }, []);
      return setOnMountHandler;
    };
    exports.default = useDidMount;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWillUnmount.js
var require_useWillUnmount = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWillUnmount.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var useWillUnmount = function useWillUnmount2(handler) {
      var _createHandlerSetter = createHandlerSetter.default(handler), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onUnmountHandler = _createHandlerSetter2[0], setOnUnmount = _createHandlerSetter2[1];
      react.useEffect(function() {
        return function() {
          if (onUnmountHandler.current) {
            onUnmountHandler.current();
          }
        };
      }, []);
      return setOnUnmount;
    };
    exports.default = useWillUnmount;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useLifecycle.js
var require_useLifecycle = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useLifecycle.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useDidMount = require_useDidMount();
    var useWillUnmount = require_useWillUnmount();
    var useLifecycle = function useLifecycle2(mount, unmount) {
      var onDidMount = useDidMount.default(mount);
      var onWillUnmount = useWillUnmount.default(unmount);
      return {
        onDidMount,
        onWillUnmount
      };
    };
    exports.default = useLifecycle;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGlobalEvent.js
var require_useGlobalEvent = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGlobalEvent.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var defaultOptions = {
      capture: false,
      once: false,
      passive: false
    };
    var useGlobalEvent2 = function useGlobalEvent3(eventName) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var fn = arguments.length > 2 ? arguments[2] : void 0;
      var _createHandlerSetter = createHandlerSetter.default(fn), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), callbackRef = _createHandlerSetter2[0], setCallbackRef = _createHandlerSetter2[1];
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      react.useEffect(function() {
        var cb = function cb2(event) {
          if (callbackRef.current) {
            callbackRef.current(event);
          }
        };
        if (callbackRef.current && eventName) {
          window.addEventListener(eventName, cb, opts);
        }
        return function() {
          if (eventName) {
            window.removeEventListener(eventName, cb, opts);
          }
        };
      }, [eventName, options2]);
      return setCallbackRef;
    };
    exports.default = useGlobalEvent2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWindowResize.js
var require_useWindowResize = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWindowResize.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useGlobalEvent2 = require_useGlobalEvent();
    var useWindowResize = function useWindowResize2(handler) {
      return useGlobalEvent2.default("resize", null, handler);
    };
    exports.default = useWindowResize;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWindowScroll.js
var require_useWindowScroll = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWindowScroll.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useGlobalEvent2 = require_useGlobalEvent();
    var useWindowScroll = function useWindowScroll2(handler) {
      return useGlobalEvent2.default("scroll", null, handler);
    };
    exports.default = useWindowScroll;
  }
});

// node_modules/lodash.debounce/index.js
var require_lodash = __commonJS({
  "node_modules/lodash.debounce/index.js"(exports, module2) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce3(func, wait, options2) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options2)) {
        leading = !!options2.leading;
        maxing = "maxWait" in options2;
        maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options2 ? !!options2.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = debounce3;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDebouncedFn.js
var require_useDebouncedFn = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDebouncedFn.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _interopDefault(ex) {
      return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
    }
    var react = require("react");
    var debounce3 = _interopDefault(require_lodash());
    var defaultOptions = {
      leading: false,
      trailing: true
    };
    var useDebouncedFn = function useDebouncedFn2(fn) {
      var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var dependencies = arguments.length > 3 ? arguments[3] : void 0;
      var debounced = debounce3(fn, wait, options2);
      return react.useCallback(debounced, dependencies);
    };
    exports.default = useDebouncedFn;
  }
});

// node_modules/lodash.throttle/index.js
var require_lodash2 = __commonJS({
  "node_modules/lodash.throttle/index.js"(exports, module2) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce3(func, wait, options2) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options2)) {
        leading = !!options2.leading;
        maxing = "maxWait" in options2;
        maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options2 ? !!options2.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function throttle(func, wait, options2) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options2)) {
        leading = "leading" in options2 ? !!options2.leading : leading;
        trailing = "trailing" in options2 ? !!options2.trailing : trailing;
      }
      return debounce3(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = throttle;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useThrottledFn.js
var require_useThrottledFn = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useThrottledFn.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _interopDefault(ex) {
      return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
    }
    var react = require("react");
    var throttle = _interopDefault(require_lodash2());
    var defaultOptions = {
      leading: false,
      trailing: true
    };
    var useThrottledFn = function useThrottledFn2(fn) {
      var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var dependencies = arguments.length > 3 ? arguments[3] : void 0;
      var throttled = throttle(fn, wait, options2);
      return react.useCallback(throttled, dependencies);
    };
    exports.default = useThrottledFn;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/createCbSetterErrorProxy.js
var require_createCbSetterErrorProxy = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/createCbSetterErrorProxy.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var createCbSetterErrorProxy = function createCbSetterErrorProxy2(errorMessage) {
      return new Proxy(/* @__PURE__ */ Object.create(null), {
        get: function get(target, property) {
          if (property && typeof property === "string" && property.slice(0, 2) === "on") {
            return function() {
              throw new Error(errorMessage);
            };
          }
          return {
            error: errorMessage
          };
        }
      });
    };
    exports.default = createCbSetterErrorProxy;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/hasOwnProperty.js
var require_hasOwnProperty = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/hasOwnProperty.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var hasOwnProperty2 = function hasOwnProperty3(obj, prop) {
      return obj ? Object.prototype.hasOwnProperty.call(obj, prop) : false;
    };
    exports.default = hasOwnProperty2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouseEvents.js
var require_useMouseEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouseEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var hasOwnProperty2 = require_hasOwnProperty();
    var assignMouseEventOnMount = function assignMouseEventOnMount2(targetRef, handlerRef, eventName) {
      react.useEffect(function() {
        var cb = function cb2(mouseEvent) {
          if (handlerRef.current) {
            handlerRef.current(mouseEvent);
          }
        };
        var target;
        if (targetRef !== null && !!targetRef.current) {
          target = targetRef.current;
        }
        if (targetRef === null) {
          target = document;
        }
        if (target && target.addEventListener) {
          target.addEventListener(eventName, cb);
        }
        return function() {
          if (target && target.removeEventListener) {
            target.removeEventListener(eventName, cb);
          }
        };
      }, []);
    };
    var useMouseEvents = function useMouseEvents2() {
      var targetRef = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onMouseDownHandler = _createHandlerSetter2[0], setOnMouseDown = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onMouseEnterHandler = _createHandlerSetter4[0], setOnMouseEnter = _createHandlerSetter4[1];
      var _createHandlerSetter5 = createHandlerSetter.default(), _createHandlerSetter6 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter5, 2), onMouseLeaveHandler = _createHandlerSetter6[0], setOnMouseLeave = _createHandlerSetter6[1];
      var _createHandlerSetter7 = createHandlerSetter.default(), _createHandlerSetter8 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter7, 2), onMouseMoveHandler = _createHandlerSetter8[0], setOnMouseMove = _createHandlerSetter8[1];
      var _createHandlerSetter9 = createHandlerSetter.default(), _createHandlerSetter10 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter9, 2), onMouseOutHandler = _createHandlerSetter10[0], setOnMouseOut = _createHandlerSetter10[1];
      var _createHandlerSetter11 = createHandlerSetter.default(), _createHandlerSetter12 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter11, 2), onMouseOverHandler = _createHandlerSetter12[0], setOnMouseOver = _createHandlerSetter12[1];
      var _createHandlerSetter13 = createHandlerSetter.default(), _createHandlerSetter14 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter13, 2), onMouseUpHandler = _createHandlerSetter14[0], setOnMouseUp = _createHandlerSetter14[1];
      if (targetRef !== null && !hasOwnProperty2.default(targetRef, "current")) {
        return createCbSetterErrorProxy.default("Unable to assign any mouse event to the given ref");
      }
      assignMouseEventOnMount(targetRef, onMouseDownHandler, "mousedown");
      assignMouseEventOnMount(targetRef, onMouseEnterHandler, "mouseenter");
      assignMouseEventOnMount(targetRef, onMouseLeaveHandler, "mouseleave");
      assignMouseEventOnMount(targetRef, onMouseMoveHandler, "mousemove");
      assignMouseEventOnMount(targetRef, onMouseOutHandler, "mouseout");
      assignMouseEventOnMount(targetRef, onMouseOverHandler, "mouseover");
      assignMouseEventOnMount(targetRef, onMouseUpHandler, "mouseup");
      return Object.freeze({
        onMouseDown: setOnMouseDown,
        onMouseEnter: setOnMouseEnter,
        onMouseLeave: setOnMouseLeave,
        onMouseMove: setOnMouseMove,
        onMouseOut: setOnMouseOut,
        onMouseOver: setOnMouseOver,
        onMouseUp: setOnMouseUp
      });
    };
    exports.default = useMouseEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouseState.js
var require_useMouseState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouseState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useMouseEvents = require_useMouseEvents();
    var createStateObject = function createStateObject2(event) {
      return {
        clientX: event.clientX,
        clientY: event.clientY,
        screenX: event.screenX,
        screenY: event.screenY
      };
    };
    var useMouseState = function useMouseState2() {
      var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var _useState = react.useState({
        clientX: 0,
        clientY: 0,
        screenX: 0,
        screenY: 0
      }), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
      var _useMouseEvents = useMouseEvents.default(ref), onMouseMove = _useMouseEvents.onMouseMove;
      onMouseMove(function(event) {
        var nextState = createStateObject(event);
        setState(nextState);
      });
      return state;
    };
    exports.default = useMouseState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouse.js
var require_useMouse = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouse.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useMouseEvents = require_useMouseEvents();
    var useMouseState = require_useMouseState();
    var useMouse = function useMouse2() {
      var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var state = useMouseState.default(ref);
      var events = useMouseEvents.default(ref);
      return [state, events];
    };
    exports.default = useMouse;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useTimeout.js
var require_useTimeout = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useTimeout.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      cancelOnUnmount: true
    };
    var useTimeout = function useTimeout2(fn, milliseconds) {
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearTimeout(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        if (typeof milliseconds === "number") {
          timeout.current = setTimeout(function() {
            callback.current();
          }, milliseconds);
        }
      }, [milliseconds]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useTimeout;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/usePreviousValue.js
var require_usePreviousValue = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/usePreviousValue.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var usePreviousValue = function usePreviousValue2(value) {
      var prevValue = react.useRef();
      react.useEffect(function() {
        prevValue.current = value;
        return function() {
          prevValue.current = void 0;
        };
      });
      return prevValue.current;
    };
    exports.default = usePreviousValue;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useConditionalTimeout.js
var require_useConditionalTimeout = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useConditionalTimeout.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var usePreviousValue = require_usePreviousValue();
    var defaultOptions = {
      cancelOnUnmount: true,
      cancelOnConditionChange: true
    };
    var useConditionalTimeout = function useConditionalTimeout2(fn, milliseconds, condition) {
      var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var prevCondition = usePreviousValue.default(condition);
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearTimeout(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        if (condition && typeof milliseconds === "number") {
          timeout.current = setTimeout(function() {
            callback.current();
          }, milliseconds);
        }
      }, [condition, milliseconds]);
      react.useEffect(function() {
        if (prevCondition && condition !== prevCondition && opts.cancelOnConditionChange) {
          clear();
        }
      }, [condition, options2]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useConditionalTimeout;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useInterval.js
var require_useInterval = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useInterval.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      cancelOnUnmount: true
    };
    var useInterval2 = function useInterval3(fn, milliseconds) {
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearInterval(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        clear();
        if (typeof milliseconds === "number") {
          timeout.current = setInterval(function() {
            callback.current();
          }, milliseconds);
        }
      }, [milliseconds]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useInterval2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/geolocationStandardOptions.js
var require_geolocationStandardOptions = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/geolocationStandardOptions.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var geoStandardOptions = /* @__PURE__ */ Object.create(null);
    geoStandardOptions.enableHighAccuracy = false;
    geoStandardOptions.timeout = 4294967295;
    geoStandardOptions.maximumAge = 0;
    var geolocationStandardOptions = Object.freeze(geoStandardOptions);
    exports.default = geolocationStandardOptions;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocationEvents.js
var require_useGeolocationEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocationEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = function useGeolocationEvents2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var watchId = react.useRef();
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onChangeRef = _createHandlerSetter2[0], setOnChangeRef = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onErrorRef = _createHandlerSetter4[0], setOnErrorRef = _createHandlerSetter4[1];
      var isSupported = typeof window !== "undefined" && "geolocation" in window.navigator;
      react.useEffect(function() {
        var onSuccess = function onSuccess2(successEvent) {
          if (onChangeRef.current) {
            onChangeRef.current(successEvent);
          }
        };
        var onError = function onError2(err) {
          if (onErrorRef.current) {
            onErrorRef.current(err);
          }
        };
        if (isSupported) {
          watchId.current = window.navigator.geolocation.watchPosition(onSuccess, onError, options2);
        }
        return function() {
          if (isSupported) {
            window.navigator.geolocation.clearWatch(watchId.current);
          }
        };
      }, []);
      return !isSupported ? createCbSetterErrorProxy.default("The Geolocation API is not supported") : Object.freeze({
        isSupported,
        onChange: setOnChangeRef,
        onError: setOnErrorRef
      });
    };
    exports.default = useGeolocationEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/makePositionObject.js
var require_makePositionObject = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/makePositionObject.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var makePositionObj = function makePositionObj2(position2) {
      return !position2 ? null : {
        timestamp: position2.timestamp,
        coords: {
          latitude: position2.coords.latitude,
          longitude: position2.coords.longitude,
          altitude: position2.coords.altitude,
          accuracy: position2.coords.accuracy,
          altitudeAccuracy: position2.coords.altitudeAccuracy,
          heading: position2.coords.heading,
          speed: position2.coords.speed
        }
      };
    };
    exports.default = makePositionObj;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isSamePosition.js
var require_isSamePosition = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isSamePosition.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isSamePosition = function isSamePosition2(current, next2) {
      if (!current || !next2 || !next2.coords)
        return false;
      if (current.timestamp && next2.timestamp && current.timestamp !== next2.timestamp)
        return false;
      return current.coords.latitude === next2.coords.latitude && current.coords.longitude === next2.coords.longitude && current.coords.altitude === next2.coords.altitude && current.coords.accuracy === next2.coords.accuracy && current.coords.altitudeAccuracy === next2.coords.altitudeAccuracy && current.coords.heading === next2.coords.heading && current.coords.speed === next2.coords.speed;
    };
    exports.default = isSamePosition;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocationState.js
var require_useGeolocationState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocationState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = require_useGeolocationEvents();
    var makePositionObject = require_makePositionObject();
    var isSamePosition = require_isSamePosition();
    var useGeolocationState = function useGeolocationState2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var _useState = react.useState(null), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), position2 = _useState2[0], setPosition = _useState2[1];
      var _useState3 = react.useState(false), _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2), isRetrieving = _useState4[0], setRetrieving = _useState4[1];
      var _useGeolocationEvents = useGeolocationEvents.default(options2), isSupported = _useGeolocationEvents.isSupported, onChange = _useGeolocationEvents.onChange;
      var savePosition = react.useCallback(function() {
        if (position2 === null) {
          setRetrieving(true);
          navigator.geolocation.getCurrentPosition(function(nextPosition) {
            if (!isSamePosition.default(position2, nextPosition)) {
              setPosition(makePositionObject.default(nextPosition));
              setRetrieving(false);
            }
          });
        }
      }, [position2]);
      react.useEffect(savePosition, [position2]);
      onChange(savePosition);
      return Object.freeze({
        isSupported,
        isRetrieving,
        position: position2
      });
    };
    exports.default = useGeolocationState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocation.js
var require_useGeolocation = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = require_useGeolocationEvents();
    var useGeolocationState = require_useGeolocationState();
    var useGeolocation = function useGeolocation2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var state = useGeolocationState.default(options2);
      var events = useGeolocationEvents.default(options2);
      return [state, events];
    };
    exports.default = useGeolocation;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isClient.js
var require_isClient = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isClient.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var isClient = (typeof window === "undefined" ? "undefined" : _rollupPluginBabelHelpers.typeof(window)) === "object";
    exports.default = isClient;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isAPISupported.js
var require_isAPISupported = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isAPISupported.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isApiSupported = function isApiSupported2(api) {
      return api in window;
    };
    exports.default = isApiSupported;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMediaQuery.js
var require_useMediaQuery = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMediaQuery.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var errorMessage = "matchMedia is not supported, this could happen both because window.matchMedia is not supported by your current browser or you're using the useMediaQuery hook whilst server side rendering.";
    var useMediaQuery = function useMediaQuery2(mediaQuery) {
      if (!isClient.default || !isAPISupported.default("matchMedia")) {
        console.warn(errorMessage);
        return null;
      }
      var _useState = react.useState(!!window.matchMedia(mediaQuery).matches), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isVerified = _useState2[0], setIsVerified = _useState2[1];
      react.useEffect(function() {
        var mediaQueryList = window.matchMedia(mediaQuery);
        var documentChangeHandler = function documentChangeHandler2() {
          return setIsVerified(!!mediaQueryList.matches);
        };
        mediaQueryList.addListener(documentChangeHandler);
        documentChangeHandler();
        return function() {
          mediaQueryList.removeListener(documentChangeHandler);
        };
      }, [mediaQuery]);
      return isVerified;
    };
    exports.default = useMediaQuery;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useValueHistory.js
var require_useValueHistory = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useValueHistory.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var useValueHistory = function useValueHistory2(value) {
      var history = react.useRef([]);
      react.useEffect(function() {
        history.current.push(value);
      }, [value]);
      return history.current;
    };
    exports.default = useValueHistory;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useOnlineState.js
var require_useOnlineState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useOnlineState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useGlobalEvent2 = require_useGlobalEvent();
    var useOnlineState = function useOnlineState2() {
      var isSupported = typeof window !== "undefined" && "ononline" in window;
      var _useState = react.useState(isSupported ? navigator.onLine : true), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isOnline = _useState2[0], setIsOnline = _useState2[1];
      var whenOnline = useGlobalEvent2.default("online", {
        capture: true
      });
      var whenOffline = useGlobalEvent2.default("offline", {
        capture: true
      });
      if (!isSupported) {
        console.warn("The current device does not support the 'online/offline' events, you should avoid using useOnlineState");
        return isOnline;
      }
      whenOnline(function() {
        setIsOnline(true);
      });
      whenOffline(function() {
        setIsOnline(false);
      });
      return isOnline;
    };
    exports.default = useOnlineState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useViewportSpy.js
var require_useViewportSpy = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useViewportSpy.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      root: void 0,
      rootMargin: "0px",
      threshold: 0
    };
    var useViewportSpy = function useViewportSpy2(elementRef) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var _useState = react.useState(), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isVisible = _useState2[0], setIsVisible = _useState2[1];
      react.useLayoutEffect(function() {
        var observer = new IntersectionObserver(function(entries) {
          return entries.forEach(function(item) {
            var nextValue = item.isIntersecting;
            setIsVisible(nextValue);
          });
        }, options2);
        observer.observe(elementRef.current);
        return function() {
          observer.disconnect(elementRef.current);
        };
      }, [elementRef]);
      return isVisible;
    };
    exports.default = useViewportSpy;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useValidatedState.js
var require_useValidatedState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useValidatedState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useValidatedState = function useValidatedState2(validator, initialValue) {
      var _useState = react.useState(initialValue), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
      var validation = react.useRef({
        changed: false
      });
      var onChange = react.useCallback(function(nextValue) {
        setState(nextValue);
        validation.current = {
          changed: true,
          valid: validator(nextValue)
        };
      }, [validator]);
      return [state, onChange, validation.current];
    };
    exports.default = useValidatedState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDragEvents.js
var require_useDragEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDragEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var hasOwnProperty2 = require_hasOwnProperty();
    var assignDragEventOnMount = function assignDragEventOnMount2(targetRef, handlerRef, eventName) {
      react.useEffect(function() {
        var cb = function cb2(dragEvent) {
          if (handlerRef.current) {
            handlerRef.current(dragEvent);
          }
        };
        if (targetRef.current) {
          targetRef.current.addEventListener(eventName, cb);
        }
        return function() {
          if (targetRef.current) {
            targetRef.current.removeEventListener(eventName, cb);
          }
        };
      }, []);
    };
    var useDragEvents = function useDragEvents2(targetRef) {
      var setDraggable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onDrag = _createHandlerSetter2[0], setOnDrag = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onDrop = _createHandlerSetter4[0], setOnDrop = _createHandlerSetter4[1];
      var _createHandlerSetter5 = createHandlerSetter.default(), _createHandlerSetter6 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter5, 2), onDragEnter = _createHandlerSetter6[0], setOnDragEnter = _createHandlerSetter6[1];
      var _createHandlerSetter7 = createHandlerSetter.default(), _createHandlerSetter8 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter7, 2), onDragEnd = _createHandlerSetter8[0], setOnDragEnd = _createHandlerSetter8[1];
      var _createHandlerSetter9 = createHandlerSetter.default(), _createHandlerSetter10 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter9, 2), onDragExit = _createHandlerSetter10[0], setOnDragExit = _createHandlerSetter10[1];
      var _createHandlerSetter11 = createHandlerSetter.default(), _createHandlerSetter12 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter11, 2), onDragLeave = _createHandlerSetter12[0], setOnDragLeave = _createHandlerSetter12[1];
      var _createHandlerSetter13 = createHandlerSetter.default(), _createHandlerSetter14 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter13, 2), onDragOver = _createHandlerSetter14[0], setOnDragOver = _createHandlerSetter14[1];
      var _createHandlerSetter15 = createHandlerSetter.default(), _createHandlerSetter16 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter15, 2), onDragStart = _createHandlerSetter16[0], setOnDragStart = _createHandlerSetter16[1];
      if (targetRef !== null && !hasOwnProperty2.default(targetRef, "current")) {
        return createCbSetterErrorProxy.default("Unable to assign any drag event to the given ref");
      }
      react.useEffect(function() {
        if (setDraggable && targetRef.current && !targetRef.current.hasAttribute("draggable")) {
          targetRef.current.setAttribute("draggable", true);
        }
      }, []);
      assignDragEventOnMount(targetRef, onDrag, "drag");
      assignDragEventOnMount(targetRef, onDrop, "drop");
      assignDragEventOnMount(targetRef, onDragEnter, "dragenter");
      assignDragEventOnMount(targetRef, onDragEnd, "dragend");
      assignDragEventOnMount(targetRef, onDragExit, "dragexit");
      assignDragEventOnMount(targetRef, onDragLeave, "dragleave");
      assignDragEventOnMount(targetRef, onDragOver, "dragover");
      assignDragEventOnMount(targetRef, onDragStart, "dragstart");
      return Object.freeze({
        onDrag: setOnDrag,
        onDrop: setOnDrop,
        onDragEnter: setOnDragEnter,
        onDragEnd: setOnDragEnd,
        onDragExit: setOnDragExit,
        onDragLeave: setOnDragLeave,
        onDragOver: setOnDragOver,
        onDragStart: setOnDragStart
      });
    };
    exports.default = useDragEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDrag.js
var require_useDrag = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDrag.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useDragEvents = require_useDragEvents();
    var defaultOptions = {
      dragImage: null,
      dragImageXOffset: 0,
      dragImageYOffset: 0,
      transfer: null,
      transferFormat: "text"
    };
    var useDrag = function useDrag2(targetRef) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var _useDragEvents = useDragEvents.default(targetRef, true), onDragStart = _useDragEvents.onDragStart, onDragEnd = _useDragEvents.onDragEnd;
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isDragging = _useState2[0], setIsDragging = _useState2[1];
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      onDragStart(function(event) {
        setIsDragging(true);
        if (opts.dragImage) {
          var img = new Image();
          img.src = opts.dragImage;
          event.dataTransfer.setDragImage(img, opts.dragImageXOffset, opts.dragImageYOffset);
        }
        if (opts.transfer) {
          var data = _rollupPluginBabelHelpers.typeof(opts.transfer) === "object" ? JSON.stringify(opts.transfer) : "".concat(opts.transfer);
          event.dataTransfer.setData(opts.transferFormat, data);
        }
      });
      onDragEnd(function() {
        return setIsDragging(false);
      });
      return isDragging;
    };
    exports.default = useDrag;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDropZone.js
var require_useDropZone = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDropZone.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useDragEvents = require_useDragEvents();
    var useDropZone = function useDropZone2(targetRef) {
      var _useDragEvents = useDragEvents.default(targetRef, false), onDrop = _useDragEvents.onDrop, onDragOver = _useDragEvents.onDragOver, onDragLeave = _useDragEvents.onDragLeave;
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isOver = _useState2[0], setIsOver = _useState2[1];
      onDragOver(function(event) {
        event.preventDefault();
        setIsOver(true);
      });
      onDragLeave(function() {
        setIsOver(false);
      });
      return {
        isOver,
        onDrop
      };
    };
    exports.default = useDropZone;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useRequestAnimationFrame.js
var require_useRequestAnimationFrame = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useRequestAnimationFrame.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var defaultOptions = {
      increment: 1,
      startAt: 0,
      finishAt: 100
    };
    var errorMessage = "requestAnimationFrame is not supported, this could happen both because window.requestAnimationFrame is not supported by your current browser version or you're using the useRequestAnimationFrame hook whilst server side rendering.";
    var useRequestAnimationFrame = function useRequestAnimationFrame2(func) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      if (!isClient.default || !isAPISupported.default("requestAnimationFrame")) {
        console.warn(errorMessage);
        return createCbSetterErrorProxy.default(errorMessage);
      }
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2);
      var progress = react.useRef(opts.startAt);
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onFinish = _createHandlerSetter2[0], setOnFinish = _createHandlerSetter2[1];
      var next2 = function next3() {
        return window.requestAnimationFrame(step);
      };
      var step = react.useCallback(function() {
        if (progress.current <= opts.finishAt || opts.finishAt === -1) {
          func(progress.current, next2);
          progress.current += opts.increment;
        } else if (onFinish.current) {
          onFinish.current();
        }
      }, [func, opts.finishAt, opts.increment, progress.current, onFinish.current]);
      if (progress.current <= opts.startAt) {
        next2();
      }
      return setOnFinish;
    };
    exports.default = useRequestAnimationFrame;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/safelyParseJson.js
var require_safelyParseJson = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/safelyParseJson.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var safelyParseJson = function safelyParseJson2(parseString) {
      try {
        return JSON.parse(parseString);
      } catch (e) {
        return null;
      }
    };
    exports.default = safelyParseJson;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useLocalStorage.js
var require_useLocalStorage = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useLocalStorage.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var safelyParseJson = require_safelyParseJson();
    var errorMessageSSR = "localStorage is not supported, this could happen because you're using the useLocalStorage hook whilst server side rendering.";
    var errorMessageIsNotSupported = "localStorage is not supported, this could happen because window.localStorage is not supported by your current browser";
    var useLocalStorage = function useLocalStorage2(localStorageKey, defaultValue) {
      if (!isClient.default) {
        console.warn(errorMessageSSR);
        return [JSON.stringify(defaultValue), function() {
          return void 0;
        }];
      }
      if (!isAPISupported.default("localStorage")) {
        console.warn(errorMessageIsNotSupported);
        return [JSON.stringify(defaultValue), function() {
          return void 0;
        }];
      }
      var _useState = react.useState(safelyParseJson.default(window.localStorage.getItem(localStorageKey) || JSON.stringify(defaultValue))), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), value = _useState2[0], setValue = _useState2[1];
      react.useEffect(function() {
        window.localStorage.setItem(localStorageKey, JSON.stringify(value));
      }, [localStorageKey, value]);
      return [value, setValue];
    };
    exports.default = useLocalStorage;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useStorage.js
var require_useStorage = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useStorage.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var safelyParseJson = require_safelyParseJson();
    var useStorage = function useStorage2(type) {
      return function(initialValue) {
        var _useState = react.useState(initialValue), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), store = _useState2[0], setStore = _useState2[1];
        var storageType = type;
        if (storageType !== "local" && storageType !== "session") {
          storageType = "local";
        }
        storageType += "Storage";
        var get = function get2(key2) {
          return safelyParseJson.default(isClient.default ? window[storageType].getItem(key2) : store[key2]);
        };
        var set = function set2(key2, value) {
          var valueToStore = value instanceof Function ? value(safelyParseJson.default(store[key2])) : value;
          if (isClient.default) {
            window[storageType].setItem(key2, JSON.stringify(valueToStore));
          }
          return setStore(function(x) {
            return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, x), {}, _rollupPluginBabelHelpers.defineProperty({}, key2, valueToStore));
          });
        };
        react.useEffect(function() {
          if (isClient.default) {
            Object.keys(store).map(function(k) {
              return window[storageType].setItem(k, JSON.stringify(store[k]));
            });
          }
        }, [store]);
        var storage = store;
        if (isClient.default) {
          storage = window[storageType];
        }
        return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, storage), {}, {
          get,
          set
        });
      };
    };
    exports.default = useStorage;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/index.js
var require_cjs = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useDidMount = require_useDidMount();
    var useWillUnmount = require_useWillUnmount();
    var useLifecycle = require_useLifecycle();
    var useGlobalEvent2 = require_useGlobalEvent();
    var useWindowResize = require_useWindowResize();
    var useWindowScroll = require_useWindowScroll();
    var useDebouncedFn = require_useDebouncedFn();
    var useThrottledFn = require_useThrottledFn();
    var useMouseEvents = require_useMouseEvents();
    var useMouseState = require_useMouseState();
    var useMouse = require_useMouse();
    var useTimeout = require_useTimeout();
    var usePreviousValue = require_usePreviousValue();
    var useConditionalTimeout = require_useConditionalTimeout();
    var useInterval2 = require_useInterval();
    var useGeolocationEvents = require_useGeolocationEvents();
    var useGeolocationState = require_useGeolocationState();
    var useGeolocation = require_useGeolocation();
    var useMediaQuery = require_useMediaQuery();
    var useValueHistory = require_useValueHistory();
    var useOnlineState = require_useOnlineState();
    var useViewportSpy = require_useViewportSpy();
    var useValidatedState = require_useValidatedState();
    var useDragEvents = require_useDragEvents();
    var useDrag = require_useDrag();
    var useDropZone = require_useDropZone();
    var useRequestAnimationFrame = require_useRequestAnimationFrame();
    var useLocalStorage = require_useLocalStorage();
    var useStorage = require_useStorage();
    exports.useDidMount = useDidMount.default;
    exports.useWillUnmount = useWillUnmount.default;
    exports.useLifecycle = useLifecycle.default;
    exports.useGlobalEvent = useGlobalEvent2.default;
    exports.useWindowResize = useWindowResize.default;
    exports.useWindowScroll = useWindowScroll.default;
    exports.useDebouncedFn = useDebouncedFn.default;
    exports.useThrottledFn = useThrottledFn.default;
    exports.useMouseEvents = useMouseEvents.default;
    exports.useMouseState = useMouseState.default;
    exports.useMouse = useMouse.default;
    exports.useTimeout = useTimeout.default;
    exports.usePreviousValue = usePreviousValue.default;
    exports.useConditionalTimeout = useConditionalTimeout.default;
    exports.useInterval = useInterval2.default;
    exports.useGeolocationEvents = useGeolocationEvents.default;
    exports.useGeolocationState = useGeolocationState.default;
    exports.useGeolocation = useGeolocation.default;
    exports.useMediaQuery = useMediaQuery.default;
    exports.useValueHistory = useValueHistory.default;
    exports.useOnlineState = useOnlineState.default;
    exports.useViewportSpy = useViewportSpy.default;
    exports.useValidatedState = useValidatedState.default;
    exports.useDragEvents = useDragEvents.default;
    exports.useDrag = useDrag.default;
    exports.useDropZone = useDropZone.default;
    exports.useRequestAnimationFrame = useRequestAnimationFrame.default;
    exports.useLocalStorage = useLocalStorage.default;
    exports.useStorage = useStorage.default;
  }
});

// node_modules/resize-observer-polyfill/dist/ResizeObserver.js
var require_ResizeObserver = __commonJS({
  "node_modules/resize-observer-polyfill/dist/ResizeObserver.js"(exports, module2) {
    (function(global2, factory) {
      typeof exports === "object" && typeof module2 !== "undefined" ? module2.exports = factory() : typeof define === "function" && define.amd ? define(factory) : global2.ResizeObserver = factory();
    })(exports, function() {
      "use strict";
      var MapShim = function() {
        if (typeof Map !== "undefined") {
          return Map;
        }
        function getIndex(arr, key2) {
          var result = -1;
          arr.some(function(entry, index2) {
            if (entry[0] === key2) {
              result = index2;
              return true;
            }
            return false;
          });
          return result;
        }
        return (
          /** @class */
          function() {
            function class_1() {
              this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
              /**
               * @returns {boolean}
               */
              get: function() {
                return this.__entries__.length;
              },
              enumerable: true,
              configurable: true
            });
            class_1.prototype.get = function(key2) {
              var index2 = getIndex(this.__entries__, key2);
              var entry = this.__entries__[index2];
              return entry && entry[1];
            };
            class_1.prototype.set = function(key2, value) {
              var index2 = getIndex(this.__entries__, key2);
              if (~index2) {
                this.__entries__[index2][1] = value;
              } else {
                this.__entries__.push([key2, value]);
              }
            };
            class_1.prototype.delete = function(key2) {
              var entries = this.__entries__;
              var index2 = getIndex(entries, key2);
              if (~index2) {
                entries.splice(index2, 1);
              }
            };
            class_1.prototype.has = function(key2) {
              return !!~getIndex(this.__entries__, key2);
            };
            class_1.prototype.clear = function() {
              this.__entries__.splice(0);
            };
            class_1.prototype.forEach = function(callback, ctx) {
              if (ctx === void 0) {
                ctx = null;
              }
              for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
              }
            };
            return class_1;
          }()
        );
      }();
      var isBrowser3 = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
      var global$1 = function() {
        if (typeof global !== "undefined" && global.Math === Math) {
          return global;
        }
        if (typeof self !== "undefined" && self.Math === Math) {
          return self;
        }
        if (typeof window !== "undefined" && window.Math === Math) {
          return window;
        }
        return Function("return this")();
      }();
      var requestAnimationFrame$1 = function() {
        if (typeof requestAnimationFrame === "function") {
          return requestAnimationFrame.bind(global$1);
        }
        return function(callback) {
          return setTimeout(function() {
            return callback(Date.now());
          }, 1e3 / 60);
        };
      }();
      var trailingTimeout = 2;
      function throttle(callback, delay) {
        var leadingCall = false, trailingCall = false, lastCallTime = 0;
        function resolvePending() {
          if (leadingCall) {
            leadingCall = false;
            callback();
          }
          if (trailingCall) {
            proxy();
          }
        }
        function timeoutCallback() {
          requestAnimationFrame$1(resolvePending);
        }
        function proxy() {
          var timeStamp = Date.now();
          if (leadingCall) {
            if (timeStamp - lastCallTime < trailingTimeout) {
              return;
            }
            trailingCall = true;
          } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
          }
          lastCallTime = timeStamp;
        }
        return proxy;
      }
      var REFRESH_DELAY = 20;
      var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
      var mutationObserverSupported = typeof MutationObserver !== "undefined";
      var ResizeObserverController = (
        /** @class */
        function() {
          function ResizeObserverController2() {
            this.connected_ = false;
            this.mutationEventsAdded_ = false;
            this.mutationsObserver_ = null;
            this.observers_ = [];
            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
          }
          ResizeObserverController2.prototype.addObserver = function(observer) {
            if (!~this.observers_.indexOf(observer)) {
              this.observers_.push(observer);
            }
            if (!this.connected_) {
              this.connect_();
            }
          };
          ResizeObserverController2.prototype.removeObserver = function(observer) {
            var observers2 = this.observers_;
            var index2 = observers2.indexOf(observer);
            if (~index2) {
              observers2.splice(index2, 1);
            }
            if (!observers2.length && this.connected_) {
              this.disconnect_();
            }
          };
          ResizeObserverController2.prototype.refresh = function() {
            var changesDetected = this.updateObservers_();
            if (changesDetected) {
              this.refresh();
            }
          };
          ResizeObserverController2.prototype.updateObservers_ = function() {
            var activeObservers = this.observers_.filter(function(observer) {
              return observer.gatherActive(), observer.hasActive();
            });
            activeObservers.forEach(function(observer) {
              return observer.broadcastActive();
            });
            return activeObservers.length > 0;
          };
          ResizeObserverController2.prototype.connect_ = function() {
            if (!isBrowser3 || this.connected_) {
              return;
            }
            document.addEventListener("transitionend", this.onTransitionEnd_);
            window.addEventListener("resize", this.refresh);
            if (mutationObserverSupported) {
              this.mutationsObserver_ = new MutationObserver(this.refresh);
              this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
              });
            } else {
              document.addEventListener("DOMSubtreeModified", this.refresh);
              this.mutationEventsAdded_ = true;
            }
            this.connected_ = true;
          };
          ResizeObserverController2.prototype.disconnect_ = function() {
            if (!isBrowser3 || !this.connected_) {
              return;
            }
            document.removeEventListener("transitionend", this.onTransitionEnd_);
            window.removeEventListener("resize", this.refresh);
            if (this.mutationsObserver_) {
              this.mutationsObserver_.disconnect();
            }
            if (this.mutationEventsAdded_) {
              document.removeEventListener("DOMSubtreeModified", this.refresh);
            }
            this.mutationsObserver_ = null;
            this.mutationEventsAdded_ = false;
            this.connected_ = false;
          };
          ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
            var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
            var isReflowProperty = transitionKeys.some(function(key2) {
              return !!~propertyName.indexOf(key2);
            });
            if (isReflowProperty) {
              this.refresh();
            }
          };
          ResizeObserverController2.getInstance = function() {
            if (!this.instance_) {
              this.instance_ = new ResizeObserverController2();
            }
            return this.instance_;
          };
          ResizeObserverController2.instance_ = null;
          return ResizeObserverController2;
        }()
      );
      var defineConfigurable = function(target, props) {
        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
          var key2 = _a[_i];
          Object.defineProperty(target, key2, {
            value: props[key2],
            enumerable: false,
            writable: false,
            configurable: true
          });
        }
        return target;
      };
      var getWindowOf = function(target) {
        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
        return ownerGlobal || global$1;
      };
      var emptyRect = createRectInit(0, 0, 0, 0);
      function toFloat(value) {
        return parseFloat(value) || 0;
      }
      function getBordersSize(styles) {
        var positions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          positions[_i - 1] = arguments[_i];
        }
        return positions.reduce(function(size, position2) {
          var value = styles["border-" + position2 + "-width"];
          return size + toFloat(value);
        }, 0);
      }
      function getPaddings(styles) {
        var positions = ["top", "right", "bottom", "left"];
        var paddings = {};
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
          var position2 = positions_1[_i];
          var value = styles["padding-" + position2];
          paddings[position2] = toFloat(value);
        }
        return paddings;
      }
      function getSVGContentRect(target) {
        var bbox = target.getBBox();
        return createRectInit(0, 0, bbox.width, bbox.height);
      }
      function getHTMLElementContentRect(target) {
        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
        if (!clientWidth && !clientHeight) {
          return emptyRect;
        }
        var styles = getWindowOf(target).getComputedStyle(target);
        var paddings = getPaddings(styles);
        var horizPad = paddings.left + paddings.right;
        var vertPad = paddings.top + paddings.bottom;
        var width = toFloat(styles.width), height = toFloat(styles.height);
        if (styles.boxSizing === "border-box") {
          if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, "left", "right") + horizPad;
          }
          if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, "top", "bottom") + vertPad;
          }
        }
        if (!isDocumentElement(target)) {
          var vertScrollbar = Math.round(width + horizPad) - clientWidth;
          var horizScrollbar = Math.round(height + vertPad) - clientHeight;
          if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
          }
          if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
          }
        }
        return createRectInit(paddings.left, paddings.top, width, height);
      }
      var isSVGGraphicsElement = function() {
        if (typeof SVGGraphicsElement !== "undefined") {
          return function(target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
          };
        }
        return function(target) {
          return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
        };
      }();
      function isDocumentElement(target) {
        return target === getWindowOf(target).document.documentElement;
      }
      function getContentRect(target) {
        if (!isBrowser3) {
          return emptyRect;
        }
        if (isSVGGraphicsElement(target)) {
          return getSVGContentRect(target);
        }
        return getHTMLElementContentRect(target);
      }
      function createReadOnlyRect(_a) {
        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
        var rect = Object.create(Constr.prototype);
        defineConfigurable(rect, {
          x,
          y,
          width,
          height,
          top: y,
          right: x + width,
          bottom: height + y,
          left: x
        });
        return rect;
      }
      function createRectInit(x, y, width, height) {
        return { x, y, width, height };
      }
      var ResizeObservation = (
        /** @class */
        function() {
          function ResizeObservation2(target) {
            this.broadcastWidth = 0;
            this.broadcastHeight = 0;
            this.contentRect_ = createRectInit(0, 0, 0, 0);
            this.target = target;
          }
          ResizeObservation2.prototype.isActive = function() {
            var rect = getContentRect(this.target);
            this.contentRect_ = rect;
            return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
          };
          ResizeObservation2.prototype.broadcastRect = function() {
            var rect = this.contentRect_;
            this.broadcastWidth = rect.width;
            this.broadcastHeight = rect.height;
            return rect;
          };
          return ResizeObservation2;
        }()
      );
      var ResizeObserverEntry = (
        /** @class */
        function() {
          function ResizeObserverEntry2(target, rectInit) {
            var contentRect = createReadOnlyRect(rectInit);
            defineConfigurable(this, { target, contentRect });
          }
          return ResizeObserverEntry2;
        }()
      );
      var ResizeObserverSPI = (
        /** @class */
        function() {
          function ResizeObserverSPI2(callback, controller, callbackCtx) {
            this.activeObservations_ = [];
            this.observations_ = new MapShim();
            if (typeof callback !== "function") {
              throw new TypeError("The callback provided as parameter 1 is not a function.");
            }
            this.callback_ = callback;
            this.controller_ = controller;
            this.callbackCtx_ = callbackCtx;
          }
          ResizeObserverSPI2.prototype.observe = function(target) {
            if (!arguments.length) {
              throw new TypeError("1 argument required, but only 0 present.");
            }
            if (typeof Element === "undefined" || !(Element instanceof Object)) {
              return;
            }
            if (!(target instanceof getWindowOf(target).Element)) {
              throw new TypeError('parameter 1 is not of type "Element".');
            }
            var observations = this.observations_;
            if (observations.has(target)) {
              return;
            }
            observations.set(target, new ResizeObservation(target));
            this.controller_.addObserver(this);
            this.controller_.refresh();
          };
          ResizeObserverSPI2.prototype.unobserve = function(target) {
            if (!arguments.length) {
              throw new TypeError("1 argument required, but only 0 present.");
            }
            if (typeof Element === "undefined" || !(Element instanceof Object)) {
              return;
            }
            if (!(target instanceof getWindowOf(target).Element)) {
              throw new TypeError('parameter 1 is not of type "Element".');
            }
            var observations = this.observations_;
            if (!observations.has(target)) {
              return;
            }
            observations.delete(target);
            if (!observations.size) {
              this.controller_.removeObserver(this);
            }
          };
          ResizeObserverSPI2.prototype.disconnect = function() {
            this.clearActive();
            this.observations_.clear();
            this.controller_.removeObserver(this);
          };
          ResizeObserverSPI2.prototype.gatherActive = function() {
            var _this = this;
            this.clearActive();
            this.observations_.forEach(function(observation) {
              if (observation.isActive()) {
                _this.activeObservations_.push(observation);
              }
            });
          };
          ResizeObserverSPI2.prototype.broadcastActive = function() {
            if (!this.hasActive()) {
              return;
            }
            var ctx = this.callbackCtx_;
            var entries = this.activeObservations_.map(function(observation) {
              return new ResizeObserverEntry(observation.target, observation.broadcastRect());
            });
            this.callback_.call(ctx, entries, ctx);
            this.clearActive();
          };
          ResizeObserverSPI2.prototype.clearActive = function() {
            this.activeObservations_.splice(0);
          };
          ResizeObserverSPI2.prototype.hasActive = function() {
            return this.activeObservations_.length > 0;
          };
          return ResizeObserverSPI2;
        }()
      );
      var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
      var ResizeObserver2 = (
        /** @class */
        function() {
          function ResizeObserver3(callback) {
            if (!(this instanceof ResizeObserver3)) {
              throw new TypeError("Cannot call a class as a function.");
            }
            if (!arguments.length) {
              throw new TypeError("1 argument required, but only 0 present.");
            }
            var controller = ResizeObserverController.getInstance();
            var observer = new ResizeObserverSPI(callback, controller, this);
            observers.set(this, observer);
          }
          return ResizeObserver3;
        }()
      );
      [
        "observe",
        "unobserve",
        "disconnect"
      ].forEach(function(method) {
        ResizeObserver2.prototype[method] = function() {
          var _a;
          return (_a = observers.get(this))[method].apply(_a, arguments);
        };
      });
      var index = function() {
        if (typeof global$1.ResizeObserver !== "undefined") {
          return global$1.ResizeObserver;
        }
        return ResizeObserver2;
      }();
      return index;
    });
  }
});

// node_modules/use-measure/use-measure.js
var require_use_measure = __commonJS({
  "node_modules/use-measure/use-measure.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = useMeasure2;
    var _react = require("react");
    var _resizeObserverPolyfill = _interopRequireDefault(require_ResizeObserver());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    function _iterableToArrayLimit(arr, i) {
      if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
        return;
      }
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i)
            break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null)
            _i["return"]();
        } finally {
          if (_d)
            throw _e;
        }
      }
      return _arr;
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr))
        return arr;
    }
    function useMeasure2(ref) {
      var _useState = (0, _react.useState)(
        // DOMRectReadOnly.fromRect()
        {
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      ), _useState2 = _slicedToArray(_useState, 2), bounds = _useState2[0], setContentRect = _useState2[1];
      (0, _react.useLayoutEffect)(function() {
        if (ref.current === null) {
          return;
        }
        var animationFrameId = null;
        var measure = function measure2(_ref) {
          var _ref2 = _slicedToArray(_ref, 1), entry = _ref2[0];
          animationFrameId = window.requestAnimationFrame(function() {
            setContentRect(entry.contentRect);
          });
        };
        var ro = new _resizeObserverPolyfill.default(measure);
        ro.observe(ref.current);
        return function() {
          window.cancelAnimationFrame(animationFrameId);
          ro.disconnect();
        };
      }, []);
      return bounds;
    }
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Accordion: () => Accordion,
  ActionsPanel: () => ActionsPanel,
  AddNewWorkspaceButton: () => AddNewWorkspaceButton,
  AddSocialBlock: () => AddSocialBlock,
  Anchor: () => Anchor,
  AnimatedDiv: () => AnimatedDiv,
  BaseButton: () => BaseButton,
  BaseModal: () => BaseModal,
  BlockButton: () => BlockButton,
  BlockElementStyle: () => BlockElementStyle,
  Bubble: () => Bubble,
  Button: () => Button,
  ButtonSize: () => ButtonSize,
  ButtonVariant: () => ButtonVariant,
  CONSENT_SETTING_KEY: () => CONSENT_SETTING_KEY,
  Carousel: () => Carousel,
  CarouselGroupedNavigator: () => CarouselGroupedNavigator,
  CarouselIndicators: () => CarouselIndicators,
  CarouselItem: () => CarouselItem,
  CarouselNavigatorContainer: () => CarouselNavigatorContainer,
  CarouselNavigatorIcon: () => CarouselNavigatorIcon,
  CheckMark: () => CheckMark,
  Checkbox: () => Checkbox,
  CloseButton: () => CloseButton,
  Container: () => Container,
  CookieDialog: () => CookieDialog,
  CookieDialogConsent: () => CookieDialogConsent,
  DEFAULT_FONT_FAMILY: () => DEFAULT_FONT_FAMILY,
  Dropdown: () => Dropdown,
  DropdownAlignment: () => DropdownAlignment,
  DropdownContainer: () => DropdownContainer,
  DynamicAccordion: () => DynamicAccordion,
  DynamicAccordionTheme: () => DynamicAccordionTheme,
  DynamicPanel: () => DynamicPanel,
  DynamicPanelGroup: () => DynamicPanelGroup,
  DynamicPanelType: () => DynamicPanelType,
  Element: () => Element2,
  EmbedTile: () => EmbedTile,
  EmbedTileAnchor: () => EmbedTileAnchor,
  EmbedTileIconImage: () => EmbedTileIconImage,
  EmbedTileLinkContent: () => EmbedTileLinkContent,
  EmbedTileMediaContent: () => EmbedTileMediaContent,
  EmbedTileMediaTile: () => EmbedTileMediaTile,
  EmbedTileProfilePanel: () => EmbedTileProfilePanel,
  EmbedTileReactionPanel: () => EmbedTileReactionPanel,
  EmbedTileTextContent: () => EmbedTileTextContent,
  EmbedTileType: () => EmbedTileType5,
  EmbedType: () => EmbedType,
  EmojiPicker: () => EmojiPicker,
  EmojiSelector: () => EmojiSelector,
  FormatButton: () => FormatButton,
  GoogleConsentType: () => GoogleConsentType,
  GridLayout: () => GridLayout,
  GridLayoutTile: () => GridLayoutTile,
  GroupContainer: () => GroupContainer,
  HideAnimation: () => HideAnimation,
  Image: () => Image3,
  IndicatorSpan: () => IndicatorSpan,
  Input: () => Input,
  InputType: () => InputType,
  Leaf: () => Leaf,
  LoadingProgress: () => LoadingProgress,
  LogoHeader: () => LogoHeader,
  MainNavigation: () => MainNavigation,
  ManageCookieModal: () => ManageCookieModal,
  ManualUploadButton: () => ManualUploadButton,
  MarkButton: () => MarkButton,
  MaskedImage: () => MaskedImage,
  MeatballMenu: () => MeatballMenu,
  MeatballMenuContainer: () => MeatballMenuContainer,
  MeatballMenuItem: () => MeatballMenuItem,
  MeatballMenuItemTheme: () => MeatballMenuItemTheme,
  MediaType: () => MediaType,
  MegaMenu: () => MegaMenu,
  MegaMenuPanel: () => MegaMenuPanel,
  Modal: () => Modal,
  ModalContainer: () => ModalContainer,
  MultiValue: () => import_react_select2.MultiValue,
  NavContainer: () => NavContainer,
  NavGroup: () => NavGroup,
  NavItem: () => NavItem,
  NavItemLabel: () => NavItemLabel,
  NavProfileDropdown: () => NavProfileDropdown,
  NavProfileDropdownItem: () => NavProfileDropdownItem,
  NavProfileDropdownItems: () => NavProfileDropdownItems,
  NavProfileIcon: () => NavProfileIcon,
  NavProfileIconVariant: () => NavProfileIconVariant,
  NavigatorIcon: () => NavigatorIcon,
  OnboardingPanel: () => OnboardingPanel,
  OnboardingPanelTheme: () => OnboardingPanelTheme,
  Panel: () => Panel,
  PanelContext: () => PanelContext_default,
  PanelGroup: () => PanelGroup,
  Ping: () => Ping,
  PreloadType: () => PreloadType,
  ProfilePanel: () => ProfilePanel,
  PromotionCard: () => PromotionCard,
  PromotionCardImageShape: () => PromotionCardImageShape,
  PromotionCardListType: () => PromotionCardListType,
  PublishableEmbed: () => PublishableEmbed,
  PublishableType: () => PublishableType,
  Questionnaire: () => Questionnaire,
  ReactionButton: () => ReactionButton,
  ReactionType: () => ReactionType2,
  RecorderState: () => RecorderState_default,
  RepliesPanel: () => RepliesPanel,
  ReplyInput: () => ReplyInput,
  ReplyInputType: () => ReplyInputType,
  ReplyPanel: () => ReplyPanel,
  ReplyPanelType: () => ReplyPanelType,
  ReplyType: () => ReplyType_default,
  RichTextEditor: () => RichTextEditor,
  RichTextViewer: () => RichTextViewer,
  Select: () => Select,
  SentWithBonjoroBadge: () => SentWithBonjoroBadge,
  SentWithBonjoroBadgeIconPosition: () => SentWithBonjoroBadgeIconPosition,
  SentWithBonjoroBadgeOpacity: () => SentWithBonjoroBadgeOpacity,
  SentWithBonjoroBadgeRounded: () => SentWithBonjoroBadgeRounded,
  SentWithBonjoroBadgeSize: () => SentWithBonjoroBadgeSize,
  SentWithBonjoroBadgeStyle: () => SentWithBonjoroBadgeStyle,
  SentWithBonjoroBadgeTheme: () => SentWithBonjoroBadgeTheme,
  ShowAnimation: () => ShowAnimation,
  ShowTrigger: () => ShowTrigger,
  SingleValue: () => import_react_select2.SingleValue,
  SlateVersionType: () => SlateVersionType,
  Slider: () => Slider,
  SliderBreakpoint: () => SliderBreakpoint,
  SocialType: () => SocialType,
  Switch: () => Switch,
  SwitchTheme: () => SwitchTheme,
  Tab: () => Tab,
  TabTheme: () => TabTheme,
  Tabs: () => Tabs,
  TextAlignType: () => TextAlignType,
  TextArea: () => TextArea,
  TextStyle: () => TextStyle,
  ThumbnailPicker: () => ThumbnailPicker,
  ThumbnailType: () => ThumbnailType,
  Tile: () => Tile,
  TileChild: () => TileChild,
  TileType: () => TileType,
  TimeFormat: () => TimeFormat,
  ToggleSelector: () => ToggleSelector,
  ToggleSelectorShape: () => ToggleSelectorShape,
  Toolbar: () => Toolbar,
  Tooltip: () => Tooltip,
  Transcript: () => Transcript,
  TranscriptMode: () => TranscriptMode,
  VideoMessage: () => VideoMessage,
  VideoPlayer: () => VideoPlayerContainer,
  VideoRecorder: () => VideoRecorderWrapper,
  VideoTextAssetTile: () => VideoTextAssetTile,
  WallOfLove: () => WallOfLove,
  Widget: () => Widget,
  WidgetBubble: () => WidgetBubble,
  WidgetPopup: () => WidgetPopup,
  WidgetPreview: () => WidgetPreview,
  WorkspaceDropdownHeader: () => WorkspaceDropdownHeader,
  WorkspaceDropdownItem: () => WorkspaceDropdownItem,
  WorkspaceDropdownItems: () => WorkspaceDropdownItems,
  WorkspaceSelector: () => WorkspaceSelector,
  clearBlockFormatting: () => clearBlockFormatting,
  clearFormatting: () => clearFormatting,
  clearMarkFormatting: () => clearMarkFormatting,
  computeTextColor: () => computeTextColor,
  computeWallOfLoveColumnTiles: () => computeWallOfLoveColumnTiles,
  computeWallOfLoveColumnTilesEventName: () => computeWallOfLoveColumnTilesEventName,
  defaultEmptyRichTextValue: () => defaultEmptyRichTextValue,
  defaultTwitterUrl: () => defaultTwitterUrl,
  embedTileDetails: () => embedTileDetails,
  fadeTransitionDuration: () => fadeTransitionDuration,
  genericTileHoverEffectClassName: () => genericTileHoverEffectClassName,
  getPlasmicComponents: () => getPlasmicComponents3,
  getRichTextFromSlateData: () => getRichTextFromSlateData,
  gtagFn: () => gtagFn,
  hotkeys: () => hotkeys,
  implementedConsent: () => implementedConsent,
  isBlockActive: () => isBlockActive,
  isBonjoroResponseEmbed: () => isBonjoroResponseEmbed,
  isColorLight: () => isColorLight,
  isLinkedinEmbed: () => isLinkedinEmbed,
  isMarkActive: () => isMarkActive,
  isRef: () => isRef,
  isTwitterEmbed: () => isTwitterEmbed,
  listStyles: () => listStyles,
  loadEmbedVideos: () => loadEmbedVideos,
  mapToConsentObject: () => mapToConsentObject,
  mapTwitterProps: () => mapTwitterProps,
  parseControlsToEmbedTileProps: () => parseControlsToEmbedTileProps,
  parseRichTextToSlateData: () => parseRichTextToSlateData,
  parseRichTextToString: () => parseRichTextToString,
  parseStringToRichText: () => parseStringToRichText,
  parseStyleToEmbedTileProps: () => parseStyleToEmbedTileProps,
  parseUtcDate: () => parseUtcDate,
  questionnaireToolbarClassName: () => questionnaireToolbarClassName,
  setConsent: () => setConsent,
  setCookie: () => setCookie,
  theme: () => theme,
  toCompactNumber: () => toCompactNumber,
  toggleBlock: () => toggleBlock,
  toggleMark: () => toggleMark,
  useCarousel: () => useCarousel,
  useDate: () => useDate,
  useDelayedState: () => useDelayedState,
  useDetectOutsideClick: () => useDetectOutsideClick,
  useEditor: () => useEditor,
  useEventListener: () => useEventListener,
  useGenerateInterpolatedThumbnails: () => useGenerateInterpolatedThumbnails,
  utcToLocalDate: () => utcToLocalDate
});
module.exports = __toCommonJS(src_exports);

// src/theme/colors.ts
var palette = {
  black: "#000000",
  white: "#FFFFFF",
  red: ["#F9DEDC", "#F0ADA8", "#E77B73", "#DE4A3F", "#C6413E"],
  orange: [
    "#FFEEE6",
    "#FFDCCC",
    "#FFB99A",
    "#FF9767",
    "#FF7435",
    "#FF5102",
    "#CC4102",
    "#993101",
    "#662001",
    "#331000"
  ],
  yellow: [
    "#F7F4EA",
    "#FFF6CC",
    "#FFEC9A",
    "#FFE367",
    "#FFD935",
    "#FFD002",
    "#CCA602",
    "#997D01",
    "#665301",
    "#332A00"
  ],
  green: [
    "#FAFFEF",
    "#E7F4CC",
    "#CFE999",
    "#B8DD67",
    "#A0D234",
    "#88C701",
    "#6D9F01",
    "#527701",
    "#365000",
    "#1B2800"
  ],
  turquoise: ["#E3F2F2", "#BADEDE", "#9ED0D1", "#4EA4A6", "#22A0AC", "#1C7E87"],
  blue: [
    "#F5F7FF",
    "#CCD6FF",
    "#9AADFF",
    "#6783FF",
    "#355AFF",
    "#0231FF",
    "#0227CC",
    "#011D99",
    "#011466",
    "#000A33"
  ],
  purple: ["#E6E5F0", "#B5B1D3", "#847CB6", "#675EA5", "#514983"],
  pink: ["#FFEFF4", "#FFD0DF", "#F2A6BE", "#EC799D", "#D0577D"],
  brown: ["#9B803D", "#8E652A", "#5B4028", "#473A31", "#2D241D", "#1C1616"],
  neutral: [
    "#F2F2F2",
    "#E2E3E7",
    "#C4C7CF",
    "#A7AAB8",
    "#898EA0",
    "#6C7288",
    "#565B6D",
    "#414452",
    "#2B2E36",
    "#16171B"
  ],
  magenta: [
    "#FFF8FF",
    "#F0CEEA",
    "#E19DD6",
    "#D16DC1",
    "#C23CAD",
    "#B30B98",
    "#A10A89",
    "#7D086A",
    "#5A064C",
    "#36032E"
  ]
};
var colors = {
  white: palette.white,
  black: palette.black,
  current: "currentColor",
  transparent: "transparent",
  neutral: {
    DEFAULT: palette.neutral[9],
    50: palette.neutral[0],
    100: palette.neutral[1],
    200: palette.neutral[2],
    300: palette.neutral[3],
    400: palette.neutral[4],
    500: palette.neutral[5],
    600: palette.neutral[6],
    700: palette.neutral[7],
    800: palette.neutral[8],
    900: palette.neutral[9]
  },
  red: {
    DEFAULT: palette.red[3],
    100: palette.red[0],
    300: palette.red[1],
    500: palette.red[2],
    700: palette.red[3],
    900: palette.red[4]
  },
  orange: {
    DEFAULT: palette.orange[5],
    50: palette.orange[0],
    100: palette.orange[1],
    200: palette.orange[2],
    300: palette.orange[3],
    400: palette.orange[4],
    500: palette.orange[5],
    600: palette.orange[6],
    700: palette.orange[7],
    800: palette.orange[8],
    900: palette.orange[9]
  },
  yellow: {
    DEFAULT: palette.yellow[5],
    50: palette.yellow[0],
    100: palette.yellow[1],
    200: palette.yellow[2],
    300: palette.yellow[3],
    400: palette.yellow[4],
    500: palette.yellow[5],
    600: palette.yellow[6],
    700: palette.yellow[7],
    800: palette.yellow[8],
    900: palette.yellow[9]
  },
  green: {
    DEFAULT: palette.green[5],
    50: palette.green[0],
    100: palette.green[1],
    200: palette.green[2],
    300: palette.green[3],
    400: palette.green[4],
    500: palette.green[5],
    600: palette.green[6],
    700: palette.green[7],
    800: palette.green[8],
    900: palette.green[9]
  },
  turquoise: {
    DEFAULT: palette.turquoise[4],
    100: palette.turquoise[0],
    300: palette.turquoise[1],
    500: palette.turquoise[2],
    600: palette.turquoise[3],
    700: palette.turquoise[4],
    900: palette.turquoise[5]
  },
  blue: {
    DEFAULT: palette.blue[5],
    50: palette.blue[0],
    100: palette.blue[1],
    200: palette.blue[2],
    300: palette.blue[3],
    400: palette.blue[4],
    500: palette.blue[5],
    600: palette.blue[6],
    700: palette.blue[7],
    800: palette.blue[8],
    900: palette.blue[9]
  },
  purple: {
    DEFAULT: palette.purple[3],
    100: palette.purple[0],
    300: palette.purple[1],
    500: palette.purple[2],
    700: palette.purple[3],
    900: palette.purple[4]
  },
  pink: {
    DEFAULT: palette.pink[3],
    100: palette.pink[0],
    300: palette.pink[1],
    500: palette.pink[2],
    700: palette.pink[3],
    900: palette.pink[4]
  },
  brown: {
    DEFAULT: palette.brown[3],
    50: palette.brown[0],
    100: palette.brown[1],
    300: palette.brown[2],
    500: palette.brown[3],
    700: palette.brown[4],
    900: palette.brown[5]
  },
  magenta: {
    DEFAULT: palette.magenta[5],
    50: palette.magenta[0],
    100: palette.magenta[1],
    200: palette.magenta[2],
    300: palette.magenta[3],
    400: palette.magenta[4],
    500: palette.magenta[5],
    600: palette.magenta[6],
    700: palette.magenta[7],
    800: palette.magenta[8],
    900: palette.magenta[9]
  }
};

// src/theme/typography.ts
var typography = {
  standard: "Lato"
};

// src/theme/index.ts
var theme = {
  colors,
  extend: {
    screens: {
      xxs: "320px",
      xs: "425px",
      // Widget mobile breakpoint
      wm: "500px"
    },
    fontSize: {
      xxs: [
        ".5rem",
        {
          lineHeight: "0.75rem"
        }
      ]
    },
    fontFamily: {
      sans: ["Circular Std", typography.standard, "sans-serif"],
      circular: ["Circular Std", "Arial", "san-serif"]
    },
    boxShadow: {
      top: "0 -4px 4px 0 rgba(166, 166, 166, 0.13)",
      around: "0 1px 10px 0 rgba(0, 0, 0, 0.16)",
      "3xl": "5px 3px 6px #00000029"
    },
    dropShadow: {
      text: "0px 3px 6px #00000029"
    },
    zIndex: {
      "99": 99
    },
    spacing: {
      "30": "7.5rem",
      "37": "9.375rem"
    },
    animation: {
      "fade-in-100": "fade-in .1s linear forwards",
      "fade-in-150": "fade-in .15s linear forwards",
      "fade-in": "fade-in .25s linear forwards",
      "fade-out-100": "fade-out .1s linear forwards",
      "fade-out-150": "fade-out .15s linear forwards",
      "fade-out": "fade-out .25s linear forwards",
      "fade-in-down-150": "fade-in-down .15s linear 1",
      "fade-in-down": "fade-in-down .25s linear 1",
      "fade-out-down-150": "fade-out-down .15s linear 1",
      "fade-out-down": "fade-out-down .25s linear 1",
      "fade-in-up-150": "fade-in-up .15s linear 1",
      "fade-in-up": "fade-in-up .25s linear 1",
      "fade-out-up-150": "fade-out-up .15s linear 1",
      "fade-out-up": "fade-out-up .25s linear 1",
      "fade-in-left-150": "fade-in-left .15s linear 1",
      "fade-in-left": "fade-in-left .25s linear 1",
      "fade-out-left-150": "fade-out-left .15s linear 1",
      "fade-out-left": "fade-out-left .25s linear 1",
      "fade-in-right-150": "fade-in-right .15s linear 1",
      "fade-in-right": "fade-in-right .25s linear 1",
      "fade-out-right-150": "fade-out-right .15s linear 1",
      "fade-out-right": "fade-out-right .25s linear 1",
      "rotate-360": "rotate-360 2s linear infinite"
    },
    keyframes: {
      "rotate-360": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
      },
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" }
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" }
      },
      "fade-in-down": {
        "0%": { opacity: "0", transform: "translateY(-20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-down": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(20px)" }
      },
      "fade-in-up": {
        "0%": { opacity: "0", transform: "translateY(20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-up": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(-20px)" }
      },
      "fade-in-left": {
        "0%": { opacity: "0", transform: "translateX(20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-left": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(-20px)" }
      },
      "fade-in-right": {
        "0%": { opacity: "0", transform: "translateX(-20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-right": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(20px)" }
      }
    }
  }
};

// src/components/Button/index.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant3) => {
  ButtonVariant3["Default"] = "default";
  ButtonVariant3["Primary"] = "primary";
  ButtonVariant3["Secondary"] = "secondary";
  ButtonVariant3["SecondaryWhite"] = "secondary-white";
  ButtonVariant3["Danger"] = "danger";
  ButtonVariant3["DangerWhite"] = "danger-white";
  ButtonVariant3["Info"] = "info";
  ButtonVariant3["Disabled"] = "disabled";
  ButtonVariant3["Blue"] = "blue";
  ButtonVariant3["Magenta"] = "magenta";
  ButtonVariant3["Icon"] = "icon";
  ButtonVariant3["Rounded"] = "rounded";
  return ButtonVariant3;
})(ButtonVariant || {});
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["Small"] = "sm";
  ButtonSize2["Medium"] = "md";
  ButtonSize2["Large"] = "lg";
  ButtonSize2["ExtraLarge"] = "xl";
  return ButtonSize2;
})(ButtonSize || {});
var sizeClasses = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  ["sm" /* Small */]: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  ["md" /* Medium */]: "v2-py-2.5 v2-px-[15px] v2-text-[15px]",
  ["lg" /* Large */]: "v2-py-2.5 v2-px-[15px] v2-text-base",
  ["xl" /* ExtraLarge */]: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
var shapeClasses = {
  ["rectangle" /* Rectangle */]: "",
  ["round" /* Round */]: "v2-rounded-md"
};
var variantClasses = {
  ["danger" /* Danger */]: "v2-border-solid v2-border-pink-900 v2-text-white",
  ["danger-white" /* DangerWhite */]: "v2-border-solid v2-border-neutral-500 v2-text-neutral-900",
  ["default" /* Default */]: "v2-border-solid v2-border-turquoise v2-text-white",
  ["disabled" /* Disabled */]: "v2-border-solid v2-border-neutral-200 v2-text-neutral-400",
  ["primary" /* Primary */]: "v2-border-solid v2-text-neutral-900 v2-border-yellow-500",
  ["secondary" /* Secondary */]: "v2-border-solid v2-border-neutral-500",
  ["secondary-white" /* SecondaryWhite */]: "v2-text-white v2-border-solid v2-border-white",
  ["info" /* Info */]: "v2-text-brown-700 v2-border-solid v2-border-neutral-200",
  ["blue" /* Blue */]: "v2-text-white v2-border-solid v2-border-blue-500",
  ["magenta" /* Magenta */]: "v2-text-white v2-border-solid v2-border-magenta-500",
  ["icon" /* Icon */]: "v2-text-neutral-400 v2-border-none v2-outline-none",
  ["rounded" /* Rounded */]: "v2-cursor-pointer v2-rounded-full v2-border-1 v2-border-solid v2-border-neutral-500"
};
function Button(_a) {
  var _b = _a, {
    children,
    variant: variantProp,
    size: sizeProp,
    shape = "rectangle" /* Rectangle */,
    bgColorClassName,
    disableHover
  } = _b, props = __objRest(_b, [
    "children",
    "variant",
    "size",
    "shape",
    "bgColorClassName",
    "disableHover"
  ]);
  var _a2;
  const variant = (0, import_react.useMemo)(() => {
    if (props.disabled) {
      return "disabled" /* Disabled */;
    }
    if (variantProp != null) {
      return variantProp;
    }
    if (props.primary) {
      return "primary" /* Primary */;
    }
    if (props.secondary) {
      return "secondary" /* Secondary */;
    }
    if (props.info) {
      return "info" /* Info */;
    }
    if (props.danger) {
      return "danger" /* Danger */;
    }
    return "default" /* Default */;
  }, [props]);
  const size = (0, import_react.useMemo)(() => {
    if (sizeProp != null) {
      return sizeProp;
    }
    if (props.sm || props.small) {
      return "sm" /* Small */;
    }
    if (props.md || props.medium) {
      return "md" /* Medium */;
    }
    if (props.lg || props.large) {
      return "lg" /* Large */;
    }
    if (props.xl || props.extraLarge) {
      return "xl" /* ExtraLarge */;
    }
    return "md" /* Medium */;
  }, [props]);
  const disabledClass = (0, import_react.useMemo)(() => {
    if (props.disabled) {
      switch (variant) {
        case "primary" /* Primary */:
          return "!v2-text-neutral-300 !v2-bg-neutral-100 !v2-border-neutral-100";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "!v2-text-neutral-300 !v2-bg-transparent !v2-border-white";
      }
    }
    return "";
  }, [props, variant]);
  const hoverClass = (0, import_react.useMemo)(() => {
    if (!disableHover) {
      switch (variant) {
        case "danger" /* Danger */:
          return "hover:v2-bg-orange-700 hover:v2-border-orange-700";
        case "danger-white" /* DangerWhite */:
          return "hover:v2-bg-orange-600 hover:v2-border-orange-600 hover:v2-text-white";
        case "default" /* Default */:
          return "hover:v2-bg-turquoise-900 hover:v2-border-turquoise-900";
        case "disabled" /* Disabled */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300 v2-cursor-not-allowed";
        case "primary" /* Primary */:
          return "hover:v2-bg-yellow-300 hover:v2-border-yellow-300";
        case "secondary" /* Secondary */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent";
        case "secondary-white" /* SecondaryWhite */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent hover:v2-text-neutral-900";
        case "blue" /* Blue */:
          return "hover:v2-bg-blue-700 hover:v2-border-blue-700";
        case "magenta" /* Magenta */:
          return "hover:v2-bg-magenta-700 hover:v2-border-magenta-700";
        case "info" /* Info */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300";
        case "icon" /* Icon */:
          return "hover:v2-text-turquoise";
        case "rounded" /* Rounded */:
          return "hover:v2-bg-yellow-500 hover:v2-border-yellow-500";
      }
    }
    return "";
  }, [props, variant]);
  const bgColorClass = (0, import_react.useMemo)(() => {
    if (!bgColorClassName) {
      switch (variant) {
        case "danger" /* Danger */:
          return "v2-bg-orange-600";
        case "danger-white" /* DangerWhite */:
          return "v2-bg-white";
        case "default" /* Default */:
          return "v2-bg-turquoise";
        case "disabled" /* Disabled */:
          return "v2-bg-neutral-200 ";
        case "primary" /* Primary */:
          return "v2-bg-yellow-500";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "v2-bg-transparent ";
        case "blue" /* Blue */:
          return "v2-bg-blue-500";
        case "magenta" /* Magenta */:
          return "v2-bg-magenta-500";
        case "info" /* Info */:
          return "v2-bg-neutral-200";
        case "icon" /* Icon */:
          return "v2-bg-transparent";
        case "rounded" /* Rounded */:
          return "v2-bg-transparent ";
      }
    }
    return bgColorClassName;
  }, [props, variant]);
  const className = (0, import_react.useMemo)(() => {
    return [
      sizeClasses.DEFAULT,
      sizeClasses[size],
      shapeClasses[shape],
      variantClasses[variant],
      disabledClass,
      hoverClass,
      bgColorClass
    ].join(" ");
  }, [size, variant, shape]);
  return /* @__PURE__ */ import_react.default.createElement("button", __spreadProps(__spreadValues({}, props), { className: (0, import_classnames.default)(`${(_a2 = props.className) != null ? _a2 : ""} ${className}`) }), children);
}

// src/components/CookieDialog/CookieDialog.tsx
var import_react12 = __toESM(require("react"));
var import_js_cookie = __toESM(require("js-cookie"));

// src/components/AnimatedDiv/AnimatedDiv.tsx
var import_react3 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));

// src/hook/use-delayed-state-hook.ts
var import_react2 = require("react");
function useDelayedState(dependency, delayDuration = 150) {
  const [state, setState] = (0, import_react2.useState)(dependency);
  (0, import_react2.useEffect)(() => {
    setTimeout(() => setState(dependency), dependency ? 0 : delayDuration);
  }, [dependency]);
  return state;
}

// src/components/AnimatedDiv/AnimatedDiv.tsx
var ShowAnimation = /* @__PURE__ */ ((ShowAnimation2) => {
  ShowAnimation2["FadeIn"] = "v2-animate-fade-in";
  ShowAnimation2["FadeIn100"] = "v2-animate-fade-in-100";
  ShowAnimation2["FadeIn150"] = "v2-animate-fade-in-150";
  ShowAnimation2["SlideInUp"] = "v2-animate-fade-in-up";
  ShowAnimation2["SlideInUp150"] = "v2-animate-fade-in-up-150";
  ShowAnimation2["SlideInDown"] = "v2-animate-fade-in-down";
  ShowAnimation2["SlideInDown150"] = "v2-animate-fade-in-down-150";
  ShowAnimation2["SlideInLeft"] = "v2-animate-fade-in-left";
  ShowAnimation2["SlideInLeft150"] = "v2-animate-fade-in-left-150";
  ShowAnimation2["SlideInRight"] = "v2-animate-fade-in-right";
  ShowAnimation2["SlideInRight150"] = "v2-animate-fade-in-right-150";
  return ShowAnimation2;
})(ShowAnimation || {});
var HideAnimation = /* @__PURE__ */ ((HideAnimation2) => {
  HideAnimation2["FadeOut"] = "v2-animate-fade-out";
  HideAnimation2["FadeOut100"] = "v2-animate-fade-out-100";
  HideAnimation2["FadeOut150"] = "v2-animate-fade-out-150";
  HideAnimation2["SlideOutUp"] = "v2-animate-fade-out-up";
  HideAnimation2["SlideOutUp150"] = "v2-animate-fade-out-up-150";
  HideAnimation2["SlideOutDown"] = "v2-animate-fade-out-down";
  HideAnimation2["SlideOutDown150"] = "v2-animate-fade-out-down-150";
  HideAnimation2["SlideOutLeft"] = "v2-animate-fade-out-left";
  HideAnimation2["SlideOutLeft150"] = "v2-animate-fade-out-left-150";
  HideAnimation2["SlideOutRight"] = "v2-animate-fade-out-right";
  HideAnimation2["SlideOutRight150"] = "v2-animate-fade-out-right-150";
  return HideAnimation2;
})(HideAnimation || {});
function AnimatedDiv(_a) {
  var _b = _a, {
    show,
    delay = 150,
    children,
    className,
    showAnimation = "v2-animate-fade-in" /* FadeIn */,
    hideAnimation = "v2-animate-fade-out" /* FadeOut */
  } = _b, otherProps = __objRest(_b, [
    "show",
    "delay",
    "children",
    "className",
    "showAnimation",
    "hideAnimation"
  ]);
  const delayedShowState = useDelayedState(show, delay);
  return delayedShowState ? /* @__PURE__ */ import_react3.default.createElement(
    "div",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames2.default)(className, {
        [showAnimation]: show,
        [hideAnimation]: !show
      })
    }),
    children
  ) : /* @__PURE__ */ import_react3.default.createElement(import_react3.default.Fragment, null);
}

// src/components/CookieDialog/CookieDialog.tsx
var import_react_fontawesome4 = require("@fortawesome/react-fontawesome");

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faCameraWeb = {
  prefix: "fas",
  iconName: "camera-web",
  icon: [448, 512, ["webcam"], "f832", "M344.2 413.1C406.6 373.3 448 303.5 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 79.5 41.4 149.3 103.8 189.1L45.6 453.8c-11.4 8-16.4 22.5-12.2 35.8S50 512 64 512H384c14 0 26.3-9.1 30.5-22.4s-.7-27.8-12.2-35.8l-58.2-40.7zM224 352c70.7 0 128-57.3 128-128s-57.3-128-128-128S96 153.3 96 224s57.3 128 128 128zm0 32c-88.4 0-160-71.6-160-160s71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM176 224c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faWebcam = faCameraWeb;
var faMicrophone = {
  prefix: "fas",
  iconName: "microphone",
  icon: [384, 512, [], "f130", "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"]
};
var faCirclePlay = {
  prefix: "fas",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
};
var faImageSlash = {
  prefix: "fas",
  iconName: "image-slash",
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64H487.4l-81.2-64H320 248 152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z"]
};
var faCirclePause = {
  prefix: "fas",
  iconName: "circle-pause",
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faXmark = {
  prefix: "fas",
  iconName: "xmark",
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"]
};
var faTimes = faXmark;
var faSpinner = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM48 304c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm464-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM142.9 437c18.7-18.7 18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zm0-294.2c18.7-18.7 18.7-49.1 0-67.9S93.7 56.2 75 75s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zM369.1 437c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9z"]
};
var faCookieBite = {
  prefix: "fas",
  iconName: "cookie-bite",
  icon: [512, 512, [], "f564", "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 208c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"]
};
var faCheck = {
  prefix: "fas",
  iconName: "check",
  icon: [512, 512, [10003, 10004], "f00c", "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};

// src/components/CookieDialog/CookieDialog.tsx
var import_classnames10 = __toESM(require("classnames"));

// src/components/Modal/Modal.tsx
var import_react9 = __toESM(require("react"));

// src/components/Modal/BaseModal.tsx
var import_react4 = __toESM(require("react"));
var import_react_modal = __toESM(require("react-modal"));
var import_classnames3 = __toESM(require("classnames"));
var fadeTransitionDuration = 150;
var BaseModal = (_a) => {
  var _b = _a, {
    open,
    ariaHideApp = false,
    overlayRef,
    contentRef,
    className,
    overlayClassName,
    children,
    hideOverlay = false,
    yPosition = "middle"
  } = _b, props = __objRest(_b, [
    "open",
    "ariaHideApp",
    "overlayRef",
    "contentRef",
    "className",
    "overlayClassName",
    "children",
    "hideOverlay",
    "yPosition"
  ]);
  const [modalOpen, setModalOpen] = (0, import_react4.useState)(open);
  (0, import_react4.useEffect)(() => {
    setTimeout(() => setModalOpen(open), open ? 0 : fadeTransitionDuration);
  }, [open]);
  const modalProps = (0, import_react4.useMemo)(() => {
    const modalProps2 = __spreadProps(__spreadValues({}, props), {
      ariaHideApp,
      isOpen: modalOpen,
      overlayClassName: (0, import_classnames3.default)(
        "modal-overlay",
        overlayClassName,
        [
          " v2-flex v2-z-[9999] v2-text-base",
          "v2-transition v2-transition-opacity"
        ],
        {
          "v2-fixed v2-bg-black/50 v2-overflow-y-scroll v2-inset-0": !hideOverlay,
          "v2-absolute v2-inset-x-0 v2-justify-self-center v2-self-center v2-w-fit v2-h-fit": hideOverlay,
          "v2-top-0": hideOverlay && yPosition === "top",
          "v2-inset-y-0": hideOverlay && yPosition === "middle",
          "v2-bottom-0": hideOverlay && yPosition === "bottom",
          "v2-animate-fade-in-150": open,
          "v2-animate-fade-out-150": !open
        }
      ),
      className: (0, import_classnames3.default)(
        "modal-contents",
        className,
        [
          "v2-relative v2-bg-white v2-shadow-md v2-rounded !v2-px-7 v2-pb-7",
          "v2-outline-none v2-p-5 v2-border-none v2-inset-0 ",
          "md:v2-inset-px v2-w-auto md:v2-w-full"
        ],
        {
          "!v2-m-auto": hideOverlay,
          "!v2-mx-auto ": !hideOverlay,
          "v2-mb-auto": !hideOverlay && yPosition === "top",
          "v2-my-auto": !hideOverlay && yPosition === "middle",
          "v2-mt-auto": !hideOverlay && yPosition === "bottom"
        }
      )
    });
    if (overlayRef) {
      modalProps2.overlayRef = (node2) => overlayRef.current = node2;
    }
    if (contentRef) {
      modalProps2.contentRef = (node2) => contentRef.current = node2;
    }
    return modalProps2;
  }, [modalOpen, overlayRef, contentRef, props, yPosition, hideOverlay]);
  return /* @__PURE__ */ import_react4.default.createElement(import_react_modal.default, __spreadValues({}, modalProps), children);
};

// src/components/Modal/ModalContainer.tsx
var import_react5 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
var ModalContainer = ({
  children,
  className
}) => {
  return /* @__PURE__ */ import_react5.default.createElement(
    "div",
    {
      className: (0, import_classnames4.default)("modal-container", className, [
        "v2-w-full v2-flex v2-flex-col"
      ])
    },
    children
  );
};

// src/components/Modal/CloseButton.tsx
var import_react6 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
var CloseButton = ({ className, onClick }) => {
  return /* @__PURE__ */ import_react6.default.createElement(
    import_react_fontawesome.FontAwesomeIcon,
    {
      icon: faTimes,
      className: (0, import_classnames5.default)("modal-close-btn", className, [
        "v2-text-neutral-300 hover:v2-text-orange-700 v2-cursor-pointer",
        "v2-flex v2-top-6 v2-right-6 v2-w-fit v2-ml-auto v2-text-[25px]",
        "v2-absolute v2-w-6 v2-h-6"
      ]),
      onClick
    }
  );
};

// src/components/Modal/ActionsPanel.tsx
var import_react7 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faArrowRight = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
};
var faTrash = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
};
var faArrowLeft = {
  prefix: "fas",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
var faArrowRotateLeft = {
  prefix: "fas",
  iconName: "arrow-rotate-left",
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"]
};
var faUndo = faArrowRotateLeft;
var faCaretDown = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
};
var faEllipsis = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M120 256c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm160 0c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm104 56c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56z"]
};
var faEllipsisH = faEllipsis;
var faChevronDown = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
};
var faPlus = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
};
var faXmark2 = {
  prefix: "fas",
  iconName: "xmark",
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"]
};
var faTimes2 = faXmark2;
var faChevronLeft = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [384, 512, [9001], "f053", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
};
var faChevronRight = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [384, 512, [9002], "f054", "M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
};
var faSpinner2 = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM48 304c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm464-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM142.9 437c18.7-18.7 18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zm0-294.2c18.7-18.7 18.7-49.1 0-67.9S93.7 56.2 75 75s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zM369.1 437c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9z"]
};
var faCheck2 = {
  prefix: "fas",
  iconName: "check",
  icon: [512, 512, [10003, 10004], "f00c", "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};
var faPaperPlane = {
  prefix: "fas",
  iconName: "paper-plane",
  icon: [512, 512, [61913], "f1d8", "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"]
};

// src/components/Modal/ActionsPanel.tsx
var import_react_fontawesome2 = require("@fortawesome/react-fontawesome");
var ActionsPanel = ({
  className,
  confirmButtonProps,
  cancelButtonProps
}) => {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ import_react7.default.createElement(
    "div",
    {
      className: (0, import_classnames6.default)(
        "modal-actions-panel",
        className,
        "v2-shrink v2-flex v2-gap-x-5 v2-flex v2-flex-col xxs:v2-flex-row"
      )
    },
    (confirmButtonProps == null ? void 0 : confirmButtonProps.onClick) && /* @__PURE__ */ import_react7.default.createElement(
      Button,
      __spreadProps(__spreadValues({}, confirmButtonProps), {
        variant: (_a = confirmButtonProps == null ? void 0 : confirmButtonProps.variant) != null ? _a : "primary" /* Primary */
      }),
      (confirmButtonProps == null ? void 0 : confirmButtonProps.loading) ? /* @__PURE__ */ import_react7.default.createElement(
        import_react_fontawesome2.FontAwesomeIcon,
        {
          icon: faSpinner2,
          className: "v2-animate-spin v2-mr-2"
        }
      ) : /* @__PURE__ */ import_react7.default.createElement(import_react7.default.Fragment, null),
      (_b = confirmButtonProps == null ? void 0 : confirmButtonProps.text) != null ? _b : "Confirm"
    ),
    (cancelButtonProps == null ? void 0 : cancelButtonProps.onClick) && /* @__PURE__ */ import_react7.default.createElement(
      Button,
      __spreadProps(__spreadValues({}, cancelButtonProps), {
        variant: (_c = cancelButtonProps == null ? void 0 : cancelButtonProps.variant) != null ? _c : "info" /* Info */
      }),
      (_d = cancelButtonProps == null ? void 0 : cancelButtonProps.text) != null ? _d : "Cancel"
    )
  );
};

// src/components/Modal/Icon.tsx
var import_react8 = __toESM(require("react"));
var import_classnames7 = __toESM(require("classnames"));
var Icon = ({ imageUrl, className }) => {
  return /* @__PURE__ */ import_react8.default.createElement(
    "img",
    {
      className: (0, import_classnames7.default)(className, "v2-h-10 v2-w-10 v2-mx-auto v2-my-2"),
      src: imageUrl
    }
  );
};

// src/components/Modal/Modal.tsx
function Modal({
  open = false,
  hideCloseButton = false,
  hideActions = false,
  iconUrl,
  className,
  overlayClassName,
  panelClassName,
  actionsPanelClassName,
  closeButtonClassName,
  iconClassName,
  children,
  confirmButtonProps,
  cancelButtonProps,
  onModalClose,
  onAfterOpen,
  noCloseOnOverlayClick = false,
  noCloseOnEsc = false,
  overlayRef,
  contentRef,
  hideOverlay = false,
  yPosition
}) {
  const closeButtonProps = {
    onClick: onModalClose,
    className: closeButtonClassName
  };
  const actionsPanelProps = {
    className: actionsPanelClassName,
    confirmButtonProps,
    cancelButtonProps
  };
  const iconProps = {
    className: iconClassName,
    imageUrl: iconUrl
  };
  const baseModalProps = {
    open,
    className,
    overlayClassName,
    shouldCloseOnOverlayClick: !noCloseOnOverlayClick && !hideOverlay,
    shouldCloseOnEsc: !noCloseOnEsc,
    onRequestClose: onModalClose,
    onAfterOpen,
    overlayRef,
    contentRef,
    hideOverlay,
    yPosition
  };
  return /* @__PURE__ */ import_react9.default.createElement(BaseModal, __spreadValues({}, baseModalProps), /* @__PURE__ */ import_react9.default.createElement(ModalContainer, { className: panelClassName }, !hideCloseButton && /* @__PURE__ */ import_react9.default.createElement(CloseButton, __spreadValues({}, closeButtonProps)), iconUrl && /* @__PURE__ */ import_react9.default.createElement(Icon, __spreadValues({}, iconProps)), children, !hideActions && /* @__PURE__ */ import_react9.default.createElement(ActionsPanel, __spreadValues({}, actionsPanelProps))));
}

// src/components/CookieDialog/ManageCookieModal.tsx
var import_react11 = __toESM(require("react"));
var import_react_fontawesome3 = require("@fortawesome/react-fontawesome");

// src/components/Checkbox/index.tsx
var import_react10 = __toESM(require("react"));
var import_styled = __toESM(require("@emotion/styled"));
var import_classnames8 = __toESM(require("classnames"));
var themes = {
  ["turquoise" /* Turquoise */]: {
    containerBorderColor: colors.turquoise[500],
    inputBorderColor: colors.turquoise[500],
    checkedBgColor: colors.turquoise[700]
  },
  ["yellow" /* Yellow */]: {
    containerBorderColor: colors.neutral[500],
    inputBorderColor: colors.neutral[500],
    checkedBgColor: colors.yellow[500],
    hoverBgColor: colors.yellow[50]
  }
};
var CheckboxContainer = import_styled.default.label`
  ${({ borderColor, hoverBgColor, disabled }) => {
  if (disabled) {
    return "";
  }
  return `
    &:hover input ~ span {
      border: 1px ${borderColor} solid;
      ${hoverBgColor ? `background: ${hoverBgColor}` : ""}
    }
  `;
}}
`;
var CheckboxInput = import_styled.default.input`
  ${({ borderColor }) => `
    &:checked ~ span {
      border: 1px ${borderColor} solid;
    }

    &:checked ~ span:after {
      display: flex;
    }
  `}
`;
var Checkmark = import_styled.default.span`
  ${({ bgColor }) => `
    &:after {
      content: '';
      display: none;
      width: 70%;
      height: 70%;
      background: ${bgColor};
      border-radius: 3px;
      margin: 15%;
    }
  `}
`;
function Checkbox(_a) {
  var _b = _a, {
    name,
    checked,
    height = 20,
    width = 20,
    onChange,
    label,
    labelTextColorClassName,
    labelTextSizeClassName,
    className,
    inputClassName,
    labelClassName,
    disabled,
    theme: theme2 = "yellow" /* Yellow */,
    bgColorClassName,
    onClick
  } = _b, props = __objRest(_b, [
    "name",
    "checked",
    "height",
    "width",
    "onChange",
    "label",
    "labelTextColorClassName",
    "labelTextSizeClassName",
    "className",
    "inputClassName",
    "labelClassName",
    "disabled",
    "theme",
    "bgColorClassName",
    "onClick"
  ]);
  const {
    containerBorderColor,
    hoverBgColor,
    inputBorderColor,
    checkedBgColor
  } = themes[theme2];
  return /* @__PURE__ */ import_react10.default.createElement(
    CheckboxContainer,
    {
      borderColor: containerBorderColor,
      hoverBgColor,
      disabled,
      className: (0, import_classnames8.default)("v2-flex v2-relative v2-mb-0 v2-w-max", className, {
        "v2-cursor-pointer": !disabled,
        "v2-cursor-not-allowed": disabled
      })
    },
    /* @__PURE__ */ import_react10.default.createElement(
      CheckboxInput,
      __spreadValues({
        borderColor: inputBorderColor,
        className: (0, import_classnames8.default)(
          inputClassName,
          "v2-absolute v2-h-0 v2-w-0 v2-opacity-1 v2-hidden"
        ),
        type: "checkbox",
        name,
        onChange,
        checked,
        disabled
      }, props)
    ),
    /* @__PURE__ */ import_react10.default.createElement(
      Checkmark,
      {
        bgColor: checkedBgColor,
        className: (0, import_classnames8.default)(
          bgColorClassName,
          "v2-border v2-border-solid v2-border-neutral-300 v2-rounded"
        ),
        style: { width, height },
        onClick
      }
    ),
    label && /* @__PURE__ */ import_react10.default.createElement(
      "div",
      {
        className: (0, import_classnames8.default)(
          labelClassName,
          "v2-flex v2-self-center v2-items-center v2-ml-3 v2-select-none",
          `${labelTextColorClassName != null ? labelTextColorClassName : "v2-text-neutral-600"}`,
          `${labelTextSizeClassName != null ? labelTextSizeClassName : "v2-text-sm"}`
        ),
        onClick
      },
      label
    )
  );
}

// src/components/CookieDialog/ManageCookieModal.tsx
var import_classnames9 = __toESM(require("classnames"));
function ManageCookieModal({
  open,
  onClose,
  consent,
  selectedConsent,
  onCheckboxClick,
  onAcceptSelectedClick,
  onRejectClick,
  modalClassName
}) {
  return /* @__PURE__ */ import_react11.default.createElement(
    Modal,
    {
      open,
      hideActions: true,
      onModalClose: onClose,
      className: (0, import_classnames9.default)(modalClassName, "!v2-w-[500px] !v2-py-3"),
      closeButtonClassName: "!v2-w-auto"
    },
    /* @__PURE__ */ import_react11.default.createElement("div", { className: "v2-flex v2-flex-col v2-py-3 v2-gap-y-5" }, /* @__PURE__ */ import_react11.default.createElement("h1", { className: "v2-text-xl v2-font-bold v2-flex v2-flex-row v2-gap-x-2 v2-items-center v2-m-0" }, /* @__PURE__ */ import_react11.default.createElement(import_react_fontawesome3.FontAwesomeIcon, { icon: faCookieBite, className: "v2-text-xl" }), "Cookie Preferences"), /* @__PURE__ */ import_react11.default.createElement("span", { className: "v2-text-base v2-text-neutral-500" }, "Taking one of our delicious cookies helps us improve your site experience."), /* @__PURE__ */ import_react11.default.createElement("hr", { className: "v2-w-full v2-border-top-[3px] v2-border-neutral-[500] m-0" }), /* @__PURE__ */ import_react11.default.createElement("span", { className: "v2-text-base v2-text-neutral-900 v2-font-bold" }, "Change cookie settings"), /* @__PURE__ */ import_react11.default.createElement("div", { className: "v2-flex v2-flex-col v2-gap-5 v2-flex-wrap v2-justify-center" }, consent == null ? void 0 : consent.map((item) => {
      return /* @__PURE__ */ import_react11.default.createElement("div", { key: item.id, className: "v2-flex v2-flex-col v2-gap-y-1.5" }, /* @__PURE__ */ import_react11.default.createElement(
        Checkbox,
        {
          labelClassName: (0, import_classnames9.default)(
            "!v2-text-base !v2-text-neutral-900 v2-font-bold",
            " v2-justify-center v2-gap-x-5"
          ),
          value: item.id,
          label: item.title,
          checked: selectedConsent == null ? void 0 : selectedConsent.includes(item.id),
          onClick: () => onCheckboxClick == null ? void 0 : onCheckboxClick(item.id)
        }
      ), /* @__PURE__ */ import_react11.default.createElement("span", { className: "v2-text-sm v2-text-neutral-500" }, item.description));
    })), /* @__PURE__ */ import_react11.default.createElement("div", { className: "v2-flex v2-flex-col v2-gap-y-2" }, /* @__PURE__ */ import_react11.default.createElement(
      Button,
      {
        variant: "primary" /* Primary */,
        onClick: onAcceptSelectedClick
      },
      "Accept selected cookies"
    ), /* @__PURE__ */ import_react11.default.createElement(Button, { variant: "secondary" /* Secondary */, onClick: onRejectClick }, "Reject all cookies")))
  );
}

// src/components/CookieDialog/CookieDialog.tsx
var Image2 = ({ className, src }) => /* @__PURE__ */ import_react12.default.createElement("div", { className }, /* @__PURE__ */ import_react12.default.createElement(
  "img",
  {
    className: "v2-overflow-hidden v2-absolute v2-bottom-0 v2-left-0 v2-h-16 md:v2-h-40",
    src
  }
));
function setCookie({
  cookieName,
  cookieValue,
  cookieLifetime,
  cookieDomain,
  sessionSecure
}) {
  var _a;
  (_a = import_js_cookie.default) == null ? void 0 : _a.set(cookieName, cookieValue, {
    expires: cookieLifetime,
    domain: cookieDomain,
    path: "/",
    secure: !!sessionSecure
  });
}
function CookieDialog({
  config,
  imageSrc = "https://dehjrbasx23dy.cloudfront.net/assets/images/bear-with-cookie.png",
  privacyPolicy = "https://www.bonjoro.com/privacy-policy",
  consent = [],
  onAcceptAllClick,
  onAcceptSelectedClick,
  onCloseClick
}) {
  var _a;
  const [showCookie, setShowCookie] = (0, import_react12.useState)(false);
  const [modalOpen, setModalOpen] = (0, import_react12.useState)(false);
  const consentIds = consent == null ? void 0 : consent.map((item) => item.id);
  const [selectedConsent, setSelectedConsent] = (0, import_react12.useState)(consentIds);
  const closeCookie = () => setShowCookie(false);
  const toggleOpen = () => setModalOpen(!modalOpen);
  const imageClassName = "v2-relative v2-overflow-visible v2-h-10 v2-w-16 md:v2-h-[8rem] md:v2-w-37", messageClassName = "v2-text-neutral-500 v2-text-sm v2-text-center v2-ml-0 v2-max-w-[500px] v2-m-0", buttonClassName = "md:v2-my-auto md:v2-mx-1 v2-py-1.5 !v2-text-sm v2-text-neutral-900 v2-truncate";
  (0, import_react12.useEffect)(() => {
    var _a2;
    const cookieExist = !!((_a2 = import_js_cookie.default) == null ? void 0 : _a2.get(config.cookieName));
    setShowCookie(!cookieExist);
  }, [config.cookieName]);
  const handleOnAcceptAllClick = () => {
    setCookie(config);
    onAcceptAllClick == null ? void 0 : onAcceptAllClick();
    closeCookie();
  };
  const handleOnRejectClick = () => {
    setCookie(__spreadProps(__spreadValues({}, config), {
      cookieValue: "0"
    }));
    onAcceptSelectedClick == null ? void 0 : onAcceptSelectedClick([]);
    closeCookie();
  };
  const handleOnAcceptSelectedClick = () => {
    setCookie(__spreadProps(__spreadValues({}, config), {
      cookieValue: selectedConsent.length > 0 ? "1" : "0"
    }));
    onAcceptSelectedClick == null ? void 0 : onAcceptSelectedClick(selectedConsent);
    closeCookie();
  };
  const handleOnCloseClick = () => {
    onCloseClick == null ? void 0 : onCloseClick();
    closeCookie();
  };
  const onCheckboxClick = (value) => {
    if (selectedConsent.includes(value)) {
      setSelectedConsent(selectedConsent.filter((item) => item != value));
    } else {
      setSelectedConsent([...selectedConsent, value]);
    }
  };
  const modalProps = {
    open: modalOpen,
    onClose: () => setModalOpen(false),
    consent,
    selectedConsent,
    onCheckboxClick,
    onRejectClick: handleOnRejectClick,
    onAcceptSelectedClick: handleOnAcceptSelectedClick
  };
  const hasConsent = ((_a = Object.keys(consent)) == null ? void 0 : _a.length) > 0;
  return showCookie ? /* @__PURE__ */ import_react12.default.createElement(
    AnimatedDiv,
    {
      show: showCookie,
      showAnimation: "v2-animate-fade-in-up" /* SlideInUp */,
      hideAnimation: "v2-animate-fade-out-down" /* SlideOutDown */,
      className: (0, import_classnames10.default)(
        "v2-z-99 v2-fixed v2-bottom-0 v2-left-0 v2-w-full",
        "v2-bg-white v2-text-center v2-text-turquoise-700 v2-shadow-top"
      )
    },
    /* @__PURE__ */ import_react12.default.createElement(
      import_react_fontawesome4.FontAwesomeIcon,
      {
        icon: faTimes,
        className: (0, import_classnames10.default)([
          "v2-text-neutral-300 hover:v2-text-orange-700 v2-cursor-pointer",
          "v2-flex v2-top-2 v2-right-3 v2-w-fit v2-ml-auto v2-text-[25px]",
          "v2-absolute v2-w-5 v2-h-5"
        ]),
        onClick: handleOnCloseClick
      }
    ),
    /* @__PURE__ */ import_react12.default.createElement(
      "div",
      {
        className: (0, import_classnames10.default)(
          "v2-max-w-screen-lg v2-block md:v2-flex",
          "v2-justify-evenly v2-m-auto"
        )
      },
      /* @__PURE__ */ import_react12.default.createElement(
        Image2,
        {
          className: (0, import_classnames10.default)(imageClassName, "v2-hidden md:v2-block v2-h-30"),
          src: imageSrc
        }
      ),
      /* @__PURE__ */ import_react12.default.createElement("div", { className: "v2-flex v2-flex-col v2-gap-y-2 v2-items-center v2-px-4" }, /* @__PURE__ */ import_react12.default.createElement("div", { className: "v2-flex v2-flex-row v2-justify-center" }, /* @__PURE__ */ import_react12.default.createElement(
        Image2,
        {
          className: (0, import_classnames10.default)(imageClassName, "v2-inline-block md:v2-hidden"),
          src: imageSrc
        }
      ), /* @__PURE__ */ import_react12.default.createElement("h3", { className: "v2-text-base v2-font-bold v2-text-neutral-700 v2-pt-0 v2-pt-3 v2-m-0" }, "Want a cookie?")), /* @__PURE__ */ import_react12.default.createElement("p", { className: messageClassName }, "Taking one of our delicious cookies helps us improve your site experience."), /* @__PURE__ */ import_react12.default.createElement("p", { className: messageClassName }, "By choosing to Accept and continuing to use our website, you agree to our\xA0", /* @__PURE__ */ import_react12.default.createElement(
        "a",
        {
          className: "v2-text-turquoise-700 v2-font-bold",
          href: privacyPolicy
        },
        "Cookie Policy"
      ), ".")),
      /* @__PURE__ */ import_react12.default.createElement(
        "div",
        {
          className: (0, import_classnames10.default)(
            "v2-flex v2-gap-2 v2-justify-center v2-p-3 m:v2-py-0",
            "v2-flex-col min-[360px]:v2-flex-row"
          )
        },
        !hasConsent ? /* @__PURE__ */ import_react12.default.createElement(
          Button,
          {
            variant: "primary" /* Primary */,
            className: buttonClassName,
            onClick: handleOnAcceptAllClick
          },
          "Accept"
        ) : /* @__PURE__ */ import_react12.default.createElement(import_react12.default.Fragment, null, /* @__PURE__ */ import_react12.default.createElement(
          Button,
          {
            variant: "primary" /* Primary */,
            className: buttonClassName,
            onClick: handleOnAcceptAllClick
          },
          "Accept"
        ), /* @__PURE__ */ import_react12.default.createElement(
          Button,
          {
            variant: "secondary" /* Secondary */,
            className: buttonClassName,
            onClick: handleOnRejectClick
          },
          "Reject"
        ), /* @__PURE__ */ import_react12.default.createElement(
          Button,
          {
            variant: "secondary" /* Secondary */,
            className: buttonClassName,
            onClick: toggleOpen
          },
          "Manage preferences"
        ))
      )
    ),
    /* @__PURE__ */ import_react12.default.createElement(ManageCookieModal, __spreadValues({}, modalProps))
  ) : /* @__PURE__ */ import_react12.default.createElement(import_react12.default.Fragment, null);
}

// src/components/CookieDialog/CookieDialogConsent.tsx
var import_react13 = __toESM(require("react"));

// src/utils/cookie.ts
var CONSENT_SETTING_KEY = "consent-setting";
var GoogleConsentType = /* @__PURE__ */ ((GoogleConsentType2) => {
  GoogleConsentType2["AdStorage"] = "ad_storage";
  GoogleConsentType2["AdUserData"] = "ad_user_data";
  GoogleConsentType2["AdPersonalization"] = "ad_personalization";
  GoogleConsentType2["PersonalizationStorage"] = "personalization_storage";
  GoogleConsentType2["FunctionalityStorage"] = "functionality_storage";
  GoogleConsentType2["AnalyticsStorage"] = "analytics_storage";
  GoogleConsentType2["SecurityStorage"] = "security_storage";
  return GoogleConsentType2;
})(GoogleConsentType || {});
var implementedConsent = [
  {
    id: "analytical",
    title: "Analytical",
    description: "Analytical cookies are used to analyze and evaluate the performance of this website.",
    types: [
      "analytics_storage" /* AnalyticsStorage */,
      "security_storage" /* SecurityStorage */
    ]
  },
  {
    id: "preference",
    title: "Preference",
    description: "Preference cookies enables a website to remember information in order to individualize your content.",
    types: [
      "personalization_storage" /* PersonalizationStorage */,
      "functionality_storage" /* FunctionalityStorage */
    ]
  },
  {
    id: "marketing",
    title: "Marketing",
    description: "Marketing cookies are used to track visitors across websites in order to display engaging ads.",
    types: [
      "ad_storage" /* AdStorage */,
      "ad_user_data" /* AdUserData */,
      "ad_personalization" /* AdPersonalization */
    ]
  }
];
var mapToConsentObject = (value) => {
  return __spreadValues({}, Object.keys(GoogleConsentType).reduce(
    (newList, key2) => {
      const newKey = GoogleConsentType[key2];
      newList[newKey] = value.includes(newKey) ? "granted" : "denied";
      return newList;
    },
    {}
  ));
};
var gtagFn = (dataLayerName, gtagName) => {
  if (typeof window !== "undefined") {
    return (
      // eslint-disable-next-line
      window[gtagName] || // eslint-disable-next-line
      (window[gtagName] = function() {
        (window[dataLayerName] || (window[dataLayerName] = [])).push(arguments);
      })
    );
  }
  return () => {
  };
};
var setConsent = ({ value, intent = "update" }) => {
  const gtag = gtagFn("dataLayer", "gtag");
  const consent = mapToConsentObject(value);
  gtag("consent", intent, consent);
  localStorage == null ? void 0 : localStorage.setItem(CONSENT_SETTING_KEY, JSON.stringify(consent));
};

// src/components/CookieDialog/CookieDialogConsent.tsx
var allConsentTypes = implementedConsent.flatMap((item) => item.types);
function CookieDialogConsent({ config }) {
  var _a, _b;
  const cookieDialogProps = {
    config: {
      cookieName: (_a = config == null ? void 0 : config.cookieName) != null ? _a : "laravel_cookie_consent",
      cookieValue: (_b = config == null ? void 0 : config.cookieValue) != null ? _b : "1",
      cookieDomain: config == null ? void 0 : config.cookieDomain,
      cookieLifetime: config == null ? void 0 : config.cookieLifetime
    },
    consent: implementedConsent,
    onAcceptAllClick: () => {
      setConsent({ value: allConsentTypes });
    },
    onAcceptSelectedClick: (consent) => {
      const selectedConsentTypes = implementedConsent.filter((item) => consent.includes(item.id)).flatMap((item) => item.types);
      setConsent({ value: selectedConsentTypes });
    }
  };
  if ((localStorage == null ? void 0 : localStorage.getItem(CONSENT_SETTING_KEY)) != null) {
    const consentSetting = JSON.parse(
      localStorage == null ? void 0 : localStorage.getItem(CONSENT_SETTING_KEY)
    );
    const grantedConsent = Object.keys(consentSetting).filter(
      // eslint-disable-next-line
      (key2) => consentSetting[key2] == "granted"
    );
    setConsent({ value: grantedConsent, intent: "default" });
  } else {
    setConsent({ value: [], intent: "default" });
  }
  return /* @__PURE__ */ import_react13.default.createElement(CookieDialog, __spreadValues({}, cookieDialogProps));
}

// src/components/Select/index.tsx
var import_react17 = __toESM(require("react"));
var import_react_select2 = __toESM(require("react-select"));

// src/components/Select/Control.tsx
var import_react14 = __toESM(require("react"));
var import_classnames11 = __toESM(require("classnames"));
function Control(props) {
  const { children, isFocused, innerRef, innerProps } = props;
  const className = [
    props.className,
    "v2-relative v2-box-border",
    "v2-flex v2-items-center v2-justify-between v2-flex-wrap",
    "v2-bg-white",
    "v2-text-sm v2-font-normal",
    "v2-border v2-border-solid v2-rounded-md hover:v2-border-turquoise-500",
    "v2-shadow-none"
  ].join(" ");
  return /* @__PURE__ */ import_react14.default.createElement(
    "div",
    __spreadValues({
      ref: innerRef,
      className: (0, import_classnames11.default)(className, {
        "v2-text-turquoise-700 v2-border-turquoise-500": isFocused,
        "v2-text-neutral-400 v2-border-neutral-400": !isFocused
      })
    }, innerProps),
    children
  );
}

// src/components/Select/Option.tsx
var import_react15 = __toESM(require("react"));
var import_classnames12 = __toESM(require("classnames"));
function Option(props) {
  const { children, isDisabled, isFocused, isSelected, innerRef, innerProps } = props;
  const className = "v2-option v2-block v2-w-full v2-box-border v2-px-3 v2-py-2";
  return /* @__PURE__ */ import_react15.default.createElement(
    "div",
    __spreadValues({
      ref: innerRef,
      className: (0, import_classnames12.default)(className, {
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected v2-bg-turquoise-700 v2-text-white": isSelected,
        "v2-bg-turquoise-100": isFocused && !isSelected
      })
    }, innerProps),
    children
  );
}

// src/components/Select/DropdownIndicator.tsx
var import_react16 = __toESM(require("react"));
var import_react_select = require("react-select");
var import_classnames13 = __toESM(require("classnames"));
function DropdownIndicator(props) {
  const { menuIsOpen } = props.selectProps;
  return /* @__PURE__ */ import_react16.default.createElement(import_react_select.components.DropdownIndicator, __spreadValues({}, props), /* @__PURE__ */ import_react16.default.createElement(
    import_react_select.components.DownChevron,
    {
      className: (0, import_classnames13.default)("v2-transition-transform v2-transform", {
        "v2-rotate-180": menuIsOpen
      })
    }
  ));
}

// src/components/Select/index.tsx
function Select(_a) {
  var _b = _a, {
    clearable = false,
    disabled = false,
    loading = false,
    multi = false,
    rtl = false,
    searchable = false,
    relativeMenu = false,
    controlClassName,
    dropdownIndicatorClassName
  } = _b, props = __objRest(_b, [
    "clearable",
    "disabled",
    "loading",
    "multi",
    "rtl",
    "searchable",
    "relativeMenu",
    "controlClassName",
    "dropdownIndicatorClassName"
  ]);
  return /* @__PURE__ */ import_react17.default.createElement(
    import_react_select2.default,
    __spreadProps(__spreadValues({
      isClearable: clearable,
      isDisabled: disabled,
      isLoading: loading,
      isMulti: multi,
      isRtl: rtl,
      isSearchable: searchable
    }, props), {
      components: {
        Control: (controlProps) => /* @__PURE__ */ import_react17.default.createElement(Control, __spreadProps(__spreadValues({}, controlProps), { className: controlClassName })),
        Option,
        DropdownIndicator: (dropdownIndicatorProps) => /* @__PURE__ */ import_react17.default.createElement(
          DropdownIndicator,
          __spreadProps(__spreadValues({}, dropdownIndicatorProps), {
            className: dropdownIndicatorClassName
          })
        )
      },
      styles: {
        menu: (base) => __spreadProps(__spreadValues({}, base), {
          position: relativeMenu ? "relative" : "absolute"
        })
      }
    })
  );
}

// src/components/Panel/index.tsx
var import_react21 = __toESM(require("react"));
var import_classnames16 = __toESM(require("classnames"));

// src/components/Panel/PanelContext.ts
var import_react18 = require("react");
var PanelContext_default = (0, import_react18.createContext)({
  disabled: false,
  active: false
});

// src/components/Panel/RightIcon/index.tsx
var import_react19 = __toESM(require("react"));
var import_classnames14 = __toESM(require("classnames"));
var arrow = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/arrow.svg";
function RightIcon({ active }) {
  return /* @__PURE__ */ import_react19.default.createElement(
    "img",
    {
      className: (0, import_classnames14.default)("v2-transition-transform", {
        "v2-filter v2-invert v2-transform -v2-rotate-90 v2-opacity-30": !active
      }),
      src: arrow
    }
  );
}

// src/components/Panel/PanelGroup.tsx
var import_react20 = __toESM(require("react"));
var import_classnames15 = __toESM(require("classnames"));
function PanelGroup(_a) {
  var _b = _a, {
    className,
    children
  } = _b, props = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ import_react20.default.createElement(
    "div",
    __spreadValues({
      className: (0, import_classnames15.default)(
        className,
        "v2-py-2 v2-px-3 v2-overflow-y-auto",
        "v2-scrollbar-thin scrollbar-track-neutral-200 scrollbar-track-rounded-full",
        "scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full"
      )
    }, props),
    children
  );
}

// src/components/Panel/index.tsx
function Panel({
  panelNumber,
  title,
  children,
  active = false,
  disabled = false,
  onClick,
  rightIcon,
  overflowVisible = false,
  activePanelHeight,
  hidePanelNumber = false,
  hideRightIcon = false
}) {
  const [height, setHeight] = (0, import_react21.useState)(
    active ? activePanelHeight : 0
  );
  const [overflow, setOverflow] = (0, import_react21.useState)(
    active && activePanelHeight ? "hidden auto" /* Auto */ : "hidden" /* Hidden */
  );
  const parentRef = (0, import_react21.useRef)(null);
  const childRef = (0, import_react21.useRef)(null);
  (0, import_react21.useEffect)(() => {
    if (!height || !active || !childRef.current)
      return void 0;
    const resizeObserver = new ResizeObserver((el) => {
      const newHeight = !activePanelHeight ? el[0].contentRect.height : Math.min(activePanelHeight, el[0].contentRect.height);
      setHeight(newHeight);
    });
    resizeObserver.observe(childRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [height, activePanelHeight, active]);
  (0, import_react21.useEffect)(() => {
    var _a;
    if (active) {
      const childRefHeight = (_a = childRef.current) == null ? void 0 : _a.getBoundingClientRect().height;
      const newHeight = !activePanelHeight ? childRefHeight : Math.min(activePanelHeight, childRefHeight);
      setHeight(newHeight);
    } else {
      setHeight(0);
    }
  }, [active]);
  const context = (0, import_react21.useMemo)(
    () => ({
      disabled,
      active
    }),
    [disabled, active]
  );
  const handleClick = (event) => {
    if (disabled || active) {
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleTransitionEnd = () => {
    if (!active)
      return;
    if (overflowVisible) {
      setOverflow("visible" /* Visible */);
    } else if (activePanelHeight) {
      setOverflow("hidden auto" /* Auto */);
    }
  };
  return /* @__PURE__ */ import_react21.default.createElement(PanelContext_default.Provider, { value: context }, /* @__PURE__ */ import_react21.default.createElement(
    "div",
    {
      className: (0, import_classnames16.default)(
        "v2-bg-white v2-w-auto v2-border-2 v2-border-solid v2-rounded-md v2-mb-6 last:v2-mb-0 v2-shadow-around",
        {
          "v2-border-turquoise-700": active,
          "v2-border-transparent": !active
        }
      ),
      role: !disabled && !active ? "button" : "",
      onClick: handleClick
    },
    /* @__PURE__ */ import_react21.default.createElement(
      "div",
      {
        className: (0, import_classnames16.default)("v2-flex v2-items-center v2-gap-x-5 v2-p-5", {
          "v2-bg-turquoise-700": active,
          "v2-bg-transparent": !active
        })
      },
      !hidePanelNumber && /* @__PURE__ */ import_react21.default.createElement("span", { className: "v2-text-sm v2-text-turquoise-700 v2-bg-white v2-border v2-border-solid v2-border-turquoise-700 v2-rounded-full v2-h-5 v2-w-5 v2-flex v2-items-center v2-justify-center" }, panelNumber),
      /* @__PURE__ */ import_react21.default.createElement(
        "span",
        {
          className: (0, import_classnames16.default)("v2-text-sm", {
            "v2-text-white": active
          })
        },
        title
      ),
      !hideRightIcon && /* @__PURE__ */ import_react21.default.createElement("div", { className: "v2-ml-auto" }, rightIcon != null ? rightIcon : /* @__PURE__ */ import_react21.default.createElement(RightIcon, { active }))
    ),
    /* @__PURE__ */ import_react21.default.createElement(
      "div",
      {
        ref: parentRef,
        className: (0, import_classnames16.default)(
          "v2-transition-all v2-duration-300",
          "v2-scrollbar-thin scrollbar-track-neutral-200",
          "scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full"
        ),
        style: { height, overflow },
        onTransitionEnd: handleTransitionEnd
      },
      /* @__PURE__ */ import_react21.default.createElement("div", { ref: childRef }, /* @__PURE__ */ import_react21.default.createElement("div", { className: "v2-p-5" }, children))
    )
  ));
}

// src/components/TextArea/index.tsx
var import_react22 = __toESM(require("react"));
var import_classnames17 = __toESM(require("classnames"));
var defaultClassName = [
  "v2-text-sm v2-w-full v2-p-3",
  "v2-border v2-border-neutral-300 v2-rounded-md",
  "focus:v2-border-turquoise-700 hover:v2-border-turquoise-700",
  "v2-outline-none v2-resize-none"
].join(" ");
function TextArea(_a) {
  var _b = _a, {
    label,
    value = "",
    placeholder,
    rows = 1,
    maxHeight,
    inputRef,
    className,
    style
  } = _b, props = __objRest(_b, [
    "label",
    "value",
    "placeholder",
    "rows",
    "maxHeight",
    "inputRef",
    "className",
    "style"
  ]);
  var _a2;
  const textAreaRef = inputRef != null ? inputRef : (0, import_react22.useRef)(null);
  const [text, setText] = (0, import_react22.useState)(value);
  const [textAreaHeight, setTextAreaHeight] = (0, import_react22.useState)("auto");
  (0, import_react22.useEffect)(() => setTextAreaHeight("auto"), [rows]);
  (0, import_react22.useEffect)(() => {
    const scrollHeight = textAreaRef.current.scrollHeight;
    if (maxHeight && maxHeight <= scrollHeight) {
      setTextAreaHeight(`${maxHeight}px`);
      return;
    }
    const newHeight = !text && !placeholder ? "auto" : `${scrollHeight}px`;
    setTextAreaHeight(newHeight);
  }, [text, placeholder, maxHeight]);
  (0, import_react22.useEffect)(() => setText(value), [value]);
  const onChangeHandler = (event) => {
    var _a3;
    setTextAreaHeight("auto");
    setText(event.target.value);
    (_a3 = props.onChange) == null ? void 0 : _a3.call(props, event);
  };
  const isScrollbarVisible = text && maxHeight && `${maxHeight}px` === textAreaHeight;
  return /* @__PURE__ */ import_react22.default.createElement(import_react22.default.Fragment, null, label, /* @__PURE__ */ import_react22.default.createElement(
    "textarea",
    __spreadProps(__spreadValues({
      className: (0, import_classnames17.default)(defaultClassName, className, {
        "v2-overflow-y-auto": isScrollbarVisible,
        "v2-scrollbar-thin scrollbar-track-neutral-200": isScrollbarVisible,
        "scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full": isScrollbarVisible,
        "v2-overflow-hidden": !isScrollbarVisible
      })
    }, props), {
      value: text,
      placeholder,
      ref: textAreaRef,
      rows,
      style: {
        height: (_a2 = style == null ? void 0 : style.height) != null ? _a2 : textAreaHeight
      },
      onChange: onChangeHandler
    })
  ));
}

// src/components/Questionnaire/index.tsx
var import_react35 = __toESM(require("react"));
var import_react_fontawesome6 = require("@fortawesome/react-fontawesome");
var import_classnames24 = __toESM(require("classnames"));

// src/components/Questionnaire/Question.tsx
var import_react34 = __toESM(require("react"));
var import_react_fontawesome5 = require("@fortawesome/react-fontawesome");
var import_classnames23 = __toESM(require("classnames"));

// src/components/RichTextEditor/Buttons/BaseButton.tsx
var import_react23 = __toESM(require("react"));
var import_classnames18 = __toESM(require("classnames"));
var BaseButton = (_a) => {
  var _b = _a, {
    className,
    icon,
    active,
    onClick
  } = _b, props = __objRest(_b, [
    "className",
    "icon",
    "active",
    "onClick"
  ]);
  return /* @__PURE__ */ import_react23.default.createElement(
    "button",
    __spreadProps(__spreadValues({}, props), {
      className: (0, import_classnames18.default)(
        className,
        [
          "v2-border-0 v2-cursor-pointer v2-px-1.5 v2-flex v2-items-center",
          "hover:v2-bg-turquoise-100 v2-rounded v2-select-none v2-h-6"
        ],
        {
          "v2-bg-neutral-100": !active,
          "v2-bg-neutral-200": active,
          "v2-opacity-20": props.disabled
        }
      ),
      onMouseDown: (event) => {
        event.preventDefault();
        onClick == null ? void 0 : onClick();
      }
    }),
    icon
  );
};

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var import_react33 = __toESM(require("react"));
var import_slate_react5 = require("slate-react");

// src/components/RichTextEditor/utils.ts
var import_slate3 = require("slate");

// src/components/RichTextEditor/types.ts
var SlateVersionType = /* @__PURE__ */ ((SlateVersionType2) => {
  SlateVersionType2["V1"] = "slate";
  return SlateVersionType2;
})(SlateVersionType || {});
var TextStyle = /* @__PURE__ */ ((TextStyle4) => {
  TextStyle4["Bold"] = "bold";
  TextStyle4["Italic"] = "italic";
  TextStyle4["Underline"] = "underline";
  return TextStyle4;
})(TextStyle || {});
var BlockElementStyle = /* @__PURE__ */ ((BlockElementStyle2) => {
  BlockElementStyle2["BlockQuote"] = "block-quote";
  BlockElementStyle2["BulletedList"] = "bulleted-list";
  BlockElementStyle2["HeadingOne"] = "heading-one";
  BlockElementStyle2["HeadingTwo"] = "heading-two";
  BlockElementStyle2["ListItem"] = "list-item";
  BlockElementStyle2["NumberedList"] = "numbered-list";
  BlockElementStyle2["Paragraph"] = "paragraph";
  BlockElementStyle2["AlignLeft"] = "left";
  BlockElementStyle2["AlignRight"] = "right";
  BlockElementStyle2["AlignCenter"] = "center";
  BlockElementStyle2["AlignJustify"] = "justify";
  return BlockElementStyle2;
})(BlockElementStyle || {});
var TextAlignType = /* @__PURE__ */ ((TextAlignType2) => {
  TextAlignType2["Center"] = "center";
  TextAlignType2["Left"] = "left";
  TextAlignType2["Right"] = "right";
  TextAlignType2["Justify"] = "justify";
  return TextAlignType2;
})(TextAlignType || {});
var hotkeys = {
  "mod+b": "bold" /* Bold */,
  "mod+i": "italic" /* Italic */,
  "mod+u": "underline" /* Underline */
};
var listStyles = [
  "numbered-list" /* NumberedList */,
  "bulleted-list" /* BulletedList */
];

// src/components/RichTextEditor/Editor/index.tsx
var import_react32 = __toESM(require("react"));
var import_is_hotkey = __toESM(require_lib());
var import_slate_react4 = require("slate-react");
var import_classnames22 = __toESM(require("classnames"));

// src/components/RichTextEditor/Renderer/Element.tsx
var import_react24 = __toESM(require("react"));
var import_styled2 = __toESM(require("@emotion/styled"));
var OrderedList = import_styled2.default.ol`
  li {
    padding-bottom: 0.75rem;
  }
`;
var Element2 = ({ attributes, children, element }) => {
  const style = { textAlign: element.align, color: "unset" };
  switch (element.type) {
    case "heading-one" /* HeadingOne */:
      return /* @__PURE__ */ import_react24.default.createElement(
        "h1",
        __spreadValues({
          className: "v2-text-[2rem] v2-font-normal v2-leading-10 v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "heading-two" /* HeadingTwo */:
      return /* @__PURE__ */ import_react24.default.createElement(
        "h2",
        __spreadValues({
          className: "v2-text-2xl v2-font-normal v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "bulleted-list" /* BulletedList */:
      return /* @__PURE__ */ import_react24.default.createElement(
        "ul",
        __spreadValues({
          className: "v2-list-inside v2-list-disc v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "list-item" /* ListItem */:
      return /* @__PURE__ */ import_react24.default.createElement("li", __spreadValues({ style }, attributes), children);
    case "numbered-list" /* NumberedList */:
      return /* @__PURE__ */ import_react24.default.createElement(
        OrderedList,
        __spreadValues({
          className: "v2-list-inside v2-list-decimal v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    default:
      return /* @__PURE__ */ import_react24.default.createElement(
        "p",
        __spreadValues({
          className: "v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
  }
};

// src/components/RichTextEditor/Renderer/Leaf.tsx
var import_react25 = __toESM(require("react"));
var Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = /* @__PURE__ */ import_react25.default.createElement("strong", { className: "v2-font-bold" }, children);
  }
  if (leaf.italic) {
    children = /* @__PURE__ */ import_react25.default.createElement("em", { className: "v2-italic" }, children);
  }
  if (leaf.underline) {
    children = /* @__PURE__ */ import_react25.default.createElement("u", { className: "v2-underline" }, children);
  }
  if (leaf.decoration === "link" /* Link */) {
    children = /* @__PURE__ */ import_react25.default.createElement(
      "a",
      {
        className: "v2-text-blue-400 hover:!v2-text-blue-300",
        href: leaf.text,
        target: "_blank",
        rel: "noreferrer"
      },
      children
    );
  }
  return /* @__PURE__ */ import_react25.default.createElement("span", __spreadValues({}, attributes), children);
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_react29 = __toESM(require("react"));

// src/components/RichTextEditor/Buttons/MarkButton.tsx
var import_react26 = __toESM(require("react"));
var import_slate_react = require("slate-react");
var MarkButton = ({
  className,
  type,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react.useSlate)();
  const onClickHandler = () => toggleMark(editor, type);
  return /* @__PURE__ */ import_react26.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isMarkActive(editor, type),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_classnames20 = __toESM(require("classnames"));

// src/components/RichTextEditor/Toolbar/GroupContainer.tsx
var import_react27 = __toESM(require("react"));
var import_classnames19 = __toESM(require("classnames"));
function GroupContainer({ className, children }) {
  return /* @__PURE__ */ import_react27.default.createElement(
    "div",
    {
      className: (0, import_classnames19.default)(
        className,
        "v2-flex v2-px-1.5 sm:v2-gap-x-2.5 sm:v2-px-2.5"
      )
    },
    children
  );
}

// src/components/RichTextEditor/Buttons/FormatButton.tsx
var import_react28 = __toESM(require("react"));
var import_slate_react2 = require("slate-react");
var import_slate = require("slate");
var clearBlockFormatting = (editor) => {
  import_slate.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate.Editor.isEditor(n) && import_slate.Element.isElement(n) && listStyles.includes(n.type),
    split: true
  });
  import_slate.Transforms.setNodes(editor, {
    type: "paragraph" /* Paragraph */
  });
};
var clearMarkFormatting = (editor) => {
  import_slate.Editor.removeMark(editor, "bold" /* Bold */);
  import_slate.Editor.removeMark(editor, "italic" /* Italic */);
  import_slate.Editor.removeMark(editor, "underline" /* Underline */);
};
var clearFormatting = (editor) => {
  clearBlockFormatting(editor);
  clearMarkFormatting(editor);
};
var FormatButton = ({
  className,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react2.useSlate)();
  const onClickHandler = () => clearFormatting(editor);
  return /* @__PURE__ */ import_react28.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var boldMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bold-mark.svg";
var italicMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/italic-mark.svg";
var underlineMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/underline-mark.svg";
var bulletedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bulleted-block.svg";
var numberedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/numbered-block.svg";
var headingOneBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-one-block.svg";
var headingTwoBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-two-block.svg";
var clearFormatIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/clear-format.svg";
function Toolbar({
  className,
  groupClassName,
  config,
  containerRef,
  disabled = false,
  toolbarPosition = "bottom"
}) {
  const {
    hideBold,
    hideUnderline,
    hideItalic,
    hideBulletedList,
    hideNumberedList,
    hideHeadingOne,
    hideHeadingTwo,
    hideClearFormat
  } = (0, import_react29.useMemo)(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      hideBold: (_a = config == null ? void 0 : config.hideBold) != null ? _a : false,
      hideUnderline: (_b = config == null ? void 0 : config.hideUnderline) != null ? _b : false,
      hideItalic: (_c = config == null ? void 0 : config.hideItalic) != null ? _c : false,
      hideBulletedList: (_d = config == null ? void 0 : config.hideBulletedList) != null ? _d : false,
      hideNumberedList: (_e = config == null ? void 0 : config.hideNumberedList) != null ? _e : false,
      hideHeadingOne: (_f = config == null ? void 0 : config.hideHeadingOne) != null ? _f : false,
      hideHeadingTwo: (_g = config == null ? void 0 : config.hideHeadingTwo) != null ? _g : false,
      hideClearFormat: (_h = config == null ? void 0 : config.hideClearFormat) != null ? _h : false
    };
  }, [config]);
  const headingButtons = (!hideHeadingOne || !hideHeadingTwo) && /* @__PURE__ */ import_react29.default.createElement(GroupContainer, { className: groupClassName }, !hideHeadingOne && /* @__PURE__ */ import_react29.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-one" /* HeadingOne */,
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingOneBlockIcon })
    }
  ), !hideHeadingTwo && /* @__PURE__ */ import_react29.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-two" /* HeadingTwo */,
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingTwoBlockIcon })
    }
  ));
  const formatButtons = (!hideBold || !hideItalic || !hideUnderline) && /* @__PURE__ */ import_react29.default.createElement(GroupContainer, { className: groupClassName }, !hideBold && /* @__PURE__ */ import_react29.default.createElement(
    MarkButton,
    {
      disabled,
      type: "bold" /* Bold */,
      className: "!v2-px-[7px]",
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-3 v2-w-2.5", src: boldMarkIcon })
    }
  ), !hideItalic && /* @__PURE__ */ import_react29.default.createElement(
    MarkButton,
    {
      disabled,
      type: "italic" /* Italic */,
      className: "!v2-px-2",
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-3 v2-w-2", src: italicMarkIcon })
    }
  ), !hideUnderline && /* @__PURE__ */ import_react29.default.createElement(
    MarkButton,
    {
      disabled,
      type: "underline" /* Underline */,
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-3 v2-w-3", src: underlineMarkIcon })
    }
  ));
  const listButtons = (!hideBulletedList || !hideNumberedList) && /* @__PURE__ */ import_react29.default.createElement(GroupContainer, { className: groupClassName }, !hideBulletedList && /* @__PURE__ */ import_react29.default.createElement(
    BlockButton,
    {
      disabled,
      style: "bulleted-list" /* BulletedList */,
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-4 v2-w-3", src: bulletedBlockIcon })
    }
  ), !hideNumberedList && /* @__PURE__ */ import_react29.default.createElement(
    BlockButton,
    {
      disabled,
      style: "numbered-list" /* NumberedList */,
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-4 v2-w-3", src: numberedBlockIcon })
    }
  ));
  const clearFormatButton = !hideClearFormat && /* @__PURE__ */ import_react29.default.createElement(GroupContainer, { className: groupClassName }, /* @__PURE__ */ import_react29.default.createElement(
    FormatButton,
    {
      disabled,
      className: "!v2-px-1.5 !v2-py-1",
      icon: /* @__PURE__ */ import_react29.default.createElement("img", { className: "v2-h-3 v2-w-3", src: clearFormatIcon })
    }
  ));
  const buttonComponents = (0, import_react29.useMemo)(() => {
    const components2 = [
      headingButtons,
      formatButtons,
      listButtons,
      clearFormatButton
    ];
    return components2.filter((component) => component != false);
  }, [config]);
  return /* @__PURE__ */ import_react29.default.createElement(
    "div",
    {
      ref: containerRef,
      className: (0, import_classnames20.default)(className, ["v2-flex v2-py-1 v2-bg-neutral-100 v2-h-8"], {
        "v2-rounded-t-sm": toolbarPosition == "top",
        "v2-rounded-b-sm": toolbarPosition == "bottom"
      })
    },
    buttonComponents.map((child, index) => /* @__PURE__ */ import_react29.default.createElement(import_react29.default.Fragment, { key: index }, !!index && /* @__PURE__ */ import_react29.default.createElement("span", { className: "v2-h-6 v2-w-[1px] v2-bg-neutral-300" }), child))
  );
}

// src/components/RichTextEditor/Container/index.tsx
var import_react30 = __toESM(require("react"));
var import_classnames21 = __toESM(require("classnames"));
function Container(_a) {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ import_react30.default.createElement("div", __spreadValues({ className: (0, import_classnames21.default)(className, "v2-font-circular") }, props), children);
}

// src/components/RichTextEditor/use-editor-hook.ts
var import_react31 = require("react");
var import_slate2 = require("slate");
var import_slate_history = require("slate-history");
var import_slate_react3 = require("slate-react");
var useEditor = () => {
  return {
    editor: (0, import_react31.useMemo)(() => (0, import_slate_history.withHistory)((0, import_slate_react3.withReact)((0, import_slate2.createEditor)())), [])
  };
};

// src/utils/url.ts
var findUrlsInText = (text) => {
  const urlRegex = (
    // eslint-disable-next-line no-useless-escape
    /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim
  );
  const matches = text.match(urlRegex);
  return matches ? matches.map((m) => [m.trim(), text.indexOf(m.trim())]) : [];
};

// src/components/RichTextEditor/Editor/index.tsx
var defaultEmptyRichTextValue = [
  {
    type: "paragraph" /* Paragraph */,
    children: [
      {
        text: ""
      }
    ]
  }
];
var RichTextEditor = (_a) => {
  var _b = _a, {
    value,
    onChange,
    placeholder = "Enter some rich text\u2026",
    className,
    editorClassName,
    toolbarClassName,
    toolbarGroupClassName,
    toolbarConfig,
    toolbarPosition = "bottom",
    editor: initialEditor,
    hideToolbar = false,
    onKeyDown,
    onScrollToView,
    style
  } = _b, props = __objRest(_b, [
    "value",
    "onChange",
    "placeholder",
    "className",
    "editorClassName",
    "toolbarClassName",
    "toolbarGroupClassName",
    "toolbarConfig",
    "toolbarPosition",
    "editor",
    "hideToolbar",
    "onKeyDown",
    "onScrollToView",
    "style"
  ]);
  const { readOnly } = props;
  const toolbarRef = (0, import_react32.useRef)(null);
  const [content, setContent] = (0, import_react32.useState)(
    value != null ? value : defaultEmptyRichTextValue
  );
  const editor = initialEditor != null ? initialEditor : useEditor().editor;
  const slateDecorator = ([node2, path]) => {
    const nodeText = node2.text;
    if (!nodeText)
      return [];
    const urls = findUrlsInText(nodeText);
    return urls.map(([url, index]) => {
      return {
        anchor: {
          path,
          offset: index
        },
        focus: {
          path,
          offset: index + url.length
        },
        decoration: "link" /* Link */
      };
    });
  };
  const onKeyDownHandler = (event) => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    for (const hotkey in hotkeys) {
      if ((0, import_is_hotkey.default)(hotkey, event)) {
        event.preventDefault();
        const mark = hotkeys[hotkey];
        toggleMark(editor, mark);
      }
    }
  };
  (0, import_react32.useEffect)(() => {
    if (value !== null && value !== void 0) {
      editor.children = value;
      setContent(value);
    }
  }, [value]);
  const onChangeHandler = (value2) => {
    setContent(value2);
    onChange == null ? void 0 : onChange(value2);
  };
  return /* @__PURE__ */ import_react32.default.createElement(import_slate_react4.Slate, { editor, initialValue: content, onChange: onChangeHandler }, /* @__PURE__ */ import_react32.default.createElement(
    Container,
    {
      style,
      className: (0, import_classnames22.default)(
        className,
        [
          "v2-rounded v2-border v2-border-neutral-200 v2-border-solid",
          "v2-flex v2-h-full v2-w-full v2-text-neutral-900"
        ],
        {
          "v2-flex-col": toolbarPosition === "bottom",
          "v2-flex-col-reverse": toolbarPosition === "top"
        }
      )
    },
    /* @__PURE__ */ import_react32.default.createElement(
      import_slate_react4.Editable,
      __spreadProps(__spreadValues({}, props), {
        key: "rich-text-editor",
        renderElement: Element2,
        renderLeaf: Leaf,
        placeholder,
        renderPlaceholder: ({ attributes, children }) => /* @__PURE__ */ import_react32.default.createElement(
          "span",
          __spreadProps(__spreadValues({}, attributes), {
            style: __spreadProps(__spreadValues({}, attributes.style), {
              display: "unset"
            })
          }),
          children
        ),
        className: (0, import_classnames22.default)(editorClassName, [
          "v2-scrollbar-thin v2-scrollbar-track-neutral-200 v2-p-2",
          "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full",
          "v2-overflow-x-hidden v2-h-full v2-w-auto v2-outline-none"
        ]),
        onKeyDown: onKeyDownHandler,
        scrollSelectionIntoView: onScrollToView,
        decorate: slateDecorator
      })
    ),
    !hideToolbar && /* @__PURE__ */ import_react32.default.createElement(
      Toolbar,
      {
        key: "rich-text-toolbar",
        containerRef: toolbarRef,
        className: toolbarClassName,
        groupClassName: toolbarGroupClassName,
        config: toolbarConfig,
        toolbarPosition,
        disabled: readOnly
      }
    )
  ));
};

// src/components/RichTextEditor/utils.ts
var checkIfTextAlignType = (style) => {
  return Object.values(TextAlignType).includes(
    style
  );
};
var isBlockActive = (editor, style, blockType = "type") => {
  const { selection } = editor;
  if (!selection)
    return false;
  const [match2] = Array.from(
    import_slate3.Editor.nodes(editor, {
      at: import_slate3.Editor.unhangRange(editor, selection),
      match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && n[blockType] === style
    })
  );
  return !!match2;
};
var isMarkActive = (editor, style) => {
  const marks = import_slate3.Editor.marks(editor);
  return marks ? marks[style] === true : false;
};
var toggleBlock = (editor, style) => {
  const isTextAlignType = checkIfTextAlignType(style);
  const isList = listStyles.includes(style);
  const isActive = isBlockActive(
    editor,
    style,
    isTextAlignType ? "align" : "type"
  );
  import_slate3.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && listStyles.includes(n.type) && !isTextAlignType,
    split: true
  });
  let newProperties;
  if (isTextAlignType) {
    newProperties = {
      align: isActive ? void 0 : style
    };
  } else {
    newProperties = {
      type: isActive ? "paragraph" /* Paragraph */ : isList ? "list-item" /* ListItem */ : style
    };
  }
  import_slate3.Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    const block = { type: style, children: [] };
    import_slate3.Transforms.wrapNodes(editor, block);
  }
};
var toggleMark = (editor, style) => {
  const isActive = isMarkActive(editor, style);
  if (isActive) {
    import_slate3.Editor.removeMark(editor, style);
  } else {
    import_slate3.Editor.addMark(editor, style, true);
  }
};
var parseRichTextToString = (value) => {
  return value.map((n) => import_slate3.Node.string(n)).join("\n");
};
var parseStringToRichText = (value) => {
  return value.split("\n").map((line2) => {
    return {
      children: [{ text: line2 }]
    };
  });
};
function parseRichTextToSlateData(data, type = "slate" /* V1 */) {
  return [{ type, data }];
}
function getRichTextFromSlateData(data, type = "slate" /* V1 */) {
  var _a, _b;
  const filteredData = (_b = (_a = data == null ? void 0 : data.filter((slate) => slate.type === type)) == null ? void 0 : _a[0]) == null ? void 0 : _b.data;
  return filteredData != null ? filteredData : defaultEmptyRichTextValue;
}

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var BlockButton = ({
  className,
  style,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react5.useSlate)();
  const onClickHandler = () => toggleBlock(editor, style);
  return /* @__PURE__ */ import_react33.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isBlockActive(
        editor,
        style,
        checkIfTextAlignType(style) ? "align" : "type"
      ),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/Questionnaire/Question.tsx
var questionnaireToolbarClassName = "sm:lg:v2-px-1.5 sm:lg:v2-gap-x-0 2xl:v2-gap-x-2.5 2xl:v2-px-2.5";
function Question({
  number = 1,
  value,
  placeholder,
  onUpdate,
  onDelete,
  onFocus,
  inputType = "textarea" /* TextArea */,
  labelClassName,
  deleteButtonClassName,
  inputClassName
}) {
  const index = (0, import_react34.useMemo)(() => number - 1, [number]);
  const textAreaProps = {
    className: (0, import_classnames23.default)(inputClassName, "v2-bg-white v2-mb-3"),
    placeholder,
    onFocus: () => onFocus == null ? void 0 : onFocus(index)
  };
  const textArea = inputType === "textarea" /* TextArea */ ? /* @__PURE__ */ import_react34.default.createElement(
    TextArea,
    __spreadProps(__spreadValues({}, textAreaProps), {
      value: value != null ? value : "",
      onChange: (event) => {
        onUpdate == null ? void 0 : onUpdate({
          index,
          value: event.target.value
        });
      }
    })
  ) : /* @__PURE__ */ import_react34.default.createElement(
    RichTextEditor,
    __spreadProps(__spreadValues({}, textAreaProps), {
      editorClassName: "!v2-min-h-[75px]",
      toolbarGroupClassName: questionnaireToolbarClassName,
      value: value != null ? value : parseStringToRichText(""),
      onChange: (value2) => onUpdate == null ? void 0 : onUpdate({ index, value: value2 })
    })
  );
  return /* @__PURE__ */ import_react34.default.createElement("div", { className: "v2-flex v2-flex-col" }, /* @__PURE__ */ import_react34.default.createElement("div", { className: "v2-flex v2-justify-between v2-items-center v2-mb-3" }, /* @__PURE__ */ import_react34.default.createElement(
    "p",
    {
      className: (0, import_classnames23.default)(
        labelClassName,
        "v2-text-sm v2-text-white v2-font-bold m-0"
      )
    },
    "Question ",
    number
  ), number > 1 && /* @__PURE__ */ import_react34.default.createElement(
    import_react_fontawesome5.FontAwesomeIcon,
    {
      role: "button",
      className: (0, import_classnames23.default)(
        deleteButtonClassName,
        "v2-text-white v2-text-sm hover:!v2-text-orange-600"
      ),
      icon: faTrash,
      onClick: () => onDelete == null ? void 0 : onDelete(index)
    }
  )), textArea);
}

// src/components/Questionnaire/index.tsx
function Questionnaire({
  data,
  maxQuestions,
  onAdd,
  onUpdate,
  onDelete,
  onFocus,
  inputType,
  labelClassName,
  deleteButtonClassName,
  addButtonClassName,
  addButtonTextClassName,
  inputClassName
}) {
  return /* @__PURE__ */ import_react35.default.createElement(import_react35.default.Fragment, null, data.map((question, index) => /* @__PURE__ */ import_react35.default.createElement(
    Question,
    __spreadValues({
      key: index,
      number: index + 1,
      onUpdate,
      onDelete,
      onFocus,
      inputType,
      labelClassName,
      deleteButtonClassName,
      inputClassName
    }, question)
  )), data.length < maxQuestions && /* @__PURE__ */ import_react35.default.createElement(
    Button,
    {
      variant: "secondary-white" /* SecondaryWhite */,
      className: (0, import_classnames24.default)(addButtonClassName, "v2-w-full"),
      onClick: onAdd
    },
    /* @__PURE__ */ import_react35.default.createElement(
      "div",
      {
        className: (0, import_classnames24.default)(
          addButtonTextClassName,
          "v2-flex v2-justify-center v2-items-center v2-gap-x-3"
        )
      },
      /* @__PURE__ */ import_react35.default.createElement(import_react_fontawesome6.FontAwesomeIcon, { className: "v2-text-2xl", icon: faPlus }),
      "Add a question"
    )
  ));
}

// src/components/Tabs/index.tsx
var import_classnames25 = __toESM(require("classnames"));
var import_react37 = __toESM(require("react"));

// src/components/Tabs/Tab.tsx
var import_react36 = __toESM(require("react"));
function Tab(props) {
  return /* @__PURE__ */ import_react36.default.createElement("div", null);
}

// src/components/Tabs/index.tsx
var defaultUlClassName = ["v2-list-none v2-p-0", "v2-flex v2-flex-wrap"].join(
  " "
);
var defaultLiClassName = ["v2-flex-initial", "v2-rounded-t"].join(" ");
var defaultLiButtonClassName = [
  "v2-text-neutral-900 v2-font-circular v2-rounded-t",
  "v2-text-base v2-font-semibold v2-text-neutral-900",
  "v2-items-center v2-justify-center v2-py-2.5 v2-px-5",
  "disabled:v2-opacity-50"
].join(" ");
var TabTheme = /* @__PURE__ */ ((TabTheme2) => {
  TabTheme2["Default"] = "default";
  TabTheme2["Blue"] = "blue";
  return TabTheme2;
})(TabTheme || {});
var themes2 = {
  ["default" /* Default */]: {
    ulClassName: "v2-border-solid v2-border-0 v2-border-neutral-200 v2-mb-0",
    liButtonClassName: "hover:v2-bg-yellow-50 v2-bg-transparent v2-border-0",
    activeLiClassName: "v2-bg-yellow-50"
  },
  ["blue" /* Blue */]: {
    ulClassName: "v2-gap-x-0.5 v2-border-none",
    liClassName: "flex-1 w-full",
    liButtonClassName: (0, import_classnames25.default)(
      "v2-border-0 v2-border-b-[5px] v2-border-solid v2-border-neutral-200",
      "v2-transform v2-transition-all hover:v2-border-blue-500 v2-duration-300",
      "v2-bg-transparent w-full"
    ),
    activeLiButtonClassName: "v2-border-blue-500"
  }
};
function Tabs({
  id,
  active = 0,
  className,
  children,
  toolbar,
  setActive,
  tabHeaderClassName,
  tabContentClassName,
  tabPanelClassName,
  ulClassName,
  liClassName,
  activeLiClassName = "",
  liButtonClassName,
  activeLiButtonClassName = "",
  hideBottomBorder = false,
  theme: theme2 = "default" /* Default */
}) {
  const themeClasses = themes2[theme2];
  const {
    activeLiClassName: themeActiveLiClassName = "",
    activeLiButtonClassName: themeActiveLiButtonClassName = ""
  } = themeClasses;
  const handleTabClick = (index) => {
    setActive == null ? void 0 : setActive(index);
  };
  const tabParts = (0, import_react37.useMemo)(() => {
    const tabList = [];
    const tabPanel = [];
    children == null ? void 0 : children.forEach((child, index) => {
      var _a;
      if (!child || !(((_a = child == null ? void 0 : child.type) == null ? void 0 : _a.name) == Tab.name)) {
        return;
      }
      const activeTab = index == active;
      const { disabled, children: children2, onClick } = child.props;
      const onTabClick = () => {
        onClick == null ? void 0 : onClick();
        handleTabClick(index);
      };
      tabList.push(
        /* @__PURE__ */ import_react37.default.createElement(
          "li",
          {
            id: child.props.id,
            role: "presentation",
            key: index,
            className: (0, import_classnames25.default)(
              "tab-list-item",
              liClassName,
              themeClasses == null ? void 0 : themeClasses.liClassName,
              defaultLiClassName,
              {
                active: activeTab,
                [`${activeLiClassName}`]: activeTab,
                [`${themeActiveLiClassName}`]: activeTab
              }
            ),
            onClick: onTabClick
          },
          /* @__PURE__ */ import_react37.default.createElement(
            "button",
            {
              role: "tab",
              className: (0, import_classnames25.default)(
                "tab-list-button",
                liButtonClassName,
                defaultLiButtonClassName,
                themeClasses == null ? void 0 : themeClasses.liButtonClassName,
                {
                  [`${activeLiButtonClassName}`]: activeTab,
                  [`${themeActiveLiButtonClassName}`]: activeTab
                }
              ),
              disabled
            },
            child.props.title
          )
        )
      );
      tabPanel.push(
        /* @__PURE__ */ import_react37.default.createElement(
          "div",
          {
            role: "tabpanel",
            key: index,
            className: (0, import_classnames25.default)(
              "tab-panel",
              tabPanelClassName,
              themeClasses == null ? void 0 : themeClasses.tabPanelClassName,
              "v2-absolute v2-p-2 v2-w-full v2-transition-opacity",
              {
                "v2-hidden v2-z-0": !activeTab,
                "v2-z-10": activeTab
              }
            )
          },
          children2
        )
      );
    });
    return {
      tabList,
      tabPanel
    };
  }, [active]);
  return /* @__PURE__ */ import_react37.default.createElement("div", { id, className }, /* @__PURE__ */ import_react37.default.createElement(
    "div",
    {
      className: (0, import_classnames25.default)(
        "tab-header v2-mb-2",
        tabHeaderClassName,
        themeClasses == null ? void 0 : themeClasses.tabHeaderClassName
      )
    },
    /* @__PURE__ */ import_react37.default.createElement(
      "ul",
      {
        role: "tablist",
        className: (0, import_classnames25.default)(
          "tab-list",
          ulClassName,
          themeClasses == null ? void 0 : themeClasses.ulClassName,
          defaultUlClassName,
          {
            "v2-border-b-2": !hideBottomBorder
          }
        )
      },
      tabParts.tabList
    ),
    toolbar && /* @__PURE__ */ import_react37.default.createElement("div", { className: "tab-toolbar v2-w-full" }, toolbar)
  ), /* @__PURE__ */ import_react37.default.createElement(
    "div",
    {
      className: (0, import_classnames25.default)(
        "tab-content v2-relative",
        tabContentClassName,
        themeClasses == null ? void 0 : themeClasses.tabContentClassName
      )
    },
    tabParts.tabPanel
  ), children);
}

// src/utils.ts
var import_react38 = __toESM(require("react"));
function openFullScreen(videoElement) {
  if (videoElement.requestFullscreen) {
    videoElement.requestFullscreen();
  } else if (videoElement.webkitEnterFullscreen) {
    videoElement.webkitEnterFullscreen();
  } else if (videoElement.msRequestFullscreen) {
    videoElement.msRequestFullscreen();
  } else if (videoElement.mozRequestFullScreen) {
    videoElement.mozRequestFullScreen();
  } else {
    throw new Error("fullscreenElement is not supported by this browser");
  }
}
var isColorLight = (hex) => {
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  const r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 > 186;
};
function consecutivePartition(collection, predicate) {
  if (collection.length === 0) {
    return [];
  }
  const partitions = [];
  let current = [collection[0]];
  for (let i = 1; i < collection.length; i++) {
    if (predicate(current[0], collection[i])) {
      current.push(collection[i]);
    } else {
      partitions.push(current);
      current = [collection[i]];
    }
  }
  partitions.push(current);
  return partitions;
}
function createPlasmicComponent(component, meta) {
  return [component, meta];
}
function toCompactNumber(number = 0, precision = 1) {
  return Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: precision
  }).format(number);
}

// src/components/Widget/index.tsx
var import_react59 = __toESM(require("react"));
var import_classnames42 = __toESM(require("classnames"));

// src/components/WidgetPreview/index.tsx
var import_classnames26 = __toESM(require("classnames"));
var import_react39 = __toESM(require("react"));
var import_react_fontawesome7 = require("@fortawesome/react-fontawesome");
var muteWhite = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/mute-white.svg";
function WidgetPreview({
  videoUrl,
  message,
  muteIconBgColor,
  className,
  messageClassName,
  videoClassName,
  onClick,
  onClose,
  onVideoLoaded,
  onVideoEnded
}) {
  const onCloseClick = (event) => {
    event.stopPropagation();
    onClose == null ? void 0 : onClose();
  };
  const videoElement = (0, import_react39.useRef)(null);
  const onVideoLoadedHandler = () => {
    var _a;
    onVideoLoaded == null ? void 0 : onVideoLoaded();
    if (videoElement.current) {
      void ((_a = videoElement.current) == null ? void 0 : _a.play());
      videoElement.current.volume = 0;
    }
  };
  return /* @__PURE__ */ import_react39.default.createElement(
    "div",
    {
      className: (0, import_classnames26.default)(className, [
        "v2-h-24 sm:v2-h-36 v2-rounded v2-shadow v2-absolute v2-transition-all",
        "v2-drop-shadow-md v2-cursor-pointer v2-inline-flex"
      ]),
      onClick
    },
    /* @__PURE__ */ import_react39.default.createElement("div", { className: "v2-flex v2-relative" }, /* @__PURE__ */ import_react39.default.createElement(
      "video",
      {
        className: (0, import_classnames26.default)(videoClassName, [
          "v2-rounded v2-cursor-pointer v2-object-cover v2-w-24 sm:v2-w-36"
        ]),
        ref: videoElement,
        autoPlay: true,
        muted: true,
        onLoadedData: onVideoLoadedHandler,
        onEnded: onVideoEnded,
        src: videoUrl
      }
    ), /* @__PURE__ */ import_react39.default.createElement(
      "img",
      {
        className: "v2-absolute v2-h-6 v2-w-6 v2-bottom-2 v2-right-2 v2-p-1 v2-rounded-full",
        src: muteWhite,
        style: { backgroundColor: muteIconBgColor }
      }
    )),
    /* @__PURE__ */ import_react39.default.createElement("div", { className: "v2-flex-1 v2-w-48 sm:v2-w-60 v2-flex v2-px-4 v2-py-4 sm:v2-pt-6 sm:v2-pb-5 v2-relative" }, /* @__PURE__ */ import_react39.default.createElement(
      import_react_fontawesome7.FontAwesomeIcon,
      {
        className: "v2-text-xs sm:v2-text-xl v2-text-neutral-300 hover:v2-text-neutral-500 v2-cursor-pointer v2-absolute v2-top-2 v2-right-2",
        icon: faTimes2,
        onClick: onCloseClick
      }
    ), /* @__PURE__ */ import_react39.default.createElement(
      "p",
      {
        className: (0, import_classnames26.default)(messageClassName, [
          "v2-line-clamp-4 v2-text-xs sm:v2-text-base"
        ])
      },
      message
    ))
  );
}

// src/components/WidgetBubble/index.tsx
var import_react41 = __toESM(require("react"));
var import_classnames28 = __toESM(require("classnames"));

// src/components/Ping/index.tsx
var import_react40 = __toESM(require("react"));
var import_classnames27 = __toESM(require("classnames"));
function Ping({
  color = colors.turquoise[700],
  animationColor = colors.turquoise[300],
  showAnimation = true,
  size = 15,
  className,
  onClick
}) {
  return /* @__PURE__ */ import_react40.default.createElement(
    "span",
    {
      className: (0, import_classnames27.default)(className, "v2-flex v2-absolute v2-cursor-pointer"),
      onClick,
      style: { width: size, height: size }
    },
    showAnimation && /* @__PURE__ */ import_react40.default.createElement(
      "span",
      {
        className: "v2-animate-ping v2-absolute v2-inline-flex v2-h-full v2-w-full v2-rounded-full v2-opacity-75",
        style: { backgroundColor: animationColor }
      }
    ),
    /* @__PURE__ */ import_react40.default.createElement(
      "span",
      {
        className: "v2-relative v2-inline-flex v2-rounded-full",
        style: { backgroundColor: color, width: size, height: size }
      }
    )
  );
}

// src/components/WidgetBubble/index.tsx
function WidgetBubble({
  iconImageUrl,
  borderColor,
  borderWidth = 2,
  pingColor = colors.pink[900],
  pingAnimationColor = colors.pink[500],
  size = 32,
  onClick,
  showPing = false,
  className
}) {
  return /* @__PURE__ */ import_react41.default.createElement(
    "div",
    {
      className: (0, import_classnames28.default)(
        className,
        `v2-rounded-md v2-border-solid v2-cursor-pointer v2-relative v2-inline-flex v2-animate-fade-in-down`
      ),
      onClick,
      style: { borderColor, borderWidth }
    },
    /* @__PURE__ */ import_react41.default.createElement(
      "img",
      {
        className: (0, import_classnames28.default)("v2-object-cover v2-rounded"),
        src: iconImageUrl,
        style: { height: size, width: size }
      }
    ),
    showPing && /* @__PURE__ */ import_react41.default.createElement(
      Ping,
      {
        color: pingColor,
        animationColor: pingAnimationColor,
        className: "-v2-top-2 -v2-right-2",
        onClick
      }
    )
  );
}

// src/components/ProfilePanel/index.tsx
var import_react42 = __toESM(require("react"));
var import_classnames29 = __toESM(require("classnames"));
var import_react_loading_skeleton = __toESM(require("react-loading-skeleton"));
function ProfilePanel({
  name,
  imageUrl,
  description,
  className,
  loading = false,
  reactionComponent
}) {
  return /* @__PURE__ */ import_react42.default.createElement(
    import_react_loading_skeleton.SkeletonTheme,
    {
      baseColor: colors.neutral[50],
      highlightColor: colors.neutral[200]
    },
    /* @__PURE__ */ import_react42.default.createElement(
      "div",
      {
        className: (0, import_classnames29.default)(
          className,
          "v2-w-full v2-bg-black v2-bg-opacity-50 v2-px-2 v2-py-1"
        )
      },
      /* @__PURE__ */ import_react42.default.createElement("div", { className: "v2-w-full v2-flex v2-justify-between" }, /* @__PURE__ */ import_react42.default.createElement("div", { className: "v2-w-full v2-inline-flex v2-gap-x-2 v2-items-center" }, /* @__PURE__ */ import_react42.default.createElement(ProfileImage, { loading, imageUrl }), /* @__PURE__ */ import_react42.default.createElement(
        "span",
        {
          className: (0, import_classnames29.default)(
            [
              "v2-flex v2-flex-col v2-w-3/5 sm:v2-w-2/3 v2-justify-items-end",
              "v2-text-left v2-text-xs v2-text-white"
            ],
            {
              "v2-gap-y-1": !loading,
              "v2-gap-y-2": loading
            }
          )
        },
        /* @__PURE__ */ import_react42.default.createElement(
          ProfileInfo,
          {
            loading,
            name,
            description
          }
        )
      ))),
      /* @__PURE__ */ import_react42.default.createElement(
        "div",
        {
          className: (0, import_classnames29.default)(
            "v2-transform v2-absolute  v2-right-2 -v2-translate-y-1/2",
            {
              "v2-w-10 v2-h-10 v2-top-[1.35rem]": loading,
              "v2-top-1/2": !loading
            }
          )
        },
        /* @__PURE__ */ import_react42.default.createElement(
          ProfileReaction,
          {
            loading,
            reactionComponent
          }
        )
      )
    )
  );
}
function ProfileImage({ loading, imageUrl }) {
  if (loading) {
    return /* @__PURE__ */ import_react42.default.createElement(
      import_react_loading_skeleton.default,
      {
        height: "100%",
        containerClassName: "v2-rounded v2-h-9 v2-w-10 v2-mb-2"
      }
    );
  }
  return /* @__PURE__ */ import_react42.default.createElement(
    "img",
    {
      className: "v2-animate-fade-in v2-object-cover v2-rounded v2-h-10 v2-w-10",
      src: imageUrl
    }
  );
}
function ProfileInfo({ loading, name, description }) {
  if (loading) {
    return /* @__PURE__ */ import_react42.default.createElement(import_react42.default.Fragment, null, /* @__PURE__ */ import_react42.default.createElement(
      import_react_loading_skeleton.default,
      {
        height: "100%",
        containerClassName: "v2-h-3 v2-w-1/2",
        borderRadius: 0
      }
    ), /* @__PURE__ */ import_react42.default.createElement(
      import_react_loading_skeleton.default,
      {
        height: "100%",
        containerClassName: "v2-h-3 v2-w-1/3",
        borderRadius: 0
      }
    ));
  }
  return /* @__PURE__ */ import_react42.default.createElement(import_react42.default.Fragment, null, /* @__PURE__ */ import_react42.default.createElement("span", { className: "v2-animate-fade-in v2-flex-1 v2-text-base v2-font-bold v2-truncate" }, name), /* @__PURE__ */ import_react42.default.createElement("span", { className: "v2-animate-fade-in v2-flex-1 v2-text-xs v2-truncate" }, description));
}
function ProfileReaction({ loading, reactionComponent }) {
  if (loading) {
    return /* @__PURE__ */ import_react42.default.createElement(import_react_loading_skeleton.default, { circle: true, height: "100%", containerClassName: "v2-w-10 v2-h-full" });
  }
  return /* @__PURE__ */ import_react42.default.createElement(import_react42.default.Fragment, null, reactionComponent);
}

// src/components/VideoPlayer/VideoPlayerContainer.tsx
var import_react49 = __toESM(require("react"));

// src/components/VideoPlayer/VideoPlayerOverlay.tsx
var import_react43 = __toESM(require("react"));
var import_classnames30 = __toESM(require("classnames"));
function VideoPlayerOverlay({
  className,
  onClick
}) {
  return /* @__PURE__ */ import_react43.default.createElement(
    "div",
    {
      className: (0, import_classnames30.default)(className, [
        "v2-fixed v2-inset-0 v2-bg-black v2-bg-opacity-50 v2-overflow-y-auto v2-w-full v2-h-full v2-z-30"
      ]),
      onClick
    }
  );
}

// src/components/VideoPlayer/VideoPlayerComponent.tsx
var import_react48 = __toESM(require("react"));
var import_classnames34 = __toESM(require("classnames"));

// src/components/VideoPlayer/VideoControls.tsx
var import_react47 = __toESM(require("react"));
var import_react_fontawesome8 = require("@fortawesome/react-fontawesome");
var import_classnames33 = __toESM(require("classnames"));
var import_styled3 = __toESM(require("@emotion/styled"));
var import_isFinite = __toESM(require_isFinite());

// src/components/VideoPlayer/hooks/useVideoProgress.ts
var import_react44 = require("react");
function useVideoProgress({
  videoRef,
  onProgress,
  intervalDelay = 250,
  forceUseInterval = false
}) {
  const [intervalId, setIntervalId] = (0, import_react44.useState)();
  const [playing, setPlaying] = (0, import_react44.useState)(false);
  function handlePlayEvent() {
    setPlaying(true);
  }
  function handlePauseEvent() {
    setPlaying(false);
  }
  (0, import_react44.useEffect)(() => {
    if (videoRef == null ? void 0 : videoRef.current) {
      videoRef.current.addEventListener("play", handlePlayEvent);
      videoRef.current.addEventListener("pause", handlePauseEvent);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("play", handlePlayEvent);
      videoRef.current.removeEventListener("pause", handlePauseEvent);
    };
  }, [videoRef == null ? void 0 : videoRef.current]);
  const supportsTimeUpdate = (0, import_react44.useMemo)(() => {
    var _a;
    return !forceUseInterval && ((_a = (videoRef == null ? void 0 : videoRef.current) && "ontimeupdate" in videoRef.current) != null ? _a : false);
  }, [videoRef == null ? void 0 : videoRef.current]);
  function handleTimeUpdate() {
    var _a;
    ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
  }
  (0, import_react44.useEffect)(() => {
    if (supportsTimeUpdate && (videoRef == null ? void 0 : videoRef.current) && onProgress) {
      videoRef.current.addEventListener("timeupdate", handleTimeUpdate);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [supportsTimeUpdate, onProgress]);
  (0, import_react44.useEffect)(() => {
    if (onProgress && playing && (videoRef == null ? void 0 : videoRef.current) && !videoRef.current.paused && !supportsTimeUpdate) {
      setIntervalId(
        setInterval(() => {
          var _a;
          ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
        }, intervalDelay)
      );
    } else if (intervalId) {
      clearInterval(intervalId);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [playing, supportsTimeUpdate]);
}

// src/utils/elapsed.ts
var import_luxon = require("luxon");
function elapsed(input, options2) {
  const duration = (import_luxon.Duration.isDuration(input) ? input : import_luxon.Duration.fromObject({ seconds: input })).shiftTo("hours", "minutes", "seconds");
  const shouldPadMinutes = !(options2 == null ? void 0 : options2.noPadMinutes);
  const format = ` ${duration.hours ? "hh:" : ""}${shouldPadMinutes ? "mm:ss" : "m:ss"}`;
  return duration.toFormat(format);
}

// src/components/Transcript/Transcript.tsx
var import_react45 = __toESM(require("react"));
var import_classnames31 = __toESM(require("classnames"));
var SENTENCE_ENDING_THRESHOLD_MS = 0.15;
var MAX_WORDS_PER_SENTENCE = 15;
var TranscriptMode = /* @__PURE__ */ ((TranscriptMode2) => {
  TranscriptMode2["WordPerWord"] = "word_per_word";
  TranscriptMode2["Sentence"] = "sentence";
  return TranscriptMode2;
})(TranscriptMode || {});
function Transcript({
  videoRef,
  sentences,
  mode = "sentence" /* Sentence */,
  maxWordsPerSentence = MAX_WORDS_PER_SENTENCE,
  containerClassName,
  className,
  onClick
}) {
  const [currentTranscription, setCurrentTranscription] = (0, import_react45.useState)();
  const [sentenceEnding, setSentenceEnding] = (0, import_react45.useState)(false);
  const parsedSentences = (0, import_react45.useMemo)(() => {
    if (!sentences || sentences.length === 0)
      return [];
    return sentences == null ? void 0 : sentences.reduce((sentences2, sentence) => {
      var _a, _b, _c;
      const currentSentence = {
        text: sentence.text,
        start: sentence.start / 1e3,
        end: sentence.end / 1e3,
        words: (_a = sentence == null ? void 0 : sentence.words) == null ? void 0 : _a.reduce((words, word) => {
          return [
            ...words,
            {
              text: word.text,
              start: word.start / 1e3,
              end: word.end / 1e3
            }
          ];
        }, [])
      };
      if ((currentSentence == null ? void 0 : currentSentence.words) && ((_b = currentSentence == null ? void 0 : currentSentence.words) == null ? void 0 : _b.length) > maxWordsPerSentence) {
        const chunkedWords = currentSentence == null ? void 0 : currentSentence.words.reduce(
          (words, word, index) => {
            const chunkIndex = Math.floor(index / maxWordsPerSentence);
            if (!words[chunkIndex]) {
              words[chunkIndex] = [];
            }
            words[chunkIndex].push(word);
            return words;
          },
          []
        );
        return [
          ...sentences2,
          ...(_c = chunkedWords == null ? void 0 : chunkedWords.reduce((sentences3, words) => {
            var _a2, _b2;
            return [
              ...sentences3,
              {
                text: words.map((word) => word.text).join(" "),
                start: (_a2 = words[0]) == null ? void 0 : _a2.start,
                end: (_b2 = words[words.length - 1]) == null ? void 0 : _b2.end,
                words
              }
            ];
          }, [])) != null ? _c : []
        ];
      }
      return [...sentences2, currentSentence];
    }, []);
  }, [sentences, maxWordsPerSentence]);
  const hasActiveTranscriptions = (0, import_react45.useMemo)(
    () => currentTranscription !== "" && currentTranscription !== void 0,
    [currentTranscription]
  );
  (0, import_react45.useEffect)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current))
      return;
    const video = videoRef.current;
    const handleTimeUpdate = () => {
      var _a;
      const currentTime = video.currentTime;
      const currentTranscription2 = parsedSentences.find(
        (transcription) => currentTime >= transcription.start && currentTime <= transcription.end
      );
      if (currentTranscription2 && currentTime <= (currentTranscription2 == null ? void 0 : currentTranscription2.end) && (currentTranscription2 == null ? void 0 : currentTranscription2.end) - currentTime <= SENTENCE_ENDING_THRESHOLD_MS) {
        setSentenceEnding(true);
      } else {
        setSentenceEnding(false);
      }
      switch (mode) {
        case "sentence" /* Sentence */: {
          setCurrentTranscription(
            currentTranscription2 ? currentTranscription2.text : ""
          );
          break;
        }
        case "word_per_word" /* WordPerWord */: {
          const compiledWords = (_a = currentTranscription2 == null ? void 0 : currentTranscription2.words) == null ? void 0 : _a.filter(
            (word) => currentTime >= currentTranscription2.start && currentTime >= word.end || currentTime >= word.start && currentTime <= word.end
          ).reduce((words, word) => {
            return [...words, word.text];
          }, []);
          setCurrentTranscription(
            compiledWords && (compiledWords == null ? void 0 : compiledWords.length) > 0 ? compiledWords.join(" ") : ""
          );
          break;
        }
      }
    };
    video.addEventListener("timeupdate", handleTimeUpdate);
    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [videoRef == null ? void 0 : videoRef.current, parsedSentences, mode]);
  return /* @__PURE__ */ import_react45.default.createElement(
    "div",
    {
      className: (0, import_classnames31.default)(
        containerClassName,
        "v2-rounded v2-cursor-pointer v2-select-none v2-w-auto"
      ),
      onClick
    },
    /* @__PURE__ */ import_react45.default.createElement(
      "span",
      {
        className: (0, import_classnames31.default)(className, {
          "v2-bg-black/50 v2-text-white v2-text-base v2-p-0.5 v2-select-none v2-animate-fade-in-100 v2-whitespace-normal v2-font-circular": hasActiveTranscriptions,
          "v2-animate-fade-out-100": sentenceEnding
        })
      },
      currentTranscription
    )
  );
}

// src/components/Transcript/CCButton.tsx
var import_react46 = __toESM(require("react"));
var import_classnames32 = __toESM(require("classnames"));
function CCButton({
  show = false,
  onShowClick,
  outerContainerClassName,
  innerContainerClassName,
  iconClassName
}) {
  return /* @__PURE__ */ import_react46.default.createElement(
    "div",
    {
      className: (0, import_classnames32.default)(
        "v2-pr-2.5 v2-pt-2.5 v2-cursor-pointer",
        outerContainerClassName
      )
    },
    /* @__PURE__ */ import_react46.default.createElement(
      "div",
      {
        className: (0, import_classnames32.default)(
          innerContainerClassName,
          [
            "v2-flex v2-items-center v2-p-0.5",
            "v2-rounded-md v2-opacity-25 v2-select-none v2-bg-black"
          ],
          {
            "hover:v2-opacity-50 v2-transition-all ": !show,
            "!v2-opacity-25 v2-bg-black": show
          }
        ),
        onClick: (e) => {
          e.stopPropagation();
          onShowClick == null ? void 0 : onShowClick(!show);
        }
      },
      /* @__PURE__ */ import_react46.default.createElement(
        "div",
        {
          className: (0, import_classnames32.default)(
            iconClassName,
            [
              "v2-text-center v2-items-center v2-justify-center v2-flex v2-text-xs",
              "v2-p-[2.5px] v2-py-0 v2-rounded-md v2-min-w-[25px] v2-min-h-[20px] ",
              "v2-border v2-border-[1.5px] v2-border-white v2-border-solid v2-font-bold",
              "v2-font-circular"
            ],
            {
              "v2-bg-black v2-text-white": !show,
              "v2-bg-white v2-text-neutral": show
            }
          )
        },
        "CC"
      )
    )
  );
}

// src/utils/localStorage.ts
var import_localforage = __toESM(require("localforage"));
var keyToStr = (key2) => key2.join(".");
function remember(key2, value) {
  return import_localforage.default.setItem(keyToStr(key2), JSON.stringify(value));
}
function recall(key2) {
  return __async(this, null, function* () {
    const json = yield import_localforage.default.getItem(keyToStr(key2));
    if (json) {
      return JSON.parse(json);
    }
    return null;
  });
}

// src/components/VideoPlayer/settings.ts
var storageKeys = {
  all: ["bonjoro", "video-player-settings"]
};
function rememberVideoPlayerSettings(settings) {
  return __async(this, null, function* () {
    const currentSettings = yield getVideoPlayerSettings();
    return remember(storageKeys.all, __spreadValues(__spreadValues({}, currentSettings), settings));
  });
}
function getVideoPlayerSettings() {
  return recall(storageKeys.all);
}

// src/components/VideoPlayer/VideoControls.tsx
var volumeIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-white.svg";
var volumeMuteIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-mute-white.svg";
var fullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/full-screen-white.svg";
var exitFullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/exit-full-screen-white.svg";
var newTabIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/new-tab-white.svg";
var actionIconClass = "v2-overflow-visible v2-z-10 v2-cursor-pointer v2-select-none";
var NewTabIcon = import_styled3.default.img`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
var VideoProgress = import_styled3.default.progress`
  &::-webkit-progress-bar {
    background-color: ${colors.neutral[200]};
  }

  &::-webkit-progress-value {
    background: ${colors.yellow[500]};
  }

  &::-moz-progress-bar {
    background: ${colors.yellow[500]};
  }
`;
var VideoProgressSliderThumb = import_styled3.default.input`
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
  }

  &::-webkit-slider-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
    z-index: 50;
  }

  &:hover::-moz-range-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
  }
`;
var CtaContainer = import_styled3.default.div`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
function VideoControls({
  fullScreen,
  playing,
  muted,
  showControls = true,
  leftHeaderComponent,
  footerComponent,
  initialTranscriptionState = "closed",
  transcription,
  transcriptMode,
  transcriptionTogglerPosition,
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  ctaHoverColor,
  hideClose,
  hideNewTab,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideTranscription,
  onPlayPauseClick,
  onMuteUnmuteClick,
  onFullScreenClick,
  onNewTabClick,
  onCloseClick,
  videoRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay,
  closedCaptionClassName,
  playPauseStyle,
  playPauseClassName,
  playPausePlacement
}) {
  var _a;
  const [currentTime, setCurrentTime] = (0, import_react47.useState)(0);
  const [showTranscription, setShowTranscription] = (0, import_react47.useState)(
    initialTranscriptionState === "open"
  );
  (0, import_react47.useEffect)(() => {
    void getVideoPlayerSettings().then((settings) => {
      var _a2;
      if (!settings)
        return;
      setShowTranscription((_a2 = settings.transcriptionEnabled) != null ? _a2 : false);
    });
  }, []);
  const [formattedCurrentTime, formattedDuration, duration] = (0, import_react47.useMemo)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current)) {
      return [null, null];
    }
    const duration2 = videoRef.current.duration;
    const formattedCurrentTime2 = elapsed(currentTime, { noPadMinutes: true });
    if (!(0, import_isFinite.default)(duration2)) {
      return [null, null];
    }
    const formattedDuration2 = elapsed(duration2, { noPadMinutes: true });
    return [formattedCurrentTime2, formattedDuration2, duration2];
  }, [videoRef == null ? void 0 : videoRef.current, (_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.duration, currentTime]);
  useVideoProgress({
    videoRef,
    onProgress: setCurrentTime,
    intervalDelay: 100,
    forceUseInterval: true
  });
  const onVideoSeek = (0, import_react47.useCallback)(
    (ev) => {
      var _a2;
      ev.preventDefault();
      if (typeof ((_a2 = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a2.currentTime) === "undefined")
        return;
      videoRef.current.currentTime = Number(ev.target.value);
    },
    [videoRef == null ? void 0 : videoRef.current]
  );
  const onTranscriptionClick = (show) => {
    void rememberVideoPlayerSettings({
      transcriptionEnabled: show
    });
    setShowTranscription(show);
  };
  const transciptionTogglerProps = {
    show: showTranscription,
    onShowClick: onTranscriptionClick,
    outerContainerClassName: closedCaptionClassName
  };
  const hasValidTranscription = transcription != void 0 && transcription.length > 0;
  const fadeControls = !(fadeControlsOnPlay && !playing || !fadeControlsOnPlay);
  const isPlayPausePlacementCenter = playPausePlacement === "center" /* Center */;
  const isPlayPausePlacementLowerLeft = playPausePlacement === "lower-left" /* LowerLeft */;
  const scaleOnHoverClassName = "v2-transition-all v2-duration-200 hover:v2-scale-105";
  return /* @__PURE__ */ import_react47.default.createElement(import_react47.default.Fragment, null, showControls && /* @__PURE__ */ import_react47.default.createElement(
    "div",
    {
      className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-top-0 v2-z-50",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-flex v2-flex-row v2-justify-between" }, /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-inline-flex" }, leftHeaderComponent, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "left" && /* @__PURE__ */ import_react47.default.createElement(
      CCButton,
      __spreadProps(__spreadValues({}, transciptionTogglerProps), {
        outerContainerClassName: "v2-pl-2.5"
      })
    )), /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-inline-flex" }, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "right" && /* @__PURE__ */ import_react47.default.createElement(CCButton, __spreadValues({}, transciptionTogglerProps)), !hideNewTab && /* @__PURE__ */ import_react47.default.createElement(
      NewTabIcon,
      {
        ctaHoverColor,
        className: (0, import_classnames33.default)(
          actionIconClass,
          "v2-w-7 v2-h-7 v2-p-1",
          scaleOnHoverClassName
        ),
        src: newTabIcon,
        onClick: (e) => {
          e.stopPropagation();
          onNewTabClick == null ? void 0 : onNewTabClick();
        },
        title: "Open in a new window"
      }
    ), !hideClose && /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-px-1 v2-bg-black v2-bg-opacity-50 v2-h-7 v2-flex v2-items-center" }, /* @__PURE__ */ import_react47.default.createElement(
      import_react_fontawesome8.FontAwesomeIcon,
      {
        className: (0, import_classnames33.default)(
          scaleOnHoverClassName,
          "v2-w-5 v2-h-6 v2-text-white v2-cursor-pointer"
        ),
        icon: faTimes,
        onClick: (e) => {
          e.stopPropagation();
          onCloseClick == null ? void 0 : onCloseClick();
        },
        title: "Close"
      }
    ))))
  ), !hidePlayPause && isPlayPausePlacementCenter && /* @__PURE__ */ import_react47.default.createElement(
    "div",
    {
      className: (0, import_classnames33.default)(
        [
          "v2-absolute v2-top-1/2 v2-left-1/2 v2-flex v2-transition-all v2-duration-200",
          "-v2-translate-x-1/2 -v2-translate-y-1/2 v2-z-[20]",
          ""
        ],
        {
          "v2-animate-fade-in": !playing,
          "v2-animate-fade-out": playing
        }
      )
    },
    /* @__PURE__ */ import_react47.default.createElement(
      import_react_fontawesome8.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames33.default)(playPauseClassName, scaleOnHoverClassName, [
          "v2-h-[90px] !v2-w-[50px] v2-text-white v2-cursor-pointer"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    )
  ), /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-bottom-0 v2-z-50" }, !hideTranscription && hasValidTranscription && (videoRef == null ? void 0 : videoRef.current) && !(fadeControlsOnPlay && !playing) && /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-flex v2-items-center v2-justify-center" }, /* @__PURE__ */ import_react47.default.createElement(
    Transcript,
    {
      onClick: onPlayPauseClick,
      sentences: transcription,
      videoRef,
      mode: transcriptMode,
      maxWordsPerSentence: transcriptionMaxWordsPerSentence,
      className: transcriptionClassName,
      containerClassName: (0, import_classnames33.default)(
        transcriptionContainerClassName,
        "v2-text-center v2-w-fit",
        {
          "v2-opacity-0": !showTranscription
        }
      )
    }
  )), showControls && /* @__PURE__ */ import_react47.default.createElement(
    "div",
    {
      className: "v2-flex v2-flex-row v2-justify-between v2-pointer-events-auto v2-z-50 v2-px-3.5 v2-pb-3.5 v2-h-[42px]",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-flex v2-space-x-3.5 v2-items-center" }, !hidePlayPause && isPlayPausePlacementLowerLeft && !fadeControls && /* @__PURE__ */ import_react47.default.createElement(
      import_react_fontawesome8.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames33.default)(playPauseClassName, [
          "v2-h-[38px] !v2-w-[30px] v2-text-4xl v2-text-white",
          "v2-cursor-pointer v2-animate-fade-in"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    ), !hideTimer && formattedCurrentTime && formattedDuration && /* @__PURE__ */ import_react47.default.createElement(
      "div",
      {
        className: (0, import_classnames33.default)(
          "v2-group/video-player-timer",
          scaleOnHoverClassName,
          "v2-flex v2-gap-x-1 v2-text-white v2-text-base v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react47.default.createElement("span", { className: "v2-w-[35px] v2-font-circular" }, formattedCurrentTime),
      /* @__PURE__ */ import_react47.default.createElement(
        "span",
        {
          className: (0, import_classnames33.default)(
            "v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        "/"
      ),
      /* @__PURE__ */ import_react47.default.createElement(
        "span",
        {
          className: (0, import_classnames33.default)(
            "v2-w-[35px] v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        formattedDuration
      )
    )),
    /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-inline-flex v2-gap-x-3 v2-items-center" }, !hideMuteUnmute && /* @__PURE__ */ import_react47.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames33.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react47.default.createElement(
        "img",
        {
          className: (0, import_classnames33.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: muted ? volumeMuteIcon : volumeIcon,
          title: "Mute/Unmute",
          onClick: (e) => {
            e.stopPropagation();
            onMuteUnmuteClick == null ? void 0 : onMuteUnmuteClick();
          }
        }
      )
    ), !hideFullScreen && /* @__PURE__ */ import_react47.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames33.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react47.default.createElement(
        "img",
        {
          className: (0, import_classnames33.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: fullScreen ? exitFullScreenIcon : fullScreenIcon,
          onClick: (e) => {
            e.stopPropagation();
            onFullScreenClick == null ? void 0 : onFullScreenClick();
          },
          title: "Full screen"
        }
      )
    ))
  ), showProgressBar && /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-flex" }, /* @__PURE__ */ import_react47.default.createElement(
    VideoProgress,
    {
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-absolute v2-bottom-0 v2-transition-all v2-duration-200"
    }
  ), /* @__PURE__ */ import_react47.default.createElement(
    VideoProgressSliderThumb,
    {
      type: "range",
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-bg-transparent v2-z-10  v2-cursor-ew-resize v2-transition-all v2-duration-200",
      min: 0,
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      onChange: onVideoSeek
    }
  )), footerComponent));
}

// src/components/VideoPlayer/VideoPlayerComponent.tsx
function VideoPlayerComponent({
  videoUrl,
  videoTitle,
  videoThumbnail,
  videoThumbnailClassName,
  containerClassName,
  videoClassName,
  playPauseStyle,
  playPauseClassName,
  videoStyle,
  showDefaultFullScreen = false,
  showDefaultControls = false,
  autoPlay = false,
  loop = false,
  fullScreen = false,
  children,
  footerComponent,
  leftHeaderComponent,
  initialTranscriptionState,
  transcription,
  transcriptMode = "sentence" /* Sentence */,
  transcriptionTogglerPosition = "right",
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  preload = "auto",
  playsInline = true,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideClose,
  hideNewTab,
  hideTranscription,
  hideLoader = false,
  ctaHoverColor,
  onNewTabClick,
  onCloseClick,
  onFullScreenClick,
  onVideoLoaded,
  onThumbnailLoad,
  onThumbnailLoadError,
  onProgress,
  onPlay,
  onPause,
  videoRef,
  containerRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay = false,
  playPausePlacement = "lower-left" /* LowerLeft */,
  rounded,
  forceFirstFrame = true,
  forceShowControls = false,
  forceShowThumbnail = false,
  loadOnIntersect = false,
  muted: initialMuted = false,
  imageComponent: DefaultImageComponent,
  closedCaptionClassName
}) {
  const [activeDefaultFullScreen, setActiveDefaultFullScreen] = (0, import_react48.useState)(false);
  const [playing, setPlaying] = (0, import_react48.useState)(false);
  const [muted, setMuted] = (0, import_react48.useState)(initialMuted);
  const [videoLoaded, setVideoLoaded] = (0, import_react48.useState)(false);
  const [thumbnailClicked, setThumbnailClicked] = (0, import_react48.useState)(false);
  const videoElement = videoRef != null ? videoRef : (0, import_react48.useRef)(null);
  const containerElement = containerRef != null ? containerRef : (0, import_react48.useRef)(null);
  const toggleMute = () => setMuted(!muted);
  const togglePlay = (0, import_react48.useCallback)(
    (play) => {
      if (!videoElement.current)
        return;
      if (play) {
        void videoElement.current.play();
        setThumbnailClicked(true);
      } else {
        videoElement.current.pause();
      }
      setPlaying(play);
    },
    [videoLoaded, videoElement.current]
  );
  const onVideoLoadedHandler = () => {
    setVideoLoaded(true);
    onVideoLoaded == null ? void 0 : onVideoLoaded();
  };
  const onCloseClickHandler = () => {
    togglePlay(false);
    onCloseClick == null ? void 0 : onCloseClick();
  };
  (0, import_react48.useEffect)(() => {
    if (videoElement.current && !videoLoaded && preload === "auto") {
      videoElement.current.load();
    }
  }, []);
  const onVolumeChangeHandler = (0, import_react48.useCallback)(() => {
    var _a;
    if (!videoLoaded || !videoElement.current)
      return;
    setMuted((_a = videoElement.current) == null ? void 0 : _a.muted);
  }, [videoElement.current]);
  const toggleFullScreen = (0, import_react48.useCallback)(() => {
    if (showDefaultFullScreen && (videoElement == null ? void 0 : videoElement.current)) {
      openFullScreen(videoElement == null ? void 0 : videoElement.current);
    } else {
      onFullScreenClick == null ? void 0 : onFullScreenClick();
    }
  }, [showDefaultFullScreen, fullScreen]);
  const onVideoContainerClickHandler = () => {
    if (document.fullscreenElement != null || document.webkitFullscreenElement != null || document.mozFullScreenElement != null) {
      console.log(
        "Video fullscreen is active. Will use default event handlers."
      );
      return;
    }
    togglePlay(!playing);
  };
  useVideoProgress({
    videoRef: videoElement,
    onProgress
  });
  (0, import_react48.useEffect)(() => {
    if (!videoElement.current)
      return;
    videoElement.current.onfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
    videoElement.current.onwebkitfullscreenchange = () => {
      setActiveDefaultFullScreen(document.webkitFullscreenElement !== null);
    };
    videoElement.current.onmozfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
  }, [activeDefaultFullScreen, videoElement.current, document]);
  (0, import_react48.useEffect)(() => {
    if (!loadOnIntersect || !(videoElement == null ? void 0 : videoElement.current) || !(containerElement == null ? void 0 : containerElement.current))
      return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          var _a, _b;
          if (entry.isIntersecting) {
            (_a = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _a.setAttribute("preload", "auto");
            (_b = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _b.load();
            if (videoElement == null ? void 0 : videoElement.current) {
              observer.unobserve(videoElement == null ? void 0 : videoElement.current);
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    );
    observer.observe(videoElement == null ? void 0 : videoElement.current);
  }, [videoElement == null ? void 0 : videoElement.current, loadOnIntersect]);
  const activeCustomFullScreen = !activeDefaultFullScreen && fullScreen;
  const imageProps = {
    src: videoThumbnail,
    width: 0,
    height: 0,
    alt: "Video Thumbnail",
    onClick: () => setThumbnailClicked(true),
    className: (0, import_classnames34.default)(
      videoThumbnailClassName,
      "v2-w-auto v2-h-auto v2-absolute v2-object-cover v2-top-0 v2-cursor-pointer",
      {
        "!v2-z-20": !thumbnailClicked,
        "!v2-z-0 !v2-hidden": thumbnailClicked
      }
    ),
    onLoad: onThumbnailLoad,
    onError: onThumbnailLoadError
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react48.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return videoThumbnail;
      }
    })
  ) : /* @__PURE__ */ import_react48.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react48.default.createElement(
    "div",
    {
      className: (0, import_classnames34.default)(
        containerClassName,
        "v2-group/video-player v2-overflow-hidden",
        {
          "v2-cursor-pointer v2-inline-flex v2-relative": !fullScreen,
          "v2-fixed v2-transform v2-left-1/2 v2-top-1/2 -v2-translate-x-1/2 ": fullScreen,
          "-v2-translate-y-1/2 v2-translate v2-z-40 v2-w-screen sm:v2-w-auto sm:v2-h-auto v2-flex v2-justify-center": fullScreen,
          "v2-rounded-[10px]": rounded,
          "v2-z-0": !fullScreen
        }
      ),
      ref: containerElement
    },
    /* @__PURE__ */ import_react48.default.createElement(
      "div",
      {
        key: videoUrl,
        className: (0, import_classnames34.default)("v2-flex v2-relative v2-w-full v2-group", {
          "v2-drop-shadow v2-shadow": activeCustomFullScreen
        })
      },
      /* @__PURE__ */ import_react48.default.createElement("div", { className: "v2-w-full", onClick: onVideoContainerClickHandler }, !hideLoader && /* @__PURE__ */ import_react48.default.createElement(
        "span",
        {
          className: (0, import_classnames34.default)(
            "v2-absolute v2-w-full v2-h-full v2-flex v2-flex-col v2-bg-neutral-400",
            {
              "v2-animate-fade-out": videoLoaded
            }
          )
        }
      ), forceShowThumbnail && videoThumbnail && imageComponent, /* @__PURE__ */ import_react48.default.createElement(
        "video",
        {
          id: "bonjoro-video-player",
          ref: videoElement,
          className: (0, import_classnames34.default)("bonjoro-video-player v2-cursor-pointer", {
            "v2-object-cover": !activeDefaultFullScreen,
            "v2-h-full v2-w-full": activeCustomFullScreen,
            [videoClassName != null ? videoClassName : ""]: !fullScreen,
            "!v2-z-0": forceShowThumbnail && !thumbnailClicked,
            "!v2-z-10": forceShowThumbnail && thumbnailClicked
          }),
          style: videoStyle,
          poster: videoThumbnail,
          title: videoTitle,
          controls: showDefaultControls,
          playsInline,
          "webkit-playsinline": playsInline && "webkit-playsinline",
          preload,
          autoPlay,
          muted,
          loop,
          onTouchEnd: (event) => {
            event.preventDefault();
            togglePlay(!playing);
          },
          onTouchMove: (event) => {
            event.preventDefault();
          },
          onPlay: () => {
            togglePlay(true);
            onPlay == null ? void 0 : onPlay();
          },
          onPause: () => {
            togglePlay(false);
            onPause == null ? void 0 : onPause();
          },
          onLoadedData: onVideoLoadedHandler,
          onVolumeChange: onVolumeChangeHandler,
          src: forceFirstFrame ? `${videoUrl}#t=0.001` : videoUrl
        },
        children
      )),
      !showDefaultControls && /* @__PURE__ */ import_react48.default.createElement(
        VideoControls,
        {
          fullScreen,
          playing,
          muted,
          hideClose,
          hideNewTab,
          hidePlayPause,
          hideMuteUnmute,
          hideFullScreen,
          hideTimer,
          hideTranscription,
          onPlayPauseClick: () => togglePlay(!playing),
          onMuteUnmuteClick: toggleMute,
          onFullScreenClick: toggleFullScreen,
          onNewTabClick,
          onCloseClick: onCloseClickHandler,
          ctaHoverColor,
          leftHeaderComponent,
          footerComponent,
          transcription,
          initialTranscriptionState,
          transcriptMode,
          transcriptionTogglerPosition,
          transcriptionMaxWordsPerSentence,
          transcriptionClassName,
          transcriptionContainerClassName,
          showControls: forceShowControls || videoLoaded,
          videoRef: videoElement,
          showProgressBar: videoLoaded && showProgressBar,
          fadeControlsOnPlay,
          closedCaptionClassName,
          playPauseStyle,
          playPauseClassName,
          playPausePlacement
        }
      )
    )
  );
}

// src/components/VideoPlayer/VideoPlayerContainer.tsx
function VideoPlayerContainer(props) {
  const [fullScreen, setFullScreen] = (0, import_react49.useState)(false);
  const toggleFullScreen = () => {
    var _a;
    (_a = props.onFullScreenClick) == null ? void 0 : _a.call(props);
    setFullScreen(!fullScreen);
  };
  const videoPlayerProps = (0, import_react49.useMemo)(() => {
    if (!fullScreen)
      return props;
    return __spreadProps(__spreadValues({}, props), {
      className: "v2-justify-center",
      hideClose: true,
      width: "100%",
      height: "100%"
    });
  }, [props, fullScreen]);
  return /* @__PURE__ */ import_react49.default.createElement(import_react49.default.Fragment, null, /* @__PURE__ */ import_react49.default.createElement(
    VideoPlayerComponent,
    __spreadProps(__spreadValues({}, videoPlayerProps), {
      fullScreen,
      onFullScreenClick: toggleFullScreen
    })
  ), fullScreen && /* @__PURE__ */ import_react49.default.createElement(
    VideoPlayerOverlay,
    {
      className: props == null ? void 0 : props.overlayClassName,
      onClick: toggleFullScreen
    }
  ));
}

// src/components/WidgetPopup/index.tsx
var import_react58 = __toESM(require("react"));

// src/components/ReactionButton/index.tsx
var import_react50 = __toESM(require("react"));
var import_classnames35 = __toESM(require("classnames"));
var import_styled4 = __toESM(require("@emotion/styled"));
var reactionAnimationImage = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/reaction-animation.png";
var ReactionIcon = import_styled4.default.button`
  min-width: 45px;
  box-shadow: 0 4px 6px rgb(50 50 93 / 10%), 0 1px 3px rgb(0 0 0 / 10%);
  &:active {
    transform: scale(0.8);
  }
`;
var TooltipTriangle = import_styled4.default.div`
  border-left-color: ${colors.yellow[500]};
`;
var ReactionAnimation = import_styled4.default.div`
  background: url(${reactionAnimationImage}) no-repeat 0 0;
  v2-transition: background-position 1s steps(25);
  transition-duration: 0s;
  &.active {
      left: 50%;
      transition-duration: 1s;
      background-position: -2500px 0;
    }
  }
`;
var emojis = [
  "\u{1F44F}",
  "\u{1F44D}",
  "\u{1F525}",
  "\u{1F601}",
  "\u{1F929}",
  "\u{1F917}",
  "\u{1F638}",
  "\u{1F91D}",
  "\u2705",
  "\u{1F44A}",
  "\u{1F44C}",
  "\u{1F919}",
  "\u{1F64F}",
  "\u{1F440}",
  "\u{1F43B}",
  "\u2B50",
  "\uFE0F\u{1F947}",
  "\u{1F3C6}",
  "\u{1F680}",
  "\u{1F389}",
  "\u{1F4AF}",
  "\u{1F192}"
];
function ReactionButton({
  initialCount,
  onClick,
  hideCount = false,
  hideTooltip = false,
  tooltipText = "Say thanks",
  className,
  tooltipClassName = "",
  tooltipTriangleClassName = "",
  tooltipContainerClassName = "",
  showAnimationClassName = "",
  buttonClassName = "",
  countClassName = "",
  emojiClassName = ""
}) {
  const [count, setCount] = (0, import_react50.useState)(initialCount != null ? initialCount : 0);
  const [showAnimation, setShowAnimation] = (0, import_react50.useState)(false);
  const emoji = count >= emojis.length ? emojis[count % emojis.length] : emojis[count];
  const toggleAnimation = () => {
    setShowAnimation(false);
    setTimeout(() => {
      setShowAnimation(true);
    }, 50);
  };
  const handleClick = (evt) => {
    evt.stopPropagation();
    const newCount = count + 1;
    setCount(newCount);
    onClick == null ? void 0 : onClick({
      count: newCount,
      emoji
    });
    toggleAnimation();
  };
  return /* @__PURE__ */ import_react50.default.createElement(
    "div",
    {
      className: (0, import_classnames35.default)(className, [
        "v2-flex v2-flex-row-reverse v2-z-50 v2-pr-25 v2-relative v2-min-w-min"
      ])
    },
    /* @__PURE__ */ import_react50.default.createElement(
      ReactionAnimation,
      {
        className: (0, import_classnames35.default)(
          [
            "v2-transform -translate-x-1/2 -v2-translate-y-1/2 v2-absolute v2-left-1/2 v2-top-1/2"
          ],
          {
            [`v2-h-24 v2-w-24 v2-z-40 v2-active ${showAnimationClassName}`]: showAnimation,
            "v2-h-0 v2-w-0 v2-z-0": !showAnimation
          }
        )
      }
    ),
    /* @__PURE__ */ import_react50.default.createElement(
      ReactionIcon,
      {
        className: (0, import_classnames35.default)(buttonClassName, [
          "v2-h-11 v2-z-40 v2-p-0 v2-flex v2-flex-row v2-justify-center v2-items-center v2-border-0",
          "v2-outline-0 v2-bg-white v2-bg-opacity-20 v2-rounded-full",
          "v2-transform v2-transition-all hover:v2-scale-125 v2-select-none"
        ]),
        onClick: handleClick
      },
      !hideCount && count > 0 && /* @__PURE__ */ import_react50.default.createElement(
        "span",
        {
          className: `v2-pl-2.5 v2-block v2-text-base v2-font-bold v2-text-white ${countClassName}`
        },
        count
      ),
      /* @__PURE__ */ import_react50.default.createElement("span", { className: `v2-px-2.5 v2-block v2-text-lg ${emojiClassName}` }, emoji)
    ),
    !hideTooltip && count === 0 && /* @__PURE__ */ import_react50.default.createElement(
      "div",
      {
        className: `v2-my-2 v2-pr-2 v2-h-7 v2-block v2-relative ${tooltipContainerClassName}`
      },
      /* @__PURE__ */ import_react50.default.createElement(
        "div",
        {
          className: (0, import_classnames35.default)(tooltipClassName, [
            "v2-h-7 v2-px-2.5 v2-inline-block v2-bg-yellow-500 v2-leading-7",
            "v2-text-sm v2-font-medium v2-text-black v2-rounded v2-truncate"
          ])
        },
        tooltipText,
        /* @__PURE__ */ import_react50.default.createElement(
          TooltipTriangle,
          {
            className: (0, import_classnames35.default)(tooltipTriangleClassName, [
              "v2-border-8 v2-border-solid v2-border-transparent v2-w-0 v2-h-0 v2-absolute",
              "-v2-right-1.5 v2-top-1.5"
            ])
          }
        )
      )
    )
  );
}
var ReactionButton_default = ReactionButton;

// src/components/WidgetPopup/index.tsx
var import_classnames41 = __toESM(require("classnames"));

// src/components/VideoMessage/index.tsx
var import_react51 = __toESM(require("react"));
var import_classnames36 = __toESM(require("classnames"));
var import_styled5 = __toESM(require("@emotion/styled"));
var import_react_loading_skeleton2 = __toESM(require("react-loading-skeleton"));
var newTabIcon2 = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/new-tab-white.svg";
var CtaIcon = import_styled5.default.div`
  ${({ color }) => `
    background: ${color};
    mask: url("${newTabIcon2}");
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `}
`;
function VideoMessage({
  message,
  hideCta = false,
  ctaText,
  className,
  ctaColor = colors.black,
  loading,
  onCtaClick,
  footer,
  ctaHref
}) {
  const callToAction = (0, import_react51.useMemo)(() => {
    const ctaButton = /* @__PURE__ */ import_react51.default.createElement(
      "button",
      {
        className: (0, import_classnames36.default)([
          "v2-inline-flex v2-px-3 v2-py-1.5 v2-items-center v2-gap-x-2 v2-rounded-full",
          "v2-border v2-border-solid v2-bg-white v2-transform v2-transition-all hover:v2-scale-105"
        ]),
        style: { borderColor: ctaColor, color: ctaColor },
        onClick: onCtaClick
      },
      ctaText,
      /* @__PURE__ */ import_react51.default.createElement(
        CtaIcon,
        {
          color: ctaColor,
          className: (0, import_classnames36.default)("v2-w-3 v2-h-3 v2-p-1"),
          title: "Open on new window"
        }
      )
    );
    if (ctaHref) {
      return /* @__PURE__ */ import_react51.default.createElement("a", { href: ctaHref, rel: "noopener noreferer noreferrer", target: "_blank" }, ctaButton);
    }
    return ctaButton;
  }, [ctaColor, onCtaClick, ctaText, ctaHref]);
  const messageComponent = /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-animate-fade-in" }, /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-text-neutral-600 v2-font-normal v2-text-sm" }, message), /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-justify-start v2-py-2" }, !hideCta && callToAction));
  const loaderComponent = /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-mb-10" }, /* @__PURE__ */ import_react51.default.createElement(
    import_react_loading_skeleton2.SkeletonTheme,
    {
      baseColor: colors.neutral[300],
      highlightColor: colors.neutral[400],
      borderRadius: 0
    },
    /* @__PURE__ */ import_react51.default.createElement(import_react_loading_skeleton2.default, { className: "v2-h-2.5", count: 6 })
  ));
  return /* @__PURE__ */ import_react51.default.createElement(
    "div",
    {
      className: (0, import_classnames36.default)(
        className,
        "v2-w-full v2-flex v2-flex-col v2-px-3 v2-py-1.5"
      )
    },
    !loading ? messageComponent : loaderComponent,
    footer
  );
}

// src/hook/use-scroll-direction-hook.ts
var import_react52 = require("react");
function useScrollDirection(target) {
  var _a, _b;
  const [scrollPosition, setScrollPosition] = (0, import_react52.useState)(
    (_b = (_a = target.current) == null ? void 0 : _a.scrollTop) != null ? _b : 0
  );
  const [scrollDirection, setScrollDirection] = (0, import_react52.useState)();
  const handleScroll = (0, import_react52.useCallback)(
    () => {
      const currentElement = target.current;
      if (currentElement) {
        const scrollTop = currentElement.scrollTop;
        if (scrollTop > scrollPosition) {
          setScrollDirection(1 /* Down */);
        } else {
          setScrollDirection(0 /* Up */);
        }
        setScrollPosition(scrollTop);
      }
    },
    [target, scrollPosition]
  );
  (0, import_react52.useEffect)(() => {
    const currentElement = target.current;
    if (currentElement) {
      currentElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      currentElement == null ? void 0 : currentElement.removeEventListener("scroll", handleScroll);
    };
  }, [target, handleScroll]);
  return {
    scrollPosition,
    scrollDirection
  };
}

// src/components/SentWithBonjoroBadge/index.tsx
var import_react53 = __toESM(require("react"));
var import_classnames37 = __toESM(require("classnames"));
var import_react_fontawesome9 = require("@fortawesome/react-fontawesome");
var SentWithBonjoroBadgeStyle = /* @__PURE__ */ ((SentWithBonjoroBadgeStyle2) => {
  SentWithBonjoroBadgeStyle2["Compact"] = "compact";
  SentWithBonjoroBadgeStyle2["Full"] = "full";
  SentWithBonjoroBadgeStyle2["Circle"] = "circle";
  return SentWithBonjoroBadgeStyle2;
})(SentWithBonjoroBadgeStyle || {});
var SentWithBonjoroBadgeSize = /* @__PURE__ */ ((SentWithBonjoroBadgeSize2) => {
  SentWithBonjoroBadgeSize2["ExtraSmall"] = "extra-small";
  SentWithBonjoroBadgeSize2["Small"] = "small";
  SentWithBonjoroBadgeSize2["Medium"] = "medium";
  SentWithBonjoroBadgeSize2["Large"] = "large";
  SentWithBonjoroBadgeSize2["ExtraLarge"] = "extra-large";
  return SentWithBonjoroBadgeSize2;
})(SentWithBonjoroBadgeSize || {});
var SentWithBonjoroBadgeTheme = /* @__PURE__ */ ((SentWithBonjoroBadgeTheme2) => {
  SentWithBonjoroBadgeTheme2["Black"] = "black";
  SentWithBonjoroBadgeTheme2["White"] = "white";
  SentWithBonjoroBadgeTheme2["Yellow"] = "Yellow";
  return SentWithBonjoroBadgeTheme2;
})(SentWithBonjoroBadgeTheme || {});
var SentWithBonjoroBadgeRounded = /* @__PURE__ */ ((SentWithBonjoroBadgeRounded2) => {
  SentWithBonjoroBadgeRounded2["FullAll"] = "full-all";
  SentWithBonjoroBadgeRounded2["TopOnly"] = "top-only";
  SentWithBonjoroBadgeRounded2["TopLeftOnly"] = "top-left-only";
  SentWithBonjoroBadgeRounded2["TopRightOnly"] = "top-right-only";
  SentWithBonjoroBadgeRounded2["BottomOnly"] = "bottom-only";
  SentWithBonjoroBadgeRounded2["BottomLeftOnly"] = "bottom-left-only";
  SentWithBonjoroBadgeRounded2["BottomRightOnly"] = "bottom-right-only";
  SentWithBonjoroBadgeRounded2["All"] = "all";
  return SentWithBonjoroBadgeRounded2;
})(SentWithBonjoroBadgeRounded || {});
var SentWithBonjoroBadgeOpacity = /* @__PURE__ */ ((SentWithBonjoroBadgeOpacity2) => {
  SentWithBonjoroBadgeOpacity2["Low"] = "low";
  SentWithBonjoroBadgeOpacity2["Medium"] = "medium";
  SentWithBonjoroBadgeOpacity2["High"] = "high";
  return SentWithBonjoroBadgeOpacity2;
})(SentWithBonjoroBadgeOpacity || {});
var SentWithBonjoroBadgeIconPosition = /* @__PURE__ */ ((SentWithBonjoroBadgeIconPosition2) => {
  SentWithBonjoroBadgeIconPosition2["Left"] = "left";
  SentWithBonjoroBadgeIconPosition2["Right"] = "right";
  return SentWithBonjoroBadgeIconPosition2;
})(SentWithBonjoroBadgeIconPosition || {});
function SentWithBonjoroBadge({
  iconUrl = "https://static.bonjoro.com/3f5aad223e7a50bbf87ac21ca3ce03cb83659bb1/assets/images/logos/bear-logo.png",
  className,
  iconAndTextContainerClassName,
  iconClassName,
  textContainerClassName,
  sentWithClassName,
  bonjoroClassName,
  arrowContainerClassName,
  arrowClassName,
  onClick,
  url,
  target,
  rel = "noopener noreferrer",
  size = "medium" /* Medium */,
  theme: theme2 = "black" /* Black */,
  rounded,
  shadow = false,
  opacity,
  style = "compact" /* Compact */,
  iconPosition = "left" /* Left */,
  hideArrow = false,
  cssStyle,
  dimOnHover = false
}) {
  const onClickHandler = (event) => {
    event.stopPropagation();
    onClick == null ? void 0 : onClick();
  };
  const isCompact = style === "compact" /* Compact */;
  const isFull = style === "full" /* Full */;
  const isCircle = style === "circle" /* Circle */;
  const sizeClass = {
    ["extra-small" /* ExtraSmall */]: "",
    ["small" /* Small */]: "",
    ["medium" /* Medium */]: "",
    ["large" /* Large */]: "",
    ["extra-large" /* ExtraLarge */]: ""
  };
  const iconAndTextContainerCompactWithArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pl-1.5 v2-py-1 v2-gap-1",
    ["small" /* Small */]: "v2-pl-2 v2-py-1 v2-gap-1",
    ["medium" /* Medium */]: "v2-pl-2.5 v2-py-2 v2-gap-1",
    ["large" /* Large */]: "v2-pl-3 v2-py-2 v2-gap-1.5",
    ["extra-large" /* ExtraLarge */]: "v2-pl-3.5 v2-py-2.5 v2-gap-2"
  };
  const iconAndTextContainerCompactWithoutArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-px-1.5 v2-py-1 v2-gap-1",
    ["small" /* Small */]: "v2-px-2 v2-py-1 v2-gap-1",
    ["medium" /* Medium */]: "v2-px-2.5 v2-py-2 v2-gap-1",
    ["large" /* Large */]: "v2-px-3 v2-py-2 v2-gap-1.5",
    ["extra-large" /* ExtraLarge */]: "v2-px-3.5 v2-py-2.5 v2-gap-2"
  };
  const iconAndTextContainerFullWithArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pl-3 v2-py-2 v2-gap-2",
    ["small" /* Small */]: "v2-pl-4 v2-py-2 v2-gap-2.5",
    ["medium" /* Medium */]: "v2-pl-5 v2-py-2.5 v2-gap-3",
    ["large" /* Large */]: "v2-pl-[22px] v2-py-2.5 v2-gap-3.5",
    ["extra-large" /* ExtraLarge */]: "v2-pl-6 v2-py-2.5 v2-gap-4"
  };
  const iconAndTextContainerFullWithoutArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-px-3 v2-py-2 v2-gap-2",
    ["small" /* Small */]: "v2-px-4 v2-py-2 v2-gap-2.5",
    ["medium" /* Medium */]: "v2-px-5 v2-py-2.5 v2-gap-3",
    ["large" /* Large */]: "v2-px-[22px] v2-py-2.5 v2-gap-3.5",
    ["extra-large" /* ExtraLarge */]: "v2-px-6 v2-py-2.5 v2-gap-4"
  };
  const iconAndTextContainerCircleClass = {
    ["extra-small" /* ExtraSmall */]: "v2-p-1 v2-gap-1",
    ["small" /* Small */]: "v2-p-1 v2-gap-1",
    ["medium" /* Medium */]: "v2-p-1 v2-gap-1",
    ["large" /* Large */]: "v2-p-1 v2-gap-1.5",
    ["extra-large" /* ExtraLarge */]: "v2-p-1 v2-gap-2"
  };
  const computeIconAndTextContainerClass = () => {
    if (isCircle) {
      return iconAndTextContainerCircleClass[size];
    }
    return isFull ? hideArrow ? iconAndTextContainerFullWithoutArrowClass[size] : iconAndTextContainerFullWithArrowClass[size] : hideArrow ? iconAndTextContainerCompactWithoutArrowClass[size] : iconAndTextContainerCompactWithArrowClass[size];
  };
  const iconClass = {
    ["extra-small" /* ExtraSmall */]: "v2-w-4 v2-h-4",
    ["small" /* Small */]: "v2-w-5 v2-h-5",
    ["medium" /* Medium */]: "v2-w-6 v2-h-6",
    ["large" /* Large */]: "v2-w-7 v2-h-7",
    ["extra-large" /* ExtraLarge */]: "v2-w-8 v2-h-8"
  };
  const sentWithFullClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xs",
    ["small" /* Small */]: "v2-text-sm",
    ["medium" /* Medium */]: "v2-text-base",
    ["large" /* Large */]: "v2-text-lg",
    ["extra-large" /* ExtraLarge */]: "v2-text-xl"
  };
  const sentWithCompactClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xxs v2-mb-px v2-leading-none",
    ["small" /* Small */]: "v2-text-xxs v2-mb-px v2-leading-tight",
    ["medium" /* Medium */]: "v2-text-xxs",
    ["large" /* Large */]: "v2-text-xs",
    ["extra-large" /* ExtraLarge */]: "v2-text-sm"
  };
  const bonjoroFullClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xs",
    ["small" /* Small */]: "v2-text-sm",
    ["medium" /* Medium */]: "v2-text-base",
    ["large" /* Large */]: "v2-text-lg",
    ["extra-large" /* ExtraLarge */]: "v2-text-xl"
  };
  const bonjoroCompactClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xs",
    ["small" /* Small */]: "v2-text-sm",
    ["medium" /* Medium */]: "v2-text-base",
    ["large" /* Large */]: "v2-text-lg",
    ["extra-large" /* ExtraLarge */]: "v2-text-xl"
  };
  const arrowContainerFullClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pr-3 v2-py-1 v2-ml-1 v2-pl-0.5",
    ["small" /* Small */]: "v2-pr-3.5 v2-py-1 v2-ml-1 v2-pl-1.5",
    ["medium" /* Medium */]: "v2-pr-4 v2-py-1.5 v2-ml-1 v2-pl-2",
    ["large" /* Large */]: "v2-pr-4 v2-py-2 v2-ml-1.5 v2-pl-2.5",
    ["extra-large" /* ExtraLarge */]: "v2-pr-5 v2-py-2.5 v2-ml-2 v2-pl-3"
  };
  const arrowContainerCompactClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pr-1.5 v2-py-1 v2-ml-1 v2-pl-0.5",
    ["small" /* Small */]: "v2-pr-2 v2-py-1 v2-ml-1 v2-pl-1",
    ["medium" /* Medium */]: "v2-pr-2.5 v2-py-1.5 v2-ml-1 v2-pl-1",
    ["large" /* Large */]: "v2-pr-3 v2-py-2 v2-ml-1.5 v2-pl-2",
    ["extra-large" /* ExtraLarge */]: "v2-pr-3.5 v2-py-2.5 v2-ml-2 v2-pl-2"
  };
  const arrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-sm",
    ["small" /* Small */]: "v2-text-base",
    ["medium" /* Medium */]: "v2-text-xl",
    ["large" /* Large */]: "v2-text-2xl",
    ["extra-large" /* ExtraLarge */]: "v2-text-3xl"
  };
  const themeClass = {
    ["black" /* Black */]: "v2-bg-black",
    ["white" /* White */]: "v2-bg-white v2-drop-shadow",
    ["Yellow" /* Yellow */]: "v2-bg-yellow-500"
  };
  const opacityClass = {
    ["low" /* Low */]: "v2-bg-opacity-25",
    ["medium" /* Medium */]: "v2-bg-opacity-50",
    ["high" /* High */]: "v2-bg-opacity-75",
    "": ""
  };
  const roundedClass = {
    ["full-all" /* FullAll */]: "v2-rounded-full",
    ["top-only" /* TopOnly */]: "v2-rounded-t-md",
    ["bottom-only" /* BottomOnly */]: "v2-rounded-b-md",
    ["all" /* All */]: "v2-rounded-md",
    ["top-left-only" /* TopLeftOnly */]: "v2-rounded-tl-md",
    ["top-right-only" /* TopRightOnly */]: "v2-rounded-tr-md",
    ["bottom-left-only" /* BottomLeftOnly */]: "v2-rounded-bl-md",
    ["bottom-right-only" /* BottomRightOnly */]: "v2-rounded-br-md",
    "": ""
  };
  const arrowContainerRoundedClass = {
    ["full-all" /* FullAll */]: "",
    ["top-only" /* TopOnly */]: "v2-rounded-tr-md",
    ["bottom-only" /* BottomOnly */]: "v2-rounded-br-md",
    ["all" /* All */]: "v2-rounded-r-md",
    ["top-right-only" /* TopRightOnly */]: "v2-rounded-tr-md",
    ["top-left-only" /* TopLeftOnly */]: "",
    ["bottom-right-only" /* BottomRightOnly */]: "v2-rounded-br-md",
    ["bottom-left-only" /* BottomLeftOnly */]: "",
    "": ""
  };
  const dimOnHoverClass = "v2-opacity-50 group-hover/main:v2-opacity-100 v2-transition-all v2-duration-200";
  const iconComponent = /* @__PURE__ */ import_react53.default.createElement(
    "img",
    {
      src: iconUrl,
      alt: "Bonjoro Logo",
      className: (0, import_classnames37.default)(
        iconClassName,
        iconClass[size],
        "v2-p-0 v2-m-0 v2-select-none"
      )
    }
  );
  return /* @__PURE__ */ import_react53.default.createElement(
    "a",
    {
      className: (0, import_classnames37.default)(className, [
        "v2-inline-flex v2-cursor-pointer v2-group/main",
        sizeClass[size],
        themeClass[theme2],
        roundedClass[rounded != null ? rounded : ""],
        opacityClass[opacity != null ? opacity : ""],
        {
          "v2-drop-shadow hover:v2-drop-shadow-md v2-transition-all v2-duration-200": shadow
        }
      ]),
      href: url,
      target,
      onClick: onClickHandler,
      style: cssStyle,
      rel
    },
    /* @__PURE__ */ import_react53.default.createElement(
      "div",
      {
        className: (0, import_classnames37.default)(
          iconAndTextContainerClassName,
          computeIconAndTextContainerClass(),
          "v2-flex v2-items-center",
          dimOnHover ? dimOnHoverClass : ""
        )
      },
      iconPosition === "left" /* Left */ && iconComponent,
      !isCircle && /* @__PURE__ */ import_react53.default.createElement(
        "div",
        {
          className: (0, import_classnames37.default)(
            textContainerClassName,
            "v2-justify-center v2-font-circular v2-select-none",
            {
              "v2-text-white": theme2 === "black" /* Black */ || theme2 === "Yellow" /* Yellow */,
              "v2-text-neutral-900": theme2 === "white" /* White */,
              "v2-flex v2-flex-row v2-justify-center v2-items-center v2-gap-x-2": isFull,
              "v2-flex v2-flex-col v2-justify-center": isCompact
            }
          )
        },
        /* @__PURE__ */ import_react53.default.createElement(
          "div",
          {
            className: (0, import_classnames37.default)(
              sentWithClassName,
              isFull ? sentWithFullClass[size] : sentWithCompactClass[size],
              "v2-font-circular v2-leading-none v2-p-0 v2-m-0 v2-select-none",
              {
                "[word-spacing:2px]": isFull
              }
            )
          },
          "Sent with"
        ),
        /* @__PURE__ */ import_react53.default.createElement(
          "div",
          {
            className: (0, import_classnames37.default)(
              bonjoroClassName,
              isFull ? bonjoroFullClass[size] : bonjoroCompactClass[size],
              "v2-font-circular v2-text-base v2-font-semibold v2-tracking-wide",
              "v2-leading-none v2-p-0 v2-m-0 v2-select-none"
            )
          },
          "bonjoro"
        )
      ),
      iconPosition === "right" /* Right */ && iconComponent
    ),
    !hideArrow && !isCircle && /* @__PURE__ */ import_react53.default.createElement(
      "div",
      {
        className: (0, import_classnames37.default)(
          arrowContainerClassName,
          isFull ? arrowContainerFullClass[size] : arrowContainerCompactClass[size],
          arrowContainerRoundedClass[rounded != null ? rounded : ""],
          "v2-flex v2-items-center ",
          {
            "v2-bg-yellow-500": theme2 === "white" /* White */
          }
        )
      },
      /* @__PURE__ */ import_react53.default.createElement(
        import_react_fontawesome9.FontAwesomeIcon,
        {
          className: (0, import_classnames37.default)(
            arrowClassName,
            arrowClass[size],
            "group-hover/main:v2-translate-x-1 v2-transition-transform v2-duration-200 v2-select-none",
            {
              "v2-text-yellow-500": theme2 === "black" /* Black */,
              "v2-text-yellow-700": theme2 === "white" /* White */ || theme2 === "Yellow" /* Yellow */
            }
          ),
          icon: faArrowRight
        }
      )
    )
  );
}

// src/components/ReplyPanel/index.tsx
var import_react57 = __toESM(require("react"));
var import_classnames40 = __toESM(require("classnames"));
var import_react_fontawesome11 = require("@fortawesome/react-fontawesome");

// src/components/EmojiSelector/index.tsx
var import_react55 = __toESM(require("react"));
var import_react_tiny_popover = require("react-tiny-popover");

// src/components/EmojiSelector/EmojiPicker.tsx
var import_react54 = __toESM(require("react"));
var defaultProps = {
  theme: "light",
  emoji: "slightly_smiling_face",
  title: "Choose your emoji",
  size: 16,
  data: () => __async(void 0, null, function* () {
    const response = yield fetch(
      "https://cdn.jsdelivr.net/npm/@emoji-mart/data/sets/14/apple.json"
    );
    return response.json();
  })
};
function EmojiPicker(props) {
  const ref = (0, import_react54.useRef)(null);
  (0, import_react54.useEffect)(() => {
    void import("emoji-mart").then((emojiMart) => {
      new emojiMart.Picker(__spreadProps(__spreadValues(__spreadValues({}, defaultProps), props), { ref }));
    });
  }, []);
  return /* @__PURE__ */ import_react54.default.createElement("div", { ref });
}

// src/components/EmojiSelector/index.tsx
var import_react_fontawesome10 = require("@fortawesome/react-fontawesome");
var import_classnames38 = __toESM(require("classnames"));

// node_modules/@fortawesome/free-regular-svg-icons/index.mjs
var faFaceLaugh = {
  prefix: "far",
  iconName: "face-laugh",
  icon: [512, 512, ["laugh"], "f599", "M130.7 313.9C126.5 300.4 137.8 288 151.1 288H364.5C378.7 288 389.9 300.4 385.8 313.9C368.1 368.4 318.2 408 258.2 408C198.2 408 147.5 368.4 130.7 313.9V313.9zM208.4 192C208.4 209.7 194 224 176.4 224C158.7 224 144.4 209.7 144.4 192C144.4 174.3 158.7 160 176.4 160C194 160 208.4 174.3 208.4 192zM304.4 192C304.4 174.3 318.7 160 336.4 160C354 160 368.4 174.3 368.4 192C368.4 209.7 354 224 336.4 224C318.7 224 304.4 209.7 304.4 192zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"]
};
var faLaugh = faFaceLaugh;

// src/components/EmojiSelector/index.tsx
function EmojiSelector(_a) {
  var _b = _a, {
    closeOnSelect = false,
    iconClassName,
    iconContainerClassName,
    popoverContainerClassName,
    positions = ["bottom"],
    align = "center",
    padding = 10,
    reposition,
    onSelect,
    onClick,
    customButton,
    container,
    label,
    disabled = false
  } = _b, props = __objRest(_b, [
    "closeOnSelect",
    "iconClassName",
    "iconContainerClassName",
    "popoverContainerClassName",
    "positions",
    "align",
    "padding",
    "reposition",
    "onSelect",
    "onClick",
    "customButton",
    "container",
    "label",
    "disabled"
  ]);
  const [open, setOpen] = (0, import_react55.useState)(false);
  const toggleOpen = () => setOpen(!open);
  const handleOnSelect = (emoji) => {
    onSelect == null ? void 0 : onSelect(emoji);
    if (closeOnSelect) {
      setOpen(false);
    }
  };
  const handleOnClick = () => {
    if (!disabled) {
      onClick == null ? void 0 : onClick();
      toggleOpen();
    }
  };
  return /* @__PURE__ */ import_react55.default.createElement(
    import_react_tiny_popover.Popover,
    {
      isOpen: open,
      onClickOutside: () => setOpen(false),
      padding,
      content: /* @__PURE__ */ import_react55.default.createElement(EmojiPicker, __spreadValues({ onEmojiSelect: handleOnSelect }, props)),
      positions,
      containerClassName: (0, import_classnames38.default)(popoverContainerClassName, "v2-z-99"),
      parentElement: container,
      align,
      reposition
    },
    /* @__PURE__ */ import_react55.default.createElement("span", { onClick: handleOnClick }, customButton != null ? customButton : /* @__PURE__ */ import_react55.default.createElement(
      "div",
      {
        className: (0, import_classnames38.default)(
          iconContainerClassName,
          "v2-group v2-flex v2-flex-row v2-gap-x-2 v2-items-center v2-cursor-pointer"
        )
      },
      /* @__PURE__ */ import_react55.default.createElement(
        import_react_fontawesome10.FontAwesomeIcon,
        {
          className: (0, import_classnames38.default)(
            iconClassName,
            ["v2-text-neutral-500 v2-rounded-full v2-cursor-pointer"],
            {
              "group-hover:v2-bg-yellow-500 group-hover:v2-text-neutral-900": !disabled
            }
          ),
          icon: faLaugh
        }
      ),
      label
    ))
  );
}

// src/components/ReplyPanel/index.tsx
var import_styled6 = __toESM(require("@emotion/styled"));

// src/components/ReplyPanel/ReplyInput.tsx
var import_react56 = __toESM(require("react"));
var import_classnames39 = __toESM(require("classnames"));
function ReplyInput({
  inputId,
  type,
  inputRef,
  disableInput,
  value,
  className,
  placeholder,
  onInputChange,
  onKeyDown,
  focused,
  textAreaDefaultHeight = 50,
  textAreaMaxHeight = 80,
  maxLength
}) {
  return type == "plain_input" /* PlainInput */ ? /* @__PURE__ */ import_react56.default.createElement(
    "input",
    {
      id: inputId,
      ref: inputRef,
      value,
      disabled: disableInput,
      className: (0, import_classnames39.default)(
        className,
        "v2-h-10 v2-text-sm text-border-neutral-700 v2-px-2 v2-w-full v2-rounded v2-border v2-border-neutral-200 v2-border-solid"
      ),
      placeholder: disableInput ? "" : placeholder,
      onChange: (event) => onInputChange == null ? void 0 : onInputChange(event.currentTarget.value),
      onKeyDown,
      maxLength
    }
  ) : /* @__PURE__ */ import_react56.default.createElement(
    TextArea,
    {
      id: inputId,
      inputRef,
      value,
      disabled: disableInput,
      className: (0, import_classnames39.default)(className, "v2-transition-all"),
      maxHeight: textAreaMaxHeight,
      style: {
        height: focused ? textAreaMaxHeight : textAreaDefaultHeight
      },
      placeholder: disableInput ? "" : placeholder,
      onChange: (event) => onInputChange == null ? void 0 : onInputChange(event.currentTarget.value),
      maxLength,
      onKeyDown
    }
  );
}

// src/components/ReplyPanel/index.tsx
var replyByVideoIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/reply-by-video.svg";
var ReplyByVideoIcon = import_styled6.default.div`
  mask: url(\"${replyByVideoIcon}\");
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
`;
var ReplyInputType = /* @__PURE__ */ ((ReplyInputType2) => {
  ReplyInputType2["TextArea"] = "text_area";
  ReplyInputType2["PlainInput"] = "plain_input";
  return ReplyInputType2;
})(ReplyInputType || {});
var ReplyPanelType = /* @__PURE__ */ ((ReplyPanelType2) => {
  ReplyPanelType2["Compact"] = "compact";
  ReplyPanelType2["Column"] = "column";
  return ReplyPanelType2;
})(ReplyPanelType || {});
var columnIconClassName = "v2-rounded v2-bg-neutral-200 v2-px-2 hover:v2-bg-turquoise-500 v2-select-none v2-font-bold v2-py-[0.3rem] v2-text-[16px]";
function ReplyPanel({
  id,
  inputId,
  value,
  inputRef,
  placeholder,
  className,
  containerClassName,
  firstLayerClassName,
  secondLayerClassName,
  disableSend = false,
  disableInput = false,
  hideEmojiSelector = false,
  hideReplyByVideo = false,
  allowTextAreaResizeOnFocus = true,
  inputType = "text_area" /* TextArea */,
  panelType = "compact" /* Compact */,
  emojiLabel = "Emoji",
  replyByVideoLabel = "Reply by video",
  sendLabel = "Send",
  inputClassName,
  sendButtonClassName,
  emojiSelectorClassName,
  emojiSelectorIconClassName,
  replyByVideoClassName,
  replyByVideoIconClassName,
  emojiPopoverClassName,
  textAreaDefaultHeight = 40,
  textAreaMaxHeight = 70,
  maxLength,
  popoverPositions = ["top", "right"],
  popoverAlign = "start",
  popoverPadding = 10,
  popoverReposition,
  onSendClick,
  onEmojiSelect,
  onInputChange,
  onFocus,
  onBlur,
  onEnterKeyPress,
  onReplyByVideoClick,
  customInputComponent,
  container = document,
  submitOnEnter = true
}) {
  const containerRef = (0, import_react57.useRef)(null);
  const [inputFocused, setInputFocused] = (0, import_react57.useState)(false);
  const onClickHandler = (0, import_react57.useCallback)(() => {
    if (!inputFocused) {
      onFocus == null ? void 0 : onFocus();
      setInputFocused(true);
    }
  }, [inputFocused]);
  (0, import_react57.useEffect)(() => {
    if (!containerRef.current)
      return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target) && inputFocused) {
        onBlur == null ? void 0 : onBlur();
        setInputFocused(false);
      }
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleClickOutside);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleClickOutside);
    };
  }, [container, inputFocused]);
  const onSendClickHandler = () => {
    if (!value)
      return;
    onSendClick == null ? void 0 : onSendClick(value);
  };
  const onKeyDownHandler = (event) => {
    if (!value)
      return;
    if (event.key === "Enter" && value != "" && !event.shiftKey) {
      if (submitOnEnter) {
        onSendClickHandler();
      }
      onEnterKeyPress == null ? void 0 : onEnterKeyPress(value);
    }
  };
  const sendDisabled = value === "" || value === void 0 || disableSend;
  const textAreaInputType = inputType === "text_area" /* TextArea */;
  const compactPanelType = panelType == "compact" /* Compact */;
  const columnPanelType = panelType == "column" /* Column */;
  const columnTextAreaFocused = columnPanelType && inputFocused && textAreaInputType && allowTextAreaResizeOnFocus;
  const containerPadding = columnPanelType ? 60 : 20;
  const containerHeight = containerPadding + (columnTextAreaFocused ? textAreaMaxHeight : textAreaDefaultHeight);
  return /* @__PURE__ */ import_react57.default.createElement(
    "div",
    {
      id,
      tabIndex: 0,
      className: (0, import_classnames40.default)(className, [
        "v2-w-full v2-bg-neutral-50 v2-flex v2-flex-row v2-transition-all",
        "v2-justify-between v2-items-center v2-gap-x-2.5 v2-px-4"
      ]),
      style: {
        height: containerHeight
      },
      onClick: onClickHandler,
      ref: containerRef
    },
    /* @__PURE__ */ import_react57.default.createElement(
      "div",
      {
        className: (0, import_classnames40.default)(containerClassName, "v2-flex v2-flex-1", {
          "v2-flex-col v2-gap-y-2": columnPanelType,
          "v2-flex-row v2-gap-x-2": compactPanelType
        })
      },
      /* @__PURE__ */ import_react57.default.createElement(
        "div",
        {
          className: (0, import_classnames40.default)(
            firstLayerClassName,
            "v2-flex v2-flex-row v2-items-center v2-gap-x-4"
          )
        },
        !hideEmojiSelector && /* @__PURE__ */ import_react57.default.createElement(
          EmojiSelector,
          {
            closeOnSelect: true,
            onSelect: onEmojiSelect,
            positions: popoverPositions,
            align: popoverAlign,
            padding: popoverPadding,
            reposition: popoverReposition,
            container: containerRef == null ? void 0 : containerRef.current,
            disabled: disableInput,
            iconContainerClassName: (0, import_classnames40.default)(
              emojiSelectorClassName,
              "v2-text-black",
              {
                [columnIconClassName]: columnPanelType
              }
            ),
            popoverContainerClassName: emojiPopoverClassName,
            iconClassName: (0, import_classnames40.default)(emojiSelectorIconClassName, "v2-text-black"),
            label: columnPanelType ? emojiLabel : ""
          }
        ),
        !hideReplyByVideo && /* @__PURE__ */ import_react57.default.createElement(
          "div",
          {
            tabIndex: 0,
            className: (0, import_classnames40.default)(
              replyByVideoClassName,
              [
                "v2-flex v2-flex-row v2-gap-x-2 v2-items-center v2-cursor-pointer v2-group",
                "v2-text-black"
              ],
              {
                [columnIconClassName]: columnPanelType
              }
            ),
            onClick: onReplyByVideoClick
          },
          /* @__PURE__ */ import_react57.default.createElement(
            ReplyByVideoIcon,
            {
              className: (0, import_classnames40.default)(
                replyByVideoIconClassName,
                "v2-w-6 v2-h-6 v2-p-1 group-hover:v2-bg-turquoise-700 v2-bg-black v2-cursor-pointer"
              ),
              title: "Reply by Video"
            }
          ),
          columnPanelType ? replyByVideoLabel : ""
        )
      ),
      /* @__PURE__ */ import_react57.default.createElement(
        "div",
        {
          className: (0, import_classnames40.default)(
            secondLayerClassName,
            "v2-flex v2-flex-row v2-gap-x-2 v2-w-full"
          )
        },
        customInputComponent != null ? customInputComponent : /* @__PURE__ */ import_react57.default.createElement(
          ReplyInput,
          {
            inputId,
            type: inputType,
            inputRef,
            disableInput,
            value,
            placeholder,
            onInputChange,
            textAreaDefaultHeight,
            textAreaMaxHeight,
            className: inputClassName,
            onKeyDown: onKeyDownHandler,
            focused: columnTextAreaFocused,
            maxLength
          }
        ),
        /* @__PURE__ */ import_react57.default.createElement(
          Button,
          {
            disabled: sendDisabled,
            className: (0, import_classnames40.default)(
              sendButtonClassName,
              "v2-p-0 v2-w-16 v2-flex v2-justify-center v2-items-center v2-flex v2-flex-col"
            ),
            onClick: onSendClickHandler
          },
          /* @__PURE__ */ import_react57.default.createElement(import_react_fontawesome11.FontAwesomeIcon, { className: "v2-w-4 v2-h-5", icon: faPaperPlane }),
          columnTextAreaFocused ? sendLabel : ""
        )
      )
    )
  );
}

// src/components/WidgetPopup/index.tsx
var bearLogo = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bear-logo.png";
function WidgetPopup({
  videoUrl,
  videoRef,
  ctaHoverColor,
  showDefaultFullScreen,
  message,
  initialFullScreen = false,
  hideCta = false,
  ctaText,
  ctaColor,
  ctaHref,
  profileName,
  profileImageUrl,
  profileDescription,
  className,
  videoContainerClassName,
  videoClassName,
  muted = false,
  loop = false,
  autoPlay = true,
  sendingReply = false,
  inputValue,
  onInputValueChange,
  messageClassName,
  profilePanelClassName,
  replyPanelClassName,
  scrollableContainerClassName,
  messageFooter,
  hideProfilePanel = false,
  hideBonjoroBadge = false,
  hideReactionComponent = false,
  placeholder,
  videoLeftHeaderComponent,
  videoFooterComponent,
  reactionComponent,
  hideEmojiSelector = false,
  hideReplyByVideo = false,
  customInputComponent,
  panelType,
  inputType,
  onReplyPanelFocus,
  onReplyPanelBlur,
  allowTextAreaResizeOnFocus,
  onSendClick,
  onCloseClick,
  onVideoLoaded,
  onReactClick,
  onBonjoroBadgeClick,
  onCtaClick,
  onNewTabClick,
  onFullScreenClick,
  onReplyByVideoClick,
  onEnterKeyPress,
  container,
  inputRef,
  transcriptMode,
  transcription,
  hideTranscription = false
}) {
  const [count, setCount] = (0, import_react58.useState)(0);
  const [fullScreen, setFullScreen] = (0, import_react58.useState)(initialFullScreen);
  const [videoLoaded, setVideoLoaded] = (0, import_react58.useState)(false);
  const containerRef = (0, import_react58.useRef)(null);
  const scrollableDivRef = (0, import_react58.useRef)(null);
  const popupVideoRef = videoRef != null ? videoRef : (0, import_react58.useRef)(null);
  const innerInputRef = inputRef != null ? inputRef : (0, import_react58.useRef)(null);
  const [popupInputValue, setPopupInputValue] = (0, import_react58.useState)("");
  const [videoPlayerVisible, setVideoPlayerVisible] = (0, import_react58.useState)(true);
  const input = inputValue != null ? inputValue : popupInputValue;
  const setInput = onInputValueChange != null ? onInputValueChange : setPopupInputValue;
  const appendEmojiToInput = (emoji) => {
    if (innerInputRef.current) {
      const cursor2 = innerInputRef.current.selectionStart;
      setInput(
        innerInputRef.current.value.slice(0, cursor2) + emoji + innerInputRef.current.value.slice(cursor2)
      );
      const newCursor = cursor2 + emoji.length;
      setTimeout(
        () => {
          var _a;
          return (_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.setSelectionRange(newCursor, newCursor);
        },
        10
      );
      innerInputRef.current.focus();
    }
  };
  const onReactClickHandler = (args) => {
    setCount(args.count);
    appendEmojiToInput(args.emoji);
    onReactClick == null ? void 0 : onReactClick(args.emoji);
  };
  const onFullScreenClickHandler = () => {
    setFullScreen(!fullScreen);
    onFullScreenClick == null ? void 0 : onFullScreenClick();
  };
  const onCloseClickHandler = () => {
    var _a;
    (_a = popupVideoRef == null ? void 0 : popupVideoRef.current) == null ? void 0 : _a.scrollIntoView();
    onCloseClick == null ? void 0 : onCloseClick();
  };
  const onEmojiSelect = (emoji) => {
    appendEmojiToInput(emoji.native);
  };
  const onVideoLoadedHandler = () => {
    onVideoLoaded == null ? void 0 : onVideoLoaded();
    setVideoLoaded(true);
  };
  const scrollableDiv = useScrollDirection(scrollableDivRef);
  (0, import_react58.useEffect)(() => {
    if (scrollableDiv.scrollDirection === void 0)
      return setVideoPlayerVisible(true);
    if (!popupVideoRef.current)
      return setVideoPlayerVisible(false);
    setVideoPlayerVisible(
      scrollableDiv.scrollPosition < popupVideoRef.current.getBoundingClientRect().height
    );
  }, [scrollableDiv, popupVideoRef.current]);
  const profilePanelProps = {
    name: profileName,
    imageUrl: profileImageUrl,
    description: profileDescription,
    loading: !videoLoaded,
    reactionComponent: reactionComponent != null ? reactionComponent : !hideReactionComponent && /* @__PURE__ */ import_react58.default.createElement(
      ReactionButton_default,
      {
        initialCount: count,
        onClick: onReactClickHandler,
        hideCount: true
      }
    )
  };
  const videoPlayerProps = {
    videoUrl,
    ctaHoverColor,
    onNewTabClick,
    showDefaultFullScreen,
    videoClassName,
    videoRef: popupVideoRef,
    muted,
    loop,
    autoPlay,
    onVideoLoaded: onVideoLoadedHandler,
    onCloseClick: onCloseClickHandler,
    onFullScreenClick: onFullScreenClickHandler,
    containerClassName: videoContainerClassName,
    hideLoader: false,
    hideTranscription,
    transcription,
    transcriptMode,
    closedCaptionClassName: "!v2-pt-1",
    leftHeaderComponent: videoLeftHeaderComponent != null ? videoLeftHeaderComponent : !hideBonjoroBadge && /* @__PURE__ */ import_react58.default.createElement(
      SentWithBonjoroBadge,
      {
        iconUrl: bearLogo,
        className: "v2-bg-opacity-50 v2-bg-black v2-animate-fade-in",
        onClick: onBonjoroBadgeClick
      }
    ),
    footerComponent: videoFooterComponent != null ? videoFooterComponent : videoPlayerVisible && !hideProfilePanel && /* @__PURE__ */ import_react58.default.createElement(
      ProfilePanel,
      __spreadProps(__spreadValues({}, profilePanelProps), {
        className: (0, import_classnames41.default)(profilePanelClassName, "v2-relative")
      })
    )
  };
  const videoMessageProps = {
    message,
    hideCta,
    ctaText,
    ctaColor,
    ctaHref,
    onCtaClick,
    footer: messageFooter,
    loading: !videoLoaded,
    className: (0, import_classnames41.default)(messageClassName, {
      "v2-pt-14": !videoPlayerVisible && !hideProfilePanel
    })
  };
  const replyPanelProps = {
    inputRef: innerInputRef,
    onEmojiSelect,
    onSendClick,
    onReplyByVideoClick,
    onEnterKeyPress,
    hideEmojiSelector,
    hideReplyByVideo,
    customInputComponent,
    panelType,
    inputType,
    onFocus: onReplyPanelFocus,
    onBlur: onReplyPanelBlur,
    allowTextAreaResizeOnFocus,
    container: container != null ? container : containerRef == null ? void 0 : containerRef.current,
    disableInput: !videoLoaded || sendingReply,
    disableSend: sendingReply,
    className: replyPanelClassName,
    value: input,
    onInputChange: setInput,
    placeholder: placeholder != null ? placeholder : `Send a reply to ${profileName}`,
    inputClassName: "v2-py-2 v2-px-3"
  };
  return /* @__PURE__ */ import_react58.default.createElement(
    "div",
    {
      className: (0, import_classnames41.default)(className, ["v2-relative v2-flex v2-flex-col"]),
      ref: containerRef
    },
    /* @__PURE__ */ import_react58.default.createElement(
      "div",
      {
        className: (0, import_classnames41.default)(scrollableContainerClassName, [
          "v2-flex-1 v2-h-screen xs:v2-h-full v2-overflow-y-auto v2-overflow-x-hidden"
        ]),
        ref: scrollableDivRef
      },
      /* @__PURE__ */ import_react58.default.createElement(VideoPlayerContainer, __spreadValues({}, videoPlayerProps)),
      !fullScreen && /* @__PURE__ */ import_react58.default.createElement(import_react58.default.Fragment, null, !videoPlayerVisible && !hideProfilePanel && /* @__PURE__ */ import_react58.default.createElement(
        ProfilePanel,
        __spreadProps(__spreadValues({}, profilePanelProps), {
          className: (0, import_classnames41.default)(
            profilePanelClassName,
            "v2-absolute v2-top-0 v2-z-50 v2-bg-opacity-80 v2-animate-fade-in"
          )
        })
      ), /* @__PURE__ */ import_react58.default.createElement(VideoMessage, __spreadValues({}, videoMessageProps)))
    ),
    !fullScreen && /* @__PURE__ */ import_react58.default.createElement(ReplyPanel, __spreadValues({}, replyPanelProps))
  );
}

// src/components/Widget/index.tsx
function Widget({
  iconImageUrl,
  themeColor,
  videoUrl,
  message,
  hidePreview = false,
  hidePing = false,
  previewDelay = 2e3,
  showDefaultFullScreen,
  ctaText,
  ctaColor,
  profileName,
  profileImageUrl,
  profileDescription,
  yPlacement = "bottom",
  xPlacement = "left",
  onSendClick,
  onBubbleClick,
  onPreviewClick,
  onPopupClose,
  onPreviewClose,
  onReactClick,
  onBonjoroBadgeClick,
  onCtaClick,
  onFullScreenClick,
  onNewTabClick
}) {
  const [popupOpen, setPopupOpen] = (0, import_react59.useState)(false);
  const [previewOpen, setPreviewOpen] = (0, import_react59.useState)(false);
  const popupParentRef = (0, import_react59.useRef)(null);
  const videoRef = (0, import_react59.useRef)(null);
  let openPreviewTimer;
  (0, import_react59.useEffect)(() => {
    if (!hidePreview) {
      openPreviewTimer = setTimeout(() => {
        setPreviewOpen(true);
      }, previewDelay);
    }
  }, [hidePreview, previewDelay]);
  (0, import_react59.useEffect)(() => {
    setPreviewOpen(false);
  }, [previewDelay, hidePreview]);
  const toggleVideoState = () => {
    var _a, _b;
    if (!popupOpen) {
      (_a = videoRef.current) == null ? void 0 : _a.play();
    } else {
      (_b = videoRef.current) == null ? void 0 : _b.pause();
    }
  };
  const openPopup = () => {
    setPreviewOpen(false);
    setPopupOpen(!popupOpen);
    clearTimeout(openPreviewTimer);
    toggleVideoState();
  };
  const onBubbleClickHandler = () => {
    openPopup();
    onBubbleClick == null ? void 0 : onBubbleClick();
  };
  const onPreviewClickHandler = () => {
    openPopup();
    onPreviewClick == null ? void 0 : onPreviewClick();
  };
  const onPreviewCloseHandler = () => {
    onPreviewClose == null ? void 0 : onPreviewClose();
    setPreviewOpen(false);
  };
  const onPopupCloseHandler = () => {
    onPopupClose == null ? void 0 : onPopupClose();
    setPopupOpen(false);
  };
  const bubbleProps = {
    iconImageUrl,
    borderColor: themeColor,
    showPing: !hidePing,
    onClick: onBubbleClickHandler,
    size: 54,
    className: (0, import_classnames42.default)({
      "v2-hidden xs:v2-inline-flex": popupOpen
    })
  };
  const previewProps = {
    videoUrl,
    message,
    muteIconBgColor: themeColor,
    className: (0, import_classnames42.default)(["v2-absolute v2-animate-fade-in-down v2-w-72 sm:v2-w-96"], {
      "xs:v2-top-1 v2-top-20": yPlacement == "top",
      "xs:v2-bottom-1 v2-bottom-20": yPlacement == "bottom",
      "v2-left-0 xs:v2-left-20": xPlacement == "left",
      "v2-right-0 xs:v2-right-20": xPlacement == "right",
      "v2-hidden": !previewOpen
    }),
    onClick: onPreviewClickHandler,
    onClose: onPreviewCloseHandler
  };
  const popupProps = {
    videoUrl,
    showDefaultFullScreen,
    message,
    ctaText,
    ctaColor,
    profileName,
    profileImageUrl,
    profileDescription,
    onSendClick,
    onReactClick,
    onBonjoroBadgeClick,
    onCtaClick,
    onFullScreenClick,
    onNewTabClick,
    videoRef,
    ctaHoverColor: themeColor,
    onCloseClick: onPopupCloseHandler,
    autoPlay: false,
    videoClassName: "v2-min-w-32 v2-w-full v2-h-full xxs:v2-h-72 xs:v2-h-80",
    messageClassName: "v2-max-h-48",
    videoContainerClassName: "v2-w-full",
    className: "v2-bg-white",
    container: popupParentRef == null ? void 0 : popupParentRef.current
  };
  return /* @__PURE__ */ import_react59.default.createElement(
    "div",
    {
      className: (0, import_classnames42.default)("v2-fixed", {
        "v2-top-0 xs:v2-top-4": popupOpen && yPlacement == "top",
        "v2-bottom-0 xs:v2-bottom-4": popupOpen && yPlacement == "bottom",
        "v2-top-4": !popupOpen && yPlacement == "top",
        "v2-bottom-4": !popupOpen && yPlacement == "bottom",
        "v2-left-0 xs:v2-left-4": popupOpen && xPlacement == "left",
        "v2-right-0 xs:v2-right-4": popupOpen && xPlacement == "right",
        "v2-left-4": !popupOpen && xPlacement == "left",
        "v2-right-4": !popupOpen && xPlacement == "right"
      })
    },
    /* @__PURE__ */ import_react59.default.createElement(WidgetPreview, __spreadValues({}, previewProps)),
    /* @__PURE__ */ import_react59.default.createElement(
      "div",
      {
        className: (0, import_classnames42.default)(
          [
            "v2-relative xs:v2-absolute v2-animate-fade-in-up xs:v2-w-80 v2-w-screen"
          ],
          {
            "v2-top-0 xs:v2-top-1 ": yPlacement == "top",
            "v2-bottom-0 xs:v2-bottom-1 ": yPlacement == "bottom",
            "v2-left-0 xs:v2-left-20": xPlacement == "left",
            "v2-right-0 xs:v2-right-20": xPlacement == "right",
            "v2-hidden": !popupOpen
          }
        ),
        ref: popupParentRef
      },
      /* @__PURE__ */ import_react59.default.createElement(WidgetPopup, __spreadValues({}, popupProps))
    ),
    /* @__PURE__ */ import_react59.default.createElement(WidgetBubble, __spreadValues({}, bubbleProps))
  );
}

// src/components/PromotionCard/PromotionCard.tsx
var import_react60 = __toESM(require("react"));
var import_classnames43 = __toESM(require("classnames"));
var import_react_fontawesome12 = require("@fortawesome/react-fontawesome");
var PromotionCardListType = /* @__PURE__ */ ((PromotionCardListType2) => {
  PromotionCardListType2["Ordered"] = "ordered";
  PromotionCardListType2["Unordered"] = "unordered";
  return PromotionCardListType2;
})(PromotionCardListType || {});
var PromotionCardImageShape = /* @__PURE__ */ ((PromotionCardImageShape2) => {
  PromotionCardImageShape2["Circle"] = "circle";
  PromotionCardImageShape2["Square"] = "square";
  return PromotionCardImageShape2;
})(PromotionCardImageShape || {});
function PromotionCard({
  preHeader,
  header,
  description,
  listItems,
  listType,
  imageUrl,
  imageShape,
  footer,
  ctaText,
  ctaVariant,
  isCtaLoading,
  isCtaDisabled,
  onCtaClick,
  className,
  imageClassName,
  ctaClassName
}) {
  const list = (0, import_react60.useMemo)(() => {
    return /* @__PURE__ */ import_react60.default.createElement("div", { className: "v2-flex v2-flex-col v2-gap-y-2.5" }, listItems && (listItems == null ? void 0 : listItems.map((item, index) => {
      const indicator = listType === "ordered" /* Ordered */ ? /* @__PURE__ */ import_react60.default.createElement(
        "span",
        {
          className: (0, import_classnames43.default)([
            "v2-h-5 v2-w-5 v2-min-w-[1.25rem] v2-text-center v2-content-center",
            "v2-leading-none v2-text-sm v2-font-bold v2-rounded-full v2-border-2",
            "v2-border-solid v2-border-neutral-900 v2-text-neutral-900"
          ])
        },
        index + 1
      ) : /* @__PURE__ */ import_react60.default.createElement(
        import_react_fontawesome12.FontAwesomeIcon,
        {
          icon: faCheck2,
          className: (0, import_classnames43.default)([
            "v2-text-white v2-font-bold v2-rounded-full v2-items-center v2-h-full v2-w-full",
            "v2-w-3.5 v2-h-3.5 v2-p-[3px] v2-bg-neutral-900"
          ])
        }
      );
      return /* @__PURE__ */ import_react60.default.createElement("div", { key: index, className: "v2-flex v2-flex-row v2-gap-x-2" }, indicator, /* @__PURE__ */ import_react60.default.createElement("span", { className: "v2-w-fit v2-text-sm v2-text-neutral-900" }, item));
    })));
  }, [listItems, listType]);
  return /* @__PURE__ */ import_react60.default.createElement(
    "div",
    {
      className: (0, import_classnames43.default)(className, [
        "v2-w-fit v2-h-full v2-flex v2-flex-col v2-gap-y-[15px] v2-rounded-md",
        "v2-py-5 v2-px-8 v2-shadow-around v2-bg-white"
      ])
    },
    /* @__PURE__ */ import_react60.default.createElement("div", { className: "v2-flex v2-flex-row v2-gap-x-1.5" }, /* @__PURE__ */ import_react60.default.createElement("span", { className: "v2-text-lg v2-text-yellow-700 v2-font-bold" }, preHeader), /* @__PURE__ */ import_react60.default.createElement("span", { className: "v2-text-lg v2-text-neutral-900 v2-font-bold" }, header)),
    /* @__PURE__ */ import_react60.default.createElement("div", { className: "v2-text-neutral-900 v2-text-base" }, description),
    /* @__PURE__ */ import_react60.default.createElement("div", { className: "v2-flex v2-flex-row v2-gap-x-10" }, /* @__PURE__ */ import_react60.default.createElement("div", { className: "v2-flex v2-flex-col v2-gap-y-[20px]" }, list, /* @__PURE__ */ import_react60.default.createElement("div", { className: "v2-flex v2-flex-col v2-gap-y-2.5" }, /* @__PURE__ */ import_react60.default.createElement(
      Button,
      {
        className: (0, import_classnames43.default)(ctaClassName, "v2-py-1 v2-h-10 v2-text-[21px]"),
        variant: ctaVariant,
        onClick: onCtaClick,
        disabled: isCtaDisabled
      },
      isCtaLoading && /* @__PURE__ */ import_react60.default.createElement(import_react_fontawesome12.FontAwesomeIcon, { icon: faSpinner, className: "v2-animate-spin v2-mr-2" }),
      ctaText
    ), footer && /* @__PURE__ */ import_react60.default.createElement("div", { className: "v2-text-xs v2-text-neutral-500" }, footer))), imageUrl && /* @__PURE__ */ import_react60.default.createElement(
      "img",
      {
        src: imageUrl,
        className: (0, import_classnames43.default)(imageClassName, "v2-self-center v2-select-none", {
          "v2-rounded-full": imageShape === "circle" /* Circle */
        })
      }
    ))
  );
}

// src/components/RepliesPanel/index.tsx
var import_react62 = __toESM(require("react"));
var import_classnames45 = __toESM(require("classnames"));

// src/components/RepliesPanel/ThreadBox.tsx
var import_react61 = __toESM(require("react"));

// src/components/RepliesPanel/ReplyType.ts
var ReplyType = /* @__PURE__ */ ((ReplyType2) => {
  ReplyType2["Recipient"] = "recipient";
  ReplyType2["Sender"] = "sender";
  return ReplyType2;
})(ReplyType || {});
var ReplyType_default = ReplyType;

// src/components/RepliesPanel/ThreadBox.tsx
var import_linkify_string = __toESM(require("linkify-string"));
var import_styled7 = __toESM(require("@emotion/styled"));
var import_classnames44 = __toESM(require("classnames"));
var ThreadBoxReply = import_styled7.default.div`
  a {
    color: ${colors.turquoise[700]};
    &:hover {
      color: ${colors.turquoise[900]};
    }
  }
`;
function defaultRenderReply(reply) {
  return /* @__PURE__ */ import_react61.default.createElement(
    "span",
    {
      dangerouslySetInnerHTML: {
        __html: (0, import_linkify_string.default)(reply.content, {
          target: {
            url: "_blank"
          }
        })
      }
    }
  );
}
function ThreadBox({
  thread,
  className,
  onVideoFullScreenClick,
  renderTextReply = defaultRenderReply
}) {
  const { name, replyType, replies } = thread;
  return /* @__PURE__ */ import_react61.default.createElement(
    "div",
    {
      className: (0, import_classnames44.default)(className, "v2-flex v2-flex-col v2-px-4 v2-py-2", {
        "v2-self-end": replyType == ReplyType_default.Recipient,
        "v2-self-start": replyType == ReplyType_default.Sender
      })
    },
    /* @__PURE__ */ import_react61.default.createElement(
      "span",
      {
        className: (0, import_classnames44.default)("v2-mb-2", {
          "v2-text-purple-700": replyType == ReplyType_default.Recipient,
          "v2-text-turquoise-700": replyType == ReplyType_default.Sender
        })
      },
      name
    ),
    replies.map((reply) => {
      const { media, content } = reply;
      return /* @__PURE__ */ import_react61.default.createElement("div", { key: reply.id }, !media && content && /* @__PURE__ */ import_react61.default.createElement(ThreadBoxReply, { className: "v2-font-thin v2-break-words" }, renderTextReply(reply)), media && /* @__PURE__ */ import_react61.default.createElement(
        VideoPlayerContainer,
        {
          key: media.id,
          containerClassName: "min-w-32 v2-min-h-[12rem] v2-w-full v2-h-full",
          videoClassName: "v2-rounded",
          videoUrl: media.videoUrl,
          hideNewTab: true,
          hideClose: true,
          videoThumbnail: media.thumbUrl,
          autoPlay: false,
          onFullScreenClick: onVideoFullScreenClick
        }
      ));
    })
  );
}

// src/components/RepliesPanel/index.tsx
function groupReplies(replies) {
  const comparator = (a, b) => {
    return a.name === b.name && !b.media && !a.media;
  };
  return consecutivePartition(replies, comparator).map((replies2) => {
    const { name, replyType } = replies2[0];
    return { name, replyType, replies: replies2 };
  });
}
function RepliesPanel({
  replies,
  className,
  onVideoFullScreenClick,
  renderTextReply
}) {
  const threads = (0, import_react62.useMemo)(
    () => replies ? groupReplies(replies) : [],
    [replies]
  );
  return /* @__PURE__ */ import_react62.default.createElement(
    "div",
    {
      className: (0, import_classnames45.default)(
        className,
        "v2-w-full v2-flex v2-flex-col v2-px-3 v2-py-1.5 v2-gap-y-3"
      )
    },
    threads.map((thread, index) => {
      return /* @__PURE__ */ import_react62.default.createElement(
        ThreadBox,
        {
          key: `${thread.name}-${index}`,
          thread,
          className: "v2-w-3/4 v2-bg-neutral-50 v2-rounded",
          onVideoFullScreenClick,
          renderTextReply
        }
      );
    })
  );
}

// src/components/Accordion/index.tsx
var import_react63 = __toESM(require("react"));
var import_react64 = require("react");
var import_react_fontawesome13 = require("@fortawesome/react-fontawesome");
var import_classnames46 = __toESM(require("classnames"));
function Accordion({
  id,
  title,
  children,
  active,
  disabled,
  onClick,
  rightComponent,
  className,
  arrowContainerClassName,
  arrowClassName,
  titleContainerClassName,
  titleClassName,
  bodyClassName,
  hideArrow = false,
  showAnimation = "v2-animate-fade-in-down-150" /* SlideInDown150 */,
  hideAnimation = "v2-animate-fade-out-up-150" /* SlideOutUp150 */
}) {
  const [localActiveState, setLocalActiveState] = (0, import_react64.useState)(false);
  const activeState = active != void 0 ? active : localActiveState;
  const handleClick = () => {
    setLocalActiveState(!activeState);
    onClick == null ? void 0 : onClick(!activeState);
  };
  return /* @__PURE__ */ import_react63.default.createElement(
    "div",
    {
      id,
      className: (0, import_classnames46.default)(className, "v2-rounded v2-shadow-around", {
        "v2-bg-neutral-50": disabled
      })
    },
    title && /* @__PURE__ */ import_react63.default.createElement(
      "div",
      {
        className: (0, import_classnames46.default)(titleContainerClassName, [
          "v2-flex v2-flex-col md:v2-flex-row v2-justify-between v2-p-2 v2-mt-2",
          "v2-select-none",
          {
            "v2-cursor-pointer": !disabled,
            "v2-cursor-not-allowed": disabled
          }
        ]),
        onClick: !disabled ? handleClick : void 0
      },
      /* @__PURE__ */ import_react63.default.createElement(
        "div",
        {
          className: (0, import_classnames46.default)(
            titleClassName,
            "v2-flex v2-justify-center md:v2-justify-start"
          )
        },
        title
      ),
      /* @__PURE__ */ import_react63.default.createElement(
        "div",
        {
          className: (0, import_classnames46.default)(
            arrowContainerClassName,
            "v2-flex v2-gap-x-3 v2-items-center v2-justify-center"
          )
        },
        rightComponent,
        !hideArrow && /* @__PURE__ */ import_react63.default.createElement(
          import_react_fontawesome13.FontAwesomeIcon,
          {
            icon: faChevronDown,
            className: (0, import_classnames46.default)(
              arrowClassName,
              "!v2-w-6 !v2-h-6 v2-transition-transform",
              {
                "v2-filter v2-transform -v2-rotate-180": activeState
              }
            )
          }
        )
      )
    ),
    /* @__PURE__ */ import_react63.default.createElement(
      AnimatedDiv,
      {
        show: activeState,
        className: bodyClassName,
        showAnimation,
        hideAnimation
      },
      children
    )
  );
}

// src/components/MegaMenu/MegaMenu.tsx
var import_react65 = __toESM(require("react"));
var import_classnames47 = __toESM(require("classnames"));
var defaultHeight = "310px";
var defaultWidth = "100%";
function MegaMenu({
  open = false,
  className,
  height = defaultHeight,
  width = defaultWidth,
  children
}) {
  return /* @__PURE__ */ import_react65.default.createElement(
    "div",
    {
      className: (0, import_classnames47.default)(
        "v2-duration-150 transition-height v2-ease-out v2-overflow-hidden",
        "v2-flex v2-w-full v2-bg-white v2-left-0 v2-w-full v2-h-0 v2-shadow-md !v2-absolute",
        "v2-z-[99999]",
        className
      ),
      style: {
        height: open ? height : 0,
        width
      }
    },
    children
  );
}

// src/components/MegaMenu/MegaMenuPanel.tsx
var import_react66 = __toESM(require("react"));
var import_classnames48 = __toESM(require("classnames"));
function MegaMenuPanel({ className, children }) {
  return /* @__PURE__ */ import_react66.default.createElement("div", { className: (0, import_classnames48.default)(className, "v2-p-[30px]") }, children);
}

// src/components/MegaMenu/plasmic.tsx
var import_react67 = __toESM(require("react"));
function PlasmicMegaMenu(_a) {
  var _b = _a, {
    inactiveSlot,
    activeSlot
  } = _b, props = __objRest(_b, [
    "inactiveSlot",
    "activeSlot"
  ]);
  var _a2;
  const [open, setOpen] = (0, import_react67.useState)((_a2 = props.open) != null ? _a2 : false);
  (0, import_react67.useEffect)(() => {
    var _a3;
    setOpen((_a3 = props.open) != null ? _a3 : false);
  }, [props.open]);
  function toggleOpen() {
    setOpen((open2) => !open2);
  }
  return /* @__PURE__ */ import_react67.default.createElement("div", null, /* @__PURE__ */ import_react67.default.createElement("div", { onClick: toggleOpen }, open && activeSlot, !open && inactiveSlot), /* @__PURE__ */ import_react67.default.createElement(MegaMenu, __spreadProps(__spreadValues({}, props), { open })));
}
var megaMenuPanel = createPlasmicComponent(MegaMenuPanel, {
  name: "MegaMenuPanel",
  props: {
    className: "string",
    children: "slot"
  }
});
var megaMenu = createPlasmicComponent(PlasmicMegaMenu, {
  name: "MegaMenu",
  props: {
    open: {
      type: "boolean",
      defaultValue: false
    },
    height: {
      type: "string",
      defaultValue: defaultHeight
    },
    width: {
      type: "string",
      defaultValue: defaultWidth
    },
    activeSlot: {
      type: "slot"
    },
    inactiveSlot: {
      type: "slot"
    },
    children: {
      type: "slot",
      defaultValue: [
        {
          type: "component",
          name: "MegaMenuPanel"
        },
        {
          type: "component",
          name: "MegaMenuPanel"
        },
        {
          type: "component",
          name: "MegaMenuPanel"
        }
      ]
    }
  }
});
function getPlasmicComponents() {
  return [megaMenu, megaMenuPanel];
}
var plasmic_default = {
  getPlasmicComponents
};

// src/components/Drawer/plasmic.tsx
var import_react71 = __toESM(require("react"));

// src/components/Drawer/Drawer.tsx
var import_react70 = __toESM(require("react"));
var import_classnames49 = __toESM(require("classnames"));

// src/hook/use-detect-outside-click-hook.ts
var import_react68 = require("react");
function useDetectOutsideClick({
  container = document,
  containerRef,
  onDetect
}, deps) {
  (0, import_react68.useEffect)(() => {
    if (!(containerRef == null ? void 0 : containerRef.current))
      return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        onDetect == null ? void 0 : onDetect();
      }
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleClickOutside);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef, ...deps]);
}

// src/components/Drawer/DrawerContext.tsx
var import_react69 = require("react");
var DrawerContext = (0, import_react69.createContext)({});

// src/components/Drawer/Drawer.tsx
var getClassNames = (props) => {
  const {
    open,
    anchor,
    className,
    contentClassName,
    modalClassName,
    anchorY,
    anchorX,
    overlayOpacity
  } = props;
  return {
    container: (0, import_classnames49.default)(
      ["v2-flex v2-absolute v2-overflow-hidden v2-z-50"],
      {
        "v2-pointer-events-none": !open,
        "v2-top-0": anchor === "top",
        "v2-right-0 v2-top-0": anchor === "right",
        "v2-bottom-0": anchor === "bottom",
        "v2-left-0 v2-top-0": anchor === "left",
        "v2-w-full": anchorY,
        "v2-h-full": anchorX
      },
      className
    ),
    content: (0, import_classnames49.default)(
      ["v2-ease-out-in v2-transition-transform v2-grow v2-relative"],
      {
        "v2-translate-y-[-100%]": !open && anchor === "top",
        "v2-translate-x-[100%]": !open && anchor === "right",
        "v2-translate-y-[100%]": !open && anchor === "bottom",
        "v2-translate-x-[-100%]": !open && anchor === "left",
        "v2-translate-x-0": open && anchorX,
        "v2-translate-y-0": open && anchorY
      },
      contentClassName
    ),
    modal: (0, import_classnames49.default)(
      [
        "v2-absolute v2-w-full v2-h-full v2-z-40",
        "v2-ease-out-in v2-transition-opacity",
        "v2-bg-black"
      ],
      {
        "v2-opacity-0 v2-pointer-events-none": !open,
        "v2-block": open,
        "v2-opacity-10": overlayOpacity === "low" /* Low */,
        "v2-bg-opacity-50": overlayOpacity === "medium" /* Medium */,
        "v2-bg-opacity-70": overlayOpacity === "high" /* High */,
        "v2-hidden": props.noModal
      },
      modalClassName
    )
  };
};
var getStyles = (props) => {
  const { anchorX, anchorY, drawerDepth, slideDuration } = props;
  const transitionDuration = `${slideDuration != null ? slideDuration : 150}ms`;
  return {
    container: {
      width: anchorX && (drawerDepth != null ? drawerDepth : "auto") || void 0,
      height: anchorY && (drawerDepth != null ? drawerDepth : "auto") || void 0
    },
    content: {
      transitionDuration
    },
    modal: {
      transitionDuration
    }
  };
};
function Drawer(props) {
  const { closeOnEsc = false } = props;
  const extraProps = (0, import_react70.useMemo)(() => {
    const anchorX = ["left", "right"].includes(props.anchor);
    const anchorY = ["top", "bottom"].includes(props.anchor);
    return {
      anchorX,
      anchorY
    };
  }, [props.anchor]);
  const { classNames, styles } = (0, import_react70.useMemo)(() => {
    const allProps = __spreadValues(__spreadValues({}, props), extraProps);
    const classNames2 = getClassNames(allProps);
    const styles2 = getStyles(allProps);
    return {
      classNames: classNames2,
      styles: styles2
    };
  }, [props, extraProps]);
  const contentRef = (0, import_react70.useRef)(null);
  (0, import_react70.useEffect)(() => {
    if (!closeOnEsc)
      return;
    const handleEscKey = (event) => {
      var _a;
      if (event.key === "Escape" && props.open) {
        (_a = props.onClose) == null ? void 0 : _a.call(props);
      }
    };
    document.addEventListener("keydown", handleEscKey);
    return () => document.removeEventListener("keydown", handleEscKey);
  }, [props.open, props.onClose, closeOnEsc]);
  useDetectOutsideClick(
    {
      containerRef: contentRef,
      onDetect: () => {
        var _a;
        if (props.open && !props.disableAutoClose) {
          (_a = props.onClose) == null ? void 0 : _a.call(props);
        }
      }
    },
    [props.open, props.onClose]
  );
  const drawerContext = {
    close: () => {
      var _a;
      return (_a = props.onClose) == null ? void 0 : _a.call(props);
    }
  };
  return /* @__PURE__ */ import_react70.default.createElement(DrawerContext.Provider, { value: drawerContext }, /* @__PURE__ */ import_react70.default.createElement("div", { className: classNames.container, style: styles.container }, /* @__PURE__ */ import_react70.default.createElement(
    "div",
    {
      ref: contentRef,
      className: classNames.content,
      style: styles.content
    },
    props.children
  )), /* @__PURE__ */ import_react70.default.createElement("div", { className: classNames.modal, style: styles.modal }));
}

// src/components/Drawer/plasmic.tsx
function DrawerCloseButton({ className, children }) {
  const { close } = (0, import_react71.useContext)(DrawerContext);
  return /* @__PURE__ */ import_react71.default.createElement("div", { className, onClick: close }, children);
}
function PlasmicDrawer(_a) {
  var _b = _a, { openSlot } = _b, drawerProps = __objRest(_b, ["openSlot"]);
  var _a2;
  const [open, setOpen] = (0, import_react71.useState)((_a2 = drawerProps.open) != null ? _a2 : false);
  (0, import_react71.useEffect)(() => {
    var _a3;
    setOpen((_a3 = drawerProps.open) != null ? _a3 : false);
  }, [drawerProps.open]);
  return /* @__PURE__ */ import_react71.default.createElement(import_react71.default.Fragment, null, openSlot && /* @__PURE__ */ import_react71.default.createElement("div", { onClick: () => setOpen(true) }, openSlot), /* @__PURE__ */ import_react71.default.createElement(Drawer, __spreadProps(__spreadValues({}, drawerProps), { open, onClose: () => setOpen(false) })));
}
var drawer = createPlasmicComponent(PlasmicDrawer, {
  name: "Drawer",
  styleSections: true,
  props: {
    open: {
      type: "boolean",
      editOnly: true,
      defaultValue: true
    },
    className: "string",
    anchor: {
      type: "choice",
      options: ["top", "right", "bottom", "left"],
      defaultValue: "top"
    },
    drawerDepth: {
      type: "string",
      displayName: "Depth of the drawer e.g. 200px, 100vw",
      defaultValue: "250px"
    },
    slideDuration: {
      type: "number",
      control: "slider",
      min: 0,
      max: 1e3,
      defaultValue: 150
    },
    openSlot: "slot",
    children: {
      type: "slot",
      defaultValue: [
        {
          type: "component",
          name: "DrawerCloseButton"
        }
      ]
    }
  }
});
var drawerCloseButton = createPlasmicComponent(DrawerCloseButton, {
  name: "DrawerCloseButton",
  props: {
    children: "slot",
    className: "string"
  }
});
function getPlasmicComponents2() {
  return [drawer, drawerCloseButton];
}
var plasmic_default2 = {
  getPlasmicComponents: getPlasmicComponents2
};

// src/plasmic.ts
function getPlasmicComponents3() {
  return [...plasmic_default.getPlasmicComponents(), ...plasmic_default2.getPlasmicComponents()];
}

// src/components/GridLayout/GridLayout.tsx
var import_react77 = __toESM(require("react"));
var import_classnames50 = __toESM(require("classnames"));
var import_styled8 = __toESM(require("@emotion/styled"));

// node_modules/react-use/esm/misc/util.js
function on(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.addEventListener) {
    obj.addEventListener.apply(obj, args);
  }
}
function off(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.removeEventListener) {
    obj.removeEventListener.apply(obj, args);
  }
}
var isBrowser = typeof window !== "undefined";

// node_modules/react-use/esm/useEffectOnce.js
var import_react72 = require("react");
var useEffectOnce = function(effect) {
  (0, import_react72.useEffect)(effect, []);
};
var useEffectOnce_default = useEffectOnce;

// node_modules/react-use/esm/useEvent.js
var import_react73 = require("react");
var defaultTarget = isBrowser ? window : null;
var isListenerType1 = function(target) {
  return !!target.addEventListener;
};
var isListenerType2 = function(target) {
  return !!target.on;
};
var useEvent = function(name, handler, target, options2) {
  if (target === void 0) {
    target = defaultTarget;
  }
  (0, import_react73.useEffect)(function() {
    if (!handler) {
      return;
    }
    if (!target) {
      return;
    }
    if (isListenerType1(target)) {
      on(target, name, handler, options2);
    } else if (isListenerType2(target)) {
      target.on(name, handler, options2);
    }
    return function() {
      if (isListenerType1(target)) {
        off(target, name, handler, options2);
      } else if (isListenerType2(target)) {
        target.off(name, handler, options2);
      }
    };
  }, [name, handler, target, JSON.stringify(options2)]);
};
var useEvent_default = useEvent;

// node_modules/react-use/esm/useRafState.js
var import_react75 = require("react");

// node_modules/react-use/esm/useUnmount.js
var import_react74 = require("react");
var useUnmount = function(fn) {
  var fnRef = (0, import_react74.useRef)(fn);
  fnRef.current = fn;
  useEffectOnce_default(function() {
    return function() {
      return fnRef.current();
    };
  });
};
var useUnmount_default = useUnmount;

// node_modules/react-use/esm/useRafState.js
var useRafState = function(initialState2) {
  var frame = (0, import_react75.useRef)(0);
  var _a = (0, import_react75.useState)(initialState2), state = _a[0], setState = _a[1];
  var setRafState = (0, import_react75.useCallback)(function(value) {
    cancelAnimationFrame(frame.current);
    frame.current = requestAnimationFrame(function() {
      setState(value);
    });
  }, []);
  useUnmount_default(function() {
    cancelAnimationFrame(frame.current);
  });
  return [state, setRafState];
};
var useRafState_default = useRafState;

// node_modules/react-use/esm/useWindowSize.js
var import_react76 = require("react");
var useWindowSize = function(initialWidth, initialHeight) {
  if (initialWidth === void 0) {
    initialWidth = Infinity;
  }
  if (initialHeight === void 0) {
    initialHeight = Infinity;
  }
  var _a = useRafState_default({
    width: isBrowser ? window.innerWidth : initialWidth,
    height: isBrowser ? window.innerHeight : initialHeight
  }), state = _a[0], setState = _a[1];
  (0, import_react76.useEffect)(function() {
    if (isBrowser) {
      var handler_1 = function() {
        setState({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      on(window, "resize", handler_1);
      return function() {
        off(window, "resize", handler_1);
      };
    }
  }, []);
  return state;
};
var useWindowSize_default = useWindowSize;

// src/components/GridLayout/GridLayout.tsx
var Container2 = import_styled8.default.div`
  @media (max-width: 400px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;
function GridLayout({
  containerRef,
  className,
  children
}) {
  const { width } = useWindowSize_default();
  const gridRef = containerRef != null ? containerRef : (0, import_react77.useRef)(null);
  function resizeGridItem(item, rowHeight, rowGap) {
    if (!item.firstChild) {
      item.style.display = "none";
      return;
    }
    const rowSpan = Math.ceil(
      (item.firstChild.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap)
    );
    item.style.gridRowEnd = `span ${rowSpan}`;
  }
  function resizeAllGridItems() {
    var _a;
    const tiles = (_a = gridRef.current) == null ? void 0 : _a.children;
    if (!tiles)
      return;
    const gridStyles = window.getComputedStyle(gridRef.current);
    const rowHeight = parseInt(gridStyles.gridAutoRows);
    const rowGap = parseInt(gridStyles.rowGap);
    for (const tile of Array.from(tiles)) {
      resizeGridItem(tile, rowHeight, rowGap);
    }
  }
  const tileResizeObserver = (0, import_react77.useRef)(
    new ResizeObserver((entries) => {
      entries.forEach(() => {
        resizeAllGridItems();
      });
    })
  );
  (0, import_react77.useLayoutEffect)(() => {
    resizeAllGridItems();
  }, [width, children]);
  (0, import_react77.useEffect)(() => {
    var _a;
    const tiles = (_a = gridRef.current) == null ? void 0 : _a.children;
    if (!tiles || !tileResizeObserver)
      return;
    for (const tile of Array.from(tiles)) {
      if (tile && tile.children[0]) {
        tileResizeObserver.current.observe(tile.children[0]);
      }
    }
    return () => {
      if (tileResizeObserver) {
        for (const tile of Array.from(tiles)) {
          if (tile && tile.children[0]) {
            tileResizeObserver.current.unobserve(tile.children[0]);
          }
        }
        tileResizeObserver.current.disconnect();
      }
    };
  }, [children, tileResizeObserver]);
  return /* @__PURE__ */ import_react77.default.createElement(
    Container2,
    {
      id: "bonjoro-grid-layout",
      ref: gridRef,
      className: (0, import_classnames50.default)("grid-layout", className, [
        "v2-grid v2-gap-2.5 v2-grid-cols-[repeat(auto-fill,_minmax(350px,1fr))]",
        "v2-auto-rows-[10px] v2-transition v2-transition-all v2-ease-in"
      ])
    },
    children
  );
}

// src/components/GridLayout/GridLayoutTile.tsx
var import_react78 = __toESM(require("react"));
var import_classnames51 = __toESM(require("classnames"));
function GridLayoutTile({
  className,
  contentClassName,
  children
}) {
  return /* @__PURE__ */ import_react78.default.createElement("div", { className: (0, import_classnames51.default)("grid-layout-tile v2-h-full", className) }, /* @__PURE__ */ import_react78.default.createElement("div", { className: (0, import_classnames51.default)("v2-w-auto v2-h-auto v2-relative", contentClassName) }, children));
}

// src/components/Nav/MainNavigation/LogoHeader.tsx
var import_react79 = __toESM(require("react"));
var import_classnames52 = __toESM(require("classnames"));
var closeIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/close-white.svg";
var menuIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/menu-white.svg";
var headerIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bj-logo-header-white.svg";
function LogoHeader({
  imageUrl = headerIcon,
  className,
  collapsed = false,
  onLogoClick,
  onMenuClick
}) {
  return /* @__PURE__ */ import_react79.default.createElement(
    "div",
    {
      className: (0, import_classnames52.default)("logo-header", className, [
        "v2-px-6 v2-py-4 v2-flex v2-flex-row v2-justify-between"
      ])
    },
    /* @__PURE__ */ import_react79.default.createElement(
      "img",
      {
        className: (0, import_classnames52.default)("logo-image", [
          "md:v2-min-w-[150px] v2-h-[28px] v2-select-none"
        ]),
        src: imageUrl,
        onClick: onLogoClick
      }
    ),
    /* @__PURE__ */ import_react79.default.createElement(
      "img",
      {
        className: (0, import_classnames52.default)("menu-icon", [
          "v2-h-[28px] v2-block md:v2-hidden v2-cursor-pointer v2-select-none"
        ]),
        src: collapsed ? closeIcon : menuIcon,
        onClick: onMenuClick
      }
    )
  );
}

// src/components/Nav/MainNavigation/MainNavigation.tsx
var import_react80 = __toESM(require("react"));
var import_classnames53 = __toESM(require("classnames"));
function MainNavigation({
  id,
  className,
  children
}) {
  return /* @__PURE__ */ import_react80.default.createElement(
    "div",
    {
      id,
      className: (0, import_classnames53.default)("top-navigation", className, [
        "v2-relative",
        "v2-flex v2-h-[60px] v2-bg-neutral-800",
        "v2-flex v2-flex-col md:v2-flex-row v2-w-full"
      ])
    },
    children
  );
}

// src/components/Nav/MainNavigation/MaskedImage.tsx
var import_react81 = __toESM(require("react"));
var import_styled9 = __toESM(require("@emotion/styled"));
var import_classnames54 = __toESM(require("classnames"));
var Image3 = import_styled9.default.i`
  ${({ imageUrl, bgColor, hideWhiteBackground = false }) => `
    ${!hideWhiteBackground ? "background-color: white;" : ""}
    ${bgColor ? `background-color: ${bgColor} !important;` : ""}
    mask: url("${imageUrl}");
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `}
`;
function MaskedImage({ imageUrl, className }) {
  return /* @__PURE__ */ import_react81.default.createElement(import_react81.default.Fragment, null, imageUrl && /* @__PURE__ */ import_react81.default.createElement(Image3, { imageUrl, className: (0, import_classnames54.default)(className, "v2-w-8 v2-h-8") }));
}

// src/components/Nav/MainNavigation/NavContainer.tsx
var import_react82 = __toESM(require("react"));
var import_classnames55 = __toESM(require("classnames"));
function NavContainer({
  className,
  collapsed = false,
  children
}) {
  return /* @__PURE__ */ import_react82.default.createElement(
    "div",
    {
      className: (0, import_classnames55.default)(
        "nav-container",
        className,
        [
          "v2-w-full v2-h-[calc(100vh-60px)] v2-top-[60px] v2-pt-7 md:v2-pt-0 v2-z-10",
          "md:v2-h-auto v2-animate-fade-in v2-flex-1",
          "md:v2-flex v2-flex-col md:v2-flex-row md:v2-bg-neutral-800"
        ],
        {
          ["v2-absolute v2-flex v2-bg-neutral-700"]: collapsed,
          ["v2-hidden"]: !collapsed
        }
      )
    },
    children
  );
}

// src/components/Nav/MainNavigation/NavGroup.tsx
var import_react83 = __toESM(require("react"));
var import_classnames56 = __toESM(require("classnames"));
function NavGroup({ className, children }) {
  return /* @__PURE__ */ import_react83.default.createElement(
    "ul",
    {
      className: (0, import_classnames56.default)("nav-group", className, [
        "v2-flex v2-flex-col md:v2-flex-row md:v2-items-center v2-relative",
        "md:v2-space-x-4",
        "v2-my-0 v2-pl-0"
      ])
    },
    children
  );
}

// src/components/Nav/MainNavigation/NavItem.tsx
var import_react85 = __toESM(require("react"));
var import_classnames58 = __toESM(require("classnames"));
var import_styled10 = __toESM(require("@emotion/styled"));

// src/components/Nav/MainNavigation/NavItemLabel.tsx
var import_react84 = __toESM(require("react"));
var import_classnames57 = __toESM(require("classnames"));
function NavItemLabel({ className, children }) {
  return /* @__PURE__ */ import_react84.default.createElement(
    "span",
    {
      className: (0, import_classnames57.default)(className, [
        "v2-text-xl v2-font-semibold v2-font-circular v2-select-none"
      ])
    },
    children
  );
}

// src/components/Nav/MainNavigation/NavItem.tsx
var hoverImageStyle = (hoverImageUrl) => `
  i {
    background: url("${hoverImageUrl != null ? hoverImageUrl : ""}") no-repeat 0 0;
    background-position: center;
    mask: none;
  }
`;
var ItemContainer = import_styled10.default.li`
  ${({ hoverImageUrl, active }) => `
    ${hoverImageUrl ? `:hover { ${hoverImageStyle(hoverImageUrl)}}` : ""}
    ${active ? hoverImageStyle(hoverImageUrl) : ""}
  `}
`;
function NavItem(_a) {
  var _b = _a, {
    noHoverAnimation = false,
    icon,
    className,
    iconImageUrl,
    iconHoverImageUrl,
    label,
    labelClassName,
    anchorUrl,
    anchorClassName,
    onClick,
    active,
    id
  } = _b, otherProps = __objRest(_b, [
    "noHoverAnimation",
    "icon",
    "className",
    "iconImageUrl",
    "iconHoverImageUrl",
    "label",
    "labelClassName",
    "anchorUrl",
    "anchorClassName",
    "onClick",
    "active",
    "id"
  ]);
  const itemContent = /* @__PURE__ */ import_react85.default.createElement(import_react85.default.Fragment, null, icon != null ? icon : /* @__PURE__ */ import_react85.default.createElement(MaskedImage, { imageUrl: iconImageUrl }), /* @__PURE__ */ import_react85.default.createElement(NavItemLabel, { className: labelClassName }, " ", label));
  return /* @__PURE__ */ import_react85.default.createElement(
    ItemContainer,
    __spreadValues({
      id,
      className: (0, import_classnames58.default)(
        "nav-item",
        className,
        [
          "v2-py-1.5 v2-px-5 md:v2-px-3 v2-flex v2-space-x-3",
          "v2-group v2-rounded-md v2-text-white v2-relative v2-items-center",
          "v2-cursor-pointer v2-list-none v2-transition-colors"
        ],
        {
          "hover:v2-text-black hover:v2-bg-white": !noHoverAnimation,
          "v2-text-black v2-bg-white": active
        }
      ),
      hoverImageUrl: iconHoverImageUrl,
      active,
      onClick
    }, otherProps),
    anchorUrl && typeof onClick === "undefined" ? /* @__PURE__ */ import_react85.default.createElement(
      "a",
      {
        className: (0, import_classnames58.default)(
          anchorClassName,
          [
            "v2-no-underline v2-text-current v2-items-center group-hover:v2-text-black v2-flex v2-gap-x-3",
            "v2-text-white active:v2-text-black focus:v2-text-white hover:v2-text-black"
          ],
          {
            "v2-text-black": active
          }
        ),
        href: anchorUrl
      },
      itemContent
    ) : itemContent
  );
}

// src/components/Nav/NavProfileDropdown/NavProfileDropdown.tsx
var import_react91 = __toESM(require("react"));
var import_classnames63 = __toESM(require("classnames"));

// src/components/Nav/NavProfileIcon/NavProfileIcon.tsx
var import_react86 = __toESM(require("react"));
var import_classnames59 = __toESM(require("classnames"));
var import_react_fontawesome14 = require("@fortawesome/react-fontawesome");
var NavProfileIconVariant = /* @__PURE__ */ ((NavProfileIconVariant2) => {
  NavProfileIconVariant2["Compact"] = "compact";
  NavProfileIconVariant2["Plain"] = "plain";
  return NavProfileIconVariant2;
})(NavProfileIconVariant || {});
function NavProfileIcon({
  imageUrl,
  id,
  title,
  rightComponent,
  variant = "compact" /* Compact */,
  activeState,
  onClick
}) {
  const [localActiveState, setLocalActiveState] = (0, import_react86.useState)(false);
  const active = activeState != null ? activeState : localActiveState;
  const setActive = onClick != null ? onClick : setLocalActiveState;
  const onClickHandler = () => {
    setActive == null ? void 0 : setActive(!active);
  };
  const isPlainVariant = variant === "plain" /* Plain */;
  const isCompactVariant = variant === "compact" /* Compact */;
  return /* @__PURE__ */ import_react86.default.createElement(
    "button",
    {
      className: (0, import_classnames59.default)(
        [
          "v2-flex v2-border-0 v2-bg-neutral-800 v2-h-14 md:v2-h-full v2-w-auto v2-rounded-md",
          "hover:v2-bg-neutral-500 active:v2-bg-neutral-500 v2-cursor-pointer",
          "v2-items-center v2-py-[5px] v2-pl-[10px] v2-pr-0"
        ],
        {
          "!v2-w-full !v2-bg-neutral-500 hover:!v2-bg-neutral-500 active:!v2-bg-neutral-500 !v2-px-[10px]": isPlainVariant
        }
      ),
      id,
      onClick: onClickHandler
    },
    /* @__PURE__ */ import_react86.default.createElement(
      "div",
      {
        className: (0, import_classnames59.default)(
          [
            "v2-flex-1 v2-flex v2-text-center v2-gap-x-2 v2-pointer-events-none v2-items-center"
          ],
          {
            "v2-gap-x-4": isPlainVariant
          }
        )
      },
      imageUrl && /* @__PURE__ */ import_react86.default.createElement(
        "img",
        {
          src: imageUrl,
          className: (0, import_classnames59.default)(["v2-rounded-full v2-w-[34px] v2-h-[34px]"], {
            "!v2-w-6 !v2-h-6": isPlainVariant
          })
        }
      ),
      !isCompactVariant && /* @__PURE__ */ import_react86.default.createElement(
        "span",
        {
          className: (0, import_classnames59.default)([
            "v2-flex v2-items-center v2-font-circular v2-text-white v2-text-lg v2-font-bold"
          ])
        },
        title
      )
    ),
    /* @__PURE__ */ import_react86.default.createElement(
      "div",
      {
        className: (0, import_classnames59.default)([
          "v2-flex v2-text-white v2-items-center v2-pointer-events-none"
        ])
      },
      rightComponent != null ? rightComponent : /* @__PURE__ */ import_react86.default.createElement(
        import_react_fontawesome14.FontAwesomeIcon,
        {
          icon: isPlainVariant ? faChevronDown : faCaretDown,
          className: (0, import_classnames59.default)({
            "!v2-w-6 !v2-h-6 v2-transition-transform v2-duration-400 v2-filter v2-transform -v2-rotate-90": isPlainVariant,
            "!v2-w-[32px] !v2-h-6 v2-transition-transform v2-duration-400": isCompactVariant,
            "v2-filter v2-transform v2-rotate-180": isCompactVariant && active
          })
        }
      )
    )
  );
}

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItems.tsx
var import_react88 = __toESM(require("react"));

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItem.tsx
var import_react87 = __toESM(require("react"));
var import_classnames60 = __toESM(require("classnames"));
function NavProfileDropdownItem({
  id,
  url,
  title,
  icon,
  onClick,
  anchorId,
  anchorRel,
  anchorTarget
}) {
  return /* @__PURE__ */ import_react87.default.createElement("li", { id, className: "v2-flex v2-h-10" }, /* @__PURE__ */ import_react87.default.createElement(
    "a",
    {
      className: (0, import_classnames60.default)([
        "v2-flex v2-flex-1 v2-h-full v2-w-full v2-no-underline",
        "hover:v2-bg-yellow-100 v2-items-center v2-text-neutral-900",
        "hover:v2-text-neutral-900 v2-font-normal focus:v2-text-neutral-900"
      ]),
      onClick,
      id: anchorId,
      href: url,
      rel: anchorRel,
      target: anchorTarget
    },
    /* @__PURE__ */ import_react87.default.createElement("span", { className: "!v2-px-4" }, icon),
    /* @__PURE__ */ import_react87.default.createElement("span", { className: "v2-truncate v2-text-neutral-900 v2-font-circular v2-text-base" }, title)
  ));
}

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItems.tsx
function NavProfileDropdownItems({
  dropdownItems
}) {
  return /* @__PURE__ */ import_react88.default.createElement(import_react88.default.Fragment, null, dropdownItems && dropdownItems.map((dropdownItem, index) => {
    return /* @__PURE__ */ import_react88.default.createElement(NavProfileDropdownItem, __spreadValues({ key: `${index}` }, dropdownItem));
  }));
}

// src/components/Dropdown/Dropdown.tsx
var import_react90 = __toESM(require("react"));
var import_classnames62 = __toESM(require("classnames"));

// src/components/Dropdown/DropdownContainer.tsx
var import_react89 = __toESM(require("react"));
var import_classnames61 = __toESM(require("classnames"));
function DropdownContainer({
  id,
  className,
  style,
  children
}) {
  return /* @__PURE__ */ import_react89.default.createElement(
    "ul",
    {
      id,
      className: (0, import_classnames61.default)(className, [
        "v2-flex v2-flex-col v2-h-auto v2-rounded-sm v2-shadow ",
        "v2-bg-white v2-absolute"
      ]),
      style
    },
    children
  );
}

// src/components/Dropdown/Dropdown.tsx
var DropdownAlignment = /* @__PURE__ */ ((DropdownAlignment2) => {
  DropdownAlignment2["Start"] = "flex-start";
  DropdownAlignment2["Center"] = "center";
  DropdownAlignment2["End"] = "flex-end";
  return DropdownAlignment2;
})(DropdownAlignment || {});
function Dropdown(_a) {
  var _b = _a, {
    id,
    className,
    active: defaultActive,
    body,
    children,
    closeOnOutsideClick = true,
    disabled = false,
    onClick,
    containerAlignment = "center" /* Center */,
    containerId,
    containerClassName,
    containerRef,
    width = 210
  } = _b, otherProps = __objRest(_b, [
    "id",
    "className",
    "active",
    "body",
    "children",
    "closeOnOutsideClick",
    "disabled",
    "onClick",
    "containerAlignment",
    "containerId",
    "containerClassName",
    "containerRef",
    "width"
  ]);
  const ref = containerRef != null ? containerRef : (0, import_react90.useRef)(null);
  const bodyRef = (0, import_react90.useRef)(null);
  const [active, setActive] = (0, import_react90.useState)(defaultActive);
  (0, import_react90.useEffect)(() => {
    setActive(defaultActive);
  }, [defaultActive]);
  const toggleDropdown = () => {
    if (!disabled) {
      setActive(!active);
      onClick == null ? void 0 : onClick(!active);
    }
  };
  useDetectOutsideClick(
    {
      containerRef: ref,
      onDetect: () => {
        if (closeOnOutsideClick && active) {
          toggleDropdown();
        }
      }
    },
    [active]
  );
  const defaultStyle = { width };
  const containerStyle = (0, import_react90.useMemo)(() => {
    var _a2;
    if (bodyRef.current) {
      const buttonRect = (_a2 = bodyRef.current) == null ? void 0 : _a2.getBoundingClientRect();
      return __spreadValues({
        marginTop: buttonRect.height
      }, defaultStyle);
    }
    return __spreadValues({}, defaultStyle);
  }, [bodyRef.current]);
  return /* @__PURE__ */ import_react90.default.createElement(
    "div",
    __spreadValues({
      id,
      className: (0, import_classnames62.default)(className, ["v2-flex v2-flex-col"]),
      style: {
        alignItems: containerAlignment
      },
      ref
    }, otherProps),
    /* @__PURE__ */ import_react90.default.createElement(
      "div",
      {
        onClick: toggleDropdown,
        ref: bodyRef,
        className: "v2-h-full v2-w-full"
      },
      body
    ),
    (bodyRef == null ? void 0 : bodyRef.current) && /* @__PURE__ */ import_react90.default.createElement(
      DropdownContainer,
      {
        id: containerId,
        className: (0, import_classnames62.default)(containerClassName, ["v2-transition"], {
          "v2-animate-fade-in": active,
          "v2-hidden": !active
        }),
        style: containerStyle
      },
      children
    )
  );
}

// src/components/Nav/NavProfileDropdown/NavProfileDropdown.tsx
function NavProfileDropdown(_a) {
  var _b = _a, {
    id,
    className,
    iconProps,
    hideDropdown = false,
    dropdownProps,
    dropdownItems,
    children,
    onClick
  } = _b, otherProps = __objRest(_b, [
    "id",
    "className",
    "iconProps",
    "hideDropdown",
    "dropdownProps",
    "dropdownItems",
    "children",
    "onClick"
  ]);
  var _a2;
  const [active, setActive] = (0, import_react91.useState)(false);
  const onNavIconClick = () => {
    setActive(!active);
    onClick == null ? void 0 : onClick();
  };
  return /* @__PURE__ */ import_react91.default.createElement(
    Dropdown,
    __spreadValues({
      id,
      className,
      containerAlignment: (_a2 = dropdownProps == null ? void 0 : dropdownProps.containerAlignment) != null ? _a2 : "flex-end" /* End */,
      containerClassName: (0, import_classnames63.default)(
        dropdownProps == null ? void 0 : dropdownProps.containerClassName,
        "!v2-mt-16 v2-w-[200px] v2-p-0"
      ),
      containerId: dropdownProps == null ? void 0 : dropdownProps.id,
      body: /* @__PURE__ */ import_react91.default.createElement(
        NavProfileIcon,
        __spreadProps(__spreadValues({}, iconProps), {
          activeState: active,
          onClick: onNavIconClick
        })
      ),
      active,
      onClick: onNavIconClick
    }, otherProps),
    !hideDropdown && (children != null ? children : /* @__PURE__ */ import_react91.default.createElement(NavProfileDropdownItems, { dropdownItems }))
  );
}

// src/components/WorkspaceSelector/WorkspaceSelector.tsx
var import_react103 = __toESM(require("react"));
var import_classnames73 = __toESM(require("classnames"));

// src/components/WorkspaceSelector/WorkspaceDropdownItems.tsx
var import_react93 = __toESM(require("react"));

// src/components/WorkspaceSelector/WorkspaceDropdownItem.tsx
var import_react92 = __toESM(require("react"));
var import_classnames64 = __toESM(require("classnames"));
function WorkspaceDropdownItem({
  id,
  keyString,
  name,
  category,
  active,
  onClick
}) {
  return /* @__PURE__ */ import_react92.default.createElement(
    "li",
    {
      id,
      key: keyString,
      className: (0, import_classnames64.default)(
        [
          "v2-flex v2-flex-1 v2-h-full v2-w-full v2-no-underline v2-cursor-pointer",
          "hover:v2-text-neutral-900 v2-font-normal focus:v2-text-neutral-900",
          "hover:v2-bg-yellow-100"
        ],
        {
          "v2-bg-yellow-100": active
        }
      ),
      onClick
    },
    /* @__PURE__ */ import_react92.default.createElement(
      "span",
      {
        className: (0, import_classnames64.default)("v2-px-4 v2-flex v2-flex-col v2-truncate", {
          "v2-py-5": !category,
          "v2-py-2.5": category
        })
      },
      category && /* @__PURE__ */ import_react92.default.createElement("span", { className: "v2-text-xs v2-text-neutral-500 v2-my-0.5" }, category),
      /* @__PURE__ */ import_react92.default.createElement(
        "span",
        {
          className: (0, import_classnames64.default)([
            "v2-text-base v2-truncate v2-text-neutral-900 ",
            "v2-font-circular v2-text-base"
          ])
        },
        name
      )
    )
  );
}

// src/components/WorkspaceSelector/WorkspaceDropdownItems.tsx
var import_classnames65 = __toESM(require("classnames"));
function WorkspaceDropdownItems({
  items,
  className,
  onClick
}) {
  const itemComponents = (0, import_react93.useCallback)(() => {
    const components2 = [];
    if (items) {
      items.forEach((item, key2) => {
        components2.push(
          /* @__PURE__ */ import_react93.default.createElement(
            WorkspaceDropdownItem,
            __spreadProps(__spreadValues({
              key: key2,
              keyString: `${key2}`
            }, item), {
              onClick: () => onClick == null ? void 0 : onClick(item)
            })
          )
        );
      });
      return components2;
    }
  }, [items]);
  return /* @__PURE__ */ import_react93.default.createElement(
    "div",
    {
      className: (0, import_classnames65.default)(className, [
        "v2-max-h-64",
        "v2-overflow-y-scroll v2-overflow-x-hidden",
        "v2-scrollbar-thin v2-scrollbar-track-neutral-50",
        "v2-scrollbar-thumb-neutral-300 v2-scrollbar-thumb-rounded-full"
      ])
    },
    itemComponents()
  );
}

// src/components/DropdownSelector/DropdownSelector.tsx
var import_react100 = __toESM(require("react"));
var import_classnames70 = __toESM(require("classnames"));

// src/components/DropdownSelector/DropdownSelectorItems.tsx
var import_react97 = __toESM(require("react"));

// src/components/DropdownSelector/DropdownSelectorItem.tsx
var import_react96 = __toESM(require("react"));
var import_classnames68 = __toESM(require("classnames"));

// src/components/Tooltip/Bubble.tsx
var import_react94 = __toESM(require("react"));
var import_classnames66 = __toESM(require("classnames"));
function Bubble({
  containerClassName,
  className,
  content = "Say Thanks",
  bgColor = colors.black,
  textColor = colors.white,
  maxWidth = 260,
  maxHeight = 120
}) {
  return /* @__PURE__ */ import_react94.default.createElement("div", { className: (0, import_classnames66.default)(containerClassName, ["v2-block v2-relative"]) }, /* @__PURE__ */ import_react94.default.createElement(
    "div",
    {
      className: (0, import_classnames66.default)(className, [
        "v2-h-auto v2-px-2 v2-py-1 v2-inline-block v2-leading-7",
        "v2-text-sm v2-font-medium v2-text-white v2-rounded",
        "v2-leading-6 v2-break-words v2-line-clamp-4 v2-font-circular"
      ]),
      style: {
        backgroundColor: bgColor,
        color: textColor,
        maxHeight,
        maxWidth
      }
    },
    content
  ));
}

// src/components/Tooltip/Tooltip.tsx
var import_react95 = __toESM(require("react"));
var import_classnames67 = __toESM(require("classnames"));
var import_react_tiny_popover2 = require("react-tiny-popover");
var import_debounce = __toESM(require_debounce());
var ShowTrigger = /* @__PURE__ */ ((ShowTrigger2) => {
  ShowTrigger2["Hover"] = "hover";
  ShowTrigger2["Click"] = "click";
  return ShowTrigger2;
})(ShowTrigger || {});
function Tooltip(_a) {
  var _b = _a, {
    open: controlledOpen = false,
    isOpenControlled = false,
    disabled = false,
    content,
    positions = ["top", "right"],
    align = "center",
    textColor = colors.white,
    bgColor = colors.black,
    arrowSize = 5,
    padding = 2,
    className,
    bubbleClassName,
    arrowClassName,
    childrenContainerClassName,
    containerRef,
    reposition,
    maxWidth,
    maxHeight,
    children,
    touchable = true,
    showTrigger = "hover" /* Hover */,
    parentRef,
    onMouseLeave,
    onMouseEnter,
    onClick,
    onOutsideClick
  } = _b, tooltipProps = __objRest(_b, [
    "open",
    "isOpenControlled",
    "disabled",
    "content",
    "positions",
    "align",
    "textColor",
    "bgColor",
    "arrowSize",
    "padding",
    "className",
    "bubbleClassName",
    "arrowClassName",
    "childrenContainerClassName",
    "containerRef",
    "reposition",
    "maxWidth",
    "maxHeight",
    "children",
    "touchable",
    "showTrigger",
    "parentRef",
    "onMouseLeave",
    "onMouseEnter",
    "onClick",
    "onOutsideClick"
  ]);
  const ref = containerRef != null ? containerRef : (0, import_react95.useRef)(null);
  const [openPopover, setOpenPopover] = (0, import_react95.useState)(false);
  const [touched, setTouched] = (0, import_react95.useState)(false);
  const [contentHovered, setContentHovered] = (0, import_react95.useState)(false);
  const contentHoveredRef = (0, import_react95.useRef)(contentHovered);
  const [hovered, setHovered] = (0, import_react95.useState)(false);
  const hoveredRef = (0, import_react95.useRef)(hovered);
  const [parentElement, setParentElement] = (0, import_react95.useState)();
  const open = isOpenControlled ? controlledOpen : disabled == false && openPopover;
  (0, import_react95.useEffect)(() => {
    contentHoveredRef.current = contentHovered;
  }, [contentHovered]);
  (0, import_react95.useEffect)(() => {
    hoveredRef.current = hovered;
  }, [hovered]);
  const onMouseEnterHandler = () => setHovered(true);
  const onMouseLeaveHandler = () => setHovered(false);
  const onContentEnter = () => setContentHovered(true);
  const onContentLeave = () => {
    setContentHovered(false);
    onMouseLeaveHandler();
  };
  const closePopover = (0, import_react95.useCallback)(
    (0, import_debounce.default)(() => {
      if (contentHoveredRef.current || hoveredRef.current)
        return;
      if (showTrigger === "hover" /* Hover */ && (!touched || !touchable)) {
        setOpenPopover(false);
        onMouseLeave == null ? void 0 : onMouseLeave();
      }
    }, 200),
    []
  );
  (0, import_react95.useEffect)(() => {
    if (showTrigger === "hover" /* Hover */) {
      if (hovered) {
        setOpenPopover(true);
        onMouseEnter == null ? void 0 : onMouseEnter();
      } else {
        closePopover();
      }
    }
  }, [showTrigger, touched, hovered, contentHovered, contentHoveredRef]);
  const onBodyClick = () => {
    setTouched(!touched);
    if (showTrigger === "click" /* Click */) {
      setOpenPopover(!openPopover);
      onClick == null ? void 0 : onClick();
    }
  };
  const onOutsideClickHandler = () => {
    setOpenPopover(false);
    onOutsideClick == null ? void 0 : onOutsideClick();
  };
  (0, import_react95.useEffect)(() => {
    if (!parentRef)
      return;
    setParentElement(parentRef == null ? void 0 : parentRef.current);
  }, [parentRef]);
  (0, import_react95.useEffect)(() => {
    const tooltipContainer = document.getElementsByClassName(
      "tooltip-container"
    )[0];
    if (!tooltipContainer)
      return;
    tooltipContainer.addEventListener("mouseenter", onContentEnter);
    tooltipContainer.addEventListener("mouseleave", onContentLeave);
    return () => {
      if (!tooltipContainer)
        return;
      tooltipContainer.removeEventListener("mouseenter", onContentEnter);
      tooltipContainer.removeEventListener("mouseleave", onContentLeave);
    };
  }, [open, document]);
  return /* @__PURE__ */ import_react95.default.createElement(
    import_react_tiny_popover2.Popover,
    __spreadProps(__spreadValues({}, tooltipProps), {
      ref,
      parentElement,
      isOpen: open,
      onClickOutside: onOutsideClickHandler,
      padding,
      content: ({ position: position2, childRect, popoverRect }) => /* @__PURE__ */ import_react95.default.createElement(
        import_react_tiny_popover2.ArrowContainer,
        {
          position: position2,
          childRect,
          popoverRect,
          arrowColor: bgColor,
          arrowSize,
          className: "tooltip-arrow-container v2-animate-fade-in-150",
          arrowClassName: (0, import_classnames67.default)(
            "tooltip-arrow v2-animate-fade-in-150",
            arrowClassName
          )
        },
        /* @__PURE__ */ import_react95.default.createElement(
          Bubble,
          {
            className: bubbleClassName,
            content,
            textColor,
            bgColor,
            maxHeight,
            maxWidth
          }
        )
      ),
      positions,
      containerClassName: (0, import_classnames67.default)(className, "tooltip-container v2-z-99"),
      align,
      reposition
    }),
    /* @__PURE__ */ import_react95.default.createElement(
      "div",
      {
        onClick: onBodyClick,
        className: childrenContainerClassName,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        onPointerEnter: onMouseEnterHandler,
        onPointerLeave: onMouseLeaveHandler
      },
      children
    )
  );
}

// src/components/DropdownSelector/DropdownSelectorBody.tsx
var import_react98 = __toESM(require("react"));
var import_classnames69 = __toESM(require("classnames"));
var import_react_fontawesome15 = require("@fortawesome/react-fontawesome");
function DropdownSelectorBody({
  id,
  className,
  contentClassName,
  iconClassName,
  active,
  disabled,
  content,
  width
}) {
  return /* @__PURE__ */ import_react98.default.createElement(
    "div",
    {
      id,
      style: { width },
      className: (0, import_classnames69.default)(
        className,
        ["v2-group v2-border v2-border-solid v2-items-center"],
        {
          "v2-border-white hover:v2-border-yellow-500 v2-bg-white": !disabled,
          "v2-bg-neutral-50 v2-border-neutral-300 v2-text-neutral-300": disabled
        }
      )
    },
    /* @__PURE__ */ import_react98.default.createElement(
      "div",
      {
        className: (0, import_classnames69.default)(contentClassName, [
          "v2-px-4 v2-py-2 v2-flex v2-cursor-pointer",
          " v2-gap-x-2 v2-font-circular v2-select-none"
        ])
      },
      content,
      /* @__PURE__ */ import_react98.default.createElement(
        import_react_fontawesome15.FontAwesomeIcon,
        {
          icon: faChevronDown,
          className: (0, import_classnames69.default)(
            iconClassName,
            ["!v2-w-[24px] !v2-h-5 v2-transition-transform v2-duration-400"],
            {
              "v2-filter v2-transform v2-rotate-180 v2-text-black": active,
              "v2-text-neutral-500 group-hover:v2-text-black": !disabled,
              "v2-text-neutral-300": disabled
            }
          )
        }
      )
    )
  );
}

// src/components/DropdownSelector/DropdownGroupSelector.tsx
var import_react99 = __toESM(require("react"));

// src/components/WorkspaceSelector/AddNewWorkspaceButton.tsx
var import_react101 = __toESM(require("react"));
var import_classnames71 = __toESM(require("classnames"));
function AddNewWorkspaceButton({
  text,
  onClick
}) {
  return /* @__PURE__ */ import_react101.default.createElement("li", { className: "v2-flex v2-text-center", onClick }, /* @__PURE__ */ import_react101.default.createElement(
    "button",
    {
      className: (0, import_classnames71.default)([
        "v2-font-bold v2-py-3 v2-text-xs v2-w-full hover:v2-text-neutral-900",
        "focus:v2-text-neutral-900 hover:!v2-bg-yellow-100 v2-cursor-pointer",
        "v2-border-none v2-bg-white v2-truncate"
      ])
    },
    text
  ));
}

// src/components/WorkspaceSelector/WorkspaceDropdownHeader.tsx
var import_react102 = __toESM(require("react"));
var import_classnames72 = __toESM(require("classnames"));
function WorkspaceDropdownHeader({
  title,
  viewAllText,
  onViewAllClick
}) {
  return /* @__PURE__ */ import_react102.default.createElement("li", { className: "v2-flex v2-flex-row v2-justify-between v2-py-2.5 v2-px-3.5" }, /* @__PURE__ */ import_react102.default.createElement("span", { className: "v2-flex-1 v2-text-xs v2-text-neutral-500 v2-font-bold" }, title), /* @__PURE__ */ import_react102.default.createElement(
    "span",
    {
      className: (0, import_classnames72.default)([
        "v2-text-xs v2-text-neutral-900 hover:v2-text-neutral-500",
        "v2-cursor-pointer v2-underline v2-truncate"
      ]),
      onClick: onViewAllClick
    },
    viewAllText
  ));
}

// src/components/WorkspaceSelector/WorkspaceSelector.tsx
function WorkspaceSelector(_a) {
  var _b = _a, {
    id,
    bodyText = "",
    className,
    itemsContainerClassName,
    dropdownProps,
    headerText = "WORKSPACES",
    viewAllText = "View all",
    addNewText = "+ Add a new workspace",
    items,
    disabled,
    bodyWidth = 200,
    dropdownWidth = 250,
    onClick,
    onViewAllClick,
    onAddNewClick,
    dropdownBodyProps = {}
  } = _b, otherProps = __objRest(_b, [
    "id",
    "bodyText",
    "className",
    "itemsContainerClassName",
    "dropdownProps",
    "headerText",
    "viewAllText",
    "addNewText",
    "items",
    "disabled",
    "bodyWidth",
    "dropdownWidth",
    "onClick",
    "onViewAllClick",
    "onAddNewClick",
    "dropdownBodyProps"
  ]);
  var _a2;
  const [active, setActive] = (0, import_react103.useState)(false);
  const onBodyClick = () => {
    setActive(!active);
    onClick == null ? void 0 : onClick();
  };
  const onItemClick = (item) => {
    var _a3;
    (_a3 = item.onClick) == null ? void 0 : _a3.call(item);
    setActive(false);
  };
  return /* @__PURE__ */ import_react103.default.createElement(
    Dropdown,
    __spreadValues({
      id,
      className: (0, import_classnames73.default)(className, "v2-select-none v2-font-circular"),
      containerAlignment: (_a2 = dropdownProps == null ? void 0 : dropdownProps.containerAlignment) != null ? _a2 : "flex-start" /* Start */,
      containerClassName: (0, import_classnames73.default)(
        dropdownProps == null ? void 0 : dropdownProps.containerClassName,
        "!v2-mt-11 v2-p-0 v2-rounded"
      ),
      containerId: dropdownProps == null ? void 0 : dropdownProps.id,
      body: /* @__PURE__ */ import_react103.default.createElement(
        DropdownSelectorBody,
        __spreadValues({
          content: /* @__PURE__ */ import_react103.default.createElement("span", { className: "!text-base v2-truncate v2-w-full v2-flex-1 v2-text-sm" }, bodyText),
          className: (0, import_classnames73.default)("h-100", {
            "!v2-border-yellow-500": active
          }),
          contentClassName: "v2-justify-between",
          active,
          disabled,
          width: bodyWidth
        }, dropdownBodyProps)
      ),
      width: dropdownWidth,
      active,
      disabled,
      onClick: onBodyClick
    }, otherProps),
    /* @__PURE__ */ import_react103.default.createElement(
      WorkspaceDropdownHeader,
      {
        title: headerText,
        viewAllText,
        onViewAllClick
      }
    ),
    /* @__PURE__ */ import_react103.default.createElement(
      WorkspaceDropdownItems,
      {
        items,
        className: itemsContainerClassName,
        onClick: onItemClick
      }
    ),
    /* @__PURE__ */ import_react103.default.createElement(AddNewWorkspaceButton, { text: addNewText, onClick: onAddNewClick })
  );
}

// src/components/DynamicAccordion/DynamicAccordion.tsx
var import_react105 = __toESM(require("react"));

// src/components/DynamicAccordion/util/DynamicAccordionContext.ts
var import_react104 = require("react");
var DynamicAccordionContext_default = (0, import_react104.createContext)({
  isTurquoiseThemed: false,
  isBlueThemed: true,
  isMagentaThemed: false,
  steps: {},
  activePanelGroup: "",
  setActivePanelGroup: () => void 0,
  activePanel: "",
  setActivePanel: () => void 0
});

// src/components/DynamicAccordion/DynamicAccordion.tsx
var import_classnames74 = __toESM(require("classnames"));
var DynamicAccordionTheme = /* @__PURE__ */ ((DynamicAccordionTheme2) => {
  DynamicAccordionTheme2["Turquoise"] = "turquoise";
  DynamicAccordionTheme2["Blue"] = "blue";
  DynamicAccordionTheme2["Magenta"] = "magenta";
  return DynamicAccordionTheme2;
})(DynamicAccordionTheme || {});
var DynamicAccordion = import_react105.default.forwardRef(
  ({ children, activeStep = "", theme: theme2, className }, ref) => {
    var _a, _b;
    const activeStepArray = activeStep.split(".");
    const [activePanelGroup, setActivePanelGroup] = (0, import_react105.useState)(
      (_a = activeStepArray[0]) != null ? _a : ""
    );
    const [activePanel, setActivePanel] = (0, import_react105.useState)(
      (_b = activeStepArray[1]) != null ? _b : ""
    );
    const isTurquoiseThemed = theme2 === "turquoise" /* Turquoise */;
    const isBlueThemed = theme2 === "blue" /* Blue */;
    const isMagentaThemed = theme2 === "magenta" /* Magenta */;
    const steps = (0, import_react105.useMemo)(() => {
      const stepMap = {};
      import_react105.default.Children.map(children, (panelGroupChild) => {
        const panelGroupProps = panelGroupChild.props;
        import_react105.default.Children.map(panelGroupProps.children, (panelChildren) => {
          var _a2;
          const panelProps = panelChildren.props;
          stepMap[panelGroupProps.identifier] = [
            ...(_a2 = stepMap[panelGroupProps.identifier]) != null ? _a2 : [],
            panelProps.identifier
          ];
        });
      });
      return stepMap;
    }, [children]);
    (0, import_react105.useEffect)(() => {
      if (activePanelGroup === "" && Object.keys(steps).length > 0) {
        const panelGroup = Object.keys(steps)[0];
        setActivePanelGroup(panelGroup);
        setActivePanel(steps[panelGroup][0]);
      }
    }, [steps]);
    const context = {
      isTurquoiseThemed,
      isBlueThemed,
      isMagentaThemed,
      steps,
      activePanelGroup,
      setActivePanelGroup,
      activePanel,
      setActivePanel
    };
    if (!activePanel && !activePanelGroup)
      return /* @__PURE__ */ import_react105.default.createElement(import_react105.default.Fragment, null);
    return /* @__PURE__ */ import_react105.default.createElement(
      "div",
      {
        className: (0, import_classnames74.default)(className, "v2-flex v2-flex-col v2-gap-y-5"),
        ref
      },
      /* @__PURE__ */ import_react105.default.createElement(DynamicAccordionContext_default.Provider, { value: context }, import_react105.default.Children.map(children, (child, index) => {
        if (child == null)
          return;
        return import_react105.default.cloneElement(child, __spreadProps(__spreadValues({}, child.props), {
          panelNumber: index + 1
        }));
      }))
    );
  }
);

// src/components/DynamicAccordion/Components/CheckMark.tsx
var import_react106 = __toESM(require("react"));
var import_react_fontawesome16 = require("@fortawesome/react-fontawesome");
var import_react107 = require("react");
var import_classnames75 = __toESM(require("classnames"));
function CheckMark() {
  const { isTurquoiseThemed, isBlueThemed, isMagentaThemed } = (0, import_react107.useContext)(
    DynamicAccordionContext_default
  );
  return /* @__PURE__ */ import_react106.default.createElement(
    import_react_fontawesome16.FontAwesomeIcon,
    {
      icon: faCheck,
      className: (0, import_classnames75.default)(
        [
          "v2-text-white v2-rounded-full v2-items-center v2-h-full v2-w-full",
          "v2-w-4 v2-h-4 v2-px-[5px]"
        ],
        {
          "v2-text-turquoise-600": isTurquoiseThemed,
          "v2-text-blue-500": isBlueThemed,
          "v2-text-magenta-500": isMagentaThemed
        }
      )
    }
  );
}

// src/components/DynamicAccordion/Components/DynamicPanel.tsx
var import_react108 = __toESM(require("react"));
var import_classnames76 = __toESM(require("classnames"));
var import_react_fontawesome17 = require("@fortawesome/react-fontawesome");
var DynamicPanelType = /* @__PURE__ */ ((DynamicPanelType2) => {
  DynamicPanelType2["Panel"] = "panel";
  DynamicPanelType2["Accordion"] = "accordion";
  return DynamicPanelType2;
})(DynamicPanelType || {});
function DynamicPanel({
  children,
  type = "panel" /* Panel */,
  identifier: identifier2,
  title,
  onCtaClick,
  ctaLoading = false,
  ctaText = "Continue",
  disabledCtaText = "Complete the above to continue",
  customActions,
  preHeader,
  titleContainerClassName,
  titleClassName,
  className,
  bodyClassName,
  disabled = false,
  isComplete: isComplete2 = false,
  hideActiveBackgroundColor = false
}) {
  const {
    isTurquoiseThemed,
    isBlueThemed,
    isMagentaThemed,
    steps,
    activePanelGroup,
    setActivePanelGroup,
    activePanel,
    setActivePanel
  } = (0, import_react108.useContext)(DynamicAccordionContext_default);
  const active = identifier2 === activePanel;
  const currentActivePanels = steps[activePanelGroup];
  const currentActivePanelKey = Number(
    Object.keys(currentActivePanels).find(
      (key2) => currentActivePanels[Number(key2)] === identifier2
    )
  );
  const currentActivePanelGroupKey = Object.keys(steps).findIndex(
    (step) => step === activePanelGroup
  );
  const nextActivePanelGroupKey = Object.keys(steps)[currentActivePanelGroupKey + 1];
  const isLastPanel = currentActivePanels.length - 1 === currentActivePanelKey;
  const onClickHandler = () => {
    setActivePanel(identifier2);
  };
  const onContinueClick = (0, import_react108.useCallback)(() => {
    onCtaClick == null ? void 0 : onCtaClick();
    if (isLastPanel && nextActivePanelGroupKey) {
      setActivePanelGroup(nextActivePanelGroupKey);
      setActivePanel(steps[nextActivePanelGroupKey][0]);
    } else {
      setActivePanel(currentActivePanels[currentActivePanelKey + 1]);
    }
  }, [
    currentActivePanels,
    currentActivePanelKey,
    nextActivePanelGroupKey,
    steps
  ]);
  const titleComponent = /* @__PURE__ */ import_react108.default.createElement(
    "div",
    {
      className: (0, import_classnames76.default)(
        titleClassName,
        "v2-flex v2-flex-row v2-gap-x-2.5 v2-items-center  v2-truncate"
      )
    },
    isComplete2 && /* @__PURE__ */ import_react108.default.createElement(CheckMark, null),
    preHeader && /* @__PURE__ */ import_react108.default.createElement(
      "span",
      {
        className: (0, import_classnames76.default)("v2-font-base v2-font-bold v2-truncate", {
          "v2-text-turquoise-700": isTurquoiseThemed,
          "v2-text-blue-500": isBlueThemed,
          "v2-text-magenta-500": isMagentaThemed
        })
      },
      preHeader
    ),
    /* @__PURE__ */ import_react108.default.createElement(
      "span",
      {
        className: (0, import_classnames76.default)(
          "v2-font-base v2-text-neutral-900 v2-text-base v2-truncate",
          {
            "v2-pl-9": !isComplete2
          }
        )
      },
      title
    )
  );
  const showTitle = isComplete2 || preHeader != void 0 || title != void 0;
  const actionsComponent = /* @__PURE__ */ import_react108.default.createElement(import_react108.default.Fragment, null, nextActivePanelGroupKey && /* @__PURE__ */ import_react108.default.createElement(
    Button,
    {
      variant: "primary" /* Primary */,
      className: "v2-py-1 v2-text-base",
      onClick: onContinueClick,
      disabled: disabled || ctaLoading
    },
    ctaLoading && /* @__PURE__ */ import_react108.default.createElement(
      import_react_fontawesome17.FontAwesomeIcon,
      {
        icon: faSpinner,
        className: "v2-animate-spin v2-mr-2"
      }
    ),
    !disabled ? ctaText : disabledCtaText
  ), customActions);
  const genericTitleContainerClassName = (0, import_classnames76.default)(
    titleContainerClassName,
    "v2-px-5 v2-mt-0 v2-h-[60px] !v2-flex-row"
  );
  const genericBodyClassName = (0, import_classnames76.default)(
    bodyClassName,
    "v2-flex v2-flex-col v2-gap-y-4 v2-px-14 v2-py-5 v2-pt-0"
  );
  const genericContainerContainerClassName = (0, import_classnames76.default)(
    className,
    [
      "v2-flex-col v2-shadow-none",
      "v2-border-0 !v2-border-b v2-border-solid v2-border-neutral-100"
    ],
    {
      "v2-bg-turquoise-100": !active && isComplete2 && !hideActiveBackgroundColor && isTurquoiseThemed,
      "v2-bg-blue-50": !active && isComplete2 && !hideActiveBackgroundColor && isBlueThemed,
      "v2-bg-magenta-50": !active && isComplete2 && !hideActiveBackgroundColor && isMagentaThemed,
      "!v2-rounded-b-lg": isLastPanel,
      "!v2-rounded-none": !isLastPanel
    }
  );
  if (type === "accordion" /* Accordion */) {
    return /* @__PURE__ */ import_react108.default.createElement(
      Accordion,
      {
        id: identifier2,
        active,
        disabled: !active && disabled,
        onClick: onClickHandler,
        titleContainerClassName: (0, import_classnames76.default)(genericTitleContainerClassName),
        className: (0, import_classnames76.default)(genericContainerContainerClassName),
        bodyClassName: genericBodyClassName,
        titleClassName: "!v2-justify-start v2-truncate",
        title: showTitle ? titleComponent : void 0,
        showAnimation: "v2-animate-fade-in-down-150" /* SlideInDown150 */,
        hideAnimation: "v2-animate-fade-out-up-150" /* SlideOutUp150 */,
        hideArrow: true
      },
      children,
      actionsComponent
    );
  }
  return /* @__PURE__ */ import_react108.default.createElement(
    "div",
    {
      id: identifier2,
      className: (0, import_classnames76.default)(genericContainerContainerClassName, ["v2-py-5"], {
        "v2-bg-neutral-50": !active && disabled
      })
    },
    showTitle && /* @__PURE__ */ import_react108.default.createElement(
      "div",
      {
        className: (0, import_classnames76.default)(genericTitleContainerClassName, ["v2-pb-4 !v2-h-auto"])
      },
      titleComponent
    ),
    /* @__PURE__ */ import_react108.default.createElement("div", { className: (0, import_classnames76.default)(genericBodyClassName) }, children, actionsComponent)
  );
}

// src/components/DynamicAccordion/Components/DynamicPanelGroup.tsx
var import_react109 = __toESM(require("react"));
var import_classnames77 = __toESM(require("classnames"));
function DynamicPanelGroup({
  identifier: identifier2,
  title,
  disabled,
  children,
  onClick,
  rightComponent,
  panelNumber,
  contentClassName,
  titleContainerClassName,
  titleClassName,
  className,
  bodyClassName,
  isComplete: isComplete2 = false,
  hidePanelNumber = false,
  hideActiveBorderColor = false,
  hideArrow = false
}) {
  const {
    isTurquoiseThemed,
    isBlueThemed,
    isMagentaThemed,
    steps,
    activePanelGroup,
    setActivePanel,
    setActivePanelGroup
  } = (0, import_react109.useContext)(DynamicAccordionContext_default);
  const active = identifier2 === activePanelGroup;
  const onClickHandler = () => {
    onClick == null ? void 0 : onClick(identifier2);
    setActivePanelGroup(identifier2);
    setActivePanel(steps[identifier2][0]);
  };
  const panelNumberComponent = /* @__PURE__ */ import_react109.default.createElement(
    "span",
    {
      className: (0, import_classnames77.default)(
        [
          "v2-block v2-border-2 v2-border-solid v2-rounded-full",
          "v2-min-w-[25px] v2-min-h-[20px] v2-text-center v2-text-sm"
        ],
        {
          "v2-border-turquoise-700 v2-text-turquoise-700": isTurquoiseThemed,
          "v2-border-blue-500 v2-text-blue-500": isBlueThemed,
          "v2-border-magenta-500 v2-text-magenta-500": isMagentaThemed,
          "v2-bg-turquoise-700": active && isTurquoiseThemed,
          "v2-bg-blue-500": active && isBlueThemed,
          "v2-bg-magenta-500": active && isMagentaThemed,
          "!v2-text-white": active
        }
      )
    },
    panelNumber
  );
  const titleComponent = /* @__PURE__ */ import_react109.default.createElement(
    "div",
    {
      className: (0, import_classnames77.default)(
        titleClassName,
        "v2-flex v2-flex-row v2-gap-x-3 v2-items-center v2-justify-center v2-truncate"
      )
    },
    !hidePanelNumber && panelNumberComponent,
    /* @__PURE__ */ import_react109.default.createElement(
      "span",
      {
        className: (0, import_classnames77.default)(
          "v2-flex v2-flex-row v2-gap-x-3 v2-font-base v2-text-neutral-900 v2-text-base v2-truncate"
        )
      },
      title
    ),
    isComplete2 && /* @__PURE__ */ import_react109.default.createElement(CheckMark, null)
  );
  return /* @__PURE__ */ import_react109.default.createElement(
    Accordion,
    {
      id: identifier2,
      active,
      disabled,
      onClick: onClickHandler,
      titleContainerClassName: (0, import_classnames77.default)(
        titleContainerClassName,
        "v2-px-5 v2-mt-0 v2-h-[60px] !v2-flex-row v2-rounded-t-lg"
      ),
      className: (0, import_classnames77.default)("v2-rounded-lg", className, {
        "v2-border v2-border-solid v2-border-turquoise-700": active && !hideActiveBorderColor && isTurquoiseThemed,
        "v2-border v2-border-solid v2-border-blue-500": active && !hideActiveBorderColor && isBlueThemed,
        "v2-border v2-border-solid v2-border-magenta-500": active && !hideActiveBorderColor && isMagentaThemed,
        "v2-bg-white": !disabled
      }),
      bodyClassName: (0, import_classnames77.default)(bodyClassName, "v2-pt-0"),
      titleClassName: "!v2-justify-start v2-truncate",
      title: titleComponent,
      rightComponent,
      showAnimation: "v2-animate-fade-in-down-150" /* SlideInDown150 */,
      hideAnimation: "v2-animate-fade-out-up-150" /* SlideOutUp150 */,
      hideArrow
    },
    /* @__PURE__ */ import_react109.default.createElement(
      "div",
      {
        className: (0, import_classnames77.default)(
          "dynamic-panel-group-content",
          contentClassName,
          "v2-flex v2-flex-col v2-flex-wrap v2-gap-x-5 v2-border-0 !v2-border-t",
          "v2-border-solid v2-border-neutral-100"
        )
      },
      children
    )
  );
}

// src/utils/date.ts
var import_luxon2 = require("luxon");
var TimeFormat = /* @__PURE__ */ ((TimeFormat2) => {
  TimeFormat2["AM"] = "am";
  TimeFormat2["PM"] = "pm";
  return TimeFormat2;
})(TimeFormat || {});
function parseUtcDate(input, options2) {
  var _a;
  const dtOptions = {
    zone: "utc"
  };
  if (typeof input === "string") {
    const sqlDate = import_luxon2.DateTime.fromSQL(input, dtOptions);
    if (sqlDate.invalidReason) {
      return import_luxon2.DateTime.fromISO(input, dtOptions);
    } else {
      return sqlDate;
    }
  }
  if (typeof input === "number") {
    switch ((_a = options2 == null ? void 0 : options2.parseNumberAs) != null ? _a : "seconds") {
      case "millis":
        return import_luxon2.DateTime.fromMillis(input, dtOptions);
      case "seconds":
      default:
        return import_luxon2.DateTime.fromSeconds(input, dtOptions);
    }
  }
  if (input instanceof Date) {
    return import_luxon2.DateTime.fromJSDate(input, dtOptions);
  }
}
function utcToLocalDate(utcDate, timeZone) {
  if (timeZone) {
    return utcDate.setZone(timeZone);
  }
  return utcDate.toLocal();
}

// src/utils/color.ts
var import_memoize = __toESM(require_memoize());
var defaultColor = {
  BLACK: "#000000",
  WHITE: "#FFFFFF"
};
var cutHex = (0, import_memoize.default)((h) => {
  return h.charAt(0) == "#" ? h.substring(1, 7) : h;
});
var hexToR = (0, import_memoize.default)((h) => {
  return parseInt(cutHex(h).substring(0, 2), 16);
});
var hexToG = (0, import_memoize.default)((h) => {
  return parseInt(cutHex(h).substring(2, 4), 16);
});
var hexToB = (0, import_memoize.default)((h) => {
  return parseInt(cutHex(h).substring(4, 6), 16);
});
var computeTextColor = (0, import_memoize.default)((color) => {
  const r = hexToR(color);
  const g = hexToG(color);
  const b = hexToB(color);
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? defaultColor.BLACK : defaultColor.WHITE;
});

// src/hook/use-date-hook.ts
var import_react110 = require("react");
var import_luxon3 = require("luxon");
function useDate(input, options2) {
  const utc = (0, import_react110.useMemo)(() => {
    if (import_luxon3.DateTime.isDateTime(input)) {
      return input.toUTC();
    }
    return parseUtcDate(input, { parseNumberAs: options2 == null ? void 0 : options2.parseNumberAs });
  }, [input]);
  return (0, import_react110.useMemo)(() => {
    var _a;
    const local = utc && utcToLocalDate(utc, options2 == null ? void 0 : options2.timezone);
    const relative = local == null ? void 0 : local.toRelative({
      style: (_a = options2 == null ? void 0 : options2.relativeStyle) != null ? _a : "short"
    });
    return {
      original: input,
      utc,
      local,
      relative: relative != null ? relative : void 0
    };
  }, [options2 == null ? void 0 : options2.timezone, input, utc]);
}

// src/hook/use-event-listener-hook.ts
var import_has = __toESM(require_has());
var import_react111 = require("react");
function isRef(elementOrRef) {
  return (0, import_has.default)(elementOrRef, "current");
}
function useEventListener(eventName, callback, elementOrRef = window) {
  const element = (0, import_react111.useRef)();
  const savedCallback = (0, import_react111.useRef)();
  (0, import_react111.useEffect)(() => {
    if (element.current)
      return;
    if (isRef(elementOrRef)) {
      element.current = elementOrRef.current;
    } else {
      element.current = elementOrRef;
    }
  }, [elementOrRef]);
  (0, import_react111.useEffect)(() => {
    savedCallback.current = callback;
  }, [callback]);
  (0, import_react111.useLayoutEffect)(() => {
    if (element.current == null || savedCallback.current == null)
      return;
    const eventListener = (event) => {
      var _a;
      return (_a = savedCallback.current) == null ? void 0 : _a.call(savedCallback, event);
    };
    element.current.addEventListener(
      eventName,
      eventListener
    );
    return function cleanup() {
      var _a;
      return (_a = element == null ? void 0 : element.current) == null ? void 0 : _a.removeEventListener(
        eventName,
        eventListener
      );
    };
  }, [eventName, element.current]);
}

// src/components/VideoRecorder/VideoRecorderWrapper.tsx
var import_react144 = __toESM(require("react"));
var import_react_i18next9 = require("react-i18next");

// src/components/VideoRecorder/Recorder.tsx
var import_react142 = __toESM(require("react"));
var import_classnames90 = __toESM(require("classnames"));

// src/utils/assetUrl.ts
function assetUrl(path) {
  return `https://cdn.bonjoro.com/assets/bonjoro-ui-components/${path}`;
}

// src/components/VideoRecorder/ActionButton.tsx
var import_react112 = __toESM(require("react"));
var import_react_fontawesome18 = require("@fortawesome/react-fontawesome");
function ActionButton({
  icon,
  label,
  onClick,
  className = ""
}) {
  return /* @__PURE__ */ import_react112.default.createElement(
    "div",
    {
      className: `v2-inline-flex v2-items-center v2-bg-black/50 v2-rounded-full v2-text-white v2-px-2 v2-py-1 hover:v2-bg-black/100 v2-transition-colors ${className}`,
      role: "button",
      onClick
    },
    /* @__PURE__ */ import_react112.default.createElement(import_react_fontawesome18.FontAwesomeIcon, { className: "v2-text-xl", icon }),
    /* @__PURE__ */ import_react112.default.createElement("span", { className: "v2-ml-2" }, label)
  );
}

// src/components/VideoRecorder/VideoRecorder.tsx
var import_pick2 = __toESM(require_pick());
var import_stop_media_stream3 = __toESM(require_stop_media_stream());
var import_react_page_visibility = __toESM(require("react-page-visibility"));
var import_toolkit4 = require("@reduxjs/toolkit");
var import_react137 = __toESM(require("react"));

// src/components/VideoRecorder/VideoPane.tsx
var import_classnames86 = __toESM(require("classnames"));

// node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var import_react115 = require("react");

// node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options2.speedy === void 0 ? false : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (true) {
      var isImportRule3 = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
      if (isImportRule3 && this._alreadyInsertedOrderInsensitiveRule) {
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule3;
    }
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (!/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error('There was a problem inserting the following rule: "' + rule + '"', e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
    if (true) {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };
  return StyleSheet2;
}();

// node_modules/stylis/src/Enum.js
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";

// node_modules/stylis/src/Utility.js
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}

// node_modules/stylis/src/Tokenizer.js
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type, props, children, length2) {
  return { value, root, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0), root, { length: -root.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index) {
  while (!token(peek()))
    next();
  return slice(index, position);
}

// node_modules/stylis/src/Parser.js
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset:
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i)
    for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
      if (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
        props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}

// node_modules/stylis/src/Serializer.js
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

// node_modules/stylis/src/Middleware.js
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index, children, callback) || "";
    return output;
  };
}

// node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize2(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var emotion_memoize_esm_default = memoize2;

// node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index] = peek() === 58 ? "&\f" : "";
          points[index] = parsed[index].length;
          break;
        }
      default:
        parsed[index] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment2(element) {
  return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm2(cache) {
  return function(element, index, children) {
    if (element.type !== "rule" || cache.compat)
      return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0];
      var commentContainer = isNested ? children[0].children : (
        // global rule at the root level
        children
      );
      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node2 = commentContainer[i];
        if (node2.line < element.line) {
          break;
        }
        if (node2.column < element.column) {
          if (isIgnoringComment(node2)) {
            return;
          }
          break;
        }
      }
      unsafePseudoClasses.forEach(function(unsafePseudoClass) {
        console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
      });
    }
  };
};
var isImportRule = function isImportRule2(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules2(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }
  return false;
};
var nullifyElement = function nullifyElement2(element) {
  element.type = "";
  element.value = "";
  element["return"] = "";
  element.children = "";
  element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm2(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index, children, callback) {
  if (element.length > -1) {
    if (!element["return"])
      switch (element.type) {
        case DECLARATION:
          element["return"] = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, {
            value: replace(element.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key2 = options2.key;
  if (!key2) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (key2 === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  if (true) {
    if (/[^a-z-]/.test(key2)) {
      throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key2 + '" was passed');
    }
  }
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options2.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key2 + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (true) {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }
    }), incorrectImportAlarm);
  }
  {
    var currentSheet;
    var finalizingPlugins = [stringify, true ? function(element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      if (serialized.map !== void 0) {
        currentSheet = {
          insert: function insert2(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key: key2,
    sheet: new StyleSheet({
      key: key2,
      container,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var emotion_cache_browser_esm_default = createCache;

// node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var import_react114 = require("react");

// node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser2 = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser2 === false) && cache.registered[className] === void 0
  ) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};

// node_modules/@emotion/hash/dist/emotion-hash.esm.js
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var emotion_hash_esm_default = murmur2;

// node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var emotion_unitless_esm_default = unitlessKeys;

// node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`;
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ emotion_memoize_esm_default(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key2, value) {
  switch (key2) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (emotion_unitless_esm_default[key2] !== 1 && !isCustomProperty(key2) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
if (true) {
  contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  contentValues = ["normal", "none", "initial", "inherit", "unset"];
  oldProcessStyleValue = processStyleValue;
  msPattern = /^-ms-/;
  hyphenPattern = /-(.)/g;
  hyphenatedCache = {};
  processStyleValue = function processStyleValue3(key2, value) {
    if (key2 === "content") {
      if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key2, value);
    if (processed !== "" && !isCustomProperty(key2) && key2.indexOf("-") !== -1 && hyphenatedCache[key2] === void 0) {
      hyphenatedCache[key2] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key2.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var contentValuePattern;
var contentValues;
var oldProcessStyleValue;
var msPattern;
var hyphenPattern;
var hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    if (interpolation.toString() === "NO_COMPONENT_SELECTOR") {
      throw new Error(noComponentSelectorMessage);
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation.styles + ";";
        if (interpolation.map !== void 0) {
          styles += interpolation.map;
        }
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      } else if (true) {
        console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      }
      break;
    }
    case "string":
      if (true) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function(match2, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, ["`" + replaced + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
        }
      }
      break;
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && true) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              if (_key === "undefined") {
                console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
              }
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (true) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
}
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (strings[0] === void 0) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (strings[i] === void 0) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (true) {
    styles = styles.replace(sourceMapPattern, function(match3) {
      sourceMap = match3;
      return "";
    });
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + // $FlowFixMe we know it's not null
    match2[1];
  }
  var name = emotion_hash_esm_default(styles) + identifierName;
  if (true) {
    return {
      name,
      styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name,
    styles,
    next: cursor
  };
};

// node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var React97 = __toESM(require("react"));
var import_react113 = require("react");
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect2 = React97["useInsertionEffect"] ? React97["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect2 || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect2 || import_react113.useLayoutEffect;

// node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ (0, import_react114.createContext)(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ emotion_cache_browser_esm_default({
    key: "css"
  }) : null
);
if (true) {
  EmotionCacheContext.displayName = "EmotionCacheContext";
}
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ (0, import_react114.forwardRef)(function(props, ref) {
    var cache = (0, import_react114.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ (0, import_react114.createContext)({});
if (true) {
  ThemeContext.displayName = "EmotionThemeContext";
}
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var Insertion = function Insertion2(_ref) {
  var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, (0, import_react114.useContext)(ThemeContext));
  if (serialized.name.indexOf("-") === -1) {
    var labelFromStack = props[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, "label:" + labelFromStack + ";"]);
    }
  }
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key2 in props) {
    if (hasOwnProperty.call(props, key2) && key2 !== "css" && key2 !== typePropName && key2 !== labelPropName) {
      newProps[key2] = props[key2];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ (0, import_react114.createElement)(import_react114.Fragment, null, /* @__PURE__ */ (0, import_react114.createElement)(Insertion, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ (0, import_react114.createElement)(WrappedComponent, newProps));
});
if (true) {
  Emotion.displayName = "EmotionCssPropInternal";
}

// node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var import_hoist_non_react_statics = __toESM(require_hoist_non_react_statics_cjs());
var pkg = {
  name: "@emotion/react",
  version: "11.10.5",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        "default": "./dist/emotion-react.esm.js"
      },
      "default": "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": "./macro.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: false,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.10.5",
    "@emotion/cache": "^11.10.5",
    "@emotion/serialize": "^1.1.1",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
    "@emotion/utils": "^1.2.0",
    "@emotion/weak-memoize": "^0.3.0",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: true
    },
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@babel/core": "^7.18.5",
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.10.5",
    "@emotion/css-prettifier": "1.1.1",
    "@emotion/server": "11.10.0",
    "@emotion/styled": "11.10.5",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
      }
    }
  }
};
var warnedAboutCssPropForGlobal = false;
var Global = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  if (!warnedAboutCssPropForGlobal && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }
  var styles = props.styles;
  var serialized = serializeStyles([styles], void 0, (0, import_react115.useContext)(ThemeContext));
  var sheetRef = (0, import_react115.useRef)();
  useInsertionEffectWithLayoutFallback(function() {
    var key2 = cache.key + "-global";
    var sheet = new cache.sheet.constructor({
      key: key2,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node2 = document.querySelector('style[data-emotion="' + key2 + " " + serialized.name + '"]');
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node2 !== null) {
      rehydrating = true;
      node2.setAttribute("data-emotion", key2);
      sheet.hydrate([node2]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function() {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function() {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== void 0) {
      insertStyles(cache, serialized.next, true);
    }
    if (sheet.tags.length) {
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});
if (true) {
  Global.displayName = "EmotionGlobal";
}
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var classnames = function classnames2(args) {
  var len = args.length;
  var i = 0;
  var cls = "";
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          if (arg.styles !== void 0 && arg.name !== void 0) {
            console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
          }
          toAdd = "";
          for (var k in arg) {
            if (arg[k] && k) {
              toAdd && (toAdd += " ");
              toAdd += k;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css2, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css2(registeredStyles);
}
var Insertion3 = function Insertion4(_ref) {
  var cache = _ref.cache, serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css2 = function css3() {
    if (hasRendered && true) {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized);
    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx126 = function cx127() {
    if (hasRendered && true) {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css2, classnames(args));
  };
  var content = {
    css: css2,
    cx: cx126,
    theme: (0, import_react115.useContext)(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /* @__PURE__ */ (0, import_react115.createElement)(import_react115.Fragment, null, /* @__PURE__ */ (0, import_react115.createElement)(Insertion3, {
    cache,
    serializedArr
  }), ele);
});
if (true) {
  ClassNames.displayName = "EmotionClassNames";
}
if (true) {
  isBrowser3 = true;
  isTestEnv = typeof jest !== "undefined" || typeof vi !== "undefined";
  if (isBrowser3 && !isTestEnv) {
    globalContext = // $FlowIgnore
    typeof globalThis !== "undefined" ? globalThis : isBrowser3 ? window : global;
    globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__";
    if (globalContext[globalKey]) {
      console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used.");
    }
    globalContext[globalKey] = true;
  }
}
var isBrowser3;
var isTestEnv;
var globalContext;
var globalKey;

// src/components/VideoRecorder/VideoPane.tsx
var import_styled11 = __toESM(require("@emotion/styled"));
var import_react134 = __toESM(require("react"));
var import_react_fontawesome19 = require("@fortawesome/react-fontawesome");

// src/components/VideoRecorder/Timer.tsx
var import_classnames78 = __toESM(require("classnames"));
var import_react116 = __toESM(require("react"));
var import_luxon4 = require("luxon");
var Timer = (0, import_react116.memo)(({ startTime, endTime, className }) => {
  const [intervalId, setIntervalId] = (0, import_react116.useState)();
  const [currentTick, setCurrentTick] = (0, import_react116.useState)(0);
  function tick() {
    setCurrentTick((tick2) => tick2 + 1);
  }
  (0, import_react116.useEffect)(() => {
    if (startTime != null && endTime == null) {
      setIntervalId(setInterval(tick, 250));
    } else if (intervalId) {
      clearInterval(intervalId);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [startTime, endTime]);
  const output = (0, import_react116.useMemo)(() => {
    const now = import_luxon4.DateTime.local();
    let duration;
    if (startTime != null) {
      duration = (endTime != null ? endTime : now).diff(startTime);
    } else {
      duration = import_luxon4.Duration.fromMillis(0);
    }
    return elapsed(duration);
  }, [startTime, endTime, currentTick]);
  return /* @__PURE__ */ import_react116.default.createElement(
    "div",
    {
      className: (0, import_classnames78.default)(
        "v2-text-md v2-px-2 v2-text-white v2-bg-black/20 v2-rounded-full",
        className
      )
    },
    output
  );
});
Timer.displayName = "Timer";
var Timer_default = Timer;

// src/components/VideoRecorder/Video.tsx
var import_classnames79 = __toESM(require("classnames"));
var import_debounce2 = __toESM(require_debounce());
var import_partial = __toESM(require_partial());
var import_react117 = __toESM(require("react"));
var loadedData = (0, import_debounce2.default)((callback, evt) => {
  setTimeout((0, import_partial.default)(callback, evt), 100);
}, 100);
var landscapeVideoClassName = "v2-h-full v2-w-auto v2-min-h-[min(100vh,450px)]";
var portraitVideoClassName = "v2-h-auto v2-w-full v2-min-w-[min(100vw,450px)]";
function Video(_a) {
  var _b = _a, {
    videoRef,
    canvasRef,
    src,
    mediaStream,
    preload = "auto"
  } = _b, props = __objRest(_b, [
    "videoRef",
    "canvasRef",
    "src",
    "mediaStream",
    "preload"
  ]);
  const windowSize = useWindowSize_default();
  const video = (0, import_react117.useRef)();
  const [canvasResolution, setCanvasResolution] = (0, import_react117.useState)({
    height: 450,
    width: 800
  });
  const [videoClassName, setVideoClassName] = (0, import_react117.useState)(
    windowSize.width > windowSize.height ? landscapeVideoClassName : portraitVideoClassName
  );
  function getVideoRef(ref) {
    videoRef.current = video.current = ref;
  }
  (0, import_react117.useEffect)(() => {
    var _a2;
    const handleLoadedData = (0, import_partial.default)(
      loadedData,
      (evt) => {
        const { videoWidth, videoHeight } = evt.target;
        const isLandscape = videoWidth > videoHeight;
        setVideoClassName(
          isLandscape ? landscapeVideoClassName : portraitVideoClassName
        );
      }
    );
    (_a2 = video.current) == null ? void 0 : _a2.addEventListener("loadeddata", handleLoadedData);
    return () => {
      var _a3;
      (_a3 = video.current) == null ? void 0 : _a3.removeEventListener("loadeddata", handleLoadedData);
    };
  }, [video]);
  (0, import_react117.useEffect)(() => {
    if (!video.current)
      return;
    if (src != null) {
      video.current.srcObject = null;
      if (video.current.readyState === 0) {
        video.current.load();
      }
    } else if (mediaStream != null) {
      video.current.srcObject = mediaStream;
      video.current.onloadedmetadata = function() {
        video.current.play().catch((e) => {
          console.debug(e);
        });
      };
    } else {
      video.current.srcObject = null;
    }
  }, [src, video.current, mediaStream]);
  return /* @__PURE__ */ import_react117.default.createElement(import_react117.default.Fragment, null, /* @__PURE__ */ import_react117.default.createElement(
    "video",
    __spreadProps(__spreadValues({
      className: (0, import_classnames79.default)(
        "v2-object-fit v2-absolute !v2-block v2-translate-x-[-50%] v2-translate-y-[-50%] v2-left-[50%] v2-top-[50%] v2-z-0 v2-max-w-none",
        {
          "v2-hidden": !!src
        },
        videoClassName
      ),
      ref: getVideoRef
    }, props), {
      src,
      preload,
      playsInline: true,
      onPlaying: () => setCanvasResolution({
        width: video.current.videoWidth,
        height: video.current.videoHeight
      })
    })
  ), /* @__PURE__ */ import_react117.default.createElement(
    "canvas",
    {
      id: "canvas",
      className: (0, import_classnames79.default)(
        "v2-object-fit v2-absolute !v2-block v2-translate-x-[-50%] v2-translate-y-[-50%] v2-left-[50%] v2-top-[50%] v2-z-0 v2-max-w-none",
        {
          "!v2-hidden": src
        },
        videoClassName
      ),
      ref: canvasRef,
      width: canvasResolution.width,
      height: canvasResolution.height
    }
  ));
}

// src/components/VideoRecorder/StartStop.tsx
var import_react118 = __toESM(require("react"));
var import_classnames80 = __toESM(require("classnames"));
var StartStop = ({
  isComplete: isComplete2,
  isPlaying,
  onStartClick,
  onStopClick,
  className
}) => {
  return /* @__PURE__ */ import_react118.default.createElement(
    "div",
    {
      role: "button",
      onClick: isPlaying ? onStopClick : onStartClick,
      className
    },
    /* @__PURE__ */ import_react118.default.createElement(
      "img",
      {
        src: assetUrl("video-recorder/ic_record_start.svg"),
        className: (0, import_classnames80.default)("v2-h-12 v2-w-12 v2-z-20", {
          "v2-hidden": isComplete2 || isPlaying
        })
      }
    ),
    /* @__PURE__ */ import_react118.default.createElement(
      "img",
      {
        src: assetUrl("video-recorder/ic_record_stop.svg"),
        className: (0, import_classnames80.default)("v2-h-12 v2-w-12 v2-z-20", {
          "v2-hidden": !isPlaying
        })
      }
    ),
    /* @__PURE__ */ import_react118.default.createElement(
      "img",
      {
        src: assetUrl("video-recorder/ic_record_play.svg"),
        className: (0, import_classnames80.default)("v2-h-12 v2-w-12 v2-z-20", {
          "v2-hidden": isPlaying || !isComplete2
        })
      }
    )
  );
};
var StartStop_default = StartStop;

// src/components/VideoRecorder/SettingsAlert.tsx
var import_classnames81 = __toESM(require("classnames"));
var import_react_i18next3 = require("react-i18next");
var import_react123 = __toESM(require("react"));

// src/components/VideoRecorder/DevicesDropdown.tsx
var import_react119 = __toESM(require("react"));
var import_react_i18next = require("react-i18next");
var DevicesDropdown = ({
  devices,
  label,
  onChange,
  current,
  labelColorClassName = "text-white"
}) => {
  const { t } = (0, import_react_i18next.useTranslation)();
  return /* @__PURE__ */ import_react119.default.createElement("div", null, /* @__PURE__ */ import_react119.default.createElement("label", { className: `text-base ${labelColorClassName} text-bold` }, label), /* @__PURE__ */ import_react119.default.createElement(
    Select,
    {
      placeholder: t("videoRecorder:settings.select"),
      value: current,
      getOptionLabel: ({ label: label2 }) => label2,
      getOptionValue: ({ deviceId }) => deviceId,
      options: devices,
      onChange,
      maxMenuHeight: 120
    }
  ));
};
var DevicesDropdown_default = DevicesDropdown;

// src/components/VideoRecorder/support/Devices.ts
var import_react_query = require("react-query");
var queryKeys = {
  all: ["devices"],
  lists: () => [...queryKeys.all, "lists"],
  list: (kind) => [...queryKeys.lists(), { kind }],
  details: () => [...queryKeys.all, "details"],
  detail: (kind) => [...queryKeys.details(), kind]
};
var storageKeys2 = {
  all: ["bonjoro", "devices"],
  audioDevice: () => [...storageKeys2.all, "audioinput"],
  videoDevice: () => [...storageKeys2.all, "videoinput"]
};
function getDevices() {
  return __async(this, null, function* () {
    const allDevices = yield navigator.mediaDevices.enumerateDevices();
    if (allDevices.some((device) => device.deviceId.length === 0)) {
      throw new Error("No permissions");
    }
    return allDevices.filter((device) => device.kind.endsWith("input"));
  });
}
function useDevices() {
  return (0, import_react_query.useQuery)(queryKeys.lists(), getDevices, {
    staleTime: Infinity
  });
}
function useAudioDevices() {
  const { data: devices, isSuccess } = useDevices();
  const kind = "audioinput";
  return (0, import_react_query.useQuery)(
    queryKeys.list(kind),
    () => devices == null ? void 0 : devices.filter((device) => device.kind === kind),
    {
      enabled: isSuccess
    }
  );
}
function useVideoDevices() {
  const { data: devices, isSuccess } = useDevices();
  const kind = "videoinput";
  return (0, import_react_query.useQuery)(
    queryKeys.list(kind),
    () => devices == null ? void 0 : devices.filter((device) => device.kind === kind),
    {
      enabled: isSuccess
    }
  );
}
function rememberAudioDevice(device) {
  return remember(storageKeys2.audioDevice(), device);
}
function rememberVideoDevice(device) {
  return remember(storageKeys2.videoDevice(), device);
}
function useRememberAudioDevice() {
  const queryClient = (0, import_react_query.useQueryClient)();
  return (0, import_react_query.useMutation)(rememberAudioDevice, {
    onSuccess: (_, device) => {
      queryClient.setQueryData(queryKeys.detail("audioinput"), device);
    }
  });
}
function useRememberVideoDevice() {
  const queryClient = (0, import_react_query.useQueryClient)();
  return (0, import_react_query.useMutation)(rememberVideoDevice, {
    onSuccess: (_, device) => {
      queryClient.setQueryData(queryKeys.detail("videoinput"), device);
    }
  });
}
function deviceExists(device, devices) {
  return device != null && devices.some((d) => (d == null ? void 0 : d.deviceId) === device.deviceId);
}
function getAudioDevice() {
  return recall(storageKeys2.audioDevice());
}
function useDevice(kind, getDevice) {
  const devicesResult = useDevices();
  const { data: devices = [], isSuccess } = devicesResult;
  const result = (0, import_react_query.useQuery)(queryKeys.detail(kind), getDevice, {
    enabled: isSuccess && devices.length > 0
  });
  const device = devices.find(
    (device2) => {
      var _a;
      return device2.kind === kind && device2.deviceId === ((_a = result.data) == null ? void 0 : _a.deviceId);
    }
  );
  return __spreadProps(__spreadValues({}, result), {
    data: device,
    isValidDevice: deviceExists(result.data, devices)
  });
}
function useAudioDevice() {
  return useDevice("audioinput", getAudioDevice);
}
function getVideoDevice() {
  return __async(this, null, function* () {
    return recall(storageKeys2.videoDevice());
  });
}
function useVideoDevice() {
  return useDevice("videoinput", getVideoDevice);
}
function getDeviceName(deviceId, devices) {
  var _a;
  return (_a = devices == null ? void 0 : devices.find((device) => device.deviceId === deviceId)) == null ? void 0 : _a.label;
}

// src/utils/BrowserSupport.ts
var import_memoize4 = __toESM(require_memoize());
var detectBrowser = (0, import_memoize4.default)(() => {
  const isIE = !!document.documentMode;
  if (isIE) {
    return "ie";
  }
  const isEdge = !isIE && !!window.StyleMedia;
  if (isEdge) {
    return "edge";
  }
  const isChrome = !!window.chrome;
  if (isChrome) {
    return "chrome";
  }
  const isOpera = !!window.opera || navigator.userAgent.includes(" OPR/");
  if (isOpera) {
    return "opera";
  }
  const isFirefox = typeof InstallTrigger !== "undefined";
  if (isFirefox) {
    return "firefox";
  }
  const isSafari = /constructor/i.test(window.HTMLElement.toString()) || // eslint-disable-next-line
  function(p) {
    return p.toString() === "[object SafariRemoteNotification]";
  }(!window["safari"] || window["safari"].pushNotification) || navigator.userAgent.includes("Safari");
  if (isSafari) {
    return "safari";
  }
  const isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isBlink) {
    return "blink";
  }
});

// src/components/VideoRecorder/support/settings.ts
var import_first = __toESM(require_first());
var import_intersection = __toESM(require_intersection());
var import_memoize5 = __toESM(require_memoize());
var defaultUserMediaConstraints = {
  audio: {
    sampleRate: 44100,
    sampleSize: 16
  },
  /**
   * If 1280x720 is not supported, `ideal` will look for resolution that is near 1280x720.
   * Note: Do not use `min` and `max` constraints as it throws an `OverConstraintError`
   * on the camera devices that does not support the resolutions. Unless we are willing to catch it
   * on `use-msr-handler` then use a fallback constraint that is supported by the camera device.
   */
  video: {
    facingMode: "user",
    width: {
      ideal: 1280
    },
    height: {
      ideal: 720
    }
  }
};
var RecordingQuality = /* @__PURE__ */ ((RecordingQuality2) => {
  RecordingQuality2["High"] = "high";
  RecordingQuality2["Medium"] = "medium";
  RecordingQuality2["Low"] = "low";
  return RecordingQuality2;
})(RecordingQuality || {});
function getVideoConstraints(videoDevice, quality = "medium" /* Medium */) {
  var _a;
  const capabilities = videoDevice && "getCapabilities" in videoDevice && videoDevice.getCapabilities() || void 0;
  let videoConstraints = {};
  if ((_a = capabilities == null ? void 0 : capabilities.facingMode) == null ? void 0 : _a.length) {
    videoConstraints = __spreadProps(__spreadValues({}, defaultUserMediaConstraints.video), {
      facingMode: capabilities.facingMode[0]
    });
  } else {
    videoConstraints = __spreadProps(__spreadValues({}, defaultUserMediaConstraints.video), {
      deviceId: videoDevice == null ? void 0 : videoDevice.deviceId,
      groupId: videoDevice == null ? void 0 : videoDevice.groupId,
      facingMode: void 0
    });
  }
  switch (quality) {
    case "high" /* High */:
      videoConstraints.width = {
        ideal: 1920
      };
      videoConstraints.height = {
        ideal: 1080
      };
      break;
    case "low" /* Low */:
      videoConstraints.width = {
        ideal: 854
      };
      videoConstraints.height = {
        ideal: 480
      };
      break;
    case "medium" /* Medium */:
    default:
      videoConstraints.width = {
        ideal: 1280
      };
      videoConstraints.height = {
        ideal: 720
      };
      break;
  }
  return videoConstraints;
}
var videoCodecs = ["vp9", "vp8", "avc1"];
function getDefaultVideoCodecForBrowser() {
  const browser = detectBrowser();
  switch (browser) {
    case "chrome":
      return "vp9";
    case "firefox":
      return "vp8";
    case "safari":
    default:
      return "avc1";
  }
}
var parseMimeType = (0, import_memoize5.default)((mimeType) => {
  var _a, _b;
  const [container, ...options2] = mimeType.split(";");
  const optionsArray = options2 == null ? void 0 : options2.map((option) => {
    const [name, args] = option.split("=");
    return {
      name,
      args: args == null ? void 0 : args.split(",")
    };
  });
  const codecs = (_b = (_a = optionsArray.find((option) => option.name === "codecs")) == null ? void 0 : _a.args) != null ? _b : [];
  return {
    container,
    codecs
  };
});
function getVp9VideoBitrate(quality) {
  const baseKbps = {
    ["high" /* High */]: 2800,
    ["medium" /* Medium */]: 1600,
    ["low" /* Low */]: 750
  };
  return baseKbps[quality] * 1e3;
}
function getVp8VideoBitrate(quality) {
  const baseKbps = {
    ["high" /* High */]: 3e3,
    ["medium" /* Medium */]: 1850,
    ["low" /* Low */]: 1e3
  };
  return baseKbps[quality] * 1e3;
}
function getH264VideoBitrate(quality) {
  const baseKbps = {
    ["high" /* High */]: 3500,
    ["medium" /* Medium */]: 1750,
    ["low" /* Low */]: 1400
  };
  return baseKbps[quality] * 1e3;
}
var getVideoBitrate = (0, import_memoize5.default)(
  (quality, mimeType) => {
    var _a;
    const { codecs } = parseMimeType(mimeType);
    const videoCodec = (_a = (0, import_first.default)((0, import_intersection.default)(videoCodecs, codecs))) != null ? _a : getDefaultVideoCodecForBrowser();
    switch (videoCodec) {
      case "vp9":
        return getVp9VideoBitrate(quality);
      case "vp8":
        return getVp8VideoBitrate(quality);
      case "avc1":
      default:
        return getH264VideoBitrate(quality);
    }
  },
  (quality, mimeType) => `${quality}${mimeType}`
);
function getMediaRecorderOptions({
  mimeType,
  quality
}) {
  return {
    mimeType,
    videoBitsPerSecond: getVideoBitrate(quality, mimeType)
  };
}
var storageKeys3 = {
  all: ["bonjoro", "settings"]
};
function rememberSettings(settings) {
  return __async(this, null, function* () {
    const currentSettings = yield getSettings();
    return remember(storageKeys3.all, __spreadValues(__spreadValues({}, currentSettings), settings));
  });
}
function getSettings() {
  return recall(storageKeys3.all);
}

// src/components/VideoRecorder/QualityDropdown.tsx
var import_react120 = __toESM(require("react"));
var import_react_i18next2 = require("react-i18next");
var QualityDropdown = ({
  label,
  onChange,
  current,
  disabled
}) => {
  const { t } = (0, import_react_i18next2.useTranslation)();
  const options2 = (0, import_react120.useMemo)(
    () => Object.values(RecordingQuality).map((quality) => ({
      label: t(`videoRecorder:settings.quality.${quality}`),
      value: quality
    })),
    []
  );
  const selected = (0, import_react120.useMemo)(
    () => options2.find(({ value }) => value === current),
    [current]
  );
  return /* @__PURE__ */ import_react120.default.createElement("div", null, /* @__PURE__ */ import_react120.default.createElement("label", { className: "v2-text-white" }, label), /* @__PURE__ */ import_react120.default.createElement(
    Select,
    {
      disabled,
      placeholder: t("videoRecorder:settings.select"),
      value: selected,
      options: options2,
      onChange: (option) => onChange == null ? void 0 : onChange(option.value),
      maxMenuHeight: 120
    }
  ));
};
var QualityDropdown_default = QualityDropdown;

// src/components/VideoRecorder/hooks/useRecordingQuality.ts
var import_react_query2 = require("react-query");
var import_react122 = require("react");

// src/components/VideoRecorder/VideoRecorderContext.ts
var import_react121 = require("react");
var VideoRecorderContext = (0, import_react121.createContext)({});
var VideoRecorderContext_default = VideoRecorderContext;

// src/components/VideoRecorder/hooks/useRecordingQuality.ts
var key = ["bonjoro", "video-recorder", "quality"];
function useRecordingQuality() {
  const queryClient = (0, import_react_query2.useQueryClient)();
  const query = (0, import_react_query2.useQuery)(key, () => recall(key));
  const { mutate } = (0, import_react_query2.useMutation)(
    (quality) => remember(key, quality),
    {
      onSuccess: (_, value) => {
        queryClient.setQueryData(key, value);
      }
    }
  );
  const { options: contextOptions } = (0, import_react122.useContext)(VideoRecorderContext_default);
  const defaultRecordingQuality = "medium" /* Medium */;
  const recordingQuality = (0, import_react122.useMemo)(() => {
    var _a, _b;
    return (_b = (_a = contextOptions.recordingQuality) != null ? _a : query.data) != null ? _b : defaultRecordingQuality;
  }, [contextOptions.recordingQuality, query]);
  return {
    defaultRecordingQuality,
    recordingQuality,
    setRecordingQuality: mutate,
    isLoading: query.isLoading
  };
}

// src/components/VideoRecorder/SettingsAlert.tsx
function Settings({
  onDeviceChange,
  onClose,
  className,
  positionClassName = "v2-absolute v2-top-0 v2-left-0",
  backgroundColorClassName = "v2-bg-neutral-800",
  textColorClassName = "v2-text-white",
  paddingClassName = "v2-p-7",
  hideTitle = false,
  hideSave = false
}) {
  const { data: videoDevice } = useVideoDevice();
  const { data: audioDevice } = useAudioDevice();
  const { data: videoDevices = [] } = useVideoDevices();
  const { data: audioDevices = [] } = useAudioDevices();
  const { mutateAsync: rememberAudioDevice2 } = useRememberAudioDevice();
  const { mutateAsync: rememberVideoDevice2 } = useRememberVideoDevice();
  const { recordingQuality, setRecordingQuality } = useRecordingQuality();
  const { options: options2 } = (0, import_react123.useContext)(VideoRecorderContext_default);
  const createDeviceChangeHandler = (onChangeAction) => (newValue) => {
    onChangeAction(newValue);
    onDeviceChange == null ? void 0 : onDeviceChange();
  };
  const handleVideoDeviceChange = (0, import_react123.useMemo)(
    () => createDeviceChangeHandler((device) => {
      void rememberVideoDevice2(device);
    }),
    [videoDevices]
  );
  const handleAudioDeviceChange = (0, import_react123.useMemo)(
    () => createDeviceChangeHandler((device) => {
      void rememberAudioDevice2(device);
    }),
    [audioDevices]
  );
  const handleConfirm = (0, import_react123.useCallback)(() => {
    onClose == null ? void 0 : onClose(videoDevice, audioDevice);
  }, [videoDevice, audioDevice]);
  const { t } = (0, import_react_i18next3.useTranslation)();
  return /* @__PURE__ */ import_react123.default.createElement(
    "div",
    {
      className: (0, import_classnames81.default)(
        "v2-h-full v2-w-full v2-flex v2-z-50",
        className,
        paddingClassName,
        positionClassName,
        backgroundColorClassName
      )
    },
    /* @__PURE__ */ import_react123.default.createElement("div", { className: "v2-my-auto v2-w-full" }, !hideTitle && /* @__PURE__ */ import_react123.default.createElement("h3", { className: `v2-text-xl ${textColorClassName} v2-text-center` }, t("videoRecorder:settings.header")), /* @__PURE__ */ import_react123.default.createElement(
      DevicesDropdown_default,
      {
        label: t("videoRecorder:settings.camera"),
        devices: videoDevices,
        current: videoDevice,
        onChange: handleVideoDeviceChange,
        labelColorClassName: textColorClassName
      }
    ), /* @__PURE__ */ import_react123.default.createElement(
      DevicesDropdown_default,
      {
        label: t("videoRecorder:settings.audio"),
        devices: audioDevices,
        current: audioDevice,
        onChange: handleAudioDeviceChange,
        labelColorClassName: textColorClassName
      }
    ), /* @__PURE__ */ import_react123.default.createElement(
      QualityDropdown_default,
      {
        label: "Quality",
        current: recordingQuality,
        onChange: setRecordingQuality,
        disabled: options2.recordingQuality != null
      }
    ), !hideSave && /* @__PURE__ */ import_react123.default.createElement("div", { className: "v2-text-center v2-mt-4" }, /* @__PURE__ */ import_react123.default.createElement(Button, { md: true, onClick: handleConfirm }, t("videoRecorder:settings.save"))))
  );
}

// src/components/VideoRecorder/VideoDebug.tsx
var import_react124 = __toESM(require("react"));

// node_modules/reselect/es/defaultMemoize.js
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key2) {
      if (entry && equals(entry.key, key2)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put: function put(key2, value) {
      entry = {
        key: key2,
        value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  var entries = [];
  function get(key2) {
    var cacheIndex = entries.findIndex(function(entry2) {
      return equals(key2, entry2.key);
    });
    if (cacheIndex > -1) {
      var entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key2, value) {
    if (get(key2) === NOT_FOUND) {
      entries.unshift({
        key: key2,
        value
      });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return {
    get,
    put,
    getEntries,
    clear
  };
}
var defaultEqualityCheck = function defaultEqualityCheck2(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev2, next2) {
    if (prev2 === null || next2 === null || prev2.length !== next2.length) {
      return false;
    }
    var length2 = prev2.length;
    for (var i = 0; i < length2; i++) {
      if (!equalityCheck(prev2[i], next2[i])) {
        return false;
      }
    }
    return true;
  };
}
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    var value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func.apply(null, arguments);
      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function(entry) {
          return resultEqualityCheck(entry.value, value);
        });
        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = function() {
    return cache.clear();
  };
  return memoized;
}

// node_modules/reselect/es/index.js
function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
  if (!dependencies.every(function(dep) {
    return typeof dep === "function";
  })) {
    var dependencyTypes = dependencies.map(function(dep) {
      return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }
  return dependencies;
}
function createSelectorCreator(memoize6) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }
  var createSelector2 = function createSelector3() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }
    var _recomputations = 0;
    var _lastResult;
    var directlyPassedOptions = {
      memoizeOptions: void 0
    };
    var resultFunc = funcs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = funcs.pop();
    }
    if (typeof resultFunc !== "function") {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    }
    var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2;
    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize6.apply(void 0, [function recomputationWrapper() {
      _recomputations++;
      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions));
    var selector = memoize6(function dependenciesChecker() {
      var params = [];
      var length2 = dependencies.length;
      for (var i = 0; i < length2; i++) {
        params.push(dependencies[i].apply(null, arguments));
      }
      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  };
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(defaultMemoize);

// src/components/VideoRecorder/store/Selectors.ts
var import_luxon5 = require("luxon");
function getStartTime(state) {
  var _a;
  return (_a = state.startTime) != null ? _a : void 0;
}
function getBlob(state) {
  return state.blob;
}
function getBlobs(state) {
  return state.blobs;
}
function getMediaStream(state) {
  var _a;
  return (_a = state.mediaStream) != null ? _a : void 0;
}
function getEndTime(state) {
  var _a;
  return (_a = state.endTime) != null ? _a : void 0;
}
function getVideoSourceUrl(state) {
  var _a;
  return (_a = state.videoSourceUrl) != null ? _a : null;
}
var isRecording = createSelector(
  getStartTime,
  getEndTime,
  (startTime, endTime) => startTime != null && endTime == null
);
function getDurationState(state) {
  return state.duration;
}
var getDuration = createSelector(
  getStartTime,
  getEndTime,
  getDurationState,
  (startTime, endTime, duration) => duration ? import_luxon5.Duration.fromObject({ seconds: duration }) : endTime != null ? endTime.diff(startTime != null ? startTime : import_luxon5.DateTime.local()) : 0
);
var isComplete = createSelector(
  getStartTime,
  getEndTime,
  getBlob,
  (startTime, endTime, blob) => startTime != null && endTime != null && blob != null
);
function getThumbnails(state) {
  return state.thumbs;
}
var getThumbnailCount = createSelector(
  getThumbnails,
  (thumbs) => thumbs.length
);
var getVideoUrl = createSelector(
  getBlob,
  getVideoSourceUrl,
  (blob, videoSourceUrl) => {
    if (videoSourceUrl)
      return videoSourceUrl;
    return blob != null ? URL.createObjectURL(blob) : null;
  }
);
var getVideoComponentProps = createSelector(
  getVideoUrl,
  getMediaStream,
  (videoUrl, mediaStream) => ({
    src: videoUrl != null ? videoUrl : void 0,
    mediaStream
  })
);
function getDeviceErrorStatus(state) {
  return state.deviceErrorStatus;
}
function getMetadata(state) {
  return state.metadata;
}

// src/components/VideoRecorder/VideoDebug.tsx
function VideoDebug({
  recorderState,
  videoRef,
  currentHandler
}) {
  var _a, _b, _c, _d, _e, _f, _g;
  const { state } = (0, import_react124.useContext)(VideoRecorderContext_default);
  const metadata = (0, import_react124.useMemo)(
    () => getMetadata(state),
    [state.metadata]
  );
  const resolution = (_a = metadata == null ? void 0 : metadata.video) == null ? void 0 : _a.resolution;
  const videoDevice = (_b = metadata == null ? void 0 : metadata.video) == null ? void 0 : _b.device;
  const aspectRatio = (_c = metadata == null ? void 0 : metadata.video) == null ? void 0 : _c.aspectRatio;
  const frameRate = (_d = metadata == null ? void 0 : metadata.video) == null ? void 0 : _d.frameRate;
  const audioDevice = (_e = metadata == null ? void 0 : metadata.audio) == null ? void 0 : _e.device;
  const sampleRate = (_f = metadata == null ? void 0 : metadata.audio) == null ? void 0 : _f.sampleRate;
  const sampleSize = (_g = metadata == null ? void 0 : metadata.audio) == null ? void 0 : _g.sampleSize;
  const [readyState, setReadyState] = (0, import_react124.useState)();
  (0, import_react124.useEffect)(() => {
    var _a2;
    function updateReadyState() {
      var _a3;
      setReadyState((_a3 = videoRef.current) == null ? void 0 : _a3.readyState);
    }
    function handleDataLoaded() {
      updateReadyState();
    }
    (_a2 = videoRef.current) == null ? void 0 : _a2.addEventListener("loadeddata", handleDataLoaded);
    return () => {
      var _a3;
      (_a3 = videoRef.current) == null ? void 0 : _a3.removeEventListener("loadeddata", handleDataLoaded);
    };
  }, [videoRef.current]);
  return /* @__PURE__ */ import_react124.default.createElement("div", { className: "v2-text-white v2-absolute v2-z-20 v2-left-2 v2-top-[60px] v2-pointer-events-none v2-select-none" }, /* @__PURE__ */ import_react124.default.createElement("div", null, "state: ", recorderState), /* @__PURE__ */ import_react124.default.createElement("div", null, "video device: ", videoDevice), /* @__PURE__ */ import_react124.default.createElement("div", null, "resolution:", " ", resolution && `${resolution.width}x${resolution.height}`), /* @__PURE__ */ import_react124.default.createElement("div", null, "aspect ratio: ", aspectRatio == null ? void 0 : aspectRatio.toFixed(2)), /* @__PURE__ */ import_react124.default.createElement("div", null, "frame rate: ", frameRate), /* @__PURE__ */ import_react124.default.createElement("div", null, "audio device: ", audioDevice), /* @__PURE__ */ import_react124.default.createElement("div", null, "sample rate: ", sampleRate), /* @__PURE__ */ import_react124.default.createElement("div", null, "sample size: ", sampleSize), /* @__PURE__ */ import_react124.default.createElement("div", null, "ready state: ", readyState), /* @__PURE__ */ import_react124.default.createElement("div", null, "handler: ", currentHandler));
}

// node_modules/use-reducer-logger/srhfl.js
var import_react125 = require("react");
var logger = (reducer) => {
  const reducerWithLogger = (0, import_react125.useCallback)((state, action) => {
    const next2 = reducer(state, action);
    console.log("%cPrevious State:", "color: #9E9E9E; font-weight: 700;", state);
    console.log("%cAction:", "color: #00A7F7; font-weight: 700;", action);
    console.log("%cNext State:", "color: #47B04B; font-weight: 700;", next2);
    return next2;
  }, [reducer]);
  return reducerWithLogger;
};
var srhfl_default = logger;

// src/components/VideoRecorder/store/Actions.ts
var Actions_exports = {};
__export(Actions_exports, {
  addBlob: () => addBlob,
  addThumbnail: () => addThumbnail,
  createBlob: () => createBlob,
  init: () => init,
  loadExternalVideo: () => loadExternalVideo,
  removeLoadedVideo: () => removeLoadedVideo,
  setBlob: () => setBlob,
  setDeviceErrorStatus: () => setDeviceErrorStatus,
  setDuration: () => setDuration,
  setEndTime: () => setEndTime,
  setIsExternalVideo: () => setIsExternalVideo,
  setMediaStream: () => setMediaStream,
  setMetadata: () => setMetadata,
  setRecorder: () => setRecorder,
  setRecorderState: () => setRecorderState,
  setStartTime: () => setStartTime,
  setVideoSourceUrl: () => setVideoSourceUrl
});
var import_luxon6 = require("luxon");
var import_toolkit = require("@reduxjs/toolkit");
var import_toolkit2 = require("@reduxjs/toolkit");

// src/components/VideoRecorder/store/ActionTypes.ts
var ActionTypes_default = {
  RECORDER_INIT: "RECORDER_INIT",
  RECORDER_RECORDING_START: "RECORDER_RECORDING_START",
  RECORDER_RECORDING_END: "RECORDER_RECORDING_END",
  RECORDER_ADD_THUMBNAIL: "RECORDER_ADD_THUMBNAIL",
  RECORDER_SET_BLOB: "RECORDER_SET_BLOB",
  RECORDER_ADD_BLOB: "RECORDER_ADD_BLOB",
  RECORDER_SET_MEDIA_STREAM: "RECORDER_SET_MEDIA_STREAM",
  RECORDER_SET_RECORDER: "RECORDER_SET_RECORDER",
  RECORDER_SET_IS_EXTERNAL_VIDEO: "RECORDER_SET_IS_EXTERNAL_VIDEO",
  RECORDER_SET_DURATION: "RECORDER_SET_DURATION",
  RECORDER_SET_VIDEO_SOURCE_URL: "RECORDER_SET_VIDEO_SOURCE_URL",
  RECORDER_SET_DEVICE_ERROR_STATUS: "RECORDER_SET_DEVICE_ERROR_STATUS",
  RECORDER_SET_RECORDER_STATE: "RECORDER_SET_RECORDER_STATE",
  RECORDER_SET_METADATA: "RECORDER_SET_METADATA"
};

// src/components/VideoRecorder/RecorderState.ts
var RecorderState = /* @__PURE__ */ ((RecorderState2) => {
  RecorderState2["WaitingForDevices"] = "waiting_for_devices";
  RecorderState2["GenerateThumbnails"] = "generate_thumbnails";
  RecorderState2["Counting"] = "counting";
  RecorderState2["Init"] = "init";
  RecorderState2["Loading"] = "loading";
  RecorderState2["Idle"] = "idle";
  RecorderState2["Starting"] = "starting";
  RecorderState2["Recording"] = "recording";
  RecorderState2["Finishing"] = "finishing";
  RecorderState2["Complete"] = "complete";
  RecorderState2["Playing"] = "playing";
  return RecorderState2;
})(RecorderState || {});
var RecorderState_default = RecorderState;

// src/components/VideoRecorder/store/Actions.ts
var import_once = __toESM(require_once());
var setStartTime = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_RECORDING_START
);
var setEndTime = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_RECORDING_END
);
var init = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_INIT
);
var setBlob = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_BLOB
);
var addBlob = (0, import_toolkit2.createAction)(ActionTypes_default.RECORDER_ADD_BLOB);
var setMediaStream = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_MEDIA_STREAM
);
var setMetadata = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_METADATA
);
var setRecorder = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_RECORDER
);
var setIsExternalVideo = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_IS_EXTERNAL_VIDEO
);
var setDuration = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_DURATION
);
var setVideoSourceUrl = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_VIDEO_SOURCE_URL
);
var addThumbnail = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_ADD_THUMBNAIL
);
var loadExternalVideoAction = (0, import_toolkit2.createAction)(
  "RECORDER_LOAD_EXTERNAL_VIDEO"
);
var loadExternalVideo = (file) => (dispatch) => {
  dispatch(loadExternalVideoAction(file));
  const actions = (0, import_toolkit.bindActionCreators)(
    {
      setBlob,
      init,
      setStartTime,
      setEndTime,
      setRecorder,
      setIsExternalVideo,
      setDuration,
      setVideoSourceUrl
    },
    // eslint-disable-next-line
    dispatch
  );
  actions.init(RecorderState_default.Idle);
  actions.setBlob(file);
  actions.setVideoSourceUrl(null);
  actions.setIsExternalVideo(true);
  const video = document.createElement("video");
  video.muted = true;
  video.id = "external-video-loader";
  video.className = "v2-hidden";
  let interval = null;
  const handleSeeked = (0, import_once.default)(() => {
    interval && clearInterval(interval);
    const start = import_luxon6.DateTime.local();
    const end = start.plus({ seconds: video.duration });
    actions.setStartTime(start);
    actions.setEndTime(end);
    actions.setDuration(video.duration);
    URL.revokeObjectURL(video.src);
    video.removeEventListener("seeked", handleSeeked);
    document.body.removeChild(video);
  });
  interval = setInterval(() => {
    if (isFinite(video.duration)) {
      handleSeeked();
    }
  }, 250);
  const handleLoadedMetadata = () => {
    if (isFinite(video.duration)) {
      handleSeeked();
    } else {
      video.currentTime = 86400;
    }
    video.removeEventListener("loadedmetadata", handleLoadedMetadata);
  };
  video.addEventListener("seeked", handleSeeked);
  video.addEventListener("loadedmetadata", handleLoadedMetadata);
  document.body.appendChild(video);
  video.src = URL.createObjectURL(file);
};
var removeLoadedVideo = () => (dispatch) => {
  const actions = (0, import_toolkit.bindActionCreators)(
    {
      setBlob,
      setStartTime,
      setEndTime,
      setRecorder,
      setDuration,
      setVideoSourceUrl
    },
    // eslint-disable-next-line
    dispatch
  );
  actions.setBlob(null);
  actions.setRecorder(null);
  actions.setStartTime(null);
  actions.setEndTime(null);
  actions.setDuration(null);
  actions.setVideoSourceUrl(null);
};
var createBlob = () => (dispatch, getState) => {
  var _a;
  const blobs = getBlobs(getState());
  dispatch(setBlob(new Blob(blobs, { type: (_a = blobs[0]) == null ? void 0 : _a.type })));
};
var setDeviceErrorStatus = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_DEVICE_ERROR_STATUS
);
var setRecorderState = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_RECORDER_STATE
);

// src/components/VideoRecorder/store/index.ts
var import_toolkit3 = require("@reduxjs/toolkit");

// src/hook/use-thunk-reducer-hook.ts
var import_react126 = require("react");
function useThunkReducer(reducer, initialArg, init2 = (a) => a) {
  const [hookState, setHookState] = (0, import_react126.useState)(() => init2(initialArg));
  const state = (0, import_react126.useRef)(hookState);
  const getState = (0, import_react126.useCallback)(() => state.current, [state]);
  const setState = (0, import_react126.useCallback)((newState) => {
    state.current = newState;
    setHookState(newState);
  }, [state, setHookState]);
  const reduce = (0, import_react126.useCallback)((action) => {
    return reducer(getState(), action);
  }, [reducer, getState]);
  const dispatch = (0, import_react126.useCallback)((action) => {
    return typeof action === "function" ? action(dispatch, getState) : setState(reduce(action));
  }, [getState, setState, reduce]);
  return [hookState, dispatch];
}

// src/components/VideoRecorder/store/index.ts
var initialState = {
  recorderState: RecorderState_default.Init,
  startTime: null,
  endTime: null,
  thumbs: [],
  blob: null,
  blobs: [],
  recorder: null,
  mediaStream: null,
  isExternalVideo: false,
  duration: null,
  videoSourceUrl: null
};
var recorderReducer = (0, import_toolkit3.createReducer)(initialState, (builder) => {
  builder.addCase(init, (_, action) => {
    var _a;
    return __spreadProps(__spreadValues({}, initialState), {
      recorderState: (_a = action.payload) != null ? _a : initialState.recorderState
    });
  });
  builder.addCase(setStartTime, (state, action) => {
    state.startTime = action.payload;
    state.endTime = null;
  });
  builder.addCase(setEndTime, (state, action) => {
    state.endTime = action.payload;
  });
  builder.addCase(addThumbnail, (state, action) => {
    const thumb = action.payload;
    if (thumb.hash && state.thumbs.findIndex((t) => t.hash === thumb.hash) !== -1) {
      console.warn("VideoRecorder: found duplicate thumbnail hash", thumb.hash);
      return;
    }
    state.thumbs = [...state.thumbs, thumb];
  });
  builder.addCase(setBlob, (state, action) => {
    state.blob = action.payload;
  });
  builder.addCase(addBlob, (state, action) => {
    state.blobs.push(action.payload);
  });
  builder.addCase(setMediaStream, (state, action) => {
    var _a;
    state.mediaStream = (_a = action.payload) != null ? _a : null;
  });
  builder.addCase(setMetadata, (state, action) => {
    state.metadata = action.payload;
    const { duration } = action.payload;
    if (duration && isFinite(duration) && state.startTime) {
      state.endTime = state.startTime.plus({ seconds: duration });
    }
  });
  builder.addCase(setRecorder, (state, action) => {
    state.recorder = action.payload;
  });
  builder.addCase(setIsExternalVideo, (state, action) => {
    state.isExternalVideo = action.payload;
  });
  builder.addCase(setDuration, (state, action) => {
    state.duration = action.payload;
  });
  builder.addCase(setVideoSourceUrl, (state, action) => {
    state.videoSourceUrl = action.payload;
  });
  builder.addCase(setDeviceErrorStatus, (state, action) => {
    state.deviceErrorStatus = action.payload;
  });
  builder.addCase(setRecorderState, (state, action) => {
    state.recorderState = action.payload;
  });
});
var useRecorderReducer = () => {
  return useThunkReducer(
    srhfl_default(recorderReducer),
    initialState
  );
};

// src/components/VideoRecorder/MirrorControl.tsx
var import_react127 = __toESM(require("react"));
var import_classnames82 = __toESM(require("classnames"));
function MirrorControl({
  mirrored,
  onMirror,
  className
}) {
  return /* @__PURE__ */ import_react127.default.createElement(
    "div",
    {
      className: (0, import_classnames82.default)(
        "v2-rounded-full v2-flex v2-gap-1 v2-text-white v2-h-8 v2-px-3 v2-items-center v2-cursor-pointer",
        {
          "v2-bg-black/20 hover:v2-bg-black/70": mirrored,
          "v2-bg-black/70 hover:v2-bg-black/20": !mirrored
        },
        className
      ),
      onClick: onMirror
    },
    /* @__PURE__ */ import_react127.default.createElement(
      Image3,
      {
        imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/mirror.svg",
        className: (0, import_classnames82.default)("v2-h-5 v2-w-5 v2-text-white")
      }
    ),
    /* @__PURE__ */ import_react127.default.createElement("div", null, mirrored ? "Mirrored" : "Mirror")
  );
}

// src/components/VideoRecorder/TimerControl.tsx
var import_react128 = __toESM(require("react"));
var import_classnames83 = __toESM(require("classnames"));
function TimerControl({
  enable,
  onToggle,
  className
}) {
  return /* @__PURE__ */ import_react128.default.createElement(
    "div",
    {
      className: (0, import_classnames83.default)(
        "v2-rounded-full v2-flex v2-gap-1 v2-w-8 v2-h-8 v2-px-2 v2-items-center v2-cursor-pointer v2-ml-auto",
        {
          "v2-bg-black/20 v2-text-white hover:v2-bg-black/70": !enable,
          "v2-bg-[#fbd001] v2-text-black ": enable
        },
        className
      ),
      onClick: onToggle
    },
    /* @__PURE__ */ import_react128.default.createElement(
      Image3,
      {
        imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/timer.svg",
        className: (0, import_classnames83.default)("v2-h-5 v2-w-5 v2-text-white")
      }
    )
  );
}

// src/components/VideoRecorder/CountdownTimer.tsx
var import_react129 = __toESM(require("react"));
var import_classnames84 = __toESM(require("classnames"));
function CountdownTimer({ time, className }) {
  return /* @__PURE__ */ import_react129.default.createElement(
    "div",
    {
      className: (0, import_classnames84.default)(
        "v2-absolute v2-inset-x-0 v2-inset-y-0 v2-m-auto v2-flex v2-flex-col v2-w-[100px] v2-h-fit",
        className
      )
    },
    /* @__PURE__ */ import_react129.default.createElement("div", { className: "v2-flex v2-flex-grow v2-z-20 v2-items-center v2-justify-center" }, /* @__PURE__ */ import_react129.default.createElement("div", { className: "v2-text-[200px] v2-text-white/50 v2-leading-[150px] v2-font-bold" }, time))
  );
}

// src/components/VideoRecorder/AudioIndicator.tsx
var import_react131 = __toESM(require("react"));
var import_classnames85 = __toESM(require("classnames"));

// src/components/VideoRecorder/volume-meter-processor.ts
var audioWorkletName = "volume-meter";
var volume_meter_processor_default = `if (globalThis.AudioWorkletProcessor) {
const SMOOTHING_FACTOR = 0.8;
const FRAME_PER_SECOND = 60;
const FRAME_INTERVAL = 1 / FRAME_PER_SECOND;

/**
 *  Measure microphone volume.
 *
 * @class VolumeMeter
 * @extends AudioWorkletProcessor
 */
class VolumeMeter extends AudioWorkletProcessor {
  constructor() {
    super();
    this._lastUpdate = currentTime;
    this._volume = 0;
  }

  calculateRMS(inputChannelData) {
    // Calculate the squared-sum.
    let sum = 0;
    for (let i = 0; i < inputChannelData.length; i++) {
      sum += inputChannelData[i] * inputChannelData[i];
    }

    // Calculate the RMS level and update the volume.
    let rms = Math.sqrt(sum / inputChannelData.length);
    this._volume = Math.max(rms, this._volume * SMOOTHING_FACTOR);
  }

  process(inputs, outputs) {
    // This example only handles mono channel.
    const inputChannelData = inputs[0][0];

    // Post a message to the node every 16ms.
    if (currentTime - this._lastUpdate > FRAME_INTERVAL) {
      this.calculateRMS(inputChannelData);
      this.port.postMessage(this._volume * 1000);
      this._lastUpdate = currentTime;
    }

    return true;
  }
}

registerProcessor('${audioWorkletName}', VolumeMeter);
}`;

// src/components/VideoRecorder/hooks/use-has-audio.ts
var import_react130 = require("react");
function useHasAudio(mediaStream) {
  const [hasAudio, setHasAudio] = (0, import_react130.useState)(true);
  (0, import_react130.useEffect)(() => {
    const intervalId = setInterval(() => {
      if (!mediaStream)
        return;
      if (!mediaStream.getAudioTracks().length) {
        setHasAudio(false);
        return;
      }
      setHasAudio(mediaStream.getAudioTracks()[0].readyState == "live");
    }, 500);
    return () => clearInterval(intervalId);
  }, [mediaStream]);
  return hasAudio;
}

// src/components/VideoRecorder/AudioIndicator.tsx
var AUDIO_LEVEL_COLORS_CLASSNAME = [
  "v2-bg-blue-100",
  "v2-bg-blue-100",
  "v2-bg-blue-200",
  "v2-bg-blue-200",
  "v2-bg-blue-400",
  "v2-bg-blue-400",
  "v2-bg-blue-500",
  "v2-bg-blue-500",
  "v2-bg-blue-600",
  "v2-bg-blue-600",
  "v2-bg-blue-700",
  "v2-bg-blue-700"
];
var AUDIO_TOGGLE_CLASSNAME = "v2-h-5 v2-w-5 v2-text-white";
var SOUND_CHECK_IN_SECONDS = 5;
var RUN_SOUND_CHECK_IN_MILLISECONDS = 500;
function AudioIndicator({
  className,
  mediaStream,
  isRecording: isRecording2,
  onHasAudioChange
}) {
  const [showAudioIndicator, setShowAudioIndicator] = (0, import_react131.useState)(true);
  const [audioContext, setAudioContext] = (0, import_react131.useState)();
  const [volume, setVolume] = (0, import_react131.useState)(0);
  const [hasAudio, setHasAudio] = (0, import_react131.useState)(true);
  const [stopAudioCheckInterval, setStopAudioCheckInterval] = (0, import_react131.useState)(false);
  const hasAudioTrack = useHasAudio(mediaStream);
  const [soundCheckMilliSeconds, setSoundCheckMilliSeconds] = (0, import_react131.useState)(0);
  (0, import_react131.useEffect)(() => {
    if (!hasAudioTrack) {
      setHasAudio(false);
    }
  }, [hasAudioTrack]);
  (0, import_react131.useEffect)(() => {
    if (hasAudio && stopAudioCheckInterval)
      return;
    if (volume) {
      setStopAudioCheckInterval(true);
      setHasAudio(true);
    }
  }, [volume]);
  (0, import_react131.useEffect)(() => {
    onHasAudioChange == null ? void 0 : onHasAudioChange(hasAudio);
  }, [hasAudio]);
  (0, import_react131.useEffect)(() => {
    setSoundCheckMilliSeconds(0);
  }, [mediaStream]);
  (0, import_react131.useEffect)(() => {
    if (!isRecording2)
      return;
    if (soundCheckMilliSeconds / 1e3 >= SOUND_CHECK_IN_SECONDS)
      return;
    const intervalId = setInterval(() => {
      if (stopAudioCheckInterval) {
        clearInterval(intervalId);
        return;
      }
      const nextSoundCheckMilliSeconds = soundCheckMilliSeconds + RUN_SOUND_CHECK_IN_MILLISECONDS;
      setSoundCheckMilliSeconds(nextSoundCheckMilliSeconds);
      if (nextSoundCheckMilliSeconds / 1e3 >= SOUND_CHECK_IN_SECONDS) {
        setHasAudio(false);
        clearInterval(intervalId);
        return;
      }
    }, RUN_SOUND_CHECK_IN_MILLISECONDS);
    return () => clearInterval(intervalId);
  }, [isRecording2, stopAudioCheckInterval, soundCheckMilliSeconds]);
  const startAudio = (context) => __async(this, null, function* () {
    if (!mediaStream)
      return;
    yield context.audioWorklet.addModule(
      URL.createObjectURL(
        new Blob([volume_meter_processor_default], { type: "text/javascript" })
      )
    );
    const micNode = context.createMediaStreamSource(mediaStream);
    const volumeMeterNode = new AudioWorkletNode(context, audioWorkletName);
    volumeMeterNode.port.onmessage = ({ data }) => {
      setVolume(Math.round(data / 10));
    };
    micNode.connect(volumeMeterNode).connect(context.destination);
  });
  const startAudioContext = () => {
    const audioContext2 = new AudioContext();
    void startAudio(audioContext2);
    setAudioContext(audioContext2);
  };
  const toggleAudio = () => {
    if (showAudioIndicator && audioContext) {
      void audioContext.close();
    } else {
      startAudioContext();
    }
    const newShowIndicator = !showAudioIndicator;
    void rememberSettings({
      showAudioIndicator: newShowIndicator
    });
    setShowAudioIndicator(newShowIndicator);
  };
  const startAudioIndicator = () => __async(this, null, function* () {
    if (audioContext) {
      yield audioContext.close();
    }
    const showAudioIndicatorState = showAudioIndicator;
    const showAudioIndicatorLocal = yield getSettings().then((settings) => {
      if (!settings)
        return null;
      const { showAudioIndicator: showAudioIndicator2 = null } = settings;
      setShowAudioIndicator(showAudioIndicator2 != null ? showAudioIndicator2 : false);
      return showAudioIndicator2;
    });
    if ((showAudioIndicatorLocal || showAudioIndicatorLocal == null) && showAudioIndicatorState) {
      startAudioContext();
    }
  });
  const resetChecker = () => {
    setStopAudioCheckInterval(false);
    setHasAudio(true);
  };
  (0, import_react131.useEffect)(() => {
    if (mediaStream) {
      void startAudioIndicator();
      resetChecker();
    }
  }, [mediaStream]);
  return /* @__PURE__ */ import_react131.default.createElement(
    "div",
    {
      className: (0, import_classnames85.default)("v2-relative v2-flex v2-justify-center v2-z-20", className)
    },
    showAudioIndicator && /* @__PURE__ */ import_react131.default.createElement("div", { className: "v2-flex v2-absolute v2-flex-col-reverse v2-justify-center v2-h-[102px] v2-bottom-10 v2-px-1 v2-py-2.5 v2-gap-y-0.5 v2-overflow-hidden v2-items-center v2-rounded-full v2-bg-black/50 v2-w-5" }, hasAudio && AUDIO_LEVEL_COLORS_CLASSNAME.map((color, index) => {
      return /* @__PURE__ */ import_react131.default.createElement(
        "div",
        {
          key: index,
          className: (0, import_classnames85.default)(
            "v2-flex  v2-rounded-full v2-h-[5px] v2-w-2.5",
            {
              [color]: index + 1 <= volume,
              "v2-bg-neutral-50": index + 1 > volume
            }
          )
        }
      );
    }), !hasAudio && /* @__PURE__ */ import_react131.default.createElement(
      Image3,
      {
        imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/warning.svg",
        className: "v2-bg-yellow-500 v2-h-4 v2-w-3.5",
        hideWhiteBackground: true
      }
    )),
    /* @__PURE__ */ import_react131.default.createElement(
      "div",
      {
        className: (0, import_classnames85.default)(
          "v2-bg-black/20 v2-group hover:v2-bg-black/70 v2-rounded-full v2-flex v2-gap-1 v2-w-8 v2-h-8 v2-items-center v2-px-2 v2-justify-center v2-cursor-pointer",
          {
            "v2-bg-black/70": showAudioIndicator
          }
        ),
        onClick: toggleAudio
      },
      /* @__PURE__ */ import_react131.default.createElement(
        Image3,
        {
          imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/mic.svg",
          className: (0, import_classnames85.default)(AUDIO_TOGGLE_CLASSNAME, {
            "group-hover:v2-hidden": showAudioIndicator
          })
        }
      ),
      /* @__PURE__ */ import_react131.default.createElement(
        Image3,
        {
          imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/close.svg",
          className: (0, import_classnames85.default)(AUDIO_TOGGLE_CLASSNAME, "v2-hidden", {
            "group-hover:v2-flex": showAudioIndicator
          })
        }
      )
    )
  );
}

// src/components/VideoRecorder/NoAudioWarning.tsx
var import_react132 = __toESM(require("react"));
function NoAudioWarning({ onCtaClick }) {
  return /* @__PURE__ */ import_react132.default.createElement("div", { className: "v2-absolute v2-bg-white v2-flex v2-flex-col v2-z-50 v2-rounded v2-inset-0 v2-m-auto v2-w-80 v2-justify-center v2-h-52 v2-items-center v2-text-center v2-space-y-4" }, /* @__PURE__ */ import_react132.default.createElement(
    Image3,
    {
      imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/warning.svg",
      className: "v2-bg-yellow-500 v2-h-12 v2-w-11",
      hideWhiteBackground: true
    }
  ), /* @__PURE__ */ import_react132.default.createElement("div", { className: "v2-flex v2-text-lg v2-flex-col v2-text-black" }, /* @__PURE__ */ import_react132.default.createElement("span", null, "We are not detecting any sound."), /* @__PURE__ */ import_react132.default.createElement("span", null, "Please check your mic setup.")), /* @__PURE__ */ import_react132.default.createElement(
    Button,
    {
      variant: "primary" /* Primary */,
      shape: "round" /* Round */,
      onClick: onCtaClick
    },
    "Ok"
  ));
}

// src/components/VideoRecorder/VideoPane.tsx
var LoadingContainer = import_styled11.default.div`
  font-size: 50px;
  width: 50px;
  height: 50px;
  color: #f2f2f2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
var videoActions = css`
  display: flex;
  position: absolute;
  padding: 20px;
  text-align: center;
  height: auto;
`;
var VideoActionsBottom = import_styled11.default.div`
  ${videoActions}
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(37, 37, 37, 0.81));
`;
var VideoActionsTop = import_styled11.default.div`
  ${videoActions}
  top: 0;
  left: 0;
  right: 0;
`;
var Settings2 = import_styled11.default.div``;
var animationFrame;
function VideoPane({
  videoRef,
  videoProps,
  onResetClick,
  onStartClick,
  onStopClick,
  onSettingsClick,
  onSettingsClose,
  recorderState,
  hideVideoButtons = false,
  resetButton,
  alignResetButtonToRight = false,
  className,
  currentHandler,
  startTime,
  endTime,
  debug,
  isCountdownEnabled = true,
  onToggleCountdownTimer = () => void 0,
  countdown = 3,
  mirrored = true,
  onToggleMirror = () => void 0,
  canvasRef,
  hideCountdownTimer,
  hideMirror,
  hideAudioIndicator,
  mirrorClassName,
  countdownTimerClassName,
  audioIndicatorClassName
}) {
  var _a;
  const [showSettings, setShowSettings] = (0, import_react134.useState)(false);
  const ctx = (_a = canvasRef == null ? void 0 : canvasRef.current) == null ? void 0 : _a.getContext("2d");
  const [closeAudioModal, setCloseAudioModal] = (0, import_react134.useState)(false);
  const [hasAudio, setHasAudio] = (0, import_react134.useState)(true);
  const isComplete2 = (0, import_react134.useMemo)(
    () => recorderState === RecorderState_default.Complete,
    [recorderState]
  );
  const isRecording2 = (0, import_react134.useMemo)(
    () => recorderState === RecorderState_default.Recording,
    [recorderState]
  );
  const isPlaying = (0, import_react134.useMemo)(
    () => recorderState === RecorderState_default.Playing,
    [recorderState]
  );
  const isLoading = (0, import_react134.useMemo)(
    () => [
      RecorderState_default.Loading,
      RecorderState_default.Finishing,
      RecorderState_default.GenerateThumbnails,
      RecorderState_default.WaitingForDevices
    ].includes(recorderState),
    [recorderState]
  );
  const muted = (0, import_react134.useMemo)(() => {
    if (isRecording2) {
      return true;
    }
    return !isPlaying;
  }, [isPlaying, isRecording2]);
  function handleSettingsClick() {
    onSettingsClick == null ? void 0 : onSettingsClick();
    setShowSettings(true);
  }
  function handleOnSettingsClose(videoDevice, audioDevice) {
    onSettingsClose == null ? void 0 : onSettingsClose(videoDevice, audioDevice);
    setShowSettings(false);
  }
  const containerClassName = [
    "v2-w-full v2-h-full",
    "v2-relative v2-overflow-hidden",
    "v2-rounded",
    "v2-bg-neutral-900"
  ];
  function draw() {
    if (!videoRef.current || !(canvasRef == null ? void 0 : canvasRef.current) || !ctx)
      return;
    if (recorderState !== RecorderState_default.Idle && recorderState !== RecorderState_default.Recording && recorderState !== RecorderState_default.Counting)
      return;
    const sx = 0;
    const sy = 0;
    const sw = videoRef.current.videoWidth;
    const sh = videoRef.current.videoHeight;
    const tw = canvasRef.current.width;
    const th = canvasRef.current.height;
    ctx.scale(-1, 1);
    if (mirrored) {
      const tx = -canvasRef.current.width;
      const ty = 0;
      ctx.drawImage(videoRef.current, sx, sy, sw, sh, tx, ty, tw, th);
    } else {
      ctx.drawImage(videoRef.current, sx, sy, sw, sh, 0, 0, tw, th);
    }
    animationFrame = requestAnimationFrame(draw);
  }
  (0, import_react134.useEffect)(() => {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }
    if (!ctx || !videoRef.current || !(canvasRef == null ? void 0 : canvasRef.current))
      return;
    draw();
  }, [mirrored, ctx, recorderState, canvasRef, videoRef]);
  (0, import_react134.useEffect)(() => {
    setCloseAudioModal(false);
    setHasAudio(true);
  }, [videoProps.mediaStream]);
  return /* @__PURE__ */ import_react134.default.createElement("div", { className: (0, import_classnames86.default)("recorder-video", containerClassName, className) }, !hasAudio && !isLoading && !closeAudioModal && /* @__PURE__ */ import_react134.default.createElement(NoAudioWarning, { onCtaClick: () => setCloseAudioModal(true) }), /* @__PURE__ */ import_react134.default.createElement("div", { className: "video-inner v2-h-full v2-w-full v2-relative v2-z-10" }, /* @__PURE__ */ import_react134.default.createElement(
    Video,
    __spreadProps(__spreadValues({
      videoRef,
      canvasRef
    }, videoProps), {
      muted
    })
  )), debug && /* @__PURE__ */ import_react134.default.createElement(
    VideoDebug,
    {
      currentHandler,
      recorderState,
      stream: videoProps.mediaStream,
      videoRef
    }
  ), showSettings && /* @__PURE__ */ import_react134.default.createElement(Settings, { onClose: handleOnSettingsClose }), isLoading && /* @__PURE__ */ import_react134.default.createElement(LoadingContainer, { className: "v2-z-40" }, /* @__PURE__ */ import_react134.default.createElement(import_react_fontawesome19.FontAwesomeIcon, { icon: faSpinner2, className: "v2-animate-spin" })), /* @__PURE__ */ import_react134.default.createElement(
    VideoActionsTop,
    {
      className: (0, import_classnames86.default)("v2-z-20", { hidden: hideVideoButtons || isLoading })
    },
    !hideMirror && /* @__PURE__ */ import_react134.default.createElement(
      MirrorControl,
      {
        mirrored,
        onMirror: onToggleMirror,
        className: (0, import_classnames86.default)(
          {
            "v2-hidden": recorderState !== RecorderState_default.Idle
          },
          mirrorClassName
        )
      }
    ),
    !hideCountdownTimer && /* @__PURE__ */ import_react134.default.createElement(
      TimerControl,
      {
        enable: isCountdownEnabled,
        onToggle: onToggleCountdownTimer,
        className: (0, import_classnames86.default)(countdownTimerClassName, {
          "v2-hidden": recorderState !== RecorderState_default.Idle
        })
      }
    ),
    /* @__PURE__ */ import_react134.default.createElement(
      "div",
      {
        className: (0, import_classnames86.default)({
          "v2-hidden": isRecording2 || !isComplete2,
          "v2-ml-auto": alignResetButtonToRight
        })
      },
      resetButton != null ? resetButton : /* @__PURE__ */ import_react134.default.createElement(
        "img",
        {
          className: "v2-cursor-pointer",
          src: assetUrl("video-recorder/ic_undo.svg"),
          onClick: onResetClick
        }
      )
    )
  ), isCountdownEnabled && !hideCountdownTimer && /* @__PURE__ */ import_react134.default.createElement(
    CountdownTimer,
    {
      time: countdown,
      className: (0, import_classnames86.default)("v2-hidden", {
        "!v2-flex": recorderState == RecorderState_default.Idle || recorderState == RecorderState_default.Counting
      })
    }
  ), /* @__PURE__ */ import_react134.default.createElement(
    VideoActionsBottom,
    {
      className: (0, import_classnames86.default)("v2-justify-between v2-items-end", {
        hidden: hideVideoButtons
      })
    },
    /* @__PURE__ */ import_react134.default.createElement("div", { className: "v2-flex v2-flex-col v2-space-y-2" }, !hideAudioIndicator && /* @__PURE__ */ import_react134.default.createElement(
      AudioIndicator,
      {
        mediaStream: videoProps.mediaStream,
        className: (0, import_classnames86.default)(audioIndicatorClassName, "v2-hidden", {
          "!v2-flex": recorderState == RecorderState_default.Idle || recorderState == RecorderState_default.Counting || recorderState == RecorderState_default.Recording
        }),
        onHasAudioChange: (hasAudio2) => setHasAudio(hasAudio2),
        isRecording: isRecording2
      }
    ), /* @__PURE__ */ import_react134.default.createElement(Settings2, { className: (0, import_classnames86.default)("v2-z-50") }, /* @__PURE__ */ import_react134.default.createElement(
      "div",
      {
        className: (0, import_classnames86.default)(
          "v2-bg-black/20 hover:v2-bg-black/70 v2-rounded-full v2-flex v2-gap-1 v2-w-8 v2-h-8 v2-items-center v2-px-2 v2-justify-center v2-cursor-pointer",
          {
            hidden: showSettings || ![RecorderState_default.Idle, RecorderState_default.Loading].includes(
              recorderState
            )
          }
        )
      },
      /* @__PURE__ */ import_react134.default.createElement(
        "img",
        {
          role: "button",
          src: assetUrl("video-recorder/ic_gear.svg"),
          onClick: handleSettingsClick,
          className: "v2-cursor-pointer v2-h-5 v2-w-5"
        }
      )
    ))),
    /* @__PURE__ */ import_react134.default.createElement(Timer_default, { className: "v2-z-20", startTime, endTime })
  ), /* @__PURE__ */ import_react134.default.createElement(VideoActionsBottom, { className: "v2-justify-center" }, /* @__PURE__ */ import_react134.default.createElement(
    StartStop_default,
    {
      className: (0, import_classnames86.default)("v2-w-12 v2-h-12 v2-z-20", {
        "v2-hidden": isLoading || recorderState == RecorderState_default.Counting
      }),
      isPlaying: isRecording2 || isPlaying,
      isComplete: isComplete2,
      onStartClick,
      onStopClick
    }
  )));
}

// src/components/VideoRecorder/hooks/use-handlers.tsx
var import_react136 = require("react");

// src/components/VideoRecorder/hooks/use-msr-handlers.tsx
var import_luxon7 = require("luxon");

// src/components/VideoRecorder/store/utils.ts
function getMetadata2(stream, devices) {
  return __async(this, null, function* () {
    var _a, _b;
    const videoSettings = (_a = stream == null ? void 0 : stream.getVideoTracks()[0]) == null ? void 0 : _a.getSettings();
    const audioSettings = (_b = stream == null ? void 0 : stream.getAudioTracks()[0]) == null ? void 0 : _b.getSettings();
    devices != null ? devices : devices = yield getDevices();
    const metadata = {};
    if (videoSettings) {
      metadata.video = {
        resolution: {
          width: videoSettings.width,
          height: videoSettings.height
        },
        frameRate: videoSettings.frameRate,
        aspectRatio: videoSettings.aspectRatio,
        device: getDeviceName(videoSettings.deviceId, devices)
      };
    }
    if (audioSettings) {
      metadata.audio = {
        device: getDeviceName(audioSettings.deviceId, devices),
        channels: audioSettings.channelCount,
        latency: audioSettings.latency,
        sampleRate: audioSettings.sampleRate,
        sampleSize: audioSettings.sampleSize
      };
    }
    return metadata;
  });
}

// src/components/VideoRecorder/support/userMedia.ts
var import_pick = __toESM(require_pick());
var import_stop_media_stream = __toESM(require_stop_media_stream());
var EVENT_GET_USER_MEDIA_SUCCESS = "getusermedia:success";
var EVENT_GET_USER_MEDIA_ERROR = "getusermedia:error";
var GetUserMediaSuccess = class {
  static create(stream) {
    const event = new Event(
      EVENT_GET_USER_MEDIA_SUCCESS
    );
    event.stream = stream;
    return event;
  }
};
var GetUserMediaError = class {
  static create(error) {
    const event = new Event(EVENT_GET_USER_MEDIA_ERROR);
    event.error = error;
    return event;
  }
};
function resolveGetUserMedia() {
  const getUserMedia2 = (constraints, successCallback, errorCallback) => {
    var _a, _b;
    let fn = void 0;
    fn = (_b = (_a = navigator.webkitGetUserMedia) != null ? _a : navigator.mozGetUserMedia) != null ? _b : navigator.msGetUserMedia;
    if (!fn) {
      fn = (constraints2, successCallback2, errorCallback2) => {
        navigator.mediaDevices.getUserMedia(constraints2).then(successCallback2).catch(errorCallback2);
      };
    }
    return fn.call(navigator, constraints, successCallback, errorCallback);
  };
  return getUserMedia2;
}
var getUserMedia = resolveGetUserMedia();
function getUserMediaAsync(constraints) {
  return new Promise((resolve, reject) => {
    getUserMedia(
      constraints,
      (stream) => {
        window.dispatchEvent(GetUserMediaSuccess.create(stream));
        resolve(stream);
      },
      (error) => {
        window.dispatchEvent(GetUserMediaError.create(error));
        reject(error);
      }
    );
  });
}
function transformMediaConstraints(constraints) {
  return __async(this, null, function* () {
    const stream = yield getUserMediaAsync(constraints);
    const newConstraints = constraints;
    if (constraints.video && typeof constraints.video !== "boolean") {
      const video = document.createElement("video");
      const videoTrack = stream.getVideoTracks()[0];
      const htmlVideo = yield new Promise(
        (resolve) => {
          video.muted = true;
          video.id = "transform-media-constraints";
          video.className = "v2-hidden";
          document.body.appendChild(video);
          video.srcObject = stream;
          video.onloadedmetadata = () => {
            resolve({
              width: video.videoWidth,
              height: video.videoHeight
            });
            video.onloadedmetadata = null;
            document.body.removeChild(video);
          };
          void video.play().catch((e) => {
            console.log(e);
          });
        }
      );
      const trackSettings = (0, import_pick.default)(videoTrack.getSettings(), ["width", "height"]);
      if (htmlVideo.width === trackSettings.height && htmlVideo.height === trackSettings.width) {
        const videoConstraints = constraints.video;
        const temp = videoConstraints.width;
        videoConstraints.width = videoConstraints.height;
        videoConstraints.height = temp;
        newConstraints.video = videoConstraints;
      }
    }
    (0, import_stop_media_stream.default)(stream);
    return newConstraints;
  });
}
function hasUserMediaPermission() {
  return __async(this, arguments, function* (flags = 3 /* Both */) {
    const stream = yield getUserMediaAsync({
      video: (flags & 1 /* Video */) > 0,
      audio: (flags & 2 /* Audio */) > 0
    });
    const hasPermission = stream != null;
    (0, import_stop_media_stream.default)(stream);
    return hasPermission;
  });
}

// src/components/VideoRecorder/hooks/use-msr-handlers.tsx
function useMsrHandlers() {
  const handlers = {
    [RecorderState_default.Loading]: {
      onEnter: (_0) => __async(this, [_0], function* ({
        video,
        setMediaStream: setMediaStream2,
        setMetadata: setMetadata2,
        setRecorderState: setRecorderState2,
        userMediaConstraints,
        isExternalVideo
      }) {
        if (isExternalVideo)
          return;
        if (userMediaConstraints == null) {
          setRecorderState2(RecorderState_default.WaitingForDevices);
          return;
        }
        const constraints = yield transformMediaConstraints(
          userMediaConstraints
        );
        const stream = yield getUserMediaAsync(constraints);
        const metadata = yield getMetadata2(stream);
        setMetadata2(metadata);
        setMediaStream2(stream);
        const timeout = setTimeout(() => {
          var _a;
          if (((_a = video.current) == null ? void 0 : _a.readyState) === 0) {
            setRecorderState2(RecorderState_default.Init);
          }
        }, 3e3);
        if (video.current) {
          video.current.oncanplay = () => {
            if (video.current && video.current.readyState !== 0) {
              clearTimeout(timeout);
            }
            setRecorderState2(RecorderState_default.Idle);
          };
        }
      })
    },
    [RecorderState_default.Recording]: {
      onEnter: ({
        addBlob: addBlob2,
        createBlob: createBlob2,
        mimeType,
        video,
        setStartTime: setStartTime2,
        setRecorder: setRecorder2,
        quality,
        metadata,
        stream
      }) => {
        if (!stream)
          return;
        const options2 = getMediaRecorderOptions({
          quality,
          mimeType,
          metadata
        });
        const recorder = new MediaRecorder(stream, options2);
        recorder.addEventListener("dataavailable", (blobEvent) => {
          if (blobEvent.data.size > 0) {
            addBlob2(blobEvent.data);
          }
        });
        recorder.addEventListener("stop", () => {
          createBlob2();
        });
        if (video.current) {
          video.current.muted = true;
          video.current.volume = 0;
        }
        recorder.start(5e3);
        setStartTime2(import_luxon7.DateTime.local());
        setRecorder2(recorder);
      },
      handleStopClick: ({ recorder, setEndTime: setEndTime2, setRecorderState: setRecorderState2 }) => {
        recorder == null ? void 0 : recorder.stop();
        setEndTime2(import_luxon7.DateTime.local());
        setRecorderState2(RecorderState_default.GenerateThumbnails);
      }
    }
  };
  return handlers;
}

// src/components/VideoRecorder/hooks/use-thumbnail-renderer.ts
var import_luxon8 = require("luxon");
var import_react135 = require("react");

// src/utils/crypto.ts
function digestMessage(message, algorithm, encoder) {
  return __async(this, null, function* () {
    encoder != null ? encoder : encoder = new TextEncoder();
    algorithm != null ? algorithm : algorithm = "sha-1";
    const data = encoder.encode(message);
    const hash2 = yield crypto.subtle.digest(algorithm, data);
    return Array.from(new Uint8Array(hash2)).map((b) => b.toString(16)).join("");
  });
}
function sha1(message, encoder) {
  return digestMessage(message, "sha-1", encoder);
}

// src/components/VideoRecorder/hooks/use-thumbnail-renderer.ts
function compressedDataUrl(canvas) {
  return canvas.toDataURL("image/jpeg", 0.5);
}
function useThumbnailRenderer({
  videoRef,
  onComplete,
  interval,
  renderImmediately
}) {
  const squareCanvas = (0, import_react135.useRef)(document.createElement("canvas"));
  const originalCanvas = (0, import_react135.useRef)(document.createElement("canvas"));
  const smallCanvas = (0, import_react135.useRef)(document.createElement("canvas"));
  const [live, setLive] = (0, import_react135.useState)(false);
  const isCanvasTransparent = (x, y, context) => {
    return (context == null ? void 0 : context.getImageData(x, y, 1, 1).data[3]) === 0;
  };
  const drawThumbnailOnCanvas = (video, canvas, startXCoordinate, startYCoordinate, imageWidth, imageHeight) => {
    canvas.width = imageWidth;
    canvas.height = imageHeight;
    const ctx = canvas.getContext("2d", {
      willReadFrequently: true
    });
    ctx == null ? void 0 : ctx.drawImage(
      video,
      // center crop on x-axis if landscape
      startXCoordinate,
      // center crop on y-axis if portrait
      startYCoordinate,
      imageWidth,
      imageHeight,
      0,
      0,
      imageWidth,
      imageHeight
    );
    if (isCanvasTransparent(startXCoordinate, startYCoordinate, ctx))
      return null;
    return canvas;
  };
  const renderThumbnail = (0, import_react135.useCallback)(() => __async(this, null, function* () {
    var _a;
    if (!videoRef.current)
      return;
    const video = videoRef.current;
    const clientWidth = video.videoWidth;
    const clientHeight = video.videoHeight;
    const isLandscape = clientWidth > clientHeight;
    const xAxis = isLandscape ? (clientWidth - clientHeight) / 2 : 0;
    const yAxis = !isLandscape ? (clientHeight - clientWidth) / 2 : 0;
    const oSize = Math.min(clientWidth, clientHeight) || 450;
    const squareThumb = drawThumbnailOnCanvas(
      video,
      squareCanvas.current,
      xAxis,
      yAxis,
      oSize,
      oSize
    );
    const originalThumb = drawThumbnailOnCanvas(
      video,
      originalCanvas.current,
      0,
      0,
      clientWidth,
      clientHeight
    );
    if (!squareThumb || !originalThumb)
      return;
    const time = isFinite(video.currentTime) ? import_luxon8.Duration.fromObject({ seconds: video.currentTime }) : import_luxon8.DateTime.local();
    const thumbCanvas = smallCanvas.current;
    const thumbSize = 150;
    thumbCanvas.width = thumbCanvas.height = thumbSize;
    (_a = thumbCanvas.getContext("2d", {
      willReadFrequently: true
    })) == null ? void 0 : _a.drawImage(squareThumb, 0, 0, thumbSize, thumbSize);
    const thumbnail = {
      original: {
        data: compressedDataUrl(originalCanvas.current),
        height: clientHeight,
        width: clientWidth
      },
      square: {
        data: compressedDataUrl(squareCanvas.current),
        height: oSize,
        width: oSize
      },
      small: {
        data: compressedDataUrl(thumbCanvas),
        height: thumbSize,
        width: thumbSize
      },
      time
    };
    try {
      thumbnail.hash = yield sha1(thumbnail.original.data);
    } catch (e) {
    }
    onComplete == null ? void 0 : onComplete(thumbnail);
  }), [videoRef]);
  const [intervalId, setIntervalId] = (0, import_react135.useState)();
  const start = () => {
    if (renderImmediately != null ? renderImmediately : true) {
      void renderThumbnail();
    }
    setLive(true);
  };
  (0, import_react135.useEffect)(() => {
    if (live) {
      setIntervalId(
        setInterval(() => {
          void renderThumbnail();
        }, interval != null ? interval : 5e3)
      );
    } else {
      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  }, [live]);
  return {
    renderThumbnail,
    startRenderingThumbnails: start,
    stopRenderingThumbnails: () => setLive(false)
  };
}

// src/utils/sleep.ts
function sleep(timeout) {
  return __async(this, null, function* () {
    return new Promise((resolve) => setTimeout(resolve, timeout));
  });
}
var sleep_default = sleep;

// src/components/VideoRecorder/hooks/use-handlers.tsx
var import_stop_media_stream2 = __toESM(require_stop_media_stream());
var import_react_i18next4 = require("react-i18next");

// src/components/VideoRecorder/support/utils.ts
var import_ceil = __toESM(require_ceil());
var import_clamp = __toESM(require_clamp());
var mediaStreamErrors = ["NotReadableError", "TrackStartError", "AbortError"];
function isMediaStreamError(err) {
  return typeof (err == null ? void 0 : err.name) === "string" && mediaStreamErrors.includes(err.name);
}
function getVideoDuration(video, fallback = 120) {
  return (0, import_ceil.default)(isFinite(video.duration) ? video.duration : fallback, 2);
}
function getVideoCurrentTime(video) {
  return (0, import_ceil.default)(video.currentTime, 2);
}
function seekVideoRelative({
  video,
  stepSeconds,
  max = getVideoDuration(video)
}) {
  video.currentTime = (0, import_clamp.default)(video.currentTime + stepSeconds, 0, max);
}
function endOfVideo(currentTime, lastTime, duration) {
  return lastTime === currentTime || currentTime >= duration;
}

// src/components/VideoRecorder/hooks/use-handlers.tsx
function useHandlers(options2) {
  const { t } = (0, import_react_i18next4.useTranslation)();
  const {
    video,
    setRecorderState: setRecorderState2,
    addThumbnail: addThumbnail2,
    setVideoReviewed,
    onUnsupportedVideoFormat
  } = options2;
  const { renderThumbnail } = useThumbnailRenderer({
    videoRef: video,
    onComplete: addThumbnail2,
    renderImmediately: true
  });
  const waitForMetadata = (0, import_react136.useCallback)(() => __async(this, null, function* () {
    if (!video.current)
      return;
    const timeout = 250;
    const maxWait = 5e3;
    let totalWait = 0;
    let { readyState } = video.current;
    while (readyState <= 0 && totalWait <= maxWait) {
      yield sleep_default(timeout);
      totalWait += timeout;
      readyState = video.current.readyState;
    }
  }), [video.current]);
  const handlers = {
    [RecorderState_default.GenerateThumbnails]: {
      onEnter: () => __async(this, null, function* () {
        if (!video.current)
          return;
        yield waitForMetadata();
        let lastCurrentTime = null;
        video.current.onseeked = () => __async(this, null, function* () {
          if (!video.current)
            return;
          yield renderThumbnail();
          const duration = getVideoDuration(video.current);
          seekVideoRelative({
            video: video.current,
            stepSeconds: 5,
            max: duration
          });
          const currentTime = getVideoCurrentTime(video.current);
          if (endOfVideo(currentTime, lastCurrentTime, duration)) {
            video.current.dispatchEvent(new Event("ended"));
          }
          lastCurrentTime = currentTime;
        });
        video.current.onended = () => __async(this, null, function* () {
          if (!video.current)
            return;
          yield renderThumbnail();
          video.current.onseeked = video.current.onended = null;
          setRecorderState2(RecorderState_default.Complete);
        });
        video.current.load();
        video.current.onloadedmetadata = () => __async(this, null, function* () {
          var _a;
          if (!video.current)
            return;
          const oSize = (_a = video.current.videoHeight) != null ? _a : video.current.videoWidth;
          if (!oSize) {
            (onUnsupportedVideoFormat != null ? onUnsupportedVideoFormat : alert)(
              t("videoRecorder:errors.unsupportedVideoFormat")
            );
            setRecorderState2(RecorderState_default.Complete);
          } else {
            yield renderThumbnail();
            setTimeout(() => {
              if (!video.current)
                return;
              video.current.currentTime = 0;
            }, 500);
            video.current.onloadedmetadata = null;
          }
        });
      })
    },
    [RecorderState_default.Init]: {
      onEnter: ({
        init: init2,
        stream,
        video: video2,
        setRecorderState: setRecorderState3,
        isDevicesLoading,
        isExternalVideo
      }) => {
        if (isExternalVideo)
          return;
        init2();
        if (stream) {
          (0, import_stop_media_stream2.default)(stream);
        }
        if (video2.current) {
          video2.current.src = "";
          video2.current.srcObject = null;
        }
        if (isDevicesLoading) {
          setRecorderState3(RecorderState_default.WaitingForDevices);
        } else {
          setRecorderState3(RecorderState_default.Loading);
        }
      }
    },
    [RecorderState_default.WaitingForDevices]: {
      onEnter: ({ setRecorderState: setRecorderState3 }) => {
        setTimeout(() => setRecorderState3(RecorderState_default.Init), 500);
      }
    },
    [RecorderState_default.Idle]: {
      onEnter: ({ stream, video: video2, isExternalVideo }) => {
        if (isExternalVideo)
          return;
        if (stream && !(stream == null ? void 0 : stream.active)) {
          setRecorderState2(RecorderState_default.Init);
          return;
        }
        if (video2.current) {
          void video2.current.play().catch((e) => {
            console.log(e);
          });
          video2.current.oncanplay = null;
          video2.current.muted = true;
        }
      },
      handleStartClick: ({ setRecorderState: setRecorderState3 }) => {
        setRecorderState3(RecorderState_default.Starting);
      }
    },
    [RecorderState_default.Starting]: {
      onEnter: ({ setRecorderState: setRecorderState3 }) => {
        setRecorderState3(RecorderState_default.Counting);
      }
    },
    [RecorderState_default.Playing]: {
      onEnter() {
        if (!video.current)
          return;
        video.current.muted = false;
        video.current.volume = 1;
        video.current.onended = video.current.onpause = () => setRecorderState2(RecorderState_default.Complete);
        if (video.current.readyState === 0) {
          video.current.load();
        }
        void video.current.play();
        setVideoReviewed(true);
      },
      handleStopClick() {
        var _a;
        (_a = video.current) == null ? void 0 : _a.pause();
        setRecorderState2(RecorderState_default.Complete);
      }
    },
    [RecorderState_default.Complete]: {
      onEnter() {
        if (!video.current)
          return;
        video.current.onended = video.current.onpause = video.current.onload = null;
        video.current.currentTime = 0;
        video.current.muted = true;
      },
      handleStartClick() {
        setRecorderState2(RecorderState_default.Playing);
      }
    },
    [RecorderState_default.Counting]: {
      onEnter: ({ setRecorderState: setRecorderState3, isCountdownEnabled, countdownTimer }) => {
        if (!isCountdownEnabled || countdownTimer === 1) {
          setRecorderState3(RecorderState_default.Recording);
        }
      }
    }
  };
  return (0, import_react136.useMemo)(
    () => __spreadProps(__spreadValues(__spreadValues({}, handlers), useMsrHandlers()), {
      currentHandler: "msr"
    }),
    [handlers]
  );
}

// src/components/VideoRecorder/support/browser.ts
var import_first2 = __toESM(require_first());
var import_memoize6 = __toESM(require_memoize());
var mimeTypes = {
  vp9: [
    "video/mp4;codecs=vp9",
    "video/webm;codecs=vp9,vorbis",
    "video/webm;codecs=vp9,opus",
    "video/webm;codecs=vp9,pcm",
    "video/webm;codecs=vp9"
  ],
  vp8: [
    "video/mp4;codecs=vp8",
    "video/webm;codecs=vp8,vorbis",
    "video/webm;codecs=vp8,opus",
    "video/webm;codecs=vp8,pcm",
    "video/webm;codecs=vp8"
  ],
  avc1: [
    "video/mp4;codecs=avc1,mp4a",
    "video/mp4;codecs=avc1",
    "video/webm;codecs=avc1,opus",
    "video/webm;codecs=avc1,pcm",
    "video/webm;codecs=avc1"
  ],
  default: ["video/mp4", "video/webm"]
};
var preferredMimeTypes = {
  ["high" /* High */]: [
    ...mimeTypes.vp8,
    ...mimeTypes.vp9,
    ...mimeTypes.avc1,
    ...mimeTypes.default
  ],
  ["medium" /* Medium */]: [
    ...mimeTypes.vp8,
    ...mimeTypes.vp9,
    ...mimeTypes.avc1,
    ...mimeTypes.default
  ],
  ["low" /* Low */]: [
    ...mimeTypes.vp8,
    ...mimeTypes.avc1,
    ...mimeTypes.default
  ]
};
var allMimeTypes = [
  ...mimeTypes.vp9,
  ...mimeTypes.vp8,
  ...mimeTypes.avc1,
  ...mimeTypes.default
];
function supportsRecording(mimeType) {
  var _a, _b, _c;
  return (_c = (_b = (_a = window.MediaRecorder) == null ? void 0 : _a.isTypeSupported) == null ? void 0 : _b.call(_a, mimeType)) != null ? _c : false;
}
var getSupportedMimeTypes = (0, import_memoize6.default)(
  (mimeTypes2 = allMimeTypes) => {
    return mimeTypes2.filter(supportsRecording);
  }
);
function getPreferredMimeType(quality) {
  const supportedMimeTypes = getSupportedMimeTypes(preferredMimeTypes[quality]);
  return (0, import_first2.default)(supportedMimeTypes);
}

// src/components/VideoRecorder/VideoRecorder.tsx
var VideoRecorder = import_react137.default.forwardRef(
  ({
    recorderState,
    setRecorderState: setRecorderState2,
    setSelectedTabIndex,
    hideVideoButtons = false,
    onSettingsClick,
    onSettingsClose,
    onResetClick,
    videoPaneClassName,
    resetButton,
    alignResetButtonToRight,
    debug,
    videoRef,
    onInit,
    hideMirror,
    hideCountdownTimer,
    hideAudioIndicator,
    mirrorClassName,
    countdownTimerClassName,
    audioIndicatorClassName
  }, ref) => {
    var _b, _c;
    const canvas = (0, import_react137.useRef)(null);
    const [countdownTimer, setCountdownTimer] = (0, import_react137.useState)(3);
    const [isCountdownEnabled, setIsCountdownEnabled] = (0, import_react137.useState)(true);
    const [intervalId, setIntervalId] = (0, import_react137.useState)();
    const [isMirrored, setIsMirrored] = (0, import_react137.useState)(true);
    (0, import_react137.useEffect)(() => {
      void getSettings().then((settings) => {
        var _a2, _b2;
        if (!settings)
          return;
        setIsCountdownEnabled((_a2 = settings.countdownTimer) != null ? _a2 : true);
        setIsMirrored((_b2 = settings.mirrored) != null ? _b2 : true);
      });
    }, []);
    const { state, dispatch } = (0, import_react137.useContext)(VideoRecorderContext_default);
    const [videoReviewed, setVideoReviewed] = (0, import_react137.useState)(false);
    const isExternalVideo = state.isExternalVideo;
    const recorder = state.recorder;
    const stream = state.mediaStream;
    const metadata = state.metadata;
    const isIdleState = (0, import_react137.useMemo)(
      () => [RecorderState_default.Idle, RecorderState_default.Loading].includes(recorderState),
      [recorderState]
    );
    const handlersActions = (0, import_react137.useMemo)(() => {
      const actions = (0, import_pick2.default)(Actions_exports, [
        "setMediaStream",
        "setMetadata",
        "setBlob",
        "addBlob",
        "setStartTime",
        "setEndTime",
        "setRecorder",
        "init",
        "createBlob",
        "setDeviceErrorStatus"
      ]);
      return (0, import_toolkit4.bindActionCreators)(
        actions,
        // eslint-disable-next-line
        dispatch
      );
    }, [dispatch]);
    const { data: videoDevice, isLoading: videoDeviceLoading } = useVideoDevice();
    const { data: audioDevice, isLoading: audioDeviceLoading } = useAudioDevice();
    const isDevicesLoading = (0, import_react137.useMemo)(
      () => videoDeviceLoading || audioDeviceLoading,
      [videoDeviceLoading, audioDeviceLoading]
    );
    const recordingQualityQuery = useRecordingQuality();
    const recordingQuality = recordingQualityQuery.recordingQuality;
    (0, import_react137.useEffect)(() => {
      if (!onInit || recordingQualityQuery.isLoading) {
        return;
      }
      onInit(recordingQuality);
    }, [onInit, recordingQualityQuery.isLoading]);
    const videoConstraints = (0, import_react137.useMemo)(
      () => getVideoConstraints(videoDevice, recordingQuality),
      [videoDevice, recordingQuality]
    );
    const audioConstraints = (0, import_react137.useMemo)(() => {
      if (audioDevice == null ? void 0 : audioDevice.deviceId) {
        const { deviceId, groupId } = audioDevice;
        return __spreadProps(__spreadValues({}, defaultUserMediaConstraints.audio), {
          deviceId,
          groupId
        });
      }
      return defaultUserMediaConstraints.audio;
    }, [audioDevice]);
    const userMediaConstraints = (0, import_react137.useMemo)(() => {
      if (isDevicesLoading || recordingQualityQuery.isLoading) {
        return void 0;
      }
      return __spreadProps(__spreadValues({}, defaultUserMediaConstraints), {
        video: videoConstraints,
        audio: audioConstraints
      });
    }, [
      videoConstraints,
      audioDevice,
      isDevicesLoading,
      recordingQualityQuery.isLoading
    ]);
    (0, import_react137.useEffect)(() => {
      if (recorderState === RecorderState_default.Idle || userMediaConstraints == null) {
        setRecorderState2(RecorderState_default.Init);
      }
    }, [videoDevice == null ? void 0 : videoDevice.deviceId, audioDevice == null ? void 0 : audioDevice.deviceId, recordingQuality]);
    const mimeType = (0, import_react137.useMemo)(
      () => getPreferredMimeType(recordingQuality),
      [recordingQuality]
    );
    const options2 = (0, import_react137.useMemo)(
      () => __spreadProps(__spreadValues({
        video: videoRef,
        canvas,
        recorder: recorder != null ? recorder : void 0,
        stream: stream != null ? stream : void 0,
        isExternalVideo,
        userMediaConstraints,
        quality: recordingQuality,
        metadata,
        setRecorderState: setRecorderState2,
        setSelectedTabIndex,
        setVideoReviewed
      }, handlersActions), {
        addThumbnail: (0, import_toolkit4.bindActionCreators)(
          addThumbnail,
          // eslint-disable-next-line
          dispatch
        ),
        isDevicesLoading,
        mimeType,
        countdownTimer,
        isCountdownEnabled
      }),
      [
        videoRef.current,
        recorder,
        stream,
        isExternalVideo,
        setRecorderState2,
        setSelectedTabIndex,
        setVideoReviewed,
        handlersActions,
        dispatch,
        isDevicesLoading,
        userMediaConstraints,
        recorderState,
        mimeType,
        recordingQuality,
        countdownTimer,
        isCountdownEnabled
      ]
    );
    const _a = useHandlers(options2), { currentHandler } = _a, handlers = __objRest(_a, ["currentHandler"]);
    const { handleStartClick, handleStopClick, onEnter } = (0, import_react137.useMemo)(
      () => {
        var _a2;
        return (_a2 = handlers[recorderState]) != null ? _a2 : {};
      },
      [recorderState]
    );
    const toggleMirror = () => {
      const newIsMirrored = !isMirrored;
      void rememberSettings({
        mirrored: newIsMirrored
      });
      setIsMirrored(newIsMirrored);
    };
    const toggleCountdownTimer = () => {
      const newIsCoundownEnabled = !isCountdownEnabled;
      void rememberSettings({
        countdownTimer: newIsCoundownEnabled
      });
      setIsCountdownEnabled(newIsCoundownEnabled);
    };
    (0, import_react137.useEffect)(() => {
      if (!isCountdownEnabled)
        return;
      if (recorderState == RecorderState_default.Counting) {
        setIntervalId(
          setInterval(() => {
            setCountdownTimer(countdownTimer - 1);
            void (onEnter == null ? void 0 : onEnter(options2));
            if (countdownTimer == 1) {
              clearInterval(intervalId);
              setCountdownTimer(3);
            }
          }, 1e3)
        );
      }
      return () => intervalId && clearInterval(intervalId);
    }, [recorderState, countdownTimer]);
    (0, import_react137.useEffect)(() => {
      void (onEnter == null ? void 0 : onEnter(options2));
    }, [recorderState]);
    function handleResetClick() {
      onResetClick == null ? void 0 : onResetClick();
      setRecorderState2(RecorderState_default.Init);
    }
    (0, import_react137.useEffect)(() => {
      return () => {
        if (stream) {
          (0, import_stop_media_stream3.default)(stream);
        }
      };
    }, [stream]);
    function handlePageVisibilityChange(isVisible) {
      if (stream && isIdleState) {
        if (isVisible) {
          const newRecorderState = recorderState === RecorderState_default.Loading ? RecorderState_default.Idle : RecorderState_default.Loading;
          setRecorderState2(newRecorderState);
        } else {
          (0, import_stop_media_stream3.default)(stream);
        }
      }
    }
    (0, import_react137.useEffect)(() => {
      if (isExternalVideo) {
        setRecorderState2(RecorderState_default.GenerateThumbnails);
      }
    }, [isExternalVideo]);
    const startRecording = (0, import_react137.useCallback)(
      () => void (handleStartClick == null ? void 0 : handleStartClick(options2)),
      [handleStartClick, options2]
    );
    const stopRecording = (0, import_react137.useCallback)(
      () => void (handleStopClick == null ? void 0 : handleStopClick(options2)),
      [handleStopClick, options2]
    );
    const recorderControl = (0, import_react137.useMemo)(
      () => ({
        startRecording,
        stopRecording
      }),
      [startRecording, stopRecording]
    );
    (0, import_react137.useEffect)(() => {
      if (!ref) {
        return;
      }
      if (typeof ref === "function") {
        ref(recorderControl);
      } else {
        ref.current = recorderControl;
      }
    }, [ref, recorderControl]);
    return /* @__PURE__ */ import_react137.default.createElement(import_react137.default.Fragment, null, /* @__PURE__ */ import_react137.default.createElement(import_react_page_visibility.default, { onChange: handlePageVisibilityChange }), /* @__PURE__ */ import_react137.default.createElement(
      VideoPane,
      {
        videoRef,
        videoProps: getVideoComponentProps(state),
        currentHandler,
        className: videoPaneClassName,
        recorderState,
        videoReviewed,
        onResetClick: handleResetClick,
        onStartClick: startRecording,
        onStopClick: stopRecording,
        onSettingsClick,
        onSettingsClose,
        hideVideoButtons,
        resetButton,
        alignResetButtonToRight,
        startTime: (_b = state.startTime) != null ? _b : void 0,
        endTime: (_c = state.endTime) != null ? _c : void 0,
        debug,
        isCountdownEnabled,
        countdown: countdownTimer,
        onToggleCountdownTimer: toggleCountdownTimer,
        mirrored: isMirrored,
        onToggleMirror: toggleMirror,
        canvasRef: canvas,
        hideCountdownTimer,
        hideAudioIndicator,
        hideMirror,
        mirrorClassName,
        countdownTimerClassName,
        audioIndicatorClassName
      }
    ));
  }
);
VideoRecorder.displayName = "VideoRecorder";
var VideoRecorder_default = VideoRecorder;

// src/components/VideoRecorder/Loading.tsx
var import_beautiful_react_hooks = __toESM(require_cjs());
var import_react141 = __toESM(require("react"));

// src/components/VideoRecorder/LoadingError.tsx
var import_react138 = __toESM(require("react"));
var import_classnames87 = __toESM(require("classnames"));
var import_react_i18next5 = require("react-i18next");
var DeviceErrorMessages = {
  permissionError: {
    titleKey: "videoRecorder:loadingError.permission.title",
    bodyKey: "videoRecorder:loadingError.permission.body"
  },
  notReadable: {
    titleKey: "videoRecorder:loadingError.notReadable.title",
    bodyKey: "videoRecorder:loadingError.notReadable.body"
  }
};
function LoadingError(_a) {
  var _b = _a, {
    errorType = "permissionError" /* PermissionError */,
    className
  } = _b, otherProps = __objRest(_b, [
    "errorType",
    "className"
  ]);
  const { t } = (0, import_react_i18next5.useTranslation)();
  const { titleKey, bodyKey } = DeviceErrorMessages[errorType];
  if (errorType == "notReadable" /* NotReadable */) {
    return /* @__PURE__ */ import_react138.default.createElement(
      "div",
      __spreadValues({
        className: (0, import_classnames87.default)(
          className,
          "v2-h-full v2-w-full v2-flex v2-flex-col v2-justify-center v2-items-center"
        )
      }, otherProps),
      /* @__PURE__ */ import_react138.default.createElement("div", null, /* @__PURE__ */ import_react138.default.createElement("span", { className: "v2-text-base v2-text-neutral-600 v2-flex v2-flex-col" }, t(titleKey), " ", t(bodyKey)), /* @__PURE__ */ import_react138.default.createElement(
        Settings,
        {
          positionClassName: "v2-relative",
          backgroundColorClassName: "v2-bg-white",
          textColorClassName: "v2-text-neutral-600",
          paddingClassName: "v2-pt-2.5",
          hideSave: true,
          hideTitle: true
        }
      ))
    );
  }
  return /* @__PURE__ */ import_react138.default.createElement(
    "div",
    __spreadValues({
      className: (0, import_classnames87.default)(
        className,
        "v2-h-full v2-w-full v2-flex v2-flex-col v2-items-center v2-justify-center"
      )
    }, otherProps),
    /* @__PURE__ */ import_react138.default.createElement(
      "img",
      {
        className: "v2-w-44 v2-h-44",
        src: assetUrl("video-recorder/allow-access.gif")
      }
    ),
    /* @__PURE__ */ import_react138.default.createElement("div", { className: "v2-text-center" }, /* @__PURE__ */ import_react138.default.createElement("div", { className: "v2-text-xl v2-text-neutral-600 v2-font-medium" }, t(titleKey)), /* @__PURE__ */ import_react138.default.createElement("span", { className: "v2-text-sm v2-text-neutral-500" }, t(bodyKey)))
  );
}
var createCustomLoadingError = (onBackClick) => ({ errorType }) => {
  const { t } = (0, import_react_i18next5.useTranslation)();
  return /* @__PURE__ */ import_react138.default.createElement("div", { className: "v2-p-5 v2-h-full v2-w-full v2-relative" }, /* @__PURE__ */ import_react138.default.createElement(
    ActionButton,
    {
      className: "v2-absolute",
      icon: faArrowLeft,
      label: t("videoRecorder:buttons.back"),
      onClick: onBackClick
    }
  ), /* @__PURE__ */ import_react138.default.createElement(
    LoadingError,
    {
      className: "v2-flex v2-flex-col v2-items-center v2-justify-center v2-h-full v2-text-center v2-gap-y-4",
      errorType
    }
  ));
};

// src/components/VideoRecorder/hooks/use-get-user-media-event-listener.ts
function useGetUserMediaEventListener({
  onSuccess,
  onError
}) {
  useEvent_default(
    EVENT_GET_USER_MEDIA_SUCCESS,
    onSuccess,
    window
  );
  useEvent_default(
    EVENT_GET_USER_MEDIA_ERROR,
    onError,
    window
  );
}

// src/components/VideoRecorder/hooks/use-media-stream-error-handler.ts
var import_react139 = require("react");
function useMediaStreamErrorHandler() {
  const { dispatch } = (0, import_react139.useContext)(VideoRecorderContext_default);
  useGetUserMediaEventListener({
    onError: (evt) => {
      if (isMediaStreamError(evt.error)) {
        dispatch(setDeviceErrorStatus("notReadable" /* NotReadable */));
      } else if (evt.error.name === "NotAllowedError") {
        dispatch(setDeviceErrorStatus("permissionError" /* PermissionError */));
      } else if (confirm("Something went wrong. Please reload the page.")) {
        window.location.reload();
      }
    },
    onSuccess: () => {
      dispatch(setDeviceErrorStatus(void 0));
    }
  });
}

// src/components/VideoRecorder/Loading.tsx
var import_react_i18next6 = require("react-i18next");

// src/components/VideoRecorder/LoadingDevice.tsx
var import_react140 = __toESM(require("react"));
var import_classnames88 = __toESM(require("classnames"));
var import_react_fontawesome20 = require("@fortawesome/react-fontawesome");
function LoadingDevice({
  name,
  faIcon,
  className,
  status = "loading" /* Loading */
}) {
  const icon = (0, import_react140.useMemo)(() => {
    switch (status) {
      case "loading" /* Loading */:
        return faSpinner2;
      case "success" /* Success */:
        return faCheck2;
      case "error" /* Error */:
      default:
        return faTimes2;
    }
  }, [status]);
  return /* @__PURE__ */ import_react140.default.createElement("div", { className: (0, import_classnames88.default)("v2-flex v2-flex-col v2-items-center", className) }, /* @__PURE__ */ import_react140.default.createElement("div", { className: "v2-h-30 v2-w-30 v2-bg-neutral-100 v2-rounded-full v2-p-5 v2-relative v2-flex v2-flex-col v2-items-center" }, /* @__PURE__ */ import_react140.default.createElement(
    import_react_fontawesome20.FontAwesomeIcon,
    {
      icon: faIcon,
      className: (0, import_classnames88.default)("v2-text-[5em]", {
        "v2-animate-pulse v2-text-neutral-300": status === "loading" /* Loading */,
        "v2-text-red": status === "error" /* Error */,
        "v2-text-green-400": status === "success" /* Success */
      })
    }
  ), /* @__PURE__ */ import_react140.default.createElement(
    import_react_fontawesome20.FontAwesomeIcon,
    {
      className: (0, import_classnames88.default)(
        "v2-absolute v2-top-2 v2-right-[-15px] v2-text-[3em] v2-text-shadow",
        {
          "v2-animate-spin v2-text-neutral-500": status === "loading" /* Loading */,
          "v2-text-red": status === "error" /* Error */,
          "v2-text-green-400": status === "success" /* Success */
        }
      ),
      icon
    }
  )), /* @__PURE__ */ import_react140.default.createElement("div", { className: "v2-p-2.5" }, name));
}

// src/components/VideoRecorder/Loading.tsx
var import_partial2 = __toESM(require_partial());
var import_classnames89 = __toESM(require("classnames"));
function getLoadingDeviceStatus(status, devices) {
  if (status === "success") {
    return devices.length > 0 ? "success" /* Success */ : "error" /* Error */;
  }
  return "loading" /* Loading */;
}
function Loading(_a) {
  var _b = _a, {
    children,
    className,
    loadingError: LoadingError2 = LoadingError,
    onPermissionError,
    deviceErrorStatus
  } = _b, otherProps = __objRest(_b, [
    "children",
    "className",
    "loadingError",
    "onPermissionError",
    "deviceErrorStatus"
  ]);
  const { t } = (0, import_react_i18next6.useTranslation)();
  const [isUserMediaLoaded, setIsUserMediaLoaded] = (0, import_react141.useState)(false);
  const {
    isSuccess: hasFinished,
    refetch: refetchDevices,
    status
  } = useDevices();
  const { data: audioDevices } = useAudioDevices();
  const audioStatus = (0, import_react141.useMemo)(
    (0, import_partial2.default)(getLoadingDeviceStatus, status, audioDevices != null ? audioDevices : []),
    [status, audioDevices]
  );
  const { data: videoDevices } = useVideoDevices();
  const videoStatus = (0, import_react141.useMemo)(
    (0, import_partial2.default)(getLoadingDeviceStatus, status, videoDevices != null ? videoDevices : []),
    [status, videoDevices]
  );
  const deviceError = (0, import_react141.useMemo)(
    () => [videoStatus, audioStatus].includes("error" /* Error */),
    [videoStatus, audioStatus]
  );
  (0, import_react141.useEffect)(() => {
    const initGetUserMedia = () => __async(this, null, function* () {
      const hasPermission = yield hasUserMediaPermission();
      setIsUserMediaLoaded(hasPermission);
      if (!hasPermission) {
        onPermissionError == null ? void 0 : onPermissionError();
      }
    });
    void initGetUserMedia();
  }, []);
  useMediaStreamErrorHandler();
  (0, import_react141.useEffect)(() => {
    void refetchDevices();
  }, [isUserMediaLoaded]);
  const [, clearInterval2] = (0, import_beautiful_react_hooks.useInterval)(refetchDevices, 3e3);
  (0, import_react141.useEffect)(() => {
    if (hasFinished || deviceError) {
      clearInterval2();
    }
  }, [hasFinished, videoStatus, audioStatus]);
  if (hasFinished && deviceError || deviceErrorStatus) {
    return /* @__PURE__ */ import_react141.default.createElement(LoadingError2, __spreadProps(__spreadValues({}, otherProps), { errorType: deviceErrorStatus }));
  }
  if (hasFinished && !deviceError && isUserMediaLoaded) {
    return /* @__PURE__ */ import_react141.default.createElement(import_react141.default.Fragment, null, children);
  }
  return /* @__PURE__ */ import_react141.default.createElement(
    "div",
    {
      className: (0, import_classnames89.default)(
        className,
        "v2-flex v2-flex-col v2-items-center v2-justify-center",
        "v2-bg-white v2-h-full v2-space-y-4"
      )
    },
    /* @__PURE__ */ import_react141.default.createElement("h3", { className: "v2-text-center" }, t("videoRecorder:loadingState.header")),
    /* @__PURE__ */ import_react141.default.createElement("div", { className: "v2-flex v2-space-x-8" }, /* @__PURE__ */ import_react141.default.createElement(
      LoadingDevice,
      {
        name: t("videoRecorder:loadingState.audio"),
        faIcon: faMicrophone,
        status: audioStatus
      }
    ), /* @__PURE__ */ import_react141.default.createElement(
      LoadingDevice,
      {
        name: t("videoRecorder:loadingState.video"),
        faIcon: faWebcam,
        status: videoStatus
      }
    ))
  );
}

// src/components/VideoRecorder/Recorder.tsx
var import_react_i18next7 = require("react-i18next");
var rootDimensionsClassNames = [
  "v2-min-h-[min(100vw,100vh)] v2-min-w-[min(100vw,100vh)]",
  "md:v2-min-h-0 md:v2-min-w-0"
];
var Recorder = import_react142.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      manualUpload,
      showBonjoroBadge = false,
      onBackClick,
      onResetClick,
      onSettingsClick,
      onSettingsClose,
      onReplayClick,
      onRecordingComplete,
      onRecorderStateChange,
      debug = false,
      height = 450,
      width = 450,
      className,
      containerClassName,
      loadingClassName,
      videoPaneClassName,
      onInit,
      hideMirror = false,
      hideCountdownTimer = false,
      hideAudioIndicator = false,
      mirrorClassName,
      countdownTimerClassName,
      audioIndicatorClassName
    } = _b, props = __objRest(_b, [
      "manualUpload",
      "showBonjoroBadge",
      "onBackClick",
      "onResetClick",
      "onSettingsClick",
      "onSettingsClose",
      "onReplayClick",
      "onRecordingComplete",
      "onRecorderStateChange",
      "debug",
      "height",
      "width",
      "className",
      "containerClassName",
      "loadingClassName",
      "videoPaneClassName",
      "onInit",
      "hideMirror",
      "hideCountdownTimer",
      "hideAudioIndicator",
      "mirrorClassName",
      "countdownTimerClassName",
      "audioIndicatorClassName"
    ]);
    const [isRecorderSettingsOpen, setIsRecorderSettingsOpen] = (0, import_react142.useState)(false);
    const { dispatch, state } = (0, import_react142.useContext)(VideoRecorderContext_default);
    const deviceErrorStatus = (0, import_react142.useMemo)(
      () => getDeviceErrorStatus(state),
      [state.deviceErrorStatus]
    );
    const recorderState = (0, import_react142.useMemo)(
      () => state.recorderState,
      [state.recorderState]
    );
    const setRecorderState2 = (0, import_react142.useCallback)(
      (recorderState2) => dispatch(setRecorderState(recorderState2)),
      [dispatch]
    );
    const [externalVideo, setExternalVideo] = (0, import_react142.useState)();
    (0, import_react142.useEffect)(() => {
      setExternalVideo(manualUpload);
    }, [manualUpload]);
    (0, import_react142.useEffect)(() => {
      if (externalVideo) {
        dispatch(loadExternalVideo(externalVideo));
        setExternalVideo(void 0);
      }
    }, [externalVideo, recorderState]);
    const { data: audioDevice } = useAudioDevice();
    const { data: videoDevice } = useVideoDevice();
    const videoRef = (0, import_react142.useRef)();
    (0, import_react142.useEffect)(() => {
      if (props.videoRef) {
        props.videoRef.current = videoRef.current;
      }
    }, [videoRef.current]);
    (0, import_react142.useEffect)(() => {
      var _a2;
      onRecorderStateChange == null ? void 0 : onRecorderStateChange(recorderState);
      if (recorderState === RecorderState_default.Complete && onRecordingComplete) {
        const data = getBlob(state);
        const thumbnails = getThumbnails(state);
        let metadata = getMetadata(state);
        metadata = __spreadProps(__spreadValues({}, metadata), {
          type: data.type,
          sizeInBytes: data.size
        });
        const duration = (_a2 = videoRef.current) == null ? void 0 : _a2.duration;
        if (duration && isFinite(duration)) {
          metadata.duration = duration;
        }
        dispatch(setMetadata(metadata));
        onRecordingComplete(data, thumbnails, metadata);
      }
    }, [recorderState]);
    const handleOnResetClick = (0, import_react142.useCallback)(() => {
      dispatch(init());
      if (manualUpload) {
        onBackClick == null ? void 0 : onBackClick();
      }
      onResetClick == null ? void 0 : onResetClick();
    }, [onBackClick, onResetClick]);
    const handleBackClick = (0, import_react142.useCallback)(() => {
      onBackClick == null ? void 0 : onBackClick();
      dispatch(removeLoadedVideo());
    }, [onBackClick]);
    const handleSettingsClick = (0, import_react142.useCallback)(() => {
      setIsRecorderSettingsOpen(true);
      onSettingsClick == null ? void 0 : onSettingsClick();
    }, [onSettingsClick]);
    const handleSettingsClose = (0, import_react142.useCallback)(
      (videoDevice2, audioDevice2) => {
        setIsRecorderSettingsOpen(false);
        onSettingsClose == null ? void 0 : onSettingsClose(videoDevice2 != null ? videoDevice2 : void 0, audioDevice2 != null ? audioDevice2 : void 0);
      },
      [videoDevice, audioDevice]
    );
    (0, import_react142.useEffect)(() => {
      if (recorderState === RecorderState_default.Playing) {
        onReplayClick == null ? void 0 : onReplayClick();
      }
    }, [recorderState]);
    const LoadingError2 = onBackClick ? (0, import_react142.useCallback)(createCustomLoadingError(handleBackClick), []) : void 0;
    const showActionButton = recorderState !== RecorderState_default.GenerateThumbnails && !isRecorderSettingsOpen;
    const showDeleteButton = recorderState === RecorderState_default.Playing || recorderState === RecorderState_default.Complete;
    const { t } = (0, import_react_i18next7.useTranslation)();
    const childrenRecorder = (0, import_react142.useMemo)(() => {
      return /* @__PURE__ */ import_react142.default.createElement(
        "div",
        {
          className: (0, import_classnames90.default)(
            containerClassName,
            "v2-relative v2-h-full v2-w-full v2-overflow-hidden"
          )
        },
        showActionButton && onBackClick && /* @__PURE__ */ import_react142.default.createElement(
          ActionButton,
          {
            className: "v2-absolute v2-top-5 v2-left-5 v2-z-50",
            icon: showDeleteButton ? faTrash : faArrowLeft,
            label: showDeleteButton ? t("videoRecorder:buttons.delete") : t("videoRecorder:buttons.back"),
            onClick: handleBackClick
          }
        ),
        showBonjoroBadge && RecorderState_default.Complete !== recorderState && /* @__PURE__ */ import_react142.default.createElement("a", { href: "/", target: "_blank", rel: "noopener noreferrer" }, /* @__PURE__ */ import_react142.default.createElement(
          "img",
          {
            className: "v2-block v2-absolute v2-z-50 v2-right-0 v2-w-28",
            src: assetUrl("video-recorder/poweredby-bonjoro-dark.svg")
          }
        )),
        /* @__PURE__ */ import_react142.default.createElement("div", { className: "recorder-container !v2-w-full !v2-h-full !v2-pb-0 !v2-rounded-none" }, /* @__PURE__ */ import_react142.default.createElement(
          VideoRecorder_default,
          {
            ref,
            videoRef,
            setRecorderState: setRecorderState2,
            recorderState,
            resetButton: /* @__PURE__ */ import_react142.default.createElement(
              ActionButton,
              {
                className: "v2-ml-auto",
                icon: faUndo,
                label: t("videoRecorder:buttons.redo"),
                onClick: handleOnResetClick
              }
            ),
            videoPaneClassName: (0, import_classnames90.default)(
              videoPaneClassName,
              "v2-w-full !v2-rounded-none"
            ),
            alignResetButtonToRight: true,
            hideVideoButtons: recorderState === RecorderState_default.GenerateThumbnails,
            onSettingsClick: handleSettingsClick,
            onSettingsClose: handleSettingsClose,
            debug,
            onInit,
            hideMirror,
            hideCountdownTimer,
            hideAudioIndicator,
            mirrorClassName,
            countdownTimerClassName,
            audioIndicatorClassName
          }
        ))
      );
    }, [
      recorderState,
      setRecorderState2,
      manualUpload,
      showActionButton,
      showDeleteButton,
      showBonjoroBadge,
      handleBackClick,
      handleOnResetClick,
      handleSettingsClick,
      handleSettingsClose,
      debug,
      ref
    ]);
    return /* @__PURE__ */ import_react142.default.createElement(
      "div",
      {
        className: (0, import_classnames90.default)(
          "v2-bg-white v2-left-0 v2-top-0 v2-z-40 v2-w-full md:v2-h-full md:v2-relative md:v2-rounded-none v2-overflow-hidden",
          rootDimensionsClassNames,
          className
        ),
        style: { height, width }
      },
      manualUpload ? childrenRecorder : /* @__PURE__ */ import_react142.default.createElement(
        Loading,
        {
          loadingError: LoadingError2,
          deviceErrorStatus,
          className: loadingClassName
        },
        childrenRecorder
      )
    );
  }
);
Recorder.displayName = "Recorder";
var Recorder_default = Recorder;

// src/components/VideoRecorder/MaybeQueryClientProvider.tsx
var import_react143 = __toESM(require("react"));
var import_react_query3 = require("react-query");
function MaybeQueryClientProvider({
  createQueryClient = false,
  children
}) {
  const queryClientRef = (0, import_react143.useRef)(
    createQueryClient ? new import_react_query3.QueryClient() : void 0
  );
  if (queryClientRef.current) {
    return /* @__PURE__ */ import_react143.default.createElement(import_react_query3.QueryClientProvider, { client: queryClientRef.current }, children);
  }
  return /* @__PURE__ */ import_react143.default.createElement(import_react143.default.Fragment, null, children);
}

// src/components/VideoRecorder/i18n.ts
var import_i18next = __toESM(require("i18next"));
var import_react_i18next8 = require("react-i18next");
var import_i18next_browser_languagedetector = __toESM(require("i18next-browser-languagedetector"));

// src/locales/en/videoRecorder.json
var videoRecorder_default = {
  buttons: {
    back: "Back",
    delete: "Delete",
    redo: "Redo"
  },
  settings: {
    header: "Recorder Settings",
    save: "Save",
    camera: "Camera",
    audio: "Audio",
    select: "Select...",
    quality: {
      high: "High (1080p) (Quality)",
      medium: "Medium (720p) (Recommended)",
      low: "Low (480p) (Performance)"
    }
  },
  loadingState: {
    header: "Loading your devices...",
    video: "Video",
    audio: "Audio"
  },
  loadingError: {
    permission: {
      title: "Camera and microphone permissions are not allowed.",
      body: "Go to your browser settings and allow camera and microphone, then refresh."
    },
    notReadable: {
      title: "Your camera or microphone is being used or blocked by another application.",
      body: "Please close the application and try again or you may select your device below."
    }
  },
  manualUpload: {
    buttonText: "Upload a video",
    errors: {
      fileTypeError: "Invalid Video File. Please select a valid video file.",
      fileSizeError: "File too large. Please only upload files under {{maxFileSize}}MB."
    }
  },
  errors: {
    unsupportedVideoFormat: "Warning!\n\nThe video file you have selected is not supported by your browser. You may continue to upload this video, but you will not be able to review it or select a thumbnail before sending.\n\nTo avoid this warning in the future, please encode your video in a format that is supported by your browser. If you are not sure, reach out to support for help."
  }
};

// src/components/VideoRecorder/i18n.ts
void import_i18next.default.use(import_i18next_browser_languagedetector.default).use(import_react_i18next8.initReactI18next).init({
  debug: true,
  fallbackLng: "en",
  defaultNS: "videoRecorder",
  resources: {
    en: {
      videoRecorder: videoRecorder_default
    }
  }
});
var i18n_default = import_i18next.default;

// src/components/VideoRecorder/VideoRecorderWrapper.tsx
var VideoRecorderWrapper = import_react144.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      noCreateQueryClientProvider = false,
      recordingQuality
    } = _b, props = __objRest(_b, [
      "noCreateQueryClientProvider",
      "recordingQuality"
    ]);
    const [state, dispatch] = useRecorderReducer();
    const context = (0, import_react144.useMemo)(() => {
      return {
        state,
        dispatch,
        options: {
          recordingQuality
        }
      };
    }, [state, dispatch]);
    return /* @__PURE__ */ import_react144.default.createElement(import_react_i18next9.I18nextProvider, { i18n: i18n_default }, /* @__PURE__ */ import_react144.default.createElement(VideoRecorderContext_default.Provider, { value: context }, /* @__PURE__ */ import_react144.default.createElement(
      MaybeQueryClientProvider,
      {
        createQueryClient: !noCreateQueryClientProvider
      },
      /* @__PURE__ */ import_react144.default.createElement(Recorder_default, __spreadValues({ ref }, props))
    )));
  }
);
VideoRecorderWrapper.displayName = "VideoRecorder";

// src/components/VideoRecorder/ManualUploadButton.tsx
var import_classnames91 = __toESM(require("classnames"));
var import_react145 = __toESM(require("react"));

// src/utils/isVideoFile.ts
var isVideoFile = (f) => f != null && f.type.match(/^(video|application\/octet-stream)\/.*$/g);
var isVideoFile_default = isVideoFile;

// src/components/VideoRecorder/ManualUploadButton.tsx
function getAcceptedFormats() {
  if (detectBrowser() === "safari") {
    return [
      "video/mp4",
      "video/quicktime",
      "video/3gpp",
      "video/mpeg",
      "video/mpeg2",
      "video/m4v"
    ];
  }
  return ["video/*"];
}
function ManualUploadButton(_a) {
  var _b = _a, {
    children,
    onFileSelected,
    className,
    variant = "icon" /* Icon */,
    disabled = false,
    maxFileSize = 100,
    onFileTypeError,
    onFileSizeError
  } = _b, props = __objRest(_b, [
    "children",
    "onFileSelected",
    "className",
    "variant",
    "disabled",
    "maxFileSize",
    "onFileTypeError",
    "onFileSizeError"
  ]);
  const inputRef = (0, import_react145.useRef)(null);
  const maxFileSizeBytes = (0, import_react145.useMemo)(
    () => maxFileSize * Math.pow(10, 6),
    [maxFileSize]
  );
  const accept = (0, import_react145.useMemo)(() => {
    var _a2;
    if (typeof props.accept === "string") {
      return props.accept;
    }
    return ((_a2 = props.accept) != null ? _a2 : getAcceptedFormats()).join(",");
  }, [props.accept]);
  function handleClick() {
    if (disabled)
      return;
    inputRef.current.value = "";
    inputRef.current.click();
  }
  function handleInputChange(evt) {
    var _a2;
    const file = (_a2 = evt.currentTarget.files) == null ? void 0 : _a2[0];
    if (file == null) {
      return;
    }
    if (!isVideoFile_default(file)) {
      (onFileTypeError != null ? onFileTypeError : alert)(
        i18n_default.t("videoRecorder:manualUpload.errors.fileTypeError")
      );
      return;
    }
    if (file.size > maxFileSizeBytes) {
      (onFileSizeError != null ? onFileSizeError : alert)(
        i18n_default.t("videoRecorder:manualUpload.errors.fileSizeError", {
          maxFileSize
        })
      );
      return;
    }
    onFileSelected(file);
  }
  return /* @__PURE__ */ import_react145.default.createElement(import_react145.default.Fragment, null, /* @__PURE__ */ import_react145.default.createElement(
    "input",
    {
      style: {
        display: "none"
      },
      ref: inputRef,
      accept,
      onChange: handleInputChange,
      type: "file"
    }
  ), /* @__PURE__ */ import_react145.default.createElement(
    Button,
    __spreadProps(__spreadValues({}, props), {
      variant,
      onClick: handleClick,
      className: (0, import_classnames91.default)(className, "v2-font-bold"),
      disabled
    }),
    children != null ? children : i18n_default.t("videoRecorder:manualUpload.buttonText")
  ));
}

// src/components/RichTextViewer/RichTextViewer.tsx
var import_react146 = __toESM(require("react"));
function RichTextViewer({
  value,
  className = "",
  style
}) {
  return /* @__PURE__ */ import_react146.default.createElement(
    RichTextEditor,
    {
      className: `!v2-border-0 ${className}`,
      editorClassName: "!v2-p-0",
      placeholder: "",
      value,
      style,
      readOnly: true,
      hideToolbar: true
    }
  );
}

// src/components/AddSocialBlock/AddSocialBlock.tsx
var import_react153 = __toESM(require("react"));
var import_classnames98 = __toESM(require("classnames"));

// src/components/AddSocialBlock/UrlInput.tsx
var import_react147 = __toESM(require("react"));
var import_classnames92 = __toESM(require("classnames"));
var InputType = /* @__PURE__ */ ((InputType2) => {
  InputType2["TextArea"] = "text_area";
  InputType2["PlainInput"] = "plain_input";
  return InputType2;
})(InputType || {});
function UrlInput({
  id,
  type,
  ref,
  disabled,
  value,
  className,
  placeholder,
  onInputChange,
  onKeyDown,
  maxLength
}) {
  return type == "plain_input" /* PlainInput */ ? /* @__PURE__ */ import_react147.default.createElement(
    "input",
    {
      id,
      ref,
      value,
      disabled,
      className: (0, import_classnames92.default)(
        className,
        [
          "v2-w-full v2-border v2-border-neutral-200 v2-border-solid",
          "v2-h-10 v2-text-base text-border-neutral-700 v2-px-4 v2-outline-none"
        ],
        {
          "hover:!v2-border-yellow-500 focus:!v2-border-yellow-500": !disabled
        }
      ),
      placeholder,
      onChange: (event) => onInputChange == null ? void 0 : onInputChange(event.currentTarget.value),
      onKeyDown,
      maxLength
    }
  ) : /* @__PURE__ */ import_react147.default.createElement(
    TextArea,
    {
      id,
      inputRef: ref,
      value,
      disabled,
      className: (0, import_classnames92.default)(
        className,
        ["v2-transition-all !v2-h-24 !v2-rounded-none"],
        {
          "hover:!v2-border-yellow-500 focus:!v2-border-yellow-500": !disabled
        }
      ),
      placeholder,
      onChange: (event) => onInputChange == null ? void 0 : onInputChange(event.currentTarget.value),
      onKeyDown,
      maxLength
    }
  );
}

// src/components/AddSocialBlock/Description.tsx
var import_react148 = __toESM(require("react"));
var import_classnames93 = __toESM(require("classnames"));
var infoIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/info.svg";
function Description({ className, text }) {
  return /* @__PURE__ */ import_react148.default.createElement(
    "div",
    {
      className: (0, import_classnames93.default)(className, "v2-text-base v2-flex v2-flex-col v2-gap-y-2")
    },
    /* @__PURE__ */ import_react148.default.createElement(
      "img",
      {
        className: "v2-h-6 v2-w-6 v2-bottom-2 v2-right-2 v2-pr-1 v2-py-.5 v2-rounded-full",
        src: infoIcon
      }
    ),
    text
  );
}

// src/components/AddSocialBlock/CtaButton.tsx
var import_react149 = __toESM(require("react"));
var import_classnames94 = __toESM(require("classnames"));
var import_react_fontawesome21 = require("@fortawesome/react-fontawesome");
function CtaButton({
  className,
  label,
  disabled,
  loading,
  onClick
}) {
  return /* @__PURE__ */ import_react149.default.createElement(
    Button,
    {
      className: (0, import_classnames94.default)(className, "!v2-text-base"),
      variant: "primary" /* Primary */,
      onClick,
      disabled
    },
    loading && /* @__PURE__ */ import_react149.default.createElement(import_react_fontawesome21.FontAwesomeIcon, { icon: faSpinner, className: "v2-animate-spin v2-mr-2" }),
    label
  );
}

// src/components/AddSocialBlock/Header.tsx
var import_react150 = __toESM(require("react"));
var import_classnames95 = __toESM(require("classnames"));
function Header({ className, text }) {
  return /* @__PURE__ */ import_react150.default.createElement("p", { className: (0, import_classnames95.default)(className, "v2-text-base v2-text-neutral-900") }, text);
}

// src/components/ToggleSelector/ToggleButton.tsx
var import_react152 = __toESM(require("react"));
var import_classnames97 = __toESM(require("classnames"));

// src/components/ToggleSelector/ToggleSelector.tsx
var import_react151 = __toESM(require("react"));
var import_classnames96 = __toESM(require("classnames"));
var ToggleSelectorShape = /* @__PURE__ */ ((ToggleSelectorShape2) => {
  ToggleSelectorShape2["Rounded"] = "rounded";
  ToggleSelectorShape2["Rectangle"] = "rectangle";
  ToggleSelectorShape2["RoundedMd"] = "rounded-md";
  return ToggleSelectorShape2;
})(ToggleSelectorShape || {});
var sizeClasses2 = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  sm: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  md: "v2-py-0 v2-px-[15px] v2-text-[16px] v2-h-[40px]",
  lg: "v2-py-2.5 v2-px-[15px] v2-text-base",
  xl: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
function ToggleSelector({
  items,
  selected,
  selectedTextColorClassName,
  size,
  notSelectedBgColorClassName,
  className,
  buttonClassName,
  activeButtonClassName,
  disabled,
  shape = "rounded" /* Rounded */,
  onSelect,
  textColorClassName,
  borderColorClassName,
  textHoverColorClassName,
  buttonBorderColorClassName
}) {
  const sizeClass = (0, import_react151.useMemo)(() => {
    if (size === "sm") {
      return sizeClasses2["sm"];
    }
    if (size === "md") {
      return sizeClasses2["md"];
    }
    if (size === "lg") {
      return sizeClasses2["lg"];
    }
    if (size === "xl") {
      return sizeClasses2["xl"];
    }
    return sizeClasses2["sm"];
  }, [size]);
  const itemComponents = (0, import_react151.useMemo)(() => {
    const components2 = [];
    if (items) {
      for (const key2 in items) {
        components2.push(
          /* @__PURE__ */ import_react151.default.createElement(
            ToggleButton,
            {
              key: key2,
              id: key2,
              disabled,
              sizeClass,
              label: items[key2],
              selected: selected === key2,
              selectedTextColorClassName,
              notSelectedBgColorClassName,
              onClick: () => onSelect == null ? void 0 : onSelect(key2),
              className: buttonClassName,
              activeClassName: activeButtonClassName,
              shape,
              textColorClassName,
              textHoverColorClassName,
              buttonBorderColorClassName
            }
          )
        );
      }
      return components2;
    }
  }, [
    items,
    shape,
    selected,
    selectedTextColorClassName,
    sizeClass,
    notSelectedBgColorClassName,
    selectedTextColorClassName,
    textColorClassName,
    textHoverColorClassName,
    buttonBorderColorClassName
  ]);
  return /* @__PURE__ */ import_react151.default.createElement(
    "div",
    {
      className: (0, import_classnames96.default)(
        className,
        "toggle-selector",
        [
          "v2-flex v2-text-center v2-border v2-border-solid",
          "v2-w-full",
          `${borderColorClassName != null ? borderColorClassName : "v2-border-neutral-300"}`
        ],
        {
          "v2-rounded-full": shape === "rounded" /* Rounded */,
          "v2-rounded-none": shape === "rectangle" /* Rectangle */,
          "v2-rounded-md": shape === "rounded-md" /* RoundedMd */
        }
      )
    },
    itemComponents
  );
}

// src/components/ToggleSelector/ToggleButton.tsx
var ToggleButton = ({
  id,
  className,
  activeClassName,
  selected,
  selectedTextColorClassName,
  notSelectedBgColorClassName,
  sizeClass,
  disabled,
  label,
  shape,
  textColorClassName,
  textHoverColorClassName,
  buttonBorderColorClassName,
  onClick
}) => {
  return /* @__PURE__ */ import_react152.default.createElement(
    "button",
    {
      id: id && `toggle-button-value-${id}`,
      className: (0, import_classnames97.default)(
        className,
        sizeClass,
        textColorClassName,
        "toggle-selector-button v2-flex-1  v2-truncate",
        `${buttonBorderColorClassName ? `v2-border ${buttonBorderColorClassName}` : ""}`,
        {
          [`v2-bg-yellow-300 ${activeClassName != null ? activeClassName : ""}`]: selected,
          [`${selectedTextColorClassName != null ? selectedTextColorClassName : ""}`]: selected,
          [`${notSelectedBgColorClassName != null ? notSelectedBgColorClassName : ""}`]: !selected,
          "v2-bg-neutral-100": disabled,
          "hover:v2-bg-yellow-100": !selected && !disabled,
          [`hover:${textHoverColorClassName != null ? textHoverColorClassName : ""}`]: !disabled,
          "v2-rounded-full": shape === "rounded" /* Rounded */,
          "v2-rounded-none": shape === "rectangle" /* Rectangle */,
          "v2-rounded-md": shape === "rounded-md" /* RoundedMd */
        }
      ),
      onClick,
      disabled
    },
    label
  );
};

// src/components/AddSocialBlock/AddSocialBlock.tsx
var SocialType = /* @__PURE__ */ ((SocialType2) => {
  SocialType2["Twitter"] = "twitter";
  SocialType2["Youtube"] = "youtube";
  SocialType2["LinkedIn"] = "linked_in";
  return SocialType2;
})(SocialType || {});
var EmbedType = /* @__PURE__ */ ((EmbedType2) => {
  EmbedType2["Post"] = "post";
  EmbedType2["Comment"] = "comment";
  return EmbedType2;
})(EmbedType || {});
function AddSocialBlock({
  id,
  className,
  headerClassName,
  descriptionClassName,
  ctaClassName,
  inputClassName,
  containerRef,
  inputRef,
  ctaLabel,
  ctaDisabled = false,
  headerLabel,
  inputPlaceholder,
  value: defaultValue,
  loading = false,
  disabled = false,
  type = "youtube" /* Youtube */,
  inputType = "plain_input" /* PlainInput */,
  descriptionText,
  onSubmit,
  onInputChange,
  onInputKeyDown
}) {
  const [value, setValue] = (0, import_react153.useState)(defaultValue);
  const [embedType, setEmbedType] = (0, import_react153.useState)("post" /* Post */);
  const isPostEmbedType = embedType === "post" /* Post */;
  const isLinkedInSocialType = type === "linked_in" /* LinkedIn */;
  (0, import_react153.useEffect)(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const onInputValueChange = (value2) => {
    onInputChange == null ? void 0 : onInputChange(value2);
    setValue(value2);
  };
  const { defaultCtaLabel, defaultHeaderLabel, defaultInputPlaceholder } = (0, import_react153.useMemo)(() => {
    switch (type) {
      case "twitter" /* Twitter */:
        return {
          defaultHeaderLabel: "Add a tweet",
          defaultInputPlaceholder: "Tweet URL",
          defaultCtaLabel: "Add tweet"
        };
      case "linked_in" /* LinkedIn */:
        return isPostEmbedType ? {
          defaultHeaderLabel: "Add a LinkedIn post",
          defaultInputPlaceholder: "Enter embed code",
          defaultCtaLabel: "Add post"
        } : {
          defaultHeaderLabel: "Add a LinkedIn comment",
          defaultInputPlaceholder: "LinkedIn comment URL",
          defaultCtaLabel: "Add comment"
        };
      case "youtube" /* Youtube */:
        return {
          defaultHeaderLabel: "Add a YouTube video",
          defaultInputPlaceholder: "YouTube URL",
          defaultCtaLabel: "Add video"
        };
    }
  }, [
    type,
    embedType,
    isPostEmbedType,
    ctaLabel,
    headerLabel,
    inputPlaceholder
  ]);
  const buttonDisabled = loading || disabled;
  return /* @__PURE__ */ import_react153.default.createElement(
    "div",
    {
      id,
      className: (0, import_classnames98.default)(className, [
        "v2-w-64 v2-bg-neutral-50 v2-flex v2-flex-col v2-border v2",
        "v2-border v2-border-solid v2-border-neutral-200 v2-shadow v2-rounded",
        "v2-justify-between v2-gap-y-3.5 v2-p-4 v2-transition-all"
      ]),
      ref: containerRef
    },
    /* @__PURE__ */ import_react153.default.createElement(
      Header,
      {
        className: headerClassName,
        text: headerLabel != null ? headerLabel : defaultHeaderLabel
      }
    ),
    isLinkedInSocialType && /* @__PURE__ */ import_react153.default.createElement(
      ToggleSelector,
      {
        items: {
          ["post" /* Post */]: "Post",
          ["comment" /* Comment */]: "Comment"
        },
        selected: embedType,
        onSelect: setEmbedType,
        disabled: loading
      }
    ),
    /* @__PURE__ */ import_react153.default.createElement(
      UrlInput,
      {
        ref: inputRef,
        type: inputType,
        className: inputClassName,
        placeholder: inputPlaceholder != null ? inputPlaceholder : defaultInputPlaceholder,
        value,
        disabled: buttonDisabled,
        onInputChange: onInputValueChange,
        onKeyDown: onInputKeyDown
      }
    ),
    /* @__PURE__ */ import_react153.default.createElement(
      CtaButton,
      {
        className: ctaClassName,
        onClick: () => onSubmit == null ? void 0 : onSubmit(value != null ? value : ""),
        disabled: loading || ctaDisabled,
        loading,
        label: ctaLabel != null ? ctaLabel : defaultCtaLabel
      }
    ),
    /* @__PURE__ */ import_react153.default.createElement(
      Description,
      {
        className: descriptionClassName,
        text: descriptionText != null ? descriptionText : "Adding tags will add to any publishable that are generated from those tags."
      }
    )
  );
}

// src/components/MeatballMenu/MeatballMenuContainer.tsx
var import_react155 = __toESM(require("react"));
var import_classnames100 = __toESM(require("classnames"));

// src/components/MeatballMenu/MeatballMenuItem.tsx
var import_react154 = __toESM(require("react"));
var import_classnames99 = __toESM(require("classnames"));
var MeatballMenuItemTheme = /* @__PURE__ */ ((MeatballMenuItemTheme2) => {
  MeatballMenuItemTheme2["Primary"] = "default";
  MeatballMenuItemTheme2["Red"] = "red";
  return MeatballMenuItemTheme2;
})(MeatballMenuItemTheme || {});
function MeatballMenuItem({
  id,
  logo,
  label,
  className,
  theme: theme2 = "default" /* Primary */,
  onClick
}) {
  return /* @__PURE__ */ import_react154.default.createElement(
    "li",
    {
      id,
      className: (0, import_classnames99.default)(
        "meatball-menu-item",
        className,
        [
          "v2-flex v2-items-center v2-gap-x-4 v2-px-4 v2-py-1 v2-select-none",
          "v2-cursor-pointer v2-font-circular v2-text-sm v2-font-medium"
        ],
        {
          "v2-text-neutral-900 hover:v2-bg-yellow-100": theme2 === "default" /* Primary */,
          "v2-text-orange-700 hover:v2-bg-magenta-50": theme2 === "red" /* Red */
        }
      ),
      onClick
    },
    logo,
    label
  );
}

// src/components/MeatballMenu/MeatballMenuContainer.tsx
function MeatballMenuContainer({
  active,
  items,
  className
}) {
  return /* @__PURE__ */ import_react155.default.createElement(
    "ul",
    {
      className: (0, import_classnames100.default)(
        className,
        [
          "v2-h-auto v2-block v2-relative v2-bg-white v2-drop-shadow v2-rounded",
          "v2-p-0 v2-m-0"
        ],
        {
          "v2-animate-fade-in-up-150": active,
          "v2-animate-fade-out-down-150": !active
        }
      )
    },
    items == null ? void 0 : items.map((item, index) => {
      return /* @__PURE__ */ import_react155.default.createElement(MeatballMenuItem, __spreadValues({ key: `meatball-menu-item-${index}` }, item));
    })
  );
}

// src/components/MeatballMenu/MeatballMenu.tsx
var import_react156 = __toESM(require("react"));
var import_classnames101 = __toESM(require("classnames"));
var import_react_tiny_popover3 = require("react-tiny-popover");
var import_react_fontawesome22 = require("@fortawesome/react-fontawesome");
function MeatballMenu({
  positions = ["bottom"],
  align = "end",
  padding = 5,
  className,
  containerClassName,
  bodyClassName,
  containerRef,
  reposition,
  items,
  disabled = false
}) {
  const ref = containerRef != null ? containerRef : (0, import_react156.useRef)(null);
  const [open, setOpen] = (0, import_react156.useState)(false);
  const delayedOpenState = useDelayedState(open);
  const onClick = () => {
    if (!disabled) {
      setOpen(!open);
    }
  };
  return /* @__PURE__ */ import_react156.default.createElement(
    import_react_tiny_popover3.Popover,
    {
      ref,
      containerClassName: (0, import_classnames101.default)(className, "meatball-menu v2-z-99"),
      isOpen: delayedOpenState,
      onClickOutside: () => setOpen(false),
      padding,
      content: /* @__PURE__ */ import_react156.default.createElement(
        MeatballMenuContainer,
        {
          active: open,
          className: containerClassName,
          items
        }
      ),
      positions,
      align,
      reposition
    },
    /* @__PURE__ */ import_react156.default.createElement(
      "div",
      {
        className: (0, import_classnames101.default)(
          bodyClassName,
          [
            "v2-cursor-pointer v2-rounded-full v2-w-[30px] v2-h-[30px]",
            "v2-self-center v2-flex v2-justify-center v2-items-center"
          ],
          {
            "v2-bg-yellow-500 v2-text-neutral-900": open,
            "v2-text-neutral-500 hover:v2-bg-yellow-200": !open && !disabled,
            "v2-text-neutral-200 v2-cursor-not-allowed": !open && disabled
          }
        ),
        onClick
      },
      /* @__PURE__ */ import_react156.default.createElement(import_react_fontawesome22.FontAwesomeIcon, { icon: faEllipsisH, className: "v2-text-xl" })
    )
  );
}

// src/components/Input/Input.tsx
var import_react157 = __toESM(require("react"));
var import_classnames102 = __toESM(require("classnames"));
function Input(_a) {
  var _b = _a, { inputRef, className, disabled } = _b, props = __objRest(_b, ["inputRef", "className", "disabled"]);
  return /* @__PURE__ */ import_react157.default.createElement(
    "input",
    __spreadValues({
      ref: inputRef,
      className: (0, import_classnames102.default)(
        className,
        [
          "v2-w-full v2-border v2-border-neutral-300 v2-border-solid v2-text-neutral-900",
          "v2-h-10 v2-text-base v2-px-4 v2-outline-none placeholder:v2-text-neutral-300"
        ],
        {
          "hover:!v2-border-yellow-500 focus:!v2-border-yellow-500": !disabled,
          "v2-text-neutral-500 v2-bg-neutral-50": disabled
        }
      ),
      disabled
    }, props)
  );
}

// src/components/Carousel/Carousel.tsx
var import_react162 = __toESM(require("react"));
var import_classnames107 = __toESM(require("classnames"));

// src/components/Carousel/CarouselGroupedNavigator.tsx
var import_react160 = __toESM(require("react"));
var import_classnames105 = __toESM(require("classnames"));

// src/components/Carousel/CarouselNavigatorContainer.tsx
var import_react158 = __toESM(require("react"));
var import_classnames103 = __toESM(require("classnames"));
function CarouselNavigatorContainer({
  className,
  children,
  onClick,
  disabled = false
}) {
  return /* @__PURE__ */ import_react158.default.createElement(
    "span",
    {
      className: (0, import_classnames103.default)("carousel-navigator-container", className, [
        "v2-absolute v2-text-black v2-cursor-pointer",
        "-v2-translate-y-1/2 v2-flex v2-top-1/2 v2-items-center"
      ]),
      onClick: disabled ? void 0 : onClick
    },
    children
  );
}

// src/components/Carousel/CarouselNavigatorIcon.tsx
var import_react159 = __toESM(require("react"));
var import_classnames104 = __toESM(require("classnames"));
var import_react_fontawesome23 = require("@fortawesome/react-fontawesome");
var import_styled12 = __toESM(require("@emotion/styled"));
var NavigatorIcon = (0, import_styled12.default)(import_react_fontawesome23.FontAwesomeIcon)`
  ${({
  chevronColor = colors.neutral[900],
  chevronHoverColor = colors.neutral[900]
}) => `
    color: ${chevronColor};

    &:hover {
      color: ${chevronHoverColor};
    }
   
  `}
`;
function CarouselNavigatorIcon({
  disabled = false,
  icon,
  className,
  onClick,
  chevronColor,
  chevronHoverColor
}) {
  if (!icon)
    return /* @__PURE__ */ import_react159.default.createElement(import_react159.default.Fragment, null);
  return /* @__PURE__ */ import_react159.default.createElement(
    NavigatorIcon,
    {
      icon,
      className: (0, import_classnames104.default)(
        "carousel-navigator-icon",
        className,
        "v2-text-[38px] v2-w-8 v2-select-none v2-transition-all",
        {
          "!v2-text-neutral-300 v2-cursor-not-allowed": disabled
        }
      ),
      onClick: disabled ? void 0 : onClick,
      chevronColor,
      chevronHoverColor
    }
  );
}

// src/components/Carousel/CarouselGroupedNavigator.tsx
function CarouselGroupedNavigator({
  className,
  leftNavigatorProps,
  leftNavigatorComponent,
  rightNavigatorProps,
  rightNavigatorComponent
}) {
  return /* @__PURE__ */ import_react160.default.createElement("div", { className: (0, import_classnames105.default)("carousel-grouped-navigator", className) }, /* @__PURE__ */ import_react160.default.createElement(
    CarouselNavigatorContainer,
    __spreadProps(__spreadValues({}, leftNavigatorProps), {
      className: (0, import_classnames105.default)(leftNavigatorProps == null ? void 0 : leftNavigatorProps.containerClassName, "v2-left-1")
    }),
    leftNavigatorComponent != null ? leftNavigatorComponent : /* @__PURE__ */ import_react160.default.createElement(CarouselNavigatorIcon, __spreadValues({}, leftNavigatorProps))
  ), /* @__PURE__ */ import_react160.default.createElement(
    CarouselNavigatorContainer,
    __spreadProps(__spreadValues({}, rightNavigatorProps), {
      className: (0, import_classnames105.default)(rightNavigatorProps == null ? void 0 : rightNavigatorProps.containerClassName, "v2-right-1")
    }),
    rightNavigatorComponent != null ? rightNavigatorComponent : /* @__PURE__ */ import_react160.default.createElement(CarouselNavigatorIcon, __spreadValues({}, rightNavigatorProps))
  ));
}

// src/components/Carousel/CarouselIndicators.tsx
var import_react161 = __toESM(require("react"));
var import_classnames106 = __toESM(require("classnames"));
var import_styled13 = __toESM(require("@emotion/styled"));
var IndicatorSpan = import_styled13.default.span`
  ${({
  active = false,
  indicatorColor = colors.neutral[300],
  indicatorActiveColor = colors.yellow[500]
}) => `
    ${!active ? `background-color: ${indicatorColor} !important;` : ""}
    ${active ? `background-color: ${indicatorActiveColor} !important;` : ""}
  `}
`;
function CarouselIndicators({
  activeIndex,
  items,
  onClick,
  indicatorComponent,
  className,
  indicatorColor,
  indicatorActiveColor
}) {
  const indicatorsComponent = () => {
    const indicators = [];
    for (let i = 1; i <= items; i++) {
      indicators.push(
        /* @__PURE__ */ import_react161.default.createElement("span", { key: `indicator-container-${i}` }, indicatorComponent != null ? indicatorComponent : /* @__PURE__ */ import_react161.default.createElement(
          IndicatorSpan,
          {
            active: activeIndex === i - 1,
            key: `indicator-${i}`,
            onClick: () => onClick(i - 1),
            className: (0, import_classnames106.default)(
              "carousel-indicator-item",
              "v2-w-[15px] v2-h-[15px] v2-rounded-full v2-block",
              "v2-cursor-pointer v2-transition-all"
            ),
            indicatorColor,
            indicatorActiveColor
          }
        ))
      );
    }
    return indicators;
  };
  return /* @__PURE__ */ import_react161.default.createElement(
    "div",
    {
      className: (0, import_classnames106.default)("carousel-indicators-container", className, [
        "v2-flex v2-flex-row v2-gap-x-3 v2-gap-y-4 v2-py-2.5",
        "v2-flex-wrap v2-items-center v2-justify-center"
      ])
    },
    indicatorsComponent()
  );
}

// src/components/Carousel/Carousel.tsx
var poweredByBonjoroIcon = "https://cdn.bonjoro.com/assets/icons/powered-by-bj.svg";
function Carousel(_a) {
  var _b = _a, {
    activeIndex,
    setActiveIndex,
    setToPrev: onPrevClick,
    setToNext: onNextClick,
    carouselRef,
    transitionDuration = 300,
    children,
    overflowClassName,
    overflowStyle,
    containerClassName,
    className,
    groupedNavigatorClassName,
    items,
    hideNavigator = false,
    hideIndicators = false,
    hideBonjoroBadge = false,
    bonjoroBadgeIconClassName,
    styleProps,
    onBonjoroBadgeClick,
    leftNavigatorProps,
    leftNavigatorComponent,
    rightNavigatorProps,
    rightNavigatorComponent,
    indicatorComponent
  } = _b, otherProps = __objRest(_b, [
    "activeIndex",
    "setActiveIndex",
    "setToPrev",
    "setToNext",
    "carouselRef",
    "transitionDuration",
    "children",
    "overflowClassName",
    "overflowStyle",
    "containerClassName",
    "className",
    "groupedNavigatorClassName",
    "items",
    "hideNavigator",
    "hideIndicators",
    "hideBonjoroBadge",
    "bonjoroBadgeIconClassName",
    "styleProps",
    "onBonjoroBadgeClick",
    "leftNavigatorProps",
    "leftNavigatorComponent",
    "rightNavigatorProps",
    "rightNavigatorComponent",
    "indicatorComponent"
  ]);
  const ref = carouselRef != null ? carouselRef : (0, import_react162.useRef)(null);
  const showFooter = !hideIndicators || !hideBonjoroBadge;
  const navigatorIconStyleProps = {
    chevronColor: styleProps == null ? void 0 : styleProps.chevronColor,
    chevronHoverColor: styleProps == null ? void 0 : styleProps.chevronHoverColor
  };
  return /* @__PURE__ */ import_react162.default.createElement(
    "div",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames107.default)(
        "carousel-container",
        containerClassName,
        "v2-flex v2-flex-col v2-gap-y-2"
      )
    }),
    /* @__PURE__ */ import_react162.default.createElement(
      "div",
      {
        className: (0, import_classnames107.default)(
          "carousel-overflow",
          overflowClassName,
          "v2-overflow-hidden v2-relative"
        ),
        style: overflowStyle
      },
      /* @__PURE__ */ import_react162.default.createElement(
        "ul",
        {
          ref,
          className: (0, import_classnames107.default)(
            "carousel",
            className,
            "v2-p-0 v2-m-0 v2-whitespace-nowrap v2-transition v2-relative v2-h-full"
          ),
          style: {
            transform: `translateX(-${activeIndex * 100}%)`,
            transitionDuration: `${transitionDuration}ms`
          }
        },
        import_react162.default.Children.map(children, (child) => {
          if (child == null)
            return;
          return import_react162.default.cloneElement(child);
        })
      ),
      !hideNavigator && /* @__PURE__ */ import_react162.default.createElement(
        CarouselGroupedNavigator,
        {
          className: groupedNavigatorClassName,
          leftNavigatorComponent,
          leftNavigatorProps: __spreadProps(__spreadValues(__spreadValues({}, leftNavigatorProps), navigatorIconStyleProps), {
            icon: faChevronLeft,
            onClick: onPrevClick,
            disabled: activeIndex == 0
          }),
          rightNavigatorComponent,
          rightNavigatorProps: __spreadProps(__spreadValues(__spreadValues({}, rightNavigatorProps), navigatorIconStyleProps), {
            icon: faChevronRight,
            onClick: onNextClick,
            disabled: activeIndex + 1 == items
          })
        }
      )
    ),
    showFooter && /* @__PURE__ */ import_react162.default.createElement("div", { className: "carousel-footer v2-flex v2-flex-row v2-gap-x-4 v2-items-center v2-justify-center" }, !hideBonjoroBadge && /* @__PURE__ */ import_react162.default.createElement(
      "img",
      {
        className: (0, import_classnames107.default)(
          "carousel-bonjoro-badge",
          bonjoroBadgeIconClassName,
          "v2-h-8 v2-w-24 v2-cursor-pointer v2-select-none"
        ),
        src: poweredByBonjoroIcon,
        onClick: onBonjoroBadgeClick
      }
    ), !hideIndicators && /* @__PURE__ */ import_react162.default.createElement(
      CarouselIndicators,
      {
        indicatorComponent,
        activeIndex,
        items,
        onClick: setActiveIndex,
        indicatorColor: styleProps == null ? void 0 : styleProps.indicatorColor,
        indicatorActiveColor: styleProps == null ? void 0 : styleProps.indicatorActiveColor
      }
    ))
  );
}

// src/components/Carousel/CarouselItem.tsx
var import_react163 = __toESM(require("react"));
var import_classnames108 = __toESM(require("classnames"));
function CarouselItem({
  children,
  className,
  outerClassName,
  innerClassName
}) {
  return /* @__PURE__ */ import_react163.default.createElement(
    "div",
    {
      className: (0, import_classnames108.default)("carousel-item", className, [
        "v2-w-full v2-h-full v2-inline-flex"
      ])
    },
    /* @__PURE__ */ import_react163.default.createElement(
      "div",
      {
        className: (0, import_classnames108.default)("carousel-item-outer", outerClassName, [
          "v2-w-full v2-h-full v2-relative v2-items-center v2-justify-center"
        ])
      },
      /* @__PURE__ */ import_react163.default.createElement(
        "div",
        {
          className: (0, import_classnames108.default)(
            "carousel-item-inner",
            innerClassName,
            "v2-w-full v2-h-full v2-absolute"
          )
        },
        children
      )
    )
  );
}

// src/hook/use-child-observer-hook.ts
var import_react164 = require("react");
function useChildObserver({ ref, onChange }) {
  const mutationObserver = new MutationObserver((mutationsList) => {
    if (ref == null ? void 0 : ref.current) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          onChange == null ? void 0 : onChange();
        }
      }
    }
  });
  (0, import_react164.useEffect)(() => {
    if (ref == null ? void 0 : ref.current) {
      mutationObserver.observe(ref.current, { childList: true });
      return () => {
        mutationObserver.disconnect();
      };
    }
  }, [ref == null ? void 0 : ref.current]);
}

// src/components/Carousel/use-carousel-hook.tsx
var import_react165 = require("react");
function useCarousel(carouselRef, options2) {
  const [activeIndex, setActiveIndex] = (0, import_react165.useState)(0);
  const [items, setItems] = (0, import_react165.useState)(0);
  (0, import_react165.useEffect)(() => {
    if (carouselRef == null ? void 0 : carouselRef.current) {
      setItems(carouselRef == null ? void 0 : carouselRef.current.childElementCount);
    }
  }, []);
  const updateActiveIndex = (index) => {
    if (index < 0) {
      index = items - 1;
    } else if (index >= items) {
      index = 0;
    }
    setActiveIndex(index);
  };
  useChildObserver({
    ref: carouselRef,
    onChange: () => {
      var _a;
      if (carouselRef == null ? void 0 : carouselRef.current) {
        setItems((_a = carouselRef == null ? void 0 : carouselRef.current) == null ? void 0 : _a.children.length);
        if (options2 == null ? void 0 : options2.resetIndexOnItemsChange) {
          setActiveIndex(0);
        }
      }
    }
  });
  (0, import_react165.useEffect)(() => {
    if (items > 0 && activeIndex > items - 1) {
      setActiveIndex(items - 1);
    }
  }, [items, activeIndex]);
  return {
    activeIndex,
    setActiveIndex: updateActiveIndex,
    setToFirst: () => updateActiveIndex(0),
    setToLast: () => updateActiveIndex(items - 1),
    setToNext: () => updateActiveIndex(activeIndex + 1),
    setToPrev: () => updateActiveIndex(activeIndex - 1),
    items
  };
}

// src/components/ThumbnailPicker/ThumbnailPicker.tsx
var import_react166 = __toESM(require("react"));
var import_classnames109 = __toESM(require("classnames"));
var import_styled14 = __toESM(require("@emotion/styled"));
var ThumbnailType = /* @__PURE__ */ ((ThumbnailType2) => {
  ThumbnailType2["Original"] = "original";
  ThumbnailType2["Small"] = "small";
  ThumbnailType2["Square"] = "square";
  return ThumbnailType2;
})(ThumbnailType || {});
var StyledGrid = import_styled14.default.div`
  grid-template-columns: ${({ columns }) => `repeat(${columns}, minmax(0, 1fr))`};
`;
function ThumbnailPicker({
  className,
  gridClassName,
  imgClassName,
  onSelect,
  thumbnails = [],
  columns = 3,
  selected,
  type = "small" /* Small */
}) {
  return /* @__PURE__ */ import_react166.default.createElement(
    "div",
    {
      className: (0, import_classnames109.default)(className, [
        "v2-border v2-border-solid v2-border-neutral-200",
        "v2-bg-white v2-p-2.5 v2-justify-center v2-items-center v2-overflow-y-auto"
      ])
    },
    /* @__PURE__ */ import_react166.default.createElement(
      StyledGrid,
      {
        columns,
        className: (0, import_classnames109.default)(gridClassName, [
          "v2-grid v2-gap-x-1.5 v2-gap-y-1.5 v2-transition-all",
          "v2-w-fit v2-justify-center v2-items-center"
        ])
      },
      thumbnails && thumbnails.length > 0 && (thumbnails == null ? void 0 : thumbnails.map((thumbnail, index) => /* @__PURE__ */ import_react166.default.createElement(
        "img",
        {
          key: index,
          className: (0, import_classnames109.default)(
            imgClassName,
            [
              "v2-p-[0.187rem] hover:v2-bg-yellow-500 v2-cursor-pointer",
              "v2-transition-all max-w-full h-auto v2-animate-fade-in-150"
            ],
            {
              "v2-bg-yellow-500": index === selected
            }
          ),
          onClick: () => onSelect == null ? void 0 : onSelect(index),
          src: thumbnail[type].data,
          height: thumbnail[type].height,
          width: thumbnail[type].width
        }
      )))
    )
  );
}

// src/components/ThumbnailPicker/use-generate-interpolated-thumbnails.ts
var import_react167 = require("react");
function useGenerateInterpolatedThumbnails(thumbnails = [], thumbnailCount = 9) {
  const [interpolatedThumbnails, setInterpolatedThumbnails] = (0, import_react167.useState)([]);
  (0, import_react167.useEffect)(() => {
    if (!thumbnails || (thumbnails == null ? void 0 : thumbnails.length) === 0)
      return;
    const count = thumbnails.length;
    if (count > 0) {
      const step = count / thumbnailCount;
      const indices = Array(thumbnailCount).fill(0).map((_, i) => Math.floor(step * i));
      setInterpolatedThumbnails(indices.map((index) => thumbnails[index]));
    }
  }, [thumbnails, thumbnailCount]);
  return interpolatedThumbnails;
}

// src/components/Switch/Switch.tsx
var import_react168 = __toESM(require("react"));
var import_classnames110 = __toESM(require("classnames"));
var SwitchTheme = /* @__PURE__ */ ((SwitchTheme2) => {
  SwitchTheme2["Yellow"] = "yellow";
  SwitchTheme2["Blue"] = "blue";
  SwitchTheme2["Magenta"] = "magenta";
  return SwitchTheme2;
})(SwitchTheme || {});
function Switch({
  value: defaultValue = false,
  disabled = false,
  onToggle,
  bodyClassName,
  buttonClassName,
  theme: theme2 = "yellow" /* Yellow */
}) {
  const [value, setValue] = (0, import_react168.useState)(defaultValue);
  const onToggleHandler = (value2) => {
    if (disabled)
      return;
    setValue(value2);
    onToggle == null ? void 0 : onToggle(value2);
  };
  return /* @__PURE__ */ import_react168.default.createElement(
    "span",
    {
      className: (0, import_classnames110.default)(
        bodyClassName,
        "v2-block v2-w-16 v2-h-8 v2-rounded-full v2-p-0.5",
        {
          "v2-bg-neutral-300": !value && !disabled,
          "v2-bg-neutral-200 v2-cursor-not-allowed": disabled,
          "v2-transition-all v2-duration-150 hover:v2-bg-yellow-200 v2-cursor-pointer": !disabled,
          "v2-bg-yellow-500": value && !disabled && theme2 === "yellow" /* Yellow */,
          "v2-bg-blue-500": value && !disabled && theme2 === "blue" /* Blue */,
          "v2-bg-magenta-500": value && !disabled && theme2 === "magenta" /* Magenta */,
          "hover:v2-bg-yellow-200": !disabled && theme2 === "yellow" /* Yellow */,
          "hover:v2-bg-blue-200": !disabled && theme2 === "blue" /* Blue */,
          "hover:v2-bg-magenta-200": !disabled && theme2 === "magenta" /* Magenta */
        }
      ),
      onClick: () => onToggleHandler(!value)
    },
    /* @__PURE__ */ import_react168.default.createElement(
      "i",
      {
        className: (0, import_classnames110.default)(
          buttonClassName,
          [
            "v2-block v2-relative v2-rounded-full v2-ease-out",
            " v2-h-full v2-w-1/2 v2-transition-all v2-duration-500"
          ],
          {
            "v2-ml-[0%]": !value,
            "v2-ml-[50%]": value,
            "v2-bg-white": !disabled,
            "v2-bg-neutral-100": disabled
          }
        )
      }
    )
  );
}

// src/components/LoadingProgress/LoadingProgress.tsx
var import_react169 = __toESM(require("react"));
var import_classnames111 = __toESM(require("classnames"));
function LoadingProgress({
  progress = 0,
  maxProgress = 100,
  className,
  progressClassName,
  label,
  labelClassName,
  labelStyle
}) {
  const actualProgress = (0, import_react169.useMemo)(() => {
    if (progress < 0)
      return 0;
    if (progress > maxProgress)
      return 100;
    return progress / maxProgress * 100;
  }, [progress, maxProgress]);
  return /* @__PURE__ */ import_react169.default.createElement(
    "span",
    {
      className: (0, import_classnames111.default)(className, [
        "v2-block v2-w-full v2-h-[30px] v2-bg-white/50 v2-rounded-full v2-p-[5px] ",
        "v2-transition-all v2-duration-150 v2-cursor-pointer v2-relative"
      ])
    },
    /* @__PURE__ */ import_react169.default.createElement(
      "i",
      {
        className: (0, import_classnames111.default)(progressClassName, [
          "v2-block v2-relative v2-bg-yellow-500 v2-rounded-full v2-ease-out",
          " v2-h-full v2-transition-all v2-duration-500"
        ]),
        style: {
          width: `${actualProgress}%`
        }
      }
    ),
    label && /* @__PURE__ */ import_react169.default.createElement(
      "span",
      {
        className: (0, import_classnames111.default)(labelClassName, [
          "v2-transform v2-absolute v2-w-full v2-text-center v2-truncate",
          "v2-top-1/2 v2-left-1/2 -v2-translate-x-1/2 -v2-translate-y-1/2"
        ]),
        style: labelStyle
      },
      label
    )
  );
}

// src/components/Anchor/Anchor.tsx
var import_react170 = __toESM(require("react"));
var import_classnames112 = __toESM(require("classnames"));
var Anchor = import_react170.default.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, otherProps = __objRest(_b, ["className", "children"]);
    return /* @__PURE__ */ import_react170.default.createElement(
      "a",
      __spreadValues({
        ref,
        className: (0, import_classnames112.default)(
          className,
          "v2-cursor-pointer v2-underline focus:v2-underline hover:v2-underline",
          "v2-text-neutral-500 focus:v2-text-neutral-500 hover:v2-text-neutral-900 "
        )
      }, otherProps),
      children
    );
  }
);

// src/components/EmbedTile/EmbedTile.tsx
var import_react179 = __toESM(require("react"));
var import_classnames120 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileProfilePanel.tsx
var import_react171 = __toESM(require("react"));
var import_classnames113 = __toESM(require("classnames"));
var import_react_loading_skeleton3 = __toESM(require("react-loading-skeleton"));
function Loading2() {
  return /* @__PURE__ */ import_react171.default.createElement("div", { className: "v2-w-full v2-flex v2-space-x-2.5" }, /* @__PURE__ */ import_react171.default.createElement(
    import_react_loading_skeleton3.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      circle: true,
      containerClassName: "v2-h-10 v2-w-10 v2-flex"
    }
  ), /* @__PURE__ */ import_react171.default.createElement("div", { className: "v2-w-3/5 v2-flex v2-flex-col v2-space-y-1" }, /* @__PURE__ */ import_react171.default.createElement(
    import_react_loading_skeleton3.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      containerClassName: "v2-h-5 v2-w-3/5 v2-flex"
    }
  ), /* @__PURE__ */ import_react171.default.createElement(
    import_react_loading_skeleton3.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      containerClassName: "v2-h-3.5 v2-w-3/5 v2-flex"
    }
  )));
}
function EmbedTileProfilePanel({
  imageUrl,
  name,
  tag,
  url,
  className,
  imageClassName,
  nameClassName,
  tagClassName,
  hideProfileImage = false,
  hideProfileName = false,
  hideProfileTag = false,
  loading = false,
  imageComponent: DefaultImageComponent
}) {
  if (loading)
    return /* @__PURE__ */ import_react171.default.createElement(Loading2, null);
  const imageProps = {
    src: imageUrl,
    width: 0,
    height: 0,
    alt: "Profile Picture",
    className: (0, import_classnames113.default)(imageClassName, [
      "v2-rounded-full v2-h-10 v2-w-10 v2-object-cover v2-transition-all v2-ease-in-out",
      "group-hover:v2-outline-blue-300 group-hover:v2-outline",
      "group-hover:-v2-outline-offset-2 group-hover:v2-outline-2"
    ])
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react171.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return imageUrl;
      }
    })
  ) : /* @__PURE__ */ import_react171.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react171.default.createElement(
    "a",
    {
      className: (0, import_classnames113.default)(className, [
        "v2-flex v2-flex-row v2-gap-x-2.5 v2-items-center",
        "v2-group v2-truncate"
      ]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    !hideProfileImage && imageUrl && imageComponent,
    /* @__PURE__ */ import_react171.default.createElement("div", { className: "v2-flex v2-flex-col v2-items-start v2-justify-between v2-gap-1" }, !hideProfileName && name && /* @__PURE__ */ import_react171.default.createElement(
      "span",
      {
        className: (0, import_classnames113.default)(nameClassName, [
          "v2-text-neutral-900 v2-text-base group-hover:v2-underline"
        ])
      },
      name
    ), !hideProfileTag && tag && /* @__PURE__ */ import_react171.default.createElement(
      "span",
      {
        className: (0, import_classnames113.default)(tagClassName, [
          "v2-text-neutral-500 v2-text-xs group-hover:v2-underline"
        ])
      },
      tag
    ))
  );
}

// src/components/EmbedTile/EmbedTileReactionPanel.tsx
var import_react173 = __toESM(require("react"));
var import_classnames115 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileIconImage.tsx
var import_react172 = __toESM(require("react"));
var import_classnames114 = __toESM(require("classnames"));
function EmbedTileIconImage({
  type,
  reactionType,
  loading = false,
  theme: theme2,
  className,
  imageComponent: DefaultImageComponent,
  height = 0,
  width = 0
}) {
  var _a, _b, _c, _d, _e;
  const defaultClassName2 = "v2-shrink-0 v2-transition-all";
  const details = reactionType ? (_c = (_b = (_a = embedTileDetails) == null ? void 0 : _a[type]) == null ? void 0 : _b.reactions) == null ? void 0 : _c[reactionType] : (_e = (_d = embedTileDetails) == null ? void 0 : _d[type]) == null ? void 0 : _e.icon;
  if (!details)
    return /* @__PURE__ */ import_react172.default.createElement(import_react172.default.Fragment, null);
  const { url, iconType, iconClassName } = details;
  const imageProps = {
    src: url,
    alt: "Icon Image",
    width,
    height,
    className: (0, import_classnames114.default)(className, iconClassName, defaultClassName2, {
      "v2-grayscale": loading
    })
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react172.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return url;
      }
    })
  ) : /* @__PURE__ */ import_react172.default.createElement("img", __spreadValues({}, imageProps));
  if (iconType === "masked_image") {
    return /* @__PURE__ */ import_react172.default.createElement(
      Image3,
      {
        imageUrl: url,
        className: (0, import_classnames114.default)(className, iconClassName, defaultClassName2, {
          "!v2-bg-neutral-200": loading
        }),
        bgColor: theme2 == null ? void 0 : theme2.primaryColor,
        hideWhiteBackground: true
      }
    );
  }
  return imageComponent;
}

// src/components/EmbedTile/EmbedTileReactionPanel.tsx
var import_react_loading_skeleton4 = __toESM(require("react-loading-skeleton"));
function EmbedTileReactionPanel({
  type,
  reactions,
  url,
  className,
  reactionClassName,
  countClassName,
  loading = false
}) {
  const totalReactions = reactions == null ? void 0 : reactions.reduce((n, { count }) => n + count, 0);
  if (!totalReactions && !loading)
    return /* @__PURE__ */ import_react173.default.createElement(import_react173.default.Fragment, null);
  return /* @__PURE__ */ import_react173.default.createElement(
    "a",
    {
      className: (0, import_classnames115.default)(className, [
        "v2-flex v2-flex-row v2-gap-x-2.5 v2-items-center",
        "v2-cursor-pointer v2-group"
      ]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    loading && /* @__PURE__ */ import_react173.default.createElement("span", { className: "v2-flex v2-flex-row v2-gap-x-[3px]" }, /* @__PURE__ */ import_react173.default.createElement(
      EmbedTileIconImage,
      {
        type,
        reactionType: "like" /* Like */,
        className: (0, import_classnames115.default)(reactionClassName),
        width: 15,
        height: 15,
        loading: true
      }
    )),
    reactions && /* @__PURE__ */ import_react173.default.createElement(
      "span",
      { className: "v2-flex v2-flex-row v2-gap-x-[3px]" },
      /** Show only up to 3 reactions */
      reactions.slice(0, 3).map(({ type: reactionType }, index) => {
        return /* @__PURE__ */ import_react173.default.createElement(
          EmbedTileIconImage,
          {
            key: index,
            type,
            reactionType,
            className: (0, import_classnames115.default)(reactionClassName, "v2-h-[15px] v2-w-[15px]")
          }
        );
      })
    ),
    /* @__PURE__ */ import_react173.default.createElement(
      "span",
      {
        className: (0, import_classnames115.default)(countClassName, [
          "v2-flex v2-text-neutral-500 v2-text-xs v2-font-bold",
          "v2-transition-all group-hover:v2-text-neutral-900"
        ])
      },
      loading ? /* @__PURE__ */ import_react173.default.createElement(
        import_react_loading_skeleton4.default,
        {
          baseColor: colors.neutral[200],
          highlightColor: colors.neutral[100],
          height: "100%",
          containerClassName: "v2-h-4 v2-w-6 v2-flex"
        }
      ) : toCompactNumber(reactions == null ? void 0 : reactions.reduce((n, { count }) => n + count, 0))
    )
  );
}

// src/components/EmbedTile/EmbedTileTextContent.tsx
var import_react174 = __toESM(require("react"));

// node_modules/linkify-react/dist/linkify-react.es.js
var React144 = __toESM(require("react"));
var import_linkifyjs = require("linkifyjs");
function stringToElements(str, opts, meta) {
  const tokens = (0, import_linkifyjs.tokenize)(str);
  const elements = [];
  for (let i = 0; i < tokens.length; i++) {
    const token2 = tokens[i];
    if (token2.t === "nl" && opts.get("nl2br")) {
      const key2 = `__linkify-el-${meta.elementId++}`;
      elements.push(React144.createElement("br", {
        key: key2
      }));
    } else if (!token2.isLink || !opts.check(token2)) {
      elements.push(token2.toString());
    } else {
      let rendered = opts.render(token2);
      if (!("key" in rendered.props)) {
        const key2 = `__linkify-el-${meta.elementId++}`;
        const props = import_linkifyjs.options.assign({
          key: key2
        }, rendered.props);
        rendered = React144.cloneElement(rendered, props);
      }
      elements.push(rendered);
    }
  }
  return elements;
}
function linkifyReactElement(element, opts, meta) {
  if (React144.Children.count(element.props.children) === 0) {
    return element;
  }
  const children = [];
  React144.Children.forEach(element.props.children, (child) => {
    if (typeof child === "string") {
      children.push.apply(children, stringToElements(child, opts, meta));
    } else if (React144.isValidElement(child)) {
      if (typeof child.type === "string" && opts.ignoreTags.indexOf(child.type.toUpperCase()) >= 0) {
        children.push(child);
      } else {
        children.push(linkifyReactElement(child, opts, meta));
      }
    } else {
      children.push(child);
    }
  });
  const key2 = `__linkify-el-${meta.elementId++}`;
  const newProps = import_linkifyjs.options.assign({
    key: key2
  }, element.props);
  return React144.cloneElement(element, newProps, children);
}
var Linkify = (props) => {
  let linkId = 0;
  const defaultLinkRender = (_ref) => {
    let {
      tagName,
      attributes,
      content
    } = _ref;
    attributes.key = `__linkify-lnk-${linkId++}`;
    if (attributes.class) {
      attributes.className = attributes.class;
      delete attributes.class;
    }
    return React144.createElement(tagName, attributes, content);
  };
  const newProps = {
    key: "__linkify-wrapper"
  };
  for (const prop in props) {
    if (prop !== "options" && prop !== "as" && prop !== "tagName" && prop !== "children") {
      newProps[prop] = props[prop];
    }
  }
  const opts = new import_linkifyjs.Options(props.options, defaultLinkRender);
  const as = props.as || props.tagName || React144.Fragment || "span";
  const children = props.children;
  const element = React144.createElement(as, newProps, children);
  return linkifyReactElement(element, opts, {
    elementId: 0
  });
};

// node_modules/linkify-plugin-hashtag/dist/linkify-plugin-hashtag.es.js
var import_linkifyjs2 = require("linkifyjs");
var HashtagToken = (0, import_linkifyjs2.createTokenClass)("hashtag", {
  isLink: true
});
function hashtag(_ref) {
  let {
    scanner,
    parser
  } = _ref;
  const {
    POUND,
    UNDERSCORE
  } = scanner.tokens;
  const {
    alpha,
    numeric,
    alphanumeric,
    emoji
  } = scanner.tokens.groups;
  const Hash = parser.start.tt(POUND);
  const HashPrefix = Hash.tt(UNDERSCORE);
  const Hashtag = new import_linkifyjs2.State(HashtagToken);
  Hash.ta(numeric, HashPrefix);
  Hash.ta(alpha, Hashtag);
  Hash.ta(emoji, Hashtag);
  HashPrefix.ta(alpha, Hashtag);
  HashPrefix.ta(emoji, Hashtag);
  HashPrefix.ta(numeric, HashPrefix);
  HashPrefix.tt(UNDERSCORE, HashPrefix);
  Hashtag.ta(alphanumeric, Hashtag);
  Hashtag.ta(emoji, Hashtag);
  Hashtag.tt(UNDERSCORE, Hashtag);
}
(0, import_linkifyjs2.registerPlugin)("hashtag", hashtag);

// src/components/EmbedTile/EmbedTileTextContent.tsx
var import_styled15 = __toESM(require("@emotion/styled"));
var Container3 = import_styled15.default.span`
  a {
    color: ${colors.blue[400]};

    &:hover {
      text-decoration: underline;
    }
  }
`;
function EmbedTileTextContent({
  type,
  text,
  style
}) {
  const options2 = (0, import_react174.useMemo)(() => {
    const defaultOptions = {
      nl2br: true,
      target: "_blank",
      rel: "noopener noreferrer"
    };
    if (isTwitterEmbed(type)) {
      return __spreadProps(__spreadValues({}, defaultOptions), {
        formatHref: {
          hashtag: (href) => "https://twitter.com/hashtag/" + href.substr(1)
        }
      });
    }
    if (isLinkedinEmbed(type)) {
      return __spreadProps(__spreadValues({}, defaultOptions), {
        formatHref: {
          hashtag: (href) => "https://www.linkedin.com/feed/hashtag/?keywords=" + href.substr(1)
        }
      });
    }
  }, [type]);
  const content = typeof text === "string" ? /* @__PURE__ */ import_react174.default.createElement(Linkify, { options: options2 }, text) : /* @__PURE__ */ import_react174.default.createElement(RichTextViewer, { value: text, style });
  return /* @__PURE__ */ import_react174.default.createElement(Container3, { className: "v2-whitespace-pre-wrap v2-px-5" }, content);
}

// src/components/EmbedTile/EmbedTileMediaContent.tsx
var import_react176 = __toESM(require("react"));
var import_classnames117 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileMediaTile.tsx
var import_react175 = __toESM(require("react"));
var import_classnames116 = __toESM(require("classnames"));
var import_styled16 = __toESM(require("@emotion/styled"));
var playIcon = "https://cdn.bonjoro.com/assets/Flat-icons/play.svg";
var PlayIconContainer = import_styled16.default.span`
  ${({ bgColor }) => {
  if (bgColor) {
    return `background-color:  ${bgColor} !important`;
  }
}}
`;
function EmbedTileMediaTile(_a) {
  var _b = _a, {
    type,
    url,
    thumbnailUrl,
    transcriptionClassName,
    onThumbnailLoad,
    onThumbnailLoadError,
    theme: theme2,
    playable = false,
    hidePlayIcon = false,
    preload = "auto",
    loadOnIntersect = false,
    onClick,
    className,
    imageComponent: DefaultImageComponent
  } = _b, props = __objRest(_b, [
    "type",
    "url",
    "thumbnailUrl",
    "transcriptionClassName",
    "onThumbnailLoad",
    "onThumbnailLoadError",
    "theme",
    "playable",
    "hidePlayIcon",
    "preload",
    "loadOnIntersect",
    "onClick",
    "className",
    "imageComponent"
  ]);
  const defaultClassName2 = (0, import_classnames116.default)(className, genericTileHoverEffectClassName, [
    "v2-object-cover v2-h-auto v2-w-full v2-cursor-pointer v2-drop-shadow"
  ]);
  const imageProps = {
    src: thumbnailUrl != null ? thumbnailUrl : url,
    alt: "Media Tile",
    width: 0,
    height: 0,
    className: defaultClassName2,
    onClick,
    onLoad: onThumbnailLoad,
    onError: onThumbnailLoadError
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react175.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return thumbnailUrl != null ? thumbnailUrl : url;
      }
    })
  ) : /* @__PURE__ */ import_react175.default.createElement("img", __spreadValues({}, imageProps));
  if (type === "video" /* Video */ && !playable) {
    return /* @__PURE__ */ import_react175.default.createElement("div", { className: "v2-relative v2-w-full v2-group" }, !hidePlayIcon && /* @__PURE__ */ import_react175.default.createElement(
      PlayIconContainer,
      {
        bgColor: theme2 == null ? void 0 : theme2.primaryColor,
        className: (0, import_classnames116.default)(genericTileHoverEffectClassName, [
          "v2-absolute v2-top-1/2 v2-left-1/2 v2-z-20 v2-flex v2-bg-neutral-900/50",
          "-v2-translate-x-1/2 -v2-translate-y-1/2 v2-rounded-full v2-p-3"
        ])
      },
      /* @__PURE__ */ import_react175.default.createElement(
        Image3,
        {
          imageUrl: playIcon,
          className: "v2-h-[30px] v2-w-[30px] v2-relative"
        }
      )
    ), thumbnailUrl ? imageComponent : /* @__PURE__ */ import_react175.default.createElement(
      "video",
      {
        src: `${url}#t=1.00`,
        className: (0, import_classnames116.default)(defaultClassName2, "v2-z-10"),
        muted: true,
        onClick
      }
    ));
  }
  if (type === "video" /* Video */ && playable) {
    return /* @__PURE__ */ import_react175.default.createElement(
      VideoPlayerComponent,
      __spreadProps(__spreadValues({}, props), {
        containerClassName: defaultClassName2,
        videoThumbnail: thumbnailUrl,
        onPlay: onClick,
        onPause: onClick,
        videoUrl: url,
        hidePlayPause: hidePlayIcon,
        hideFullScreen: true,
        hideMuteUnmute: true,
        hideClose: true,
        hideNewTab: true,
        hideLoader: true,
        fadeControlsOnPlay: true,
        forceShowControls: true,
        forceShowThumbnail: true,
        preload,
        loadOnIntersect,
        onThumbnailLoad,
        onThumbnailLoadError,
        videoClassName: "embed-tile-video-player v2-max-w-full v2-h-auto v2-block v2-align-middle",
        videoThumbnailClassName: "v2-max-w-full !v2-w-full v2-h-auto v2-block v2-align-middle",
        transcriptionClassName: (0, import_classnames116.default)(transcriptionClassName, "v2-text-sm"),
        imageComponent: DefaultImageComponent,
        playPauseStyle: { color: theme2 == null ? void 0 : theme2.primaryColor }
      })
    );
  }
  return imageComponent;
}

// src/components/EmbedTile/EmbedTileMediaContent.tsx
function EmbedTileAnchor(_a) {
  var _b = _a, {
    className,
    children
  } = _b, otherProps = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ import_react176.default.createElement(
    "a",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames117.default)(
        className,
        "v2-py-[1px] v2-px-5 v2-transition-all v2-h-full v2-w-full"
      )
    }),
    children
  );
}
function EmbedTileMediaContent({
  media,
  url,
  theme: theme2,
  playable,
  imageComponent
}) {
  const anchorProps = {
    target: "_blank",
    rel: "noopener noreferrer",
    href: url
  };
  if (!media || media.length == 0)
    return /* @__PURE__ */ import_react176.default.createElement(import_react176.default.Fragment, null);
  const defaultTileProps = { theme: theme2, playable, imageComponent };
  const groupOne = media.slice(0, media.length / 2);
  const groupTwo = media.slice(media.length / 2, media.length);
  const hasOneMedia = (media == null ? void 0 : media.length) == 1;
  const hasTwoMedia = (media == null ? void 0 : media.length) == 2;
  const hasThreeMedia = (media == null ? void 0 : media.length) == 3;
  const hasFourOrMoreMedia = (media == null ? void 0 : media.length) >= 4;
  return /* @__PURE__ */ import_react176.default.createElement(
    EmbedTileAnchor,
    __spreadProps(__spreadValues({}, anchorProps), {
      className: (0, import_classnames117.default)("v2-flex v2-gap-0.5 v2-px-5 v2-h-auto v2-w-full", {
        "v2-flex-row": hasThreeMedia || hasTwoMedia,
        "v2-flex-col": hasFourOrMoreMedia
      })
    }),
    (groupOne == null ? void 0 : groupOne.length) > 0 && /* @__PURE__ */ import_react176.default.createElement(
      "div",
      {
        className: (0, import_classnames117.default)("v2-flex v2-h-full v2-gap-0.5", {
          "v2-flex-row": hasFourOrMoreMedia,
          "!v2-w-full": hasOneMedia || hasFourOrMoreMedia,
          "v2-w-1/2": !hasOneMedia
        })
      },
      groupOne.slice(0, 2).map((item, index) => /* @__PURE__ */ import_react176.default.createElement(
        EmbedTileMediaTile,
        __spreadProps(__spreadValues(__spreadValues({
          key: index
        }, defaultTileProps), item), {
          className: (0, import_classnames117.default)(item == null ? void 0 : item.className, {
            "!v2-h-[100px] v2-w-1/2": (groupOne == null ? void 0 : groupOne.length) >= 2,
            "v2-rounded-tl": (groupOne == null ? void 0 : groupOne.length) >= 2 && index == 0,
            "v2-rounded-tr": (groupOne == null ? void 0 : groupOne.length) >= 2 && index == 1,
            "v2-h-[202px] v2-rounded-l": (groupOne == null ? void 0 : groupOne.length) == 1
          })
        })
      ))
    ),
    (groupTwo == null ? void 0 : groupTwo.length) > 0 && /* @__PURE__ */ import_react176.default.createElement(
      "div",
      {
        className: (0, import_classnames117.default)("v2-flex v2-h-full v2-gap-0.5", {
          "v2-flex-row": hasFourOrMoreMedia,
          "v2-flex-col": !hasFourOrMoreMedia,
          "!v2-w-full": hasOneMedia || hasFourOrMoreMedia,
          "v2-w-1/2": !hasOneMedia
        })
      },
      groupTwo.slice(0, 2).map((item, index) => /* @__PURE__ */ import_react176.default.createElement(
        EmbedTileMediaTile,
        __spreadProps(__spreadValues(__spreadValues({
          key: index
        }, defaultTileProps), item), {
          className: (0, import_classnames117.default)(item == null ? void 0 : item.className, {
            "!v2-h-[100px]": (groupTwo == null ? void 0 : groupTwo.length) >= 2,
            "!v2-w-1/2": (groupTwo == null ? void 0 : groupTwo.length) >= 2 && hasFourOrMoreMedia,
            "!v2-w-full": (groupTwo == null ? void 0 : groupTwo.length) == 1,
            "v2-rounded-bl": hasFourOrMoreMedia && (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 0,
            "v2-rounded-tr": !hasFourOrMoreMedia && (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 0,
            "v2-rounded-br": (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 1,
            "v2-h-[202px] v2-rounded-r": (groupOne == null ? void 0 : groupOne.length) >= 1 && (groupTwo == null ? void 0 : groupTwo.length) == 1,
            "v2-rounded": (groupOne == null ? void 0 : groupOne.length) == 0 && (groupTwo == null ? void 0 : groupTwo.length) == 1
          })
        })
      ))
    )
  );
}

// src/components/EmbedTile/EmbedTileLinkContent.tsx
var import_react177 = __toESM(require("react"));
var import_classnames118 = __toESM(require("classnames"));
function getProperLink(links) {
  const completeLinks = links.filter(
    (link) => link.url && link.imageUrl && link.title && link.description
  );
  if (completeLinks.length > 0)
    return completeLinks[0];
  return links[0];
}
function EmbedTileLinkContent({
  links,
  className,
  imageComponent: DefaultImageComponent
}) {
  if (!links || links && (links == null ? void 0 : links.length) === 0)
    return /* @__PURE__ */ import_react177.default.createElement(import_react177.default.Fragment, null);
  const { url, imageUrl, title, description } = getProperLink(links);
  const urlObject = new URL(url);
  const imageProps = {
    src: imageUrl,
    alt: "Link Content",
    width: 0,
    height: 0,
    className: "v2-w-full v2-h-[160px] v2-object-cover"
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react177.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return imageUrl;
      }
    })
  ) : /* @__PURE__ */ import_react177.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react177.default.createElement(
    "a",
    {
      className: (0, import_classnames118.default)(className, ["v2-py-[1px] v2-px-5 v2-flex v2-flex-col"]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    /* @__PURE__ */ import_react177.default.createElement(
      "div",
      {
        className: (0, import_classnames118.default)(
          genericTileHoverEffectClassName,
          "v2-drop-shadow v2-w-full v2-h-full"
        )
      },
      imageUrl && imageComponent,
      /* @__PURE__ */ import_react177.default.createElement("div", { className: "v2-p-2.5 v2-bg-neutral-50 v2-flex v2-flex-col v2-gap-[5px]" }, /* @__PURE__ */ import_react177.default.createElement("span", { className: "v2-text-neutral-500 v2-text-xs v2-truncate" }, urlObject.host.toUpperCase()), title && /* @__PURE__ */ import_react177.default.createElement("span", { className: "v2-text-neutral-900 v2-font-bold v2-text-xs v2-truncate" }, title), description && /* @__PURE__ */ import_react177.default.createElement(
        "span",
        {
          className: (0, import_classnames118.default)("v2-text-xs v2-truncate", {
            "v2-text-neutral-900 v2-font-bold": !title,
            "v2-text-neutral-500": title
          })
        },
        description
      ))
    )
  );
}

// src/components/EmbedTile/EmbedTile.tsx
var import_react_loading_skeleton5 = __toESM(require("react-loading-skeleton"));

// src/components/EmbedTile/EmbedTileErrorContent.tsx
var import_react178 = __toESM(require("react"));
var import_classnames119 = __toESM(require("classnames"));
function EmbedTileErrorContent({
  iconUrl,
  text,
  iconClassName,
  textClassName
}) {
  return /* @__PURE__ */ import_react178.default.createElement("div", { className: "v2-bg-neutral-50 v2-h-[120px] v2-mx-5 v2-flex v2-flex-col v2-items-center v2-justify-center v2-space-y-1" }, iconUrl && /* @__PURE__ */ import_react178.default.createElement(
    Image3,
    {
      imageUrl: iconUrl,
      className: (0, import_classnames119.default)("v2-w-12 v2-h-12 v2-bg-neutral-500", iconClassName),
      hideWhiteBackground: true
    }
  ), text && /* @__PURE__ */ import_react178.default.createElement("div", { className: (0, import_classnames119.default)("v2-text-neutral-500", textClassName) }, text));
}

// src/components/EmbedTile/EmbedTile.tsx
var EmbedTile = import_react179.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      type,
      profile,
      text,
      media,
      reactions,
      url,
      links,
      theme: theme2,
      datetime,
      className,
      hideIcon: defaultHideIcon = false,
      hideText = false,
      hideMedia = false,
      hideLink = false,
      hideDateTime = false,
      hideReaction = false,
      onLoad,
      onClick,
      queued = false,
      playable = false,
      content: customContent,
      cornerRadius = 6,
      hideShadow = false,
      showBorder = false,
      borderWidth,
      borderColor,
      fontFamily,
      imageComponent,
      style
    } = _b, otherProps = __objRest(_b, [
      "type",
      "profile",
      "text",
      "media",
      "reactions",
      "url",
      "links",
      "theme",
      "datetime",
      "className",
      "hideIcon",
      "hideText",
      "hideMedia",
      "hideLink",
      "hideDateTime",
      "hideReaction",
      "onLoad",
      "onClick",
      "queued",
      "playable",
      "content",
      "cornerRadius",
      "hideShadow",
      "showBorder",
      "borderWidth",
      "borderColor",
      "fontFamily",
      "imageComponent",
      "style"
    ]);
    var _a2;
    (0, import_react179.useEffect)(() => {
      onLoad == null ? void 0 : onLoad();
    }, []);
    const {
      formattedDateTime,
      profileTagClassName,
      reactionClassName,
      hideIconWithoutProfile
    } = (0, import_react179.useMemo)(() => {
      const defaultProps2 = {
        formattedDateTime: datetime == null ? void 0 : datetime.toFormat("dd/LL/y"),
        profileTagClassName: "v2-text-blue-400",
        reactionClassName: "group-hover:v2-opacity-50",
        hideIconWithoutProfile: false
      };
      if (isBonjoroResponseEmbed(type)) {
        return __spreadProps(__spreadValues({}, defaultProps2), {
          profileTagClassName: "v2-text-neutral-500",
          hideIconWithoutProfile: true
        });
      }
      return defaultProps2;
    }, [type]);
    const content = () => {
      return /* @__PURE__ */ import_react179.default.createElement(
        "div",
        {
          className: (0, import_classnames120.default)([
            "v2-min-h-[120px] v2-flex v2-flex-col v2-w-full h-full v2-overflow-y-auto",
            "v2-scrollbar-thin v2-scrollbar-thumb-neutral-300 v2-overflow-x-hidden",
            "v2-scrollbar-thumb-rounded-full v2-text-neutral-900 v2-text-base v2-gap-y-[15px] "
          ])
        },
        customContent,
        queued && /* @__PURE__ */ import_react179.default.createElement(
          EmbedTileErrorContent,
          {
            iconUrl: "https://cdn.bonjoro.com/assets/Flat-icons/pending.svg",
            text: "Queued"
          }
        ),
        !hideText && text && /* @__PURE__ */ import_react179.default.createElement(
          EmbedTileTextContent,
          {
            type,
            text,
            style: { fontFamily }
          }
        ),
        !hideMedia && media && /* @__PURE__ */ import_react179.default.createElement(
          EmbedTileMediaContent,
          {
            media,
            url,
            theme: theme2,
            playable,
            imageComponent
          }
        ),
        !hideLink && links && (!media || media.length == 0) && /* @__PURE__ */ import_react179.default.createElement(EmbedTileLinkContent, { links })
      );
    };
    const footer = () => {
      if (hideDateTime && hideReaction)
        return /* @__PURE__ */ import_react179.default.createElement(import_react179.default.Fragment, null);
      return /* @__PURE__ */ import_react179.default.createElement(
        "div",
        {
          className: (0, import_classnames120.default)([
            "v2-flex v2-flex-row v2-gap-x-[15px]",
            "v2-items-center v2-h-[15px] v2-px-5 v2-mt-[15px]"
          ])
        },
        !hideReaction && /* @__PURE__ */ import_react179.default.createElement(
          EmbedTileReactionPanel,
          {
            type,
            url,
            reactions,
            reactionClassName,
            loading: queued
          }
        ),
        queued && /* @__PURE__ */ import_react179.default.createElement(
          import_react_loading_skeleton5.default,
          {
            baseColor: colors.neutral[200],
            highlightColor: colors.neutral[100],
            height: "100%",
            containerClassName: "v2-h-4 v2-w-3/5 v2-flex"
          }
        ),
        !hideDateTime && !queued && /* @__PURE__ */ import_react179.default.createElement("span", { className: "v2-text-neutral-500 v2-text-xs" }, formattedDateTime)
      );
    };
    const hideIcon = defaultHideIcon || hideIconWithoutProfile && profile == void 0;
    return /* @__PURE__ */ import_react179.default.createElement(
      "div",
      __spreadProps(__spreadValues({
        ref
      }, otherProps), {
        className: (0, import_classnames120.default)(
          className,
          [
            "v2-w-full v2-h-fit v2-min-h-[245px] v2-relative v2-gap-y-[15px]",
            "v2-flex v2-flex-col v2-py-5 v2-bg-white v2-break-inside-avoid"
          ],
          {
            "v2-shadow": !hideShadow
          }
        ),
        style: __spreadValues(__spreadValues({
          borderRadius: `${cornerRadius}px`
        }, showBorder && {
          border: "solid",
          borderWidth: `${borderWidth != null ? borderWidth : 1}px`,
          borderColor: `${borderColor != null ? borderColor : colors.neutral[500]}`
        }), style),
        onClick
      }),
      (!hideIcon || profile != void 0) && /* @__PURE__ */ import_react179.default.createElement("div", { className: "v2-flex v2-flex-row v2-h-10 v2-px-5 v2-gap-x-2 v2-justify-between" }, profile && /* @__PURE__ */ import_react179.default.createElement(
        EmbedTileProfilePanel,
        __spreadProps(__spreadValues({}, profile), {
          url: (_a2 = profile == null ? void 0 : profile.url) != null ? _a2 : url,
          tagClassName: profileTagClassName,
          hideProfileImage: otherProps == null ? void 0 : otherProps.hideProfileImage,
          hideProfileName: otherProps == null ? void 0 : otherProps.hideProfileName,
          hideProfileTag: otherProps == null ? void 0 : otherProps.hideProfileTag,
          imageComponent,
          loading: queued
        })
      ), !hideIcon && /* @__PURE__ */ import_react179.default.createElement(
        EmbedTileIconImage,
        {
          type,
          className: "v2-h-5 v2-w-5",
          width: 20,
          height: 20,
          imageComponent,
          theme: theme2
        }
      )),
      /* @__PURE__ */ import_react179.default.createElement(
        "div",
        {
          className: (0, import_classnames120.default)([
            "v2-flex v2-flex-col v2-h-full v2-w-full",
            "v2-min-h-[150px] v2-justify-between"
          ])
        },
        content(),
        footer()
      )
    );
  }
);

// src/components/EmbedTile/util.tsx
var import_react180 = __toESM(require("react"));
var defaultTwitterUrl = "https://x.com";
var mapTwitterProps = ({
  url,
  content,
  datetime
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    type: "twitter" /* Twitter */,
    profile: {
      name: (_a = content == null ? void 0 : content.profile) == null ? void 0 : _a.name,
      url: ((_b = content == null ? void 0 : content.profile) == null ? void 0 : _b.tag) ? `${defaultTwitterUrl}/${(_c = content == null ? void 0 : content.profile) == null ? void 0 : _c.tag}` : url,
      imageUrl: (_d = content == null ? void 0 : content.profile) == null ? void 0 : _d.img_url,
      tag: (_e = content == null ? void 0 : content.profile) == null ? void 0 : _e.tag
    },
    url,
    text: content == null ? void 0 : content.text,
    media: (_f = content == null ? void 0 : content.media) == null ? void 0 : _f.map((item) => {
      return {
        type: item == null ? void 0 : item.type,
        url: item == null ? void 0 : item.url,
        thumbnailUrl: item == null ? void 0 : item.preview_url
      };
    }),
    reactions: content == null ? void 0 : content.reactions,
    links: (_g = content == null ? void 0 : content.links) == null ? void 0 : _g.map((item) => {
      return {
        url: item == null ? void 0 : item.url,
        imageUrl: item == null ? void 0 : item.img_url,
        title: item == null ? void 0 : item.title,
        description: item == null ? void 0 : item.description
      };
    }),
    queued: content === null,
    content: ((_h = content == null ? void 0 : content.error) == null ? void 0 : _h.title) ? /* @__PURE__ */ import_react180.default.createElement(
      EmbedTileErrorContent,
      {
        iconUrl: " https://cdn.bonjoro.com/assets/Flat-icons/error.svg",
        text: content.error.title
      }
    ) : void 0,
    datetime
  };
};

// src/components/EmbedTile/index.ts
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["Photo"] = "photo";
  MediaType2["Video"] = "video";
  return MediaType2;
})(MediaType || {});
var EmbedTileType5 = /* @__PURE__ */ ((EmbedTileType6) => {
  EmbedTileType6["Twitter"] = "twitter";
  EmbedTileType6["LinkedIn"] = "linkedin";
  EmbedTileType6["BonjoroResponse"] = "bonjoro_response";
  return EmbedTileType6;
})(EmbedTileType5 || {});
var ReactionType2 = /* @__PURE__ */ ((ReactionType3) => {
  ReactionType3["Like"] = "like";
  ReactionType3["Celebrate"] = "celebrate";
  ReactionType3["Support"] = "support";
  ReactionType3["Love"] = "love";
  ReactionType3["Insightful"] = "insightful";
  ReactionType3["Funny"] = "funny";
  return ReactionType3;
})(ReactionType2 || {});
var embedTileDetails = {
  ["twitter" /* Twitter */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/twitter-x-black.svg",
      iconType: "image"
    },
    reactions: {
      ["like" /* Like */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/twitter-reaction-heart.svg",
        iconType: "masked_image",
        iconClassName: "v2-bg-magenta-300"
      }
    }
  },
  ["linkedin" /* LinkedIn */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/linkedin.svg",
      iconType: "image"
    },
    reactions: {
      ["like" /* Like */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-like.svg",
        iconType: "image"
      },
      ["celebrate" /* Celebrate */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-celebrate.svg",
        iconType: "image"
      },
      ["support" /* Support */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-support.svg",
        iconType: "image"
      },
      ["love" /* Love */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-love.svg",
        iconType: "image"
      },
      ["insightful" /* Insightful */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-insightful.svg",
        iconType: "image"
      },
      ["funny" /* Funny */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-funny.svg",
        iconType: "image"
      }
    }
  },
  ["bonjoro_response" /* BonjoroResponse */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/quote.svg",
      iconType: "masked_image",
      iconClassName: "v2-bg-neutral-500"
    }
  }
};
var genericTileHoverEffectClassName = "hover:v2-scale-[0.99] hover:v2-shadow group-hover:v2-scale-[0.99] group-hover:v2-shadow v2-transition-all v2-ease-in";
function isTwitterEmbed(type) {
  return type === "twitter" /* Twitter */;
}
function isLinkedinEmbed(type) {
  return type === "linkedin" /* LinkedIn */;
}
function isBonjoroResponseEmbed(type) {
  return type === "bonjoro_response" /* BonjoroResponse */;
}

// src/components/OnboardingPanel/OnboardingPanel.tsx
var import_react181 = __toESM(require("react"));
var import_classnames121 = __toESM(require("classnames"));
var import_react_fontawesome24 = require("@fortawesome/react-fontawesome");
var OnboardingPanelTheme = /* @__PURE__ */ ((OnboardingPanelTheme2) => {
  OnboardingPanelTheme2["Blue"] = "blue";
  OnboardingPanelTheme2["Magenta"] = "magenta";
  return OnboardingPanelTheme2;
})(OnboardingPanelTheme || {});
function OnboardingPanel({
  id,
  theme: theme2,
  title,
  content,
  active,
  onClick,
  preHeader,
  isComplete: isComplete2 = false,
  showBackgroundColor = false,
  contentClassName,
  titleContainerClassName,
  titleClassName,
  className,
  bodyClassName
}) {
  const isBlueTheme = theme2 === "blue" /* Blue */;
  const isMagentaTheme = theme2 === "magenta" /* Magenta */;
  const circleIcon = () => {
    if (isComplete2) {
      return /* @__PURE__ */ import_react181.default.createElement(
        import_react_fontawesome24.FontAwesomeIcon,
        {
          icon: faCheck,
          className: (0, import_classnames121.default)(
            [
              "v2-text-white v2-rounded-full v2-items-center v2-h-full v2-w-full",
              "v2-w-5 v2-h-5 v2-p-[5px]"
            ],
            {
              "v2-bg-blue-500": isBlueTheme,
              "v2-bg-magenta-500": isMagentaTheme
            }
          )
        }
      );
    }
    return /* @__PURE__ */ import_react181.default.createElement(
      "span",
      {
        className: (0, import_classnames121.default)(
          [
            "v2-block v2-border-2 v2-border-solid v2-rounded-full",
            "v2-min-w-[30px] v2-min-h-[30px]"
          ],
          {
            "v2-border-blue-500": isBlueTheme,
            "v2-border-magenta-500": isMagentaTheme
          }
        )
      }
    );
  };
  const titleComponent = /* @__PURE__ */ import_react181.default.createElement(
    "div",
    {
      className: (0, import_classnames121.default)(
        titleClassName,
        "v2-flex v2-flex-row v2-gap-x-5 v2-items-center v2-justify-center v2-truncate"
      )
    },
    circleIcon(),
    preHeader && /* @__PURE__ */ import_react181.default.createElement(
      "span",
      {
        className: (0, import_classnames121.default)("v2-font-base v2-font-bold v2-truncate", {
          "v2-text-blue-500": isBlueTheme,
          "v2-text-magenta-500": isMagentaTheme
        })
      },
      preHeader
    ),
    /* @__PURE__ */ import_react181.default.createElement(
      "span",
      {
        className: (0, import_classnames121.default)(
          "v2-font-base v2-font-bold v2-text-neutral-900 v2-text-[21px] v2-truncate"
        )
      },
      title
    ),
    isComplete2 && /* @__PURE__ */ import_react181.default.createElement(
      "span",
      {
        className: (0, import_classnames121.default)("v2-font-base v2-font-bold v2-truncate", {
          "v2-text-blue-500": isBlueTheme,
          "v2-text-magenta-500": isMagentaTheme
        })
      },
      "COMPLETE"
    )
  );
  return /* @__PURE__ */ import_react181.default.createElement(
    Accordion,
    {
      id,
      active,
      onClick,
      titleContainerClassName: (0, import_classnames121.default)(
        titleContainerClassName,
        "v2-p-5 v2-mt-0 v2-h-[70px] !v2-flex-row"
      ),
      className: (0, import_classnames121.default)(className, {
        "v2-bg-neutral-50": isComplete2,
        "v2-bg-blue-50": !isComplete2 && showBackgroundColor && isBlueTheme,
        "v2-bg-magenta-50": !isComplete2 && showBackgroundColor && isMagentaTheme
      }),
      bodyClassName: (0, import_classnames121.default)(bodyClassName, "v2-p-5 v2-pt-0"),
      titleClassName: "!v2-justify-start v2-truncate",
      title: titleComponent,
      hideAnimation: "v2-animate-fade-out-150" /* FadeOut150 */
    },
    /* @__PURE__ */ import_react181.default.createElement(
      "div",
      {
        className: (0, import_classnames121.default)(
          contentClassName,
          "v2-flex v2-flex-row v2-flex-wrap v2-gap-x-5"
        )
      },
      content
    )
  );
}

// src/components/PublishableEmbed/PublishableEmbed.tsx
var import_react187 = __toESM(require("react"));

// src/components/PublishableEmbed/WallOfLove.tsx
var import_react185 = __toESM(require("react"));
var import_classnames124 = __toESM(require("classnames"));

// src/components/PublishableEmbed/Components/Tile.tsx
var import_react184 = __toESM(require("react"));
var import_classnames123 = __toESM(require("classnames"));

// src/components/Youtube/Embed.tsx
var import_react183 = __toESM(require("react"));
var import_styled17 = __toESM(require("@emotion/styled"));
var import_classnames122 = __toESM(require("classnames"));

// src/components/Youtube/util.ts
function getIdFromYoutubeUrl(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match2 = url.match(regExp);
  return match2 && match2[7].length == 11 ? match2[7] : null;
}
function isValidYoutubeUrl(url) {
  const regExp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))/;
  const youtubeId = getIdFromYoutubeUrl(url);
  return regExp.test(url) && !!youtubeId;
}

// src/components/EmbedErrorState/EmbedErrorState.tsx
var import_react182 = __toESM(require("react"));
var import_react_fontawesome25 = require("@fortawesome/react-fontawesome");
var EmbedErrorState = ({
  text,
  className = ""
}) => {
  return /* @__PURE__ */ import_react182.default.createElement(
    "div",
    {
      className: `
        v2-w-64 v2-h-40 v2-bg-neutral-100 v2-text-neutral-500 v2-rounded-md
        v2-border v2-border-solid v2-border-neutral-300 v2-flex v2-flex-col
        v2-justify-center v2-text-center v2-text-base v2-items-center
        ${className}`
    },
    /* @__PURE__ */ import_react182.default.createElement(import_react_fontawesome25.FontAwesomeIcon, { className: "v2-h-7", icon: faImageSlash }),
    /* @__PURE__ */ import_react182.default.createElement("div", { className: "v2-m-3.5" }, text)
  );
};

// src/components/Youtube/Embed.tsx
var PlayButton = import_styled17.default.img`
  transform: translate3d(-50%, -50%, 0);
  filter: grayscale(100%);

  &:hover {
    filter: none;
  }
`;
var Container4 = import_styled17.default.div`
  &:hover img {
    filter: none;
  }
`;
var Embed = import_react183.default.forwardRef(
  ({
    containerRef: defaultContainerRef,
    youtubeUrl,
    showControls = false,
    hideErrorState = false,
    className = "",
    errorStateClassName = "",
    onLoad,
    onLoadError,
    cornerRadius = 6,
    hideShadow = false,
    showBorder = false,
    borderWidth,
    borderColor,
    style
  }, ref) => {
    const containerRef = defaultContainerRef != null ? defaultContainerRef : (0, import_react183.useRef)(null);
    const youtubeId = (0, import_react183.useMemo)(
      () => getIdFromYoutubeUrl(youtubeUrl),
      [youtubeUrl]
    );
    const [showIframe, setShowIframe] = (0, import_react183.useState)(false);
    const [preConnection, setPreConnection] = (0, import_react183.useState)(false);
    const isValidYoutube = (0, import_react183.useMemo)(
      () => isValidYoutubeUrl(youtubeUrl),
      [youtubeUrl]
    );
    (0, import_react183.useEffect)(() => {
      if (!isValidYoutube || !youtubeId) {
        onLoadError == null ? void 0 : onLoadError();
      }
    }, [isValidYoutube, youtubeUrl]);
    if ((!isValidYoutube || !youtubeId) && hideErrorState) {
      return null;
    }
    if (!isValidYoutube) {
      return /* @__PURE__ */ import_react183.default.createElement(
        EmbedErrorState,
        {
          className: errorStateClassName,
          text: "The URL you've provided is not a valid Youtube URL."
        }
      );
    }
    const posterUrl = `https://i3.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;
    const youtubeEmbedUrl = `https://www.youtube.com/embed/${youtubeId}?rel=0&controls=${Number(
      showControls
    )}&autoplay=1`;
    return /* @__PURE__ */ import_react183.default.createElement(
      Container4,
      {
        ref,
        className: (0, import_classnames122.default)(className, "v2-w-96 v2-h-56 v2-overflow-hidden ", {
          "v2-shadow": !hideShadow
        }),
        onClick: () => setShowIframe(true),
        onPointerOver: () => setPreConnection(true),
        style: __spreadValues(__spreadValues({
          borderRadius: `${cornerRadius}px`
        }, showBorder && {
          border: "solid",
          borderWidth: `${borderWidth != null ? borderWidth : 1}px`,
          borderColor: `${borderColor != null ? borderColor : colors.neutral[500]}`
        }), style)
      },
      /* @__PURE__ */ import_react183.default.createElement("link", { rel: "preload", href: posterUrl, as: "image" }),
      /* @__PURE__ */ import_react183.default.createElement(import_react183.default.Fragment, null, preConnection && /* @__PURE__ */ import_react183.default.createElement(import_react183.default.Fragment, null, /* @__PURE__ */ import_react183.default.createElement("link", { rel: "preconnect", href: "https://www.youtube.com" }), /* @__PURE__ */ import_react183.default.createElement("link", { rel: "preconnect", href: "https://www.google.com" }))),
      !showIframe ? /* @__PURE__ */ import_react183.default.createElement("div", { className: "v2-h-full v2-w-full v2-relative v2-cursor-pointer" }, /* @__PURE__ */ import_react183.default.createElement(
        "img",
        {
          className: "v2-h-full v2-w-full v2-object-cover",
          onLoad,
          src: posterUrl
        }
      ), /* @__PURE__ */ import_react183.default.createElement(
        PlayButton,
        {
          className: "v2-h-12 v2-w-[68px] v2-absolute v2-left-2/4 v2-top-2/4",
          src: "https://cdn.bonjoro.com/assets/bonjoro-ui-components/youtube-play.svg"
        }
      )) : /* @__PURE__ */ import_react183.default.createElement(
        "iframe",
        {
          ref: containerRef,
          allowFullScreen: true,
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          src: youtubeEmbedUrl,
          className: "v2-aspect-video v2-w-full v2-h-full v2-border-0",
          onLoad
        }
      )
    );
  }
);

// src/components/PublishableEmbed/Components/Tile.tsx
var PreloadType = /* @__PURE__ */ ((PreloadType2) => {
  PreloadType2["None"] = "none";
  PreloadType2["Auto"] = "auto";
  PreloadType2["OnIntersect"] = "on_intersect";
  return PreloadType2;
})(PreloadType || {});
var TileChild = import_react184.default.forwardRef(
  ({
    className,
    asset,
    controls,
    style,
    timezone,
    imageComponent,
    cssProperties,
    preload = "on_intersect" /* OnIntersect */,
    showTextAsPlainText = false
  }, ref) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const tileType = asset.type;
    const thumb = (_a = asset.thumb_full_url) != null ? _a : asset.thumb_url;
    const { utc } = useDate((_b = asset == null ? void 0 : asset.content) == null ? void 0 : _b.datetime, { timezone });
    const createdAt = useDate(asset == null ? void 0 : asset.created_at, { timezone });
    const text = getRichTextFromSlateData((_c = asset == null ? void 0 : asset.text_response_rich) != null ? _c : []);
    switch (tileType) {
      case TileType.Video:
      case TileType.Text:
      case void 0:
      case null:
        return /* @__PURE__ */ import_react184.default.createElement(
          EmbedTile,
          __spreadProps(__spreadValues(__spreadValues({
            ref
          }, parseStyleToEmbedTileProps(style)), parseControlsToEmbedTileProps(controls)), {
            type: "bonjoro_response" /* BonjoroResponse */,
            profile: ((_d = asset == null ? void 0 : asset.owner) == null ? void 0 : _d.name) ? {
              name: (_e = asset == null ? void 0 : asset.owner) == null ? void 0 : _e.name,
              imageUrl: (_f = asset == null ? void 0 : asset.owner) == null ? void 0 : _f.image,
              tag: (_g = asset == null ? void 0 : asset.owner) == null ? void 0 : _g.position
            } : void 0,
            className: (0, import_classnames123.default)(className, "!v2-min-h-[195px]"),
            datetime: createdAt == null ? void 0 : createdAt.local,
            media: (asset == null ? void 0 : asset.video_url) ? [
              {
                type: "video" /* Video */,
                url: (_h = asset == null ? void 0 : asset.video_url) != null ? _h : "",
                thumbnailUrl: thumb,
                transcription: (controls == null ? void 0 : controls.hideTranscription) ? void 0 : (_j = (_i = asset == null ? void 0 : asset.transcript) == null ? void 0 : _i.captions) == null ? void 0 : _j.sentences,
                transcriptionClassName: "!v2-text-xs",
                preload: preload === "auto" /* Auto */ ? "auto" : "none",
                loadOnIntersect: preload === "on_intersect" /* OnIntersect */
              }
            ] : void 0,
            text: parseRichTextToString(text) != "" ? showTextAsPlainText ? parseRichTextToString(text) : text : void 0,
            theme: {
              primaryColor: style == null ? void 0 : style.primaryColor
            },
            playable: true,
            imageComponent,
            style: cssProperties
          })
        );
      case TileType.Youtube:
        return /* @__PURE__ */ import_react184.default.createElement(
          Embed,
          __spreadProps(__spreadValues({
            ref
          }, parseStyleToEmbedTileProps(style)), {
            className: (0, import_classnames123.default)("!v2-w-full v2-border-none", className),
            youtubeUrl: asset.url,
            style: cssProperties,
            hideErrorState: true
          })
        );
      case TileType.Twitter:
        return /* @__PURE__ */ import_react184.default.createElement(
          EmbedTile,
          __spreadProps(__spreadValues(__spreadValues(__spreadValues({
            ref
          }, parseStyleToEmbedTileProps(style)), mapTwitterProps({
            url: asset.url,
            content: asset.content,
            datetime: utc
          })), parseControlsToEmbedTileProps(controls)), {
            className: (0, import_classnames123.default)("!v2-w-full", className),
            imageComponent,
            style: cssProperties
          })
        );
      default:
        return null;
    }
  }
);
var Tile = import_react184.default.forwardRef(
  ({
    className,
    containerClassName,
    detail,
    showHoverAnimation,
    controls,
    style,
    timezone,
    imageComponent,
    cssProperties,
    preload,
    showTextAsPlainText
  }, ref) => {
    return /* @__PURE__ */ import_react184.default.createElement(
      "div",
      {
        className: (0, import_classnames123.default)("v2-break-inside-avoid v2-max-w-sm", containerClassName, {
          "v2-transition v2-ease-in-out hover:v2-scale-[1.02]": showHoverAnimation
        })
      },
      /* @__PURE__ */ import_react184.default.createElement(
        TileChild,
        {
          ref,
          className,
          asset: detail,
          controls,
          style,
          timezone,
          imageComponent,
          cssProperties,
          preload,
          showTextAsPlainText
        }
      )
    );
  }
);
function parseControlsToEmbedTileProps(props) {
  var _a, _b, _c, _d;
  return {
    hideProfileImage: (_a = props == null ? void 0 : props.hideProfileImage) != null ? _a : false,
    hideProfileName: (_b = props == null ? void 0 : props.hideName) != null ? _b : false,
    hideProfileTag: (_c = props == null ? void 0 : props.hideTitle) != null ? _c : false,
    hideDateTime: (_d = props == null ? void 0 : props.hideDate) != null ? _d : false
  };
}
function parseStyleToEmbedTileProps(props) {
  var _a, _b, _c, _d, _e;
  return {
    cornerRadius: (_a = props == null ? void 0 : props.cornerRadius) != null ? _a : 5,
    hideShadow: (props == null ? void 0 : props.dropShadow) != void 0 ? !(props == null ? void 0 : props.dropShadow) : false,
    showBorder: (_b = props == null ? void 0 : props.border) != null ? _b : false,
    borderWidth: (_c = props == null ? void 0 : props.borderSize) != null ? _c : 1,
    borderColor: (_d = props == null ? void 0 : props.borderColor) != null ? _d : colors.neutral[500],
    fontFamily: (_e = props == null ? void 0 : props.fontFamily) != null ? _e : DEFAULT_FONT_FAMILY
  };
}

// src/components/PublishableEmbed/WallOfLove.tsx
var import_beautiful_react_hooks2 = __toESM(require_cjs());
var DEFAULT_PAGE_LIMIT = 50;
var DEFAULT_MOBILE_PAGE_LIMIT = 3;
var TILE_WIDTH_PER_COLUMN = 350;
var TILE_GAPS = 15;
var computeWallOfLoveColumnTilesEventName = "compute-wall-of-love-column-tiles";
var computeWallOfLoveColumnTiles = () => window.dispatchEvent(new CustomEvent(computeWallOfLoveColumnTilesEventName));
function WallOfLove(_a) {
  var _b = _a, {
    data = [],
    containerClassName,
    innerElementClassName,
    containerStyle,
    onBonjoroBadgeClick,
    imageComponent,
    isResizerReady = false
  } = _b, props = __objRest(_b, [
    "data",
    "containerClassName",
    "innerElementClassName",
    "containerStyle",
    "onBonjoroBadgeClick",
    "imageComponent",
    "isResizerReady"
  ]);
  const [columnTiles, setColumnTiles] = (0, import_react185.useState)(0);
  const containerRef = (0, import_react185.useRef)(null);
  const gridLayoutRef = (0, import_react185.useRef)();
  const {
    enableMaxHeight,
    maxHeight = 0,
    primaryColor,
    allowDynamicTiles,
    allowMobileTileRestriction
  } = props;
  const computeColumnTiles = () => {
    var _a2, _b2, _c;
    if (!(gridLayoutRef == null ? void 0 : gridLayoutRef.current))
      return;
    const width = (_c = (_b2 = (_a2 = gridLayoutRef == null ? void 0 : gridLayoutRef.current) == null ? void 0 : _a2.getBoundingClientRect()) == null ? void 0 : _b2.width) != null ? _c : 0;
    const columns = Math.floor(width / TILE_WIDTH_PER_COLUMN);
    if (width < columns * TILE_WIDTH_PER_COLUMN + (columns - 1) * TILE_GAPS) {
      setColumnTiles(columns - 1);
      return;
    }
    setColumnTiles(columns != 0 ? columns : 1);
    return;
  };
  const gridResizeObserver = (0, import_react185.useRef)(
    new ResizeObserver(() => computeColumnTiles())
  );
  const onComputeWallOfLoveColumnTiles = (0, import_beautiful_react_hooks2.useGlobalEvent)(
    computeWallOfLoveColumnTilesEventName
  );
  onComputeWallOfLoveColumnTiles(() => computeColumnTiles());
  (0, import_react185.useEffect)(() => {
    if (!gridLayoutRef.current || !gridResizeObserver.current)
      return;
    gridResizeObserver.current.observe(gridLayoutRef.current);
  }, [gridLayoutRef.current, gridResizeObserver]);
  const isLoadedInsideIFrame = (0, import_react185.useMemo)(() => window.self !== window.top, []);
  const [page, setPage] = (0, import_react185.useState)(1);
  const publishables = (0, import_react185.useMemo)(() => {
    if (allowMobileTileRestriction && columnTiles === 1) {
      return data == null ? void 0 : data.slice(0, DEFAULT_MOBILE_PAGE_LIMIT * page);
    }
    return data == null ? void 0 : data.slice(0, DEFAULT_PAGE_LIMIT * page);
  }, [data, page, columnTiles, allowMobileTileRestriction]);
  const hasMore = (0, import_react185.useMemo)(() => {
    return (data == null ? void 0 : data.length) > (publishables == null ? void 0 : publishables.length);
  }, [publishables, data, columnTiles]);
  const tileStyle = (0, import_react185.useMemo)(() => {
    if (!enableMaxHeight)
      return {};
    if (allowDynamicTiles) {
      return {
        overflowY: "hidden",
        maxHeight: `${maxHeight}px`
      };
    }
    return {
      height: `${maxHeight}px`
    };
  }, [maxHeight, allowDynamicTiles, enableMaxHeight]);
  return /* @__PURE__ */ import_react185.default.createElement(import_react185.default.Fragment, null, /* @__PURE__ */ import_react185.default.createElement(
    "div",
    {
      ref: containerRef,
      className: (0, import_classnames124.default)(
        "v2-w-full v2-mx-auto lg:v2-max-w-none v2-min-w-[300px] v2-animate-fade-in-down",
        containerClassName,
        {
          "h-screen": !isLoadedInsideIFrame,
          "overflow-y-auto": !props.disableScroll,
          hidden: isLoadedInsideIFrame && !isResizerReady || !(containerRef == null ? void 0 : containerRef.current)
        }
      ),
      style: containerStyle
    },
    /* @__PURE__ */ import_react185.default.createElement(
      "div",
      {
        className: (0, import_classnames124.default)("v2-flex v2-flex-col", {
          hidden: !(containerRef == null ? void 0 : containerRef.current)
        })
      },
      /* @__PURE__ */ import_react185.default.createElement("div", { className: "v2-p-4 v2-pt-10 v2-pb-4 v2-w-full v2-mx-auto v2-overflow-y-none" }, /* @__PURE__ */ import_react185.default.createElement(
        GridLayout,
        {
          containerRef: gridLayoutRef,
          className: (0, import_classnames124.default)(
            innerElementClassName,
            "v2-mx-0 v2-my-auto v2-gap-[15px] v2-justify-center",
            "min-[400px]:!v2-grid-cols-[repeat(auto-fill,350px)]",
            "!v2-grid-cols-[repeat(auto-fit, minmax(200px, 1fr))]"
          )
        },
        publishables && publishables.map((detail) => /* @__PURE__ */ import_react185.default.createElement(
          Tile,
          {
            key: detail.uuid,
            detail,
            className: (0, import_classnames124.default)(
              [
                "v2-scrollbar-thin v2-scrollbar-track-neutral-200",
                "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full"
              ],
              {
                "v2-animate-fade-in-150": isLoadedInsideIFrame && !isResizerReady || !(containerRef == null ? void 0 : containerRef.current)
              }
            ),
            controls: props,
            style: props,
            timezone: props.timezone,
            preload: props.preload,
            showTextAsPlainText: props.showTextAsPlainText,
            imageComponent,
            cssProperties: tileStyle
          }
        ))
      )),
      hasMore && /* @__PURE__ */ import_react185.default.createElement(
        Button,
        {
          className: (0, import_classnames124.default)([
            "v2-cursor-pointer v2-text-base v2-font-bold v2-text-center v2-self-center",
            "v2-w-[350px] v2-mb-5 v2-border-0 hover:v2-scale-[1.02] v2-transition-all"
          ]),
          onClick: () => setPage(page + 1),
          style: {
            backgroundColor: primaryColor,
            color: computeTextColor(primaryColor)
          }
        },
        "Load more"
      ),
      !(props == null ? void 0 : props.hideBonjoroBadge) && /* @__PURE__ */ import_react185.default.createElement(
        "div",
        {
          className: "v2-flex v2-justify-center v2-cursor-pointer",
          onClick: onBonjoroBadgeClick
        },
        /* @__PURE__ */ import_react185.default.createElement(
          "img",
          {
            className: "v2-h-12 v2-mb-10",
            src: assetUrl("powered-by-bj.svg")
          }
        )
      )
    )
  ));
}

// src/components/PublishableEmbed/Slider.tsx
var import_react186 = __toESM(require("react"));
var import_classnames125 = __toESM(require("classnames"));
var import_use_measure = __toESM(require_use_measure());
var SliderBreakpoint = /* @__PURE__ */ ((SliderBreakpoint2) => {
  SliderBreakpoint2[SliderBreakpoint2["Mobile"] = 450] = "Mobile";
  SliderBreakpoint2[SliderBreakpoint2["Tablet"] = 768] = "Tablet";
  return SliderBreakpoint2;
})(SliderBreakpoint || {});
var OVERFLOW_HEIGHT_OFFSET = 5;
function Slider(_a) {
  var _b = _a, {
    data = [],
    hideBonjoroBadge,
    disableResponsiveness = false,
    containerClassName,
    containerStyle,
    onBonjoroBadgeClick,
    imageComponent
  } = _b, props = __objRest(_b, [
    "data",
    "hideBonjoroBadge",
    "disableResponsiveness",
    "containerClassName",
    "containerStyle",
    "onBonjoroBadgeClick",
    "imageComponent"
  ]);
  const carouselRef = (0, import_react186.useRef)(null);
  const hookProps = useCarousel(carouselRef);
  const { width } = (0, import_use_measure.default)(carouselRef);
  const videoRefs = (0, import_react186.useRef)(
    document.getElementsByClassName(
      "embed-tile-video-player"
    )
  );
  const [hovered, setHovered] = (0, import_react186.useState)(false);
  const [videoPlaying, setVideoPlaying] = (0, import_react186.useState)(false);
  const { setToNext } = hookProps;
  const {
    maxHeight = 0,
    autoSlide,
    allowDynamicTiles,
    hideCarouselIndicator,
    hideCarouselChevron,
    primaryColor
  } = props;
  const disableVideoPlaying = () => setVideoPlaying(false);
  const enableVideoPlaying = () => setVideoPlaying(true);
  (0, import_react186.useEffect)(() => {
    if (!videoRefs.current)
      return;
    Object.values(videoRefs.current).map((videoRef) => {
      videoRef == null ? void 0 : videoRef.addEventListener("ended", disableVideoPlaying);
      videoRef == null ? void 0 : videoRef.addEventListener("play", enableVideoPlaying);
    });
    return () => {
      Object.values(videoRefs.current).map((videoRef) => {
        videoRef == null ? void 0 : videoRef.removeEventListener("ended", disableVideoPlaying);
        videoRef == null ? void 0 : videoRef.removeEventListener("play", enableVideoPlaying);
      });
    };
  }, [videoRefs.current, enableVideoPlaying, disableVideoPlaying]);
  (0, import_react186.useEffect)(() => {
    if (!autoSlide || videoPlaying || hovered)
      return;
    const intervalId = setInterval(() => {
      setToNext();
      clearInterval(intervalId);
    }, 5e3);
    return () => clearInterval(intervalId);
  }, [autoSlide, setToNext, videoPlaying, hovered]);
  const overflowStyle = (0, import_react186.useMemo)(() => {
    return {
      height: `${maxHeight + OVERFLOW_HEIGHT_OFFSET}px`
    };
  }, [maxHeight]);
  const tileStyle = (0, import_react186.useMemo)(() => {
    if (allowDynamicTiles) {
      return {
        overflowY: "hidden",
        maxHeight: `${maxHeight}px`
      };
    }
    return {
      height: `${maxHeight}px`
    };
  }, [maxHeight, allowDynamicTiles]);
  const tilesPerPage = (0, import_react186.useMemo)(() => {
    if (!disableResponsiveness) {
      if (width <= 450 /* Mobile */) {
        return 1;
      }
      if (width <= 768 /* Tablet */) {
        return 2;
      }
    }
    return props.tilesPerPage;
  }, [width, disableResponsiveness, props.tilesPerPage]);
  (0, import_react186.useEffect)(() => {
    Object.values(videoRefs.current).forEach((video) => video.pause());
  }, [hookProps.activeIndex]);
  const tileData = (0, import_react186.useMemo)(() => {
    let index = 0;
    return new Array(Math.ceil(data.length / tilesPerPage)).fill(0).map(() => {
      const page = new Array(
        Math.min(tilesPerPage, data.length - index)
      );
      for (let i = 0; i < page.length; i++) {
        page[i] = data[index + i];
      }
      index += tilesPerPage;
      return page;
    });
  }, [tilesPerPage, data]);
  return /* @__PURE__ */ import_react186.default.createElement(
    Carousel,
    __spreadProps(__spreadValues({}, hookProps), {
      style: containerStyle,
      styleProps: {
        indicatorActiveColor: primaryColor,
        chevronHoverColor: primaryColor
      },
      containerClassName: (0, import_classnames125.default)("v2-w-full", containerClassName),
      overflowStyle,
      carouselRef,
      hideBonjoroBadge,
      hideIndicators: hideCarouselIndicator,
      hideNavigator: hideCarouselChevron,
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      onBonjoroBadgeClick
    }),
    tileData.map((tiles, carouselIndex) => /* @__PURE__ */ import_react186.default.createElement(
      CarouselItem,
      {
        key: carouselIndex,
        innerClassName: "v2-flex v2-items-center v2-justify-center v2-space-x-6 v2-px-10"
      },
      tiles.map((tile) => /* @__PURE__ */ import_react186.default.createElement(
        Tile,
        {
          key: tile.uuid,
          detail: tile,
          containerClassName: (0, import_classnames125.default)("v2-h-full", {
            "v2-w-full": tilesPerPage === 1,
            "v2-w-1/2 v2-min-w-0": tilesPerPage === 2,
            "v2-w-1/3 v2-min-w-0": tilesPerPage === 3
          }),
          className: (0, import_classnames125.default)([
            "v2-scrollbar-thin v2-scrollbar-track-neutral-200",
            "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full"
          ]),
          controls: props,
          style: props,
          timezone: props.timezone,
          preload: props.preload,
          showTextAsPlainText: props.showTextAsPlainText,
          imageComponent,
          cssProperties: tileStyle
        }
      ))
    ))
  );
}

// src/components/PublishableEmbed/PublishableEmbed.tsx
var loadEmbedVideos = () => {
  const videoElements = document.getElementsByClassName(
    "embed-tile-video-player"
  );
  if (!videoElements || videoElements.length === 0)
    return;
  for (const videoElement of Array.from(videoElements)) {
    videoElement == null ? void 0 : videoElement.setAttribute("preload", "auto");
    videoElement == null ? void 0 : videoElement.load();
  }
};
function PublishableEmbed(_a) {
  var _b = _a, { type } = _b, props = __objRest(_b, ["type"]);
  switch (type) {
    case "wall_of_love" /* WallOfLove */:
      return /* @__PURE__ */ import_react187.default.createElement(WallOfLove, __spreadValues({}, props));
    case "slider" /* Slider */:
      return /* @__PURE__ */ import_react187.default.createElement(Slider, __spreadValues({}, props));
    default:
      return /* @__PURE__ */ import_react187.default.createElement(import_react187.default.Fragment, null);
  }
}

// src/components/PublishableEmbed/index.ts
var PublishableType = /* @__PURE__ */ ((PublishableType2) => {
  PublishableType2["Quote"] = "quote";
  PublishableType2["Slider"] = "slider";
  PublishableType2["WallOfLove"] = "wall_of_love";
  return PublishableType2;
})(PublishableType || {});
var DEFAULT_FONT_FAMILY = "Circular Std";
var VideoTextAssetTile = /* @__PURE__ */ ((VideoTextAssetTile2) => {
  VideoTextAssetTile2["Video"] = "video";
  VideoTextAssetTile2["Text"] = "text";
  return VideoTextAssetTile2;
})(VideoTextAssetTile || {});
var TileType = __spreadValues(__spreadValues({}, VideoTextAssetTile), SocialType);
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
*/
